export default {
  common: {
    actions: {
      save: 'Salvar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      delete: 'Excluir',
      edit: 'Editar',
      add: 'Adicionar',
      close: 'Fechar',
      back: 'Voltar',
      next: 'Avançar',
      finish: 'Concluir',
      search: 'Pesquisar',
      filter: 'Filtrar',
      clear: 'Limpar',
      download: 'Baixar',
      upload: 'Enviar',
      copy: 'Copiar',
      duplicate: 'Duplicar',
      view: 'Visualizar',
      send: 'Enviar',
      resend: 'Reenviar',
      activate: 'Ativar',
      deactivate: 'Desativar',
      block: 'Bloquear',
      unblock: 'Desbloquear',
      approve: 'Aprovar',
      reject: 'Recusar',
      import: 'Importar',
      export: 'Exportar',
      remove: 'Remover',
      create: 'Criar',
      update: 'Atualizar',
      yes: 'Sim',
      no: 'Não',
      ok: 'Ok',
      retry: 'Tentar novamente',
      refresh: 'Atualizar',
      addAnother: 'Adicionar outro'
    },
    fields: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      document: 'Documento',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      cpfOrCnpj: 'CPF/CNPJ',
      birthDate: 'Data de nascimento',
      date: 'Data',
      startDate: 'Data de início',
      endDate: 'Data de fim',
      description: 'Descrição',
      observation: 'Observação',
      type: 'Tipo',
      status: 'Status',
      value: 'Valor',
      code: 'Código',
      country: 'País',
      state: 'Estado',
      city: 'Cidade',
      zipCode: 'CEP',
      address: 'Endereço',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Bairro',
      period: 'Período',
      bank: 'Banco',
      agency: 'Agência',
      account: 'Conta',
      digit: 'Dígito',
      pixKey: 'Chave Pix',
      notes: 'Notas',
      optional: 'Opcional'
    },
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
      pending: 'Pendente',
      approved: 'Aprovado',
      rejected: 'Recusado',
      cancelled: 'Cancelado',
      completed: 'Concluído',
      processing: 'Em processamento',
      waiting: 'Aguardando',
      loading: 'Carregando...',
      noData: 'Nenhum dado encontrado',
      noResults: 'Nenhum resultado encontrado'
    },
    empty: {
      title: 'Nenhum registro encontrado',
      subtitle: 'Não há dados para os filtros selecionados.',
      noFilters: 'Não há registros cadastrados.'
    },
    tooltips: {
      copy: 'Copiar',
      copied: 'Copiado!',
      download: 'Baixar documento',
      remove: 'Remover',
      edit: 'Editar',
      view: 'Visualizar',
      add: 'Adicionar',
      filter: 'Filtrar',
      closeToast: 'Fechar'
    },
    confirm: {
      deleteTitle: 'Excluir registro?',
      deleteSubtitle: 'Esta ação não pode ser desfeita.',
      unsavedTitle: 'Sair sem salvar?',
      unsavedSubtitle: 'Todas as alterações não salvas serão perdidas, deseja continuar?'
    },
    feedback: {
      savedSuccess: 'Informações salvas com sucesso.',
      deletedSuccess: 'Registro excluído com sucesso.',
      copiedSuccess: 'Copiado para a área de transferência!',
      requiredFields: 'Existem campos obrigatórios não preenchidos',
      loadError: 'Não foi possível carregar os dados. Atualize a página (F5).',
      saveError: 'Não foi possível salvar. Confira os dados e tente novamente.'
    },
    filters: {
      startDate: 'Data de início',
      endDate: 'Data de fim',
      type: 'Tipo',
      status: 'Status',
      bank: 'Banco',
      corban: 'Corban',
      personType: 'Tipo de Pessoa',
      cpfCnpj: 'CPF/CNPJ',
      nature: 'Natureza',
      operation: 'Operação',
      period: 'Período'
    },
    pagination: {
      rowsPerPage: 'Itens por página',
      of: 'de',
      all: 'Todos'
    },
    time: {
      now: 'agora',
      minuteAbbr: 'min',
      hourAbbr: 'h',
      dayAbbr: 'd'
    }
  },

  validation: {
    required: 'Este campo é obrigatório',
    email: 'E-mail inválido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
    cpf: 'CPF inválido',
    cnpj: 'CNPJ inválido',
    cpfOrCnpj: 'CPF ou CNPJ inválido',
    phone: 'Telefone inválido',
    zipCode: 'CEP inválido',
    passwordMatch: 'As senhas devem ser iguais',
    passwordMinLength: 'A senha deve ter no mínimo 8 caracteres',
    numeric: 'Apenas números são permitidos',
    positiveValue: 'O valor deve ser maior que zero',
    percentageRange: 'O percentual deve estar entre 0 e 100',
    partnersSum: 'A soma das participações dos sócios deve ser igual a 100%',
    fileType: 'Formato não permitido. Use JPEG ou PNG.',
    fileSize: 'O arquivo não pode ter mais que 5MB.',
    onlyImages: 'Apenas arquivos de imagem são aceitos!',
    swiftFormat: 'Formato SWIFT inválido',
    ibanFormat: 'Formato IBAN inválido',
    stateFormat: 'Use a sigla do estado com 2 caracteres (ex: FL, CA, NY)',
    duimpSum: 'A soma dos valores DUIMP/DU-E não pode ser maior que a quantidade em M.E. da operação.',
    ssnFormat: 'Formato SSN/ITIN: XXX-XX-XXXX',
    requiredMultiple: 'É obrigatório selecionar pelo menos uma das opções',
    requiredRadio: 'É obrigatório selecionar uma das opções',
    emailInvalid: 'Informe um e-mail válido',
    cpfCnpjInvalid: 'Informe um CPF/CNPJ válido',
    cuitInvalid: 'CUIT/CUIL não confere. Revise os 11 dígitos',
    requiredCheckbox: 'É obrigatório concordar para prosseguir',
    passwordMin6: 'Senha deve ter mínimo de 6 caracteres',
    phoneCountryRequired: 'DDI é obrigatório',
    phoneInvalidDdi: 'Celular inválido para o DDI informado',
    swiftBicLength: 'Código SWIFT/BIC deve ter 8 ou 11 caracteres (ex: CHASUS33 ou CHASUS33XXX)',
    clabeLength: 'CLABE deve ter exatamente 18 dígitos',
    debitCardLength: 'Número do cartão deve ter exatamente 16 dígitos',
    cvuLength: 'CVU deve ter exatamente 22 dígitos',
    cbuLength: 'CBU deve ter exatamente 22 dígitos',
    cvuCbuLength: 'CVU/CBU deve ter exatamente 22 dígitos',
    postalCodeCountryInvalid: 'Código postal inválido para o país selecionado (ex: {example})',
    postalCodeGenericInvalid: 'Código postal inválido (mínimo 3 caracteres alfanuméricos)',
    postalCodeNoDigit: 'Código postal deve conter pelo menos um número'
  },

  http: {
    authErrorUi: {
      noConnection: 'Não foi possível conectar. Verifique sua internet e tente de novo.',
      unexpected: 'Algo deu errado do nosso lado. Tente de novo em alguns instantes.',
      genericProvider: 'esse provedor'
    },
    apiErrorUi: {
      noServer: 'Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.',
      tooManyRequests: 'Muitas tentativas em pouco tempo. Aguarde alguns minutos e tente novamente.',
      unavailable: 'O serviço está indisponível no momento. Tente novamente em alguns minutos.'
    },
    connectionUi: {
      offline: 'Seu computador está sem internet. Confira a conexão e tente novamente.',
      serverUnreachable: 'Não foi possível se conectar com o servidor. Se essa mensagem persistir, por favor, contate o suporte técnico.',
      sessionExpired: 'Seu login de acesso expirou, efetue o login novamente para acessar o sistema.'
    },
    toastTitles: {
      success: 'Sucesso',
      error: 'Atenção',
      warning: 'Aviso',
      information: 'Informação',
      info: 'Informação'
    },
    unauthorized: 'Sua sessão expirou. Faça login novamente.',
    forbidden: 'Você não tem permissão para realizar esta ação.',
    notFound: 'Recurso não encontrado. Atualize a página (F5).',
    tooLarge: 'O arquivo é maior que o limite de 10 MB. Escolha um arquivo menor.',
    tooManyRequests: 'Muitas tentativas. Aguarde alguns instantes e tente novamente.',
    badGateway: 'Sistema temporariamente indisponível. Tente novamente em breve.',
    serviceUnavailable: 'Sistema temporariamente indisponível. Tente novamente em breve.',
    timeout: 'O sistema demorou para responder. Aguarde alguns instantes e confira se a ação foi concluída antes de tentar novamente.',
    noConnection: 'Não foi possível conectar à internet. Verifique se seu dispositivo está conectado.',
    requestFailed: 'Não foi possível concluir a ação. Tente novamente; se continuar, fale com o suporte.'
  },

  login: {
    emailLabel: 'E-mail',
    passwordLabel: 'Senha',
    loginButton: 'Entrar',
    forgotPassword: 'Esqueci minha senha',
    resetInstructions: 'Preencha seu e-mail para enviarmos o código para redefinir sua senha',
    sendCodeButton: 'Enviar código de confirmação',
    backButton: 'Voltar',
    codeInstructions: 'Digite o código recebido no e-mail {email}',
    codeLabel: 'Código de Confirmação',
    confirmButton: 'Confirmar',
    newPasswordInstructions: 'Escolha sua nova senha.',
    newPasswordLabel: 'Nova Senha',
    confirmPasswordLabel: 'Confirme sua senha',
    saveButton: 'Salvar',
    codeSentSuccess: 'Enviamos o código para o e-mail informado',
    codeSendError: 'Não foi possível enviar o código por e-mail. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    codeInvalid: 'Código não confirmado. Confira e tente novamente',
    passwordChangedSuccess: 'Senha alterada com sucesso',
    passwordChangeError: 'Não foi possível redefinir a senha. Confira os campos',
    credentialsRequired: 'Informe o e-mail e senha para acesso.'
  },

  menu: {
    breadcrumbNavUi: {
      newProfile: 'Novo Perfil',
      editProfile: 'Editar Perfil'
    },
    sections: {
      main: 'PRINCIPAL',
      operational: 'OPERACIONAL',
      reports: 'RELATÓRIOS',
      registrations: 'CADASTROS',
      administration: 'ADMINISTRAÇÃO',
      others: 'OUTROS'
    },
    items: {
      home: 'Home',
      dashboard: 'Dashboard',
      customers: 'Clientes',
      customerFlow: 'Fluxo cadastral',
      operations: 'Operações',
      preSale: 'Pré-venda',
      operationalReports: 'Relatórios operacionais',
      internationalRemittances: 'Remessas internacionais',
      profitRemittances: 'Lucro / Remessas internacionais',
      touristExchange: 'Câmbio turismo',
      stablecoinReports: 'Relatórios Stablecoin',
      duimpManagement: 'Gestão de DUIMP/DU-E',
      corban: 'Corban',
      registrationsMenu: 'Cadastros',
      commissions: 'Comissões',
      operationalRegistrations: 'Cadastros operacionais',
      operationNatures: 'Naturezas de operação',
      banks: 'Bancos',
      spreadCurrencies: 'Spread / Moedas',
      paymentMethods: 'Métodos de pagamento',
      quotationApis: 'Apis de cotação',
      templates: 'Templates',
      users: 'Usuários',
      profiles: 'Perfis',
      audit: 'Auditoria',
      generateInvoices: 'Gerar Invoices',
      exchangeClosing: 'Fechamento mensal'
    },
    customerItems: {
      myWallets: 'Minhas Carteiras',
      home: 'Home',
      myAccount: 'Minha Conta',
      myOperations: 'Minhas Operações',
      newOperation: 'Nova Operação'
    },
    topbar: {
      whatsapp: 'WhatsApp',
      whatsappUnread: 'WhatsApp ({count} não lidas)',
      latestUpdates: 'Últimas Atualizações',
      pinSidebar: 'Fixar o menu aberto (empurra o conteúdo)',
      unpinSidebar: 'Desafixar o menu (volta a abrir no passar do mouse)'
    },
    avatar: {
      title: 'Alterar Foto',
      choosePhoto: 'Escolher foto',
      save: 'Salvar',
      cancel: 'Cancelar',
      updatedSuccess: 'Foto atualizada com sucesso.',
      formatError: 'Formato não permitido. Use JPEG ou PNG.',
      sizeError: 'O arquivo não pode ter mais que 5MB.',
      uploadError: 'Não foi possível salvar a foto. Confira os dados e tente novamente.'
    },
    language: {
      label: 'Idioma',
      tooltip: 'Selecionar idioma'
    },
    notifications: {
      title: 'Notificações',
      tooltip: 'Notificações',
      select: 'Selecionar',
      selectedCount: '{count} selecionada | {count} selecionadas',
      markAsRead: 'Marcar como lida',
      markAsUnread: 'Marcar como não lida',
      delete: 'Excluir',
      emptyTitle: 'Tudo em dia',
      emptySubtitle: 'Você não tem notificações',
      newSection: 'Novas',
      previousSection: 'Anteriores',
      loading: 'Carregando…',
      loadMore: 'Carregar mais',
      markAllRead: 'Marcar todas como lidas',
      viewHistory: 'Ver histórico'
    },
    userMenu: {
      calculationMemory: 'Memória de cálculo',
      changeTheme: 'Alterar tema',
      settings: 'Configurações',
      emailsSent: 'E-mails enviados',
      changePassword: 'Alterar Senha',
      accessMethods: 'Formas de acesso',
      changePhoto: 'Alterar Foto',
      firstSteps: 'Primeiros Passos',
      support: 'Suporte',
      logout: 'Sair'
    },
    changePassword: {
      title: 'Alterar Senha',
      currentPasswordLabel: 'Senha atual',
      currentPasswordRequired: 'Informe a senha atual para continuar',
      newPasswordLabel: 'Nova Senha',
      newPasswordRequired: 'Informe a nova senha para continuar',
      confirmPasswordLabel: 'Confirme sua senha',
      confirmPasswordRequired: 'Confirme a nova senha para continuar',
      save: 'Salvar',
      cancel: 'Cancelar',
      successMessage: 'Senha alterada com sucesso',
      errorMessage: 'Não foi possível alterar a senha. Confira os dados e tente novamente.',
      passwordMismatch: 'As senhas devem ser iguais'
    },
    calculationMemory: {
      title: 'Memória de cálculo',
      close: 'Fechar',
      exampleLabel: 'Exemplo',
      grossProfit: {
        term: 'Lucro bruto',
        desc: 'Total da operação - lucro do banco',
        example: 'Total operado 100 - Lucro do banco 20 = Lucro bruto 80'
      },
      corban: {
        term: 'Corban',
        desc: 'Lucro líquido * % comissão do corban',
        example: 'Lucro líquido 60 * comissão Corban 10% = Lucro do Corban 6'
      },
      corbanIndicator: {
        term: 'Corban indicador',
        desc: 'Lucro líquido * % comissão do indicador',
        example: 'Lucro líquido 60 * comissão Indicador 5% = Lucro do Indicador 3'
      },
      operationTotal: {
        term: 'Total da operação',
        forRemittance: 'Para remessa',
        forRemittanceDesc: 'Quantidade da ME * taxa do cliente',
        forRemittanceExample: 'Quantidade ME 1000 * Taxa do cliente 5,50 = Total da Operação 5500',
        forExchange: 'Para câmbio',
        forExchangeDesc: 'Quantidade da ME * taxa do cliente sem IOF',
        forExchangeExample: 'Quantidade ME 1000 * Taxa do cliente sem IOF 5,30 = Total da Operação 5300'
      },
      pisCofins: {
        term: 'PIS/COFINS',
        desc: 'Lucro bruto * 0.0465',
        example: 'Lucro bruto 80 * 0.0465 = 3,72'
      },
      contractCashback: {
        term: 'Cashback do contrato',
        desc: 'Valor do contrato * % da comissão',
        example: 'Valor do contrato 10000 * comissão 0,5% = Cashback do contrato 50'
      },
      bankProfit: {
        term: 'Lucro do banco',
        desc: '(1 - % da comissão) * lucro bruto',
        example: '1 - comissão 25% * Lucro bruto 80 = Lucro do Banco 60'
      },
      masterCorbanProfit: {
        term: 'Lucro corban master',
        desc: 'Lucro bruto - lucro do banco + cashback do contrato',
        example: 'Lucro bruto 80 - Lucro do banco 60 + Cashback do contrato 50 = Lucro Corban Master 70'
      }
    },
    preSale: {
      openOperations: 'Você possui {count} operação em aberto | Você possui {count} operações em aberto'
    },
    signupLink: {
      referClient: 'Indicar cliente',
      signupLink: 'Link de cadastro'
    },
    simulate: {
      open: 'Simular operação',
      active: 'Simulando operação'
    },
    breadcrumb: {
      myWallets: 'Minhas carteiras',
      home: 'Home',
      dashboard: 'Dashboard',
      customers: 'Clientes',
      newCustomer: 'Novo Cliente',
      editCustomer: 'Editar Cliente',
      customerFlow: 'Fluxo Cadastral',
      operations: 'Operações',
      preSale: 'Pré-venda',
      internationalRemittances: 'Remessas Internacionais',
      profitRemittances: 'Lucro / Remessas',
      exchangeClosing: 'Fechamento mensal',
      operationDetail: 'Detalhe da Operação',
      touristExchange: 'Câmbio Turismo',
      stablecoinRemittances: 'Remessas Stablecoin',
      stablecoinProfit: 'Lucro Stablecoin',
      duimpManagement: 'Gestão de DUIMP/DU-E',
      corban: 'Corban',
      commissions: 'Comissões',
      operationNatures: 'Naturezas de Operação',
      banks: 'Bancos',
      spreadCurrencies: 'Spread / Moedas',
      paymentMethods: 'Métodos de Pagamento',
      quotationApis: 'APIs de Cotação',
      templates: 'Templates',
      newTemplate: 'Novo Template',
      createTemplate: 'Cadastro de Template',
      users: 'Usuários',
      profiles: 'Perfis',
      audit: 'Auditoria',
      settings: 'Configurações',
      notifications: 'Notificações',
      emailsSent: 'E-mails Enviados',
      whatsappMessages: 'Mensagens WhatsApp',
      whatsapp: 'WhatsApp',
      newOperation: 'Nova Operação',
      myOperations: 'Minhas Operações',
      myAccount: 'Minha Conta',
      editCorban: 'Editar Corban',
      newCorban: 'Novo Corban',
      authorization: 'Autorização',
      editBank: 'Editar Banco',
      newBank: 'Novo Banco',
      editTemplate: 'Editar Template'
    }
  },

  customerAccess: {
    wallets: {
      title: 'Minhas carteiras',
      walletName: 'Carteira {position}',
      network: 'Rede {network}',
      addressHint: 'Endereço encurtado da carteira',
      available: 'Disponível',
      leaving: 'Saindo num envio',
      leavingTotal: '{amount} saindo em envios em andamento',
      totalAvailable: 'Saldo disponível total',
      totalHint: 'Soma das moedas digitais em dólar · atualizado às {time}',
      updatedAt: 'Atualizado às {time}',
      refresh: 'Atualizar',
      refreshed: 'Atualizado',
      tryAgain: 'Tentar de novo',
      viewWallets: 'Ver carteiras',
      emptyTitle: 'Nenhuma carteira ainda',
      empty: 'As carteiras aparecem aqui depois da aprovação do seu cadastro em operações digitais.',
      loadError: 'Não foi possível carregar os saldos agora. Atualize a página em alguns minutos.',
      inReviewMessage: 'Sua carteira é criada assim que o cadastro for aprovado.',
      unavailableMessage: 'Não conseguimos consultar este saldo agora. Seu dinheiro não foi afetado. Tente atualizar em alguns minutos.',
      footnote: 'Os saldos podem levar até 1 minuto para atualizar depois de uma entrada ou de um envio.',
      status: {
        ready: 'Ativa',
        inReview: 'Em análise',
        unavailable: 'Sem resposta'
      }
    },
    home: {
      greeting: 'Olá, {name}',
      myOperations: 'Minhas operações',
      noOperations: 'Nenhuma operação encontrada',
      viewOperations: 'Ver operações',
      noLimit: 'Sem limite disponível',
      noLimitDescription: 'Você não possui limite disponível em nenhum banco.',
      noLimitRequest: 'Solicite ao seu correspondente um novo limite para voltar a operar.',
      myLimits: 'Meus limites',
      newOperation: 'Realizar operação',
      loadBanksError: 'Não foi possível carregar os seus bancos e limites. Atualize a página (F5).',
      loadOperationsError: 'Não foi possível carregar as suas operações recentes. Atualize a página (F5).',
      loadPreSaleError: 'Não foi possível carregar as suas pré-vendas recentes. Atualize a página (F5).'
    },
    operations: {
      title: 'Nova operação',
      steps: {
        operationType: 'Tipo de operação',
        operationDetails: 'Detalhes da operação',
        quotation: 'Cotação',
        summary: 'Resumo',
        documents: 'Documentos da operação',
        created: 'Operação cadastrada'
      },
      buttons: {
        finish: 'Concluir',
        newOperation: 'Nova',
        next: 'Avançar',
        close: 'Fechar',
        back: 'Voltar'
      },
      quotationTimer: 'Cotação válida pelos próximos {seconds} segundos',
      loadCurrenciesError: 'Não foi possível carregar a lista de moedas. Atualize a página (F5).',
      loadCustomerError: 'Não foi possível carregar os seus dados de cliente. Atualize a página (F5).',
      loadBanksError: 'Não foi possível carregar a lista de bancos disponíveis para você. Atualize a página (F5).',
      loadQuotationError: 'Não foi possível carregar a cotação da moeda. Tente novamente.',
      loadDollarError: 'Não foi possível carregar a cotação do dólar. Tente novamente.',
      submitError: 'Não foi possível enviar a sua solicitação de operação. Confira os dados e tente novamente.',
      bankLimitExceeded: 'A operação excede o limite disponível {limit}'
    },
    account: {
      title: 'Minha Conta',
      tabs: {
        personalData: 'Dados cadastrais',
        partners: 'Sócios',
        bankAccounts: 'Dados bancários',
        documents: 'Documentos'
      },
      save: 'Salvar',
      cancel: 'Cancelar',
      unsavedConfirm: 'Todas as alterações não salvas serão perdidas, deseja continuar?',
      unsavedTitle: 'Sair sem salvar?',
      loadError: 'Não foi possível carregar os dados da sua conta. Atualize a página (F5).',
      requiredFields: 'Existem campos obrigatórios não preenchidos',
      savedSuccess: 'Informações atualizadas',
      saveError: 'Não foi possível salvar os dados da sua conta. Confira os dados e tente novamente.'
    },
    retrospective: {
      title: 'Sua retrospectiva {year}',
      bannerTitle: 'Sua retrospectiva {year}',
      bannerText: 'Veja até onde o seu dinheiro já foi neste ano.',
      open: 'Ver retrospectiva',
      yourYear: 'Seu {year}',
      moved: 'Até agora, você movimentou',
      operations: '{n} operação concluída | {n} operações concluídas',
      countries: 'Seu dinheiro chegou a {n} país | Seu dinheiro chegou a {n} países',
      noCountries: 'Seu dinheiro viajou neste ano',
      bestMonth: 'Seu maior mês até agora',
      thanks: 'Obrigado por seguir com a gente',
      thanksText: 'Vamos levar o seu dinheiro ainda mais longe.',
      next: 'Continuar'
    },
    journey: {
      received: 'Pedido recebido',
      processing: 'Processando',
      processed: 'Processado',
      done: 'Concluído'
    },
    detail: {
      sections: {
        customer: 'Cliente',
        operationNature: 'Natureza da operação',
        bankAccount: 'Conta bancária',
        intermediary: 'Intermediário',
        values: 'Valores',
        others: 'Outros'
      },
      fields: {
        code: 'Código:',
        name: 'Nome:',
        cpfCnpj: 'CPF/CNPJ:',
        bank: 'Banco:',
        agency: 'Agência:',
        account: 'Conta:',
        swift: 'SWIFT:',
        accountNumber: 'CONTA:',
        holder: 'Titular:',
        routingAba: 'ROUTING/ABA:',
        ffc: 'FFC (For Further Credit):',
        iban: 'IBAN:',
        swiftBic: 'Código Swift/BIC:',
        status: 'Status',
        bankLabel: 'Banco',
        operationDate: 'Data da operação',
        exchangeRate: 'Taxa de Câmbio:',
        iof: 'IOF:',
        ir: 'IR:',
        cide: 'CIDE:',
        tariff: 'Tarifa:',
        vet: 'VET:',
        createdAt: 'Data de criação:',
        observationLabel: 'Observação:',
        operationLabel: 'Op:'
      },
      operationTypes: {
        receive: 'Receber',
        send: 'Enviar'
      },
      back: 'Voltar',
      operationIdMissing: 'ID da operação não fornecido',
      loadError: 'Não foi possível carregar os dados da operação. Volte para a lista e abra a operação de novo.'
    },
    report: {
      title: 'Minhas operações',
      incomeTaxExtract: 'Extrato para IR',
      tabs: {
        inProgress: 'Em andamento',
        completed: 'Finalizadas'
      },
      empty: {
        inProgressTitle: 'Nenhuma operação encontrada',
        inProgressSubtitle: 'Não há operações para os filtros selecionados.',
        completedTitle: 'Nenhuma operação finalizada encontrada',
        completedSubtitle: 'Não há operações finalizadas para os filtros selecionados.'
      },
      cancelledAlert: 'Uma operação recebe o status de <b>Cancelada</b> quando não cumpre os critérios exigidos ou quando sua análise não é concluída no prazo estipulado.',
      loadOperationsError: 'Não foi possível carregar as suas operações. Atualize a página (F5).',
      searchLabel: 'Buscar operação',
      searchPlaceholder: 'Número, moeda, valor ou banco',
      loadSketchesError: 'Não foi possível carregar as suas pré-vendas. Atualize a página (F5).',
      sketchStatus: {
        cancelled: 'Cancelada',
        pending: 'Aguardando',
        inReview: 'Em análise'
      }
    },
    bankSearch: {
      placeholder: 'Digite o nome da conta bancária',
      tooltip: 'Pesquisar conta bancária'
    },
    bankCard: {
      accountName: 'Nome da conta',
      fields: {
        holder: 'Titular',
        bank: 'Banco',
        agency: 'Agência',
        checkingAccount: 'Conta corrente',
        pix: 'Pix',
        iban: 'IBAN',
        swiftBic: 'Código Swift/BIC',
        routingAba: 'Número ABA/Routing',
        ffc: 'For Further Credit'
      }
    },
    intermediaryBank: {
      title: 'Banco intermediário',
      fields: {
        country: 'País',
        bankName: 'Nome do Banco',
        swiftBic: 'Código Swift/BIC'
      }
    },
    bankLimitCard: {
      limitsAvailable: 'Limites disponíveis',
      limitAvailable: 'Limite disponível',
      inOut: 'Entrada / Saída',
      in: 'Entrada',
      out: 'Saída',
      expired: 'Vencido',
      available: 'Disponível',
      valid: 'Válido'
    },
    operationCard: {
      viewOperation: 'Visualizar operação'
    },
    filterDrawer: {
      title: 'Filtro',
      operationType: 'Tipo de Operação',
      exchangeTypes: {
        all: 'Compra/Venda',
        buy: 'Compra',
        sell: 'Venda'
      },
      statusWaiting: 'Aguardando',
      statusAnalysis: 'Em análise'
    },
    bankSelector: {
      notFound: 'Nenhum banco encontrado',
      notFoundDescription: 'Nenhum banco foi encontrado com o termo pesquisado.',
      bankLabel: 'Banco',
      limitLabel: 'Limite disponível'
    },
    exchangeRates: {
      loadError: 'Não foi possível carregar taxas de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    operationCreated: {
      title: 'Operação cadastrada',
      subtitle: 'Sua operação foi enviada para <strong>análise</strong> do seu correspondente bancário.',
      paymentData: 'Dados para pagamento',
      paymentDataSubtitle: 'Para efetivar sua operação, realize o pagamento para os dados abaixo.',
      valueToReceive: 'Valor a ser recebido',
      valueToPay: 'Valor a ser pago',
      fields: {
        cnpj: 'CNPJ',
        beneficiary: 'Favorecido'
      }
    },
    quotationPreview: {
      iofPercent: 'IOF (%)',
      irPercent: 'IR (%)',
      cidePercent: 'CIDE (%)',
      iofValue: 'Valor IOF',
      irValue: 'Valor IR',
      cideValue: 'Valor CIDE',
      vet: 'VET (Valor efetivo total)',
      tariff: 'Tarifa',
      tariffUsd: 'Tarifa ({amount})',
      valueToReceive: 'Valor a ser recebido',
      valueToPay: 'Valor a ser pago'
    },
    quotationStep: {
      valueToSend: 'Valor que desejo enviar',
      valueToReceive: 'Valor que irei receber'
    },
    resumeStep: {
      title: 'Confira as informações antes de prosseguir'
    },
    typeStep: {
      outOfHours: 'Fora do horário de operação',
      outOfHoursDescription: 'O horário para realizar esta operação online é de segunda a sexta, das {min}h às {max}h',
      outOfHoursContact: 'Por favor, tente novamente dentro deste período ou',
      outOfHoursContactLink: 'fale com a nossa equipe!',
      question: 'O que você deseja realizar ?',
      bankQuestion: 'Com qual banco deseja operar?',
      bankStatus: {
        inactive: 'Inativo',
        noLimit: 'Sem limite',
        expired: 'Expirado'
      },
      bankStatusSeparator: ' e '
    },
    detailsStep: {
      operationQuestion: 'Qual a operação pretendida?',
      operationTypeLabel: 'Tipo de operação',
      accountQuestion: 'Selecione a conta que {direction} o dinheiro',
      accountDirectionOut: 'sairá',
      accountDirectionIn: 'receberá',
      notFound: 'Nenhuma conta encontrada',
      notFoundDescription: 'Nenhuma conta foi encontrada com o termo pesquisado.'
    },
    noAccountsAlert: {
      titleNational: 'Sem conta no Brasil',
      titleInternational: 'Sem conta no exterior',
      descriptionNational: 'Você não tem uma conta no Brasil cadastrada. Cadastre uma conta para operar.',
      descriptionInternational: 'Você não tem uma conta no exterior cadastrada. Cadastre uma conta para operar.',
      registerNow: 'Cadastrar agora'
    }
  },

  stablecoin: {
    paymentStatusRetryUi: {
      approvalNeeded: 'O cliente precisa autorizar este novo envio na carteira dele. {email} Assim que ele aprovar, o pagamento sai sozinho.',
      approvalEmailSent: 'Enviamos o link para o e-mail do cliente.',
      approvalEmailPending: 'O e-mail com o link não saiu agora; o sistema tenta de novo em alguns minutos.'
    },
    remittanceApprovalPendingStatusUi: {
      label: 'Nova aprovação'
    },
    stablecoinConstantsUi: {
      accountPurpose: {
        businessExpenses: 'Despesas comerciais',
        ecommerceRetailPayments: 'Pagamentos e-commerce/varejo',
        investmentPurposes: 'Investimentos',
        receivePayments: 'Receber pagamentos por bens/serviços',
        purchaseGoods: 'Comprar bens e serviços',
        personalLiving: 'Despesas pessoais ou de vida',
        protectWealth: 'Proteger patrimônio',
        paymentsAbroad: 'Pagamentos a amigos/família no exterior',
        taxOptimization: 'Otimização fiscal',
        charitable: 'Doações beneficentes',
        thirdPartyMoneyTransmission: 'Transmissão de dinheiro a terceiros',
        payroll: 'Folha de pagamento',
        treasuryManagement: 'Gestão de tesouraria',
        other: 'Outro'
      },
      businessType: {
        soleProprietorship: 'Empresa individual',
        partnership: 'Sociedade',
        corporation: 'Corporação',
        llc: 'LLC (Sociedade de responsabilidade limitada)',
        nonProfit: 'Sem fins lucrativos',
        other: 'Outro'
      },
      businessIndustry: {
        naics111998: 'Outras Culturas Agrícolas Diversas',
        naics112120: 'Criação de Gado Leiteiro e Produção de Leite',
        naics113310: 'Extração de Madeira',
        naics115114: 'Atividades Pós-Colheita',
        naics211120: 'Extração de Petróleo Bruto',
        naics212114: 'Mineração de Carvão a Céu Aberto',
        naics213112: 'Atividades de Apoio à Exploração de Petróleo e Gás',
        naics221310: 'Abastecimento de Água e Sistemas de Irrigação',
        naics236115: 'Construção de Residências Unifamiliares Novas',
        naics236220: 'Construção de Edifícios Comerciais e Institucionais',
        naics237310: 'Construção de Rodovias, Ruas e Pontes',
        naics238210: 'Empreiteiros de Instalações Elétricas',
        naics311421: 'Conservas de Frutas e Vegetais',
        naics312130: 'Vinícolas',
        naics313110: 'Fiação de Fibras, Fios e Linhas',
        naics315990: 'Acessórios e Outros Artigos de Vestuário',
        naics322220: 'Fabricação de Sacolas de Papel e Papel Tratado',
        naics325412: 'Fabricação de Preparações Farmacêuticas',
        naics334111: 'Fabricação de Computadores Eletrônicos',
        naics334118: 'Fabricação de Terminais e Periféricos de Computadores',
        naics334210: 'Fabricação de Aparelhos Telefônicos',
        naics336110: 'Fabricação de Automóveis e Veículos Leves',
        naics336390: 'Fabricação de Outros Componentes para Veículos',
        naics337121: 'Fabricação de Móveis Residenciais Estofados',
        naics339112: 'Fabricação de Instrumentos Cirúrgicos e Médicos',
        naics339910: 'Fabricação de Joias e Artigos de Prata',
        naics339920: 'Fabricação de Artigos Esportivos',
        naics339930: 'Fabricação de Bonecas, Brinquedos e Jogos',
        naics423110: 'Atacado de Automóveis e Veículos Motorizados',
        naics423430: 'Atacado de Computadores e Periféricos',
        naics423510: 'Centros de Serviços e Atacado de Metais',
        naics423690: 'Atacado de Outros Componentes Eletrônicos',
        naics423830: 'Atacado de Máquinas e Equipamentos Industriais',
        naics423840: 'Atacado de Suprimentos Industriais',
        naics423940: 'Atacado de Joias e Pedras Preciosas',
        naics424210: 'Atacado de Medicamentos e Produtos Farmacêuticos',
        naics424410: 'Atacado de Alimentos em Geral',
        naics424480: 'Atacado de Frutas e Vegetais Frescos',
        naics424690: 'Atacado de Outros Produtos Químicos',
        naics424990: 'Atacado de Outros Bens Não Duráveis Diversos',
        naics444110: 'Lojas de Materiais para Casa e Reforma',
        naics445110: 'Supermercados e Outros Mercados',
        naics445320: 'Lojas de Bebidas Alcoólicas',
        naics446120: 'Lojas de Cosméticos, Perfumes e Produtos de Beleza',
        naics449210: 'Lojas de Eletrônicos e Eletrodomésticos',
        naics454110: 'Comércio Eletrônico e Vendas por Catálogo',
        naics455110: 'Lojas de Departamentos',
        naics455219: 'Outros Varejistas de Mercadorias em Geral',
        naics456110: 'Farmácias e Drogarias',
        naics456120: 'Varejistas de Cosméticos e Perfumes',
        naics457110: 'Postos de Combustível com Loja de Conveniência',
        naics458110: 'Lojas de Roupas e Acessórios',
        naics458210: 'Lojas de Calçados',
        naics458310: 'Joalherias',
        naics459120: 'Lojas de Hobbies, Brinquedos e Jogos',
        naics459210: 'Livrarias e Bancas de Jornal',
        naics481111: 'Transporte Aéreo Regular de Passageiros',
        naics483111: 'Transporte Marítimo de Carga Internacional',
        naics484121: 'Transporte Rodoviário de Cargas, Longa Distância',
        naics485210: 'Transporte Rodoviário Intermunicipal e Rural',
        naics488510: 'Agenciamento de Transporte de Carga',
        naics493110: 'Armazenamento e Depósito Geral',
        naics511210: 'Publicação de Software',
        naics512250: 'Produção e Distribuição de Gravações',
        naics513130: 'Editoras',
        naics513210: 'Publicação de Software',
        naics516120: 'Emissoras de Televisão',
        naics517111: 'Operadoras de Telecomunicações por Cabo',
        naics517112: 'Operadoras de Telecomunicações Sem Fio',
        naics517410: 'Telecomunicações por Satélite',
        naics518210: 'Processamento de Dados, Hospedagem e Serviços Relacionados',
        naics519130: 'Publicação e Transmissão pela Internet',
        naics519290: 'Portais de Busca e Outros Serviços de Informação',
        naics522110: 'Bancos Comerciais',
        naics522210: 'Emissão de Cartões de Crédito',
        naics522320: 'Processamento de Transações Financeiras',
        naics523150: 'Banco de Investimento e Intermediação de Valores',
        naics523940: 'Gestão de Carteiras e Consultoria de Investimentos',
        naics523999: 'Outras Atividades de Investimento Financeiro',
        naics524113: 'Seguradoras de Vida',
        naics531110: 'Locação de Imóveis Residenciais',
        naics531120: 'Locação de Imóveis Não Residenciais',
        naics531130: 'Locação de Mini-Armazéns e Self-Storage',
        naics531190: 'Locação de Outros Imóveis',
        naics531210: 'Corretores de Imóveis',
        naics531311: 'Administração de Propriedades Residenciais',
        naics531312: 'Administração de Propriedades Não Residenciais',
        naics531320: 'Avaliadores de Imóveis',
        naics531390: 'Outras Atividades Imobiliárias',
        naics532111: 'Locação de Automóveis',
        naics541110: 'Escritórios de Advocacia',
        naics541211: 'Escritórios de Contabilidade',
        naics541213: 'Serviços de Declaração de Impostos',
        naics541214: 'Serviços de Folha de Pagamento',
        naics541219: 'Outros Serviços Contábeis',
        naics541330: 'Serviços de Engenharia',
        naics541430: 'Design Gráfico',
        naics541511: 'Desenvolvimento de Software Personalizado',
        naics541512: 'Design de Sistemas de Computação',
        naics541519: 'Outros Serviços de Informática',
        naics541611: 'Consultoria em Gestão Administrativa',
        naics541618: 'Outros Serviços de Consultoria Empresarial',
        naics541715: 'Pesquisa e Desenvolvimento em Ciências',
        naics541810: 'Agências de Publicidade',
        naics541922: 'Fotografia Comercial',
        naics541930: 'Tradução e Interpretação',
        naics541940: 'Serviços Veterinários',
        naics541990: 'Outros Serviços Profissionais e Técnicos',
        naics551112: 'Holdings e Empresas de Participação',
        naics561311: 'Agências de Emprego e Recrutamento',
        naics561422: 'Telemarketing e Call Centers',
        naics561499: 'Outros Serviços de Apoio Empresarial',
        naics561510: 'Agências de Viagem',
        naics561612: 'Segurança Privada e Vigilância',
        naics561730: 'Paisagismo e Jardinagem',
        naics561740: 'Limpeza de Carpetes e Estofados',
        naics562111: 'Coleta de Resíduos Sólidos',
        naics562920: 'Reciclagem e Recuperação de Materiais',
        naics611110: 'Escolas de Ensino Fundamental e Médio',
        naics611310: 'Faculdades e Universidades',
        naics611410: 'Escolas de Negócios e Secretariado',
        naics611710: 'Serviços de Apoio Educacional',
        naics621111: 'Consultórios Médicos',
        naics621210: 'Consultórios Odontológicos',
        naics621399: 'Outros Profissionais de Saúde',
        naics621511: 'Laboratórios de Análises Clínicas',
        naics621910: 'Serviços de Ambulância',
        naics622110: 'Hospitais Gerais e Cirúrgicos',
        naics623110: 'Casas de Repouso e Enfermagem',
        naics623220: 'Centros de Saúde Mental e Reabilitação',
        naics624410: 'Creches e Educação Infantil',
        naics711110: 'Companhias de Teatro',
        naics711211: 'Times e Clubes Esportivos',
        naics711410: 'Agentes e Representantes Artísticos',
        naics711510: 'Artistas Independentes e Criadores de Conteúdo',
        naics712110: 'Museus',
        naics713110: 'Parques de Diversão e Temáticos',
        naics713210: 'Cassinos',
        naics721110: 'Hotéis e Motéis',
        naics722511: 'Restaurantes de Serviço Completo',
        naics722513: 'Restaurantes de Serviço Rápido',
        naics811111: 'Oficinas Mecânicas',
        naics811210: 'Manutenção de Equipamentos Eletrônicos',
        naics812111: 'Barbearias',
        naics812112: 'Salões de Beleza',
        naics812199: 'Outros Serviços de Cuidados Pessoais',
        naics813110: 'Organizações Religiosas',
        naics813211: 'Fundações de Financiamento e Doações',
        naics813219: 'Outros Serviços de Filantropia e Doações',
        sector11: 'Agricultura, Silvicultura, Pesca e Caça',
        sector21: 'Mineração, Extração de Petróleo e Gás',
        sector22: 'Serviços Públicos',
        sector23: 'Construção',
        sector31_33: 'Manufatura',
        sector42: 'Comércio Atacadista',
        sector44_45: 'Comércio Varejista',
        sector48_49: 'Transporte e Armazenamento',
        sector51: 'Informação',
        sector52: 'Finanças e Seguros',
        sector53: 'Imóveis e Locação',
        sector54: 'Serviços Profissionais, Científicos e Técnicos',
        sector55: 'Gestão de Empresas',
        sector56: 'Serviços Administrativos e de Apoio',
        sector61: 'Serviços Educacionais',
        sector62: 'Assistência Médica e Social',
        sector71: 'Artes, Entretenimento e Recreação'
      },
      annualRevenue: {
        lessThan100k: 'Menos de $100.000',
        moreThan10m: 'Mais de $10.000.000'
      },
      sourceOfWealth: {
        employment: 'Emprego',
        businessOwnership: 'Propriedade de negócio',
        investment: 'Investimentos',
        inheritance: 'Herança',
        realEstate: 'Imóveis',
        savings: 'Poupança',
        family: 'Família',
        other: 'Outro'
      }
    },
    customerApprovalConstantsUi: {
      messages: {
        linkNoLongerValid: 'Este link não vale mais. Se ainda precisar fazer esta operação, fale com quem enviou o link.',
        codeSent: 'Código enviado. Confira sua caixa de entrada e o spam.',
        codeWait: 'Acabamos de enviar um código. Aguarde alguns segundos antes de pedir outro.',
        codeWrong: 'Código incorreto. Confira o e-mail e digite de novo.',
        codeExpired: 'Este código venceu. Peça um novo em "Reenviar código".',
        tooMany: 'Muitas tentativas. Aguarde 10 minutos e tente de novo.',
        cancelled: 'Você não aprovou o pagamento. Quando quiser, clique em Fechar operação.',
        noConnection: 'Sem conexão com o servidor. Confira sua internet e tente de novo. (Ref.: SEM-CONEXAO)',
        debitNotConnected: 'Nenhuma conta foi conectada. A conta precisa estar no seu nome. Tente de novo ou pague por transferência.',
        quoteUpdated: 'Os valores desta operação foram atualizados. Confira os valores abaixo e clique em Fechar operação.',
        quoteUpdatedSummary: 'A cotação mudou. Clique em Continuar para ver os novos valores e aprovar de novo.',
        approvalChanged: 'A cotação mudou e a forma de aprovar também. Enviamos um novo código para o seu e-mail: digite-o para ver os novos valores e aprovar.',
        approvalChangedCodeFailed: 'A cotação mudou e a forma de aprovar também, mas não conseguimos enviar o novo código agora. Peça um novo em "reenvie o código".',
        quoteRefreshFailed: 'Não foi possível atualizar os valores da cotação agora. Antes de aprovar, clique em Atualizar valores.',
        quoteUnavailable: 'Não foi possível calcular os valores agora. Tente de novo em alguns minutos.',
        quoteRefused: 'Não foi possível calcular os valores desta operação. Fale com quem enviou este link.',
        paymentUnavailable: 'No momento não conseguimos fazer esta operação. Fale com quem enviou este link.',
        walletPreparing: 'Estamos preparando sua carteira digital. Isso pode levar alguns segundos.',
        walletNotReady: 'Não foi possível preparar sua carteira digital agora. Tente de novo em alguns minutos.',
        walletUnavailable: 'Não foi possível preparar sua carteira digital. Fale com quem enviou este link.',
        newApproval: 'Precisamos que você aprove esta operação de novo. Leva menos de um minuto.',
        notConfirmed: 'Não conseguimos confirmar sua aprovação. Clique em Fechar operação de novo.',
        generic: 'Não foi possível continuar agora. Tente de novo em instantes.',
        signing: 'Confirmando na sua carteira…'
      },
      pendingType: {
        linkSent: 'Aguardando a aprovação do cliente',
        awaitingPayment: 'Aguardando o pagamento do cliente',
        approvalRequired: 'Aguardando nova aprovação do cliente'
      },
      pendingReason: {
        expired: 'Motivo: a aprovação anterior venceu.',
        depositExpired: 'Motivo: o prazo do depósito no parceiro de pagamento venceu.',
        insufficientBalance: 'Motivo: o saldo da carteira é menor que o valor da operação.',
        amountChanged: 'Motivo: o valor da operação mudou.'
      },
      preSaleState: {
        awaitingCustomer: 'Aguardando cliente',
        approved: 'Aprovada pelo cliente',
        unknown: 'Situação indisponível'
      },
      notes: {
        escalated: 'O cliente não respondeu aos lembretes e a equipe foi avisada.'
      },
      remindResult: {
        sent: 'Lembrete enviado ao cliente.',
        failed: 'O lembrete não foi enviado. Confira o e-mail no cadastro do cliente e envie o lembrete de novo.',
        closed: 'O lembrete não foi enviado porque o link venceu ou foi cancelado. Se venceu, use "Renovar e reenviar link"; se foi cancelado, envie um link novo pela tela da operação.',
        escalated: 'O prazo dos lembretes acabou e a equipe foi avisada. Fale com o cliente ou reenvie o lembrete.',
        unknown: 'Não foi possível confirmar o envio do lembrete. Confira o histórico do link.'
      },
      reprocessOutcome: {
        queued: 'Envio retomado. A operação volta para a fila de envio nos próximos minutos.',
        alreadyRunning: 'O envio desta operação já está em andamento. Acompanhe pela linha da operação.',
        funded: 'Envio retomado.',
        fundingInProgressOrDone: 'O envio já está em andamento ou foi concluído.',
        fundingWindowExpired: 'O prazo para o envio venceu. Reenvie o lembrete para o cliente aprovar de novo.',
        noNewApproval: 'O cliente ainda não aprovou de novo, então não há o que retomar. Reenvie o lembrete.',
        unknown: 'Não foi possível confirmar a retomada do envio. Confira a situação na linha da operação.'
      },
      actionMessages: {
        renewFailed: 'Não foi possível reenviar o link. Atualize a lista para conferir a situação do link e tente de novo.',
        remindFailed: 'Não foi possível enviar o lembrete ao cliente. Confira o e-mail no cadastro do cliente e tente de novo.',
        reprocessFailed: 'Não foi possível retomar o envio ao exterior. Atualize a página para conferir a situação da operação e tente de novo.',
        pendingUnavailable: 'Não foi possível conferir quais operações aguardam nova aprovação do cliente. O restante do relatório está atualizado.'
      },
      progressStep: {
        paymentCreated: 'Dados para pagamento gerados',
        pixCreated: 'PIX gerado',
        transfer: 'Enviando ao beneficiário',
        completed: 'Concluído: valor enviado ao beneficiário',
        completedPayInOnly: 'Concluído: valor na carteira do cliente'
      },
      progressProblem: {
        emailFailed: 'O e-mail não saiu. Envie o link pelo WhatsApp.',
        linkExpired: 'O link venceu antes do pagamento. Reenvie o link pela Pré-venda.',
        linkCancelled: 'Link cancelado.',
        linkReplaced: 'Este link foi trocado por um mais novo.',
        paymentExpired: 'Os dados para pagamento não valem mais. O cliente pode gerar novos pelo mesmo link.',
        pixExpired: 'O PIX não vale mais. O cliente pode gerar outro pelo mesmo link.',
        refunded: 'Valor devolvido ao cliente.',
        transferFailed: 'O envio ao beneficiário não avançou. Veja em Relatórios Stablecoin › Remessas internacionais.'
      },
      events: {
        linkEmailed: 'Link enviado ao e-mail do cliente',
        linkEmailFailed: 'O e-mail com o link não foi enviado',
        linkOpened: 'Cliente abriu o link',
        linkExpired: 'Link venceu',
        emailMismatch: 'Tentativa de abrir o link com outro e-mail',
        codeRequested: 'Código pedido para o e-mail do cliente',
        codeVerified: 'Cliente confirmou o código do e-mail',
        codeFailed: 'Cliente digitou um código errado',
        approvalPrepared: 'Cliente conferiu os valores',
        customerApproved: 'Cliente aprovou a operação',
        approvalRequested: 'Sistema pediu nova aprovação',
        approvalExecuted: 'Valor saiu da carteira do cliente',
        approvalExpired: 'Autorização do cliente venceu',
        payinCreated: 'Pagamento gerado (PIX ou dados de transferência)',
        payoutCreated: 'Envio feito da carteira',
        providerRefused: 'O serviço de pagamento não aceitou gerar o PIX (ou os dados de transferência). A cotação foi refeita por outro e o cliente precisa aprovar os valores novos',
        payerAccountConnected: 'Cliente conectou uma conta nos EUA para o débito automático',
        debitAuthorized: 'Cliente autorizou o débito na conta nos EUA',
        reminderSent: 'Lembrete enviado por e-mail',
        reminderFailed: 'O lembrete não foi enviado',
        escalated: 'Equipe avisada porque o cliente não respondeu'
      },
      terms: {
        title: 'Termos da operação',
        approveEachTitle: 'Você aprova cada operação',
        approveEachText: 'Antes de pagar, você confere os valores e a conta de quem recebe e aprova a operação. A sua aprovação vale só para estes valores e esta operação, uma única vez.',
        checkBeforeTitle: 'Confira antes de aprovar',
        checkBeforeText: 'Você é responsável por conferir o valor, a moeda e os dados de quem recebe. Depois que o seu pagamento é confirmado, o valor é enviado ao recebedor.',
        walletTitle: 'Carteira digital',
        walletText: 'Quando a operação usa uma carteira digital no seu nome, ligada ao e-mail do seu cadastro, também enviamos um código de 6 dígitos para o seu e-mail. Só você pode autorizar a saída de valores dela: a plataforma não movimenta o saldo sozinha.',
        emailTitle: 'Cuide do seu e-mail',
        emailText: 'Quem tiver acesso ao seu e-mail consegue abrir o link e aprovar operações. Não compartilhe o código nem o link da operação com ninguém. Se perder o acesso ao e-mail, fale com quem enviou o link antes de fazer novas operações.',
        partnersTitle: 'Parceiros',
        partnersText: 'A carteira digital é fornecida pela Privy, nossa parceira de tecnologia. O pagamento e o envio do valor ao recebedor são feitos pelos parceiros de pagamento da operação.',
        recordTitle: 'Registro da sua aprovação',
        recordText: 'Guardamos a data, o horário, o endereço de internet (IP) e o navegador da sua aprovação, junto com os valores e o recebedor que você aprovou. Usamos o seu nome, e-mail e os dados da operação só para executar e registrar a operação, de acordo com a Lei Geral de Proteção de Dados (LGPD).',
        changesTitle: 'Mudanças',
        changesText: 'Se estes termos mudarem, você verá a nova versão para aceitar antes da próxima aprovação.'
      }
    },
    approvalEventFormatUi: {
      unknownEvent: 'Passo registrado',
      revokeReplaced: 'substituído por um link novo para o mesmo cliente',
      revokeOperator: 'cancelado pelo operador',
      revokePresaleRemoved: 'cancelado porque a pré-venda foi excluída',
      requirementNone: 'sem aprovação na carteira (segue direto para o PIX)',
      requirementDeposit: 'aprovação pedida depois do PIX',
      scopeCustomer: 'só para este cliente',
      scopeAll: 'para todos os clientes por alguns minutos',
      browserOnSystem: '{browser} no {system}',
      unknownBrowser: 'navegador não identificado',
      firstTime: 'primeira vez',
      typedEmail: 'e-mail digitado: {email}',
      blankEmail: 'e-mail em branco',
      byUser: 'por {name}',
      emailMismatchNote: 'Houve 1 tentativa de abrir o link com outro e-mail. | Houve {count} tentativas de abrir o link com outro e-mail.',
      reminderNote: '1 lembrete enviado ao cliente. | {count} lembretes enviados ao cliente.'
    },
    stablecoinFormattersUi: {
      status: {
        deprecated: 'Depreciado',
        complianceRequest: 'Revisão de compliance pendente',
        partiallyRejected: 'Aprovação parcial pendente',
        active: 'Ativa',
        inactive: 'Inativa',
        verified: 'Verificada',
        accepted: 'Aceito',
        linked: 'Vinculado',
        expired: 'Expirado'
      }
    },
    digitalQuotationConstantsUi: {
      walletPreparing: 'Preparando a carteira digital do cliente. Isso pode levar alguns segundos…',
      walletGaveUp: 'Não foi possível preparar a carteira do cliente agora. Tente de novo em alguns minutos.',
      autoRenewStopped: 'A cotação venceu e não é mais renovada sozinha. Para continuar, clique em Nova cotação.',
      providerRefusedPayin: 'O provedor não aceitou este pagamento agora. A cotação foi refeita por outro: confira os valores e gere de novo.',
      providerRefusedPayout: 'O provedor não aceitou este pagamento agora. A cotação foi refeita por outro: confira os valores e envie de novo.'
    },
    payoutOnlyFlowUi: {
      loadingBalance: 'Consultando o saldo da carteira...',
      balanceUnavailable: 'Saldo da carteira indisponível agora — confira na cotação',
      noBalance: 'Carteira sem saldo. Faça antes uma entrada na aba Pay-in',
      availableBalance: 'Saldo disponível: {balances}'
    },
    paymentStatusBankAccountCardUi: {
      swiftCode: 'Swift/BIC Code'
    },
    paymentStatusDetailsUi: {
      provider: 'Provider',
      payOutBlocked: 'Saída travada para conferência. Esta saída não será enviada de novo até a conferência da equipe.'
    },
    stablecoinLimitsDialogUi: {
      operationNumber: 'Operação #{id}'
    },
    pixPaymentPanelUi: {
      transferFallback: 'transferência'
    },
    customerOperationApprovalUi: {
      secureEnvironment: 'Ambiente seguro',
      brandBy: 'by {name}',
      processedByProvider: 'Pagamento processado pela PSAV autorizada {provider}',
      linkUnavailable: 'Link indisponível',
      linkValidUntil: 'Link válido até {date}',
      copyUnavailable: 'Não deu para copiar automaticamente. Deixamos o código selecionado: toque nele e escolha Copiar.',
      paymentDone: 'Pagamento feito',
      pageTitle: 'Confirmar operação'
    },
    receiverPendingIssuesModalUi: {
      pathWithProblem: '{path} com problema.'
    },
    operationDetail: {
      loadErrorTitle: 'Não foi possível carregar a operação',
      loadErrorMessage: 'Não foi possível carregar os dados da operação #{id}.',
      operationTitle: 'Operação #{id}',
      buy: 'Compra',
      sell: 'Venda',
      relaunch: 'Relançar operação',
      changeHistoryTitle: 'Alterações na operação',
      loadError: 'Os dados da operação não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      changeHistoryError: 'Não foi possível carregar as alterações da operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },

    tosCallback: {
      processing: 'Processando aceite dos termos...',
      redirecting: 'Aguarde, você será redirecionado automaticamente.'
    },

    approval: {
      // Pay-in pelo link: compra de USDC para a carteira do cliente
      payIn: {
        summarySubtitle: 'Compra de USDC para a sua carteira. Confira antes de continuar.',
        summaryCaption: 'Você recebe em {currency} na sua carteira. A quantia exata aparece no próximo passo, com a cotação.',
        youReceive: 'Você recebe na sua carteira',
        walletLabel: 'Sua carteira',
        walletOwner: 'Em seu nome. Só você movimenta.',
        approveTitle: 'Confirme a compra',
        approveSubtitle: 'Confira quanto você paga e quanto entra na sua carteira.',
        confirmButton: 'Confirmar compra',
        authorizationText: 'Ao confirmar, geramos o PIX. Quando ele for pago, os USDC entram na sua carteira. Nenhuma assinatura na carteira é necessária, porque o dinheiro só entra nela.',
        transferAuthorizationText: 'Ao confirmar, mostramos os dados para você pagar. Quando o pagamento for confirmado, os USDC entram na sua carteira. Nenhuma assinatura na carteira é necessária, porque o dinheiro só entra nela.',
        estimate: 'Você recebe cerca de {amount} na sua carteira. A quantia exata aparece no próximo passo, com a cotação atualizada.',
        debitAuthorizationText: 'Ao confirmar, pedimos o débito ao seu banco. Quando o valor chegar, os USDC entram na sua carteira. Nenhuma assinatura na carteira é necessária, porque o dinheiro só entra nela.',
        pixDestination: 'Depois do pagamento, {amount} entram na sua carteira.',
        stageProcessingMessage: 'Estamos comprando os seus USDC. Eles entram na sua carteira em instantes. Você pode fechar esta página: avisamos por e-mail quando terminar.',
        stageDelayed: 'Compra em andamento',
        stageDelayedMessage: 'Seu pagamento já foi recebido, mas a compra está levando mais tempo que o normal. Você não precisa fazer nada: avisamos por e-mail quando os USDC entrarem na sua carteira.',
        stageDone: 'USDC na sua carteira',
        stageDoneMessage: 'A compra foi concluída e o valor já está na sua carteira. Você não precisa fazer mais nada.',
        valueCredited: 'USDC na sua carteira',
        received: 'Você recebeu',
        paid: 'Você pagou'
      },
      payOut: {
        summarySubtitle: 'Envio da sua carteira para a conta abaixo. Confira antes de continuar.',
        youSend: 'Sai da sua carteira',
        approveTitle: 'Confirme o envio',
        approveSubtitle: 'Confira quanto sai da sua carteira e quanto chega na conta.',
        confirmButton: 'Confirmar envio',
        authorizationText: 'Ao confirmar, autorizamos este envio da sua carteira para a conta acima, nestes valores. Depois de enviado, ele não pode ser desfeito por aqui.',
        approved: 'Envio aprovado',
        stageProcessing: 'Envio aprovado',
        received: 'Chegou na conta',
        sent: 'Saiu da sua carteira',
        stageProcessingMessage: 'Estamos enviando o valor para a conta de destino. Você pode fechar esta página.',
        stageDelayed: 'Envio em andamento',
        stageDelayedMessage: 'O envio está levando mais tempo que o normal. Quem enviou este link acompanha e fala com você se precisar de algo.',
        stageDoneMessage: 'O valor foi enviado para a conta de destino. Você não precisa fazer mais nada.'
      },
      enterCode: 'Digite o código',
      approvePayment: 'Aprove o pagamento',
      emailLabel: 'Seu e-mail',
      termsLink: 'termos da operação',
      paymentValue: 'Valor a pagar',
      steps: {
        code: 'Código',
        sign: 'Assinar',
        summary: 'Resumo',
        status: 'Status'
      },
      stepsAriaLabel: 'Etapas',
      stepReview: 'Conferir',
      stepConfirm: 'Confirmar',
      stepPay: 'Pagar',
      codeSentTo: 'Enviamos um código de 6 dígitos para {email}.',
      codeAriaLabel: 'Código de 6 dígitos',
      notReceived: 'Não recebeu? Confira o spam ou',
      resendIn: 'reenvie em {seconds}s',
      resendCode: 'reenvie o código',
      approveSubtitle: 'Confira quanto você paga, quanto chega e para quem vai.',
      youPay: 'Você paga',
      recipientReceives: 'Destinatário receberá',
      operationAmount: 'Valor da operação',
      quoteNotUpdated: 'Cotação das {time} · não atualizada',
      quoteCaptionSimple: 'Cotação das {time}',
      quoteCaptionWithRefresh: 'Cotação das {time} · {refresh}',
      refreshing: 'atualizando...',
      refreshesIn: 'atualiza em {time}',
      authorizationText: 'Ao aprovar, você autoriza esta operação uma única vez, só com estes valores.',
      transferAuthorizationText: 'Ao aprovar, você autoriza esta operação só com estes valores. A autorização vence no prazo da operação.',
      updateValues: 'Atualizar valores',
      notNow: 'Agora não',
      recipientFields: {
        bank: 'Banco',
        routing: 'ABA/Routing',
        swift: 'Swift/BIC',
        account: 'Conta',
        iban: 'IBAN',
        accountOrIban: 'Conta/IBAN',
        accountType: 'Tipo de conta',
        accountClass: 'Tipo de conta',
        ffc: 'FFC',
        intermediary: 'Banco intermediário',
        ifsc: 'IFSC da agência',
        sortCode: 'Sort code',
        speiClabe: 'CLABE',
        speiDebitCard: 'Cartão de débito',
        speiPhone: 'Celular',
        institutionCode: 'Código da instituição',
        transfersType: 'Tipo de conta',
        transfersAccount: 'Conta',
        bankCode: 'Código do banco',
        document: 'Documento',
        pixKey: 'Chave PIX',
        agency: 'Agência',
        nationalAccount: 'Conta'
      },
      accountTypes: {
        checking: 'Conta corrente',
        savings: 'Poupança',
        individual: 'Individual',
        business: 'Empresarial'
      },
      transferMethods: {
        pix: 'PIX',
        wire: 'Wire (EUA)',
        ach: 'ACH (EUA)',
        rtp: 'RTP (EUA)',
        sepa: 'SEPA (Europa)',
        faster_payments: 'Faster Payments (Reino Unido)',
        international_swift: 'SWIFT internacional',
        spei: 'SPEI (México)',
        transfers_3: 'Transfers 3.0 (Argentina)',
        ach_colombia: 'ACH (Colômbia)'
      },
      closeOperation: 'Fechar operação',
      payerAccountNotice: 'O pagamento precisa ser feito a partir de uma conta em nome do titular da operação:',
      greeting: 'Olá',
      greetingNamed: 'Olá, {name}',
      summarySubtitle: 'Confira os dados da sua operação antes de continuar.',
      recipientWillReceive: 'Destinatário receberá',
      yourEmail: 'Seu e-mail',
      emailHint: 'Use o e-mail do seu cadastro.',
      emailHintWithKnown: 'E-mail do cadastro: {email}',
      acceptTermsText: 'Li e aceito os',
      continueButton: 'Continuar',
      fetchingQuote: 'Buscando a cotação atualizada…',
      invalidEmail: 'Digite um e-mail válido.',
      stagePix: 'Preparando o seu PIX',
      stagePayment: 'Preparando o seu pagamento',
      stageProcessing: 'Pagamento recebido',
      stageDelayed: 'Envio em andamento',
      stageRefunded: 'Valor devolvido',
      stageDone: 'Operação concluída',
      stagePixMessage: 'Estamos preparando o seu PIX. Em instantes o código aparece aqui.',
      stagePaymentMessage: 'Estamos preparando os dados para o seu pagamento. Em instantes eles aparecem aqui.',
      stageProcessingMessage: 'Estamos enviando o valor ao recebedor. Você pode fechar esta página: avisamos por e-mail quando terminar.',
      stageDelayedMessage: 'Seu pagamento já foi recebido, mas o envio ao recebedor está levando mais tempo que o normal. Você não precisa fazer nada: avisamos por e-mail quando o valor chegar.',
      stageRefundedMessage: 'O valor que você pagou foi devolvido para você. Esta operação não vai seguir: para fazer uma nova, fale com quem enviou este link.',
      stageDoneMessage: 'O valor foi enviado ao recebedor. Você não precisa fazer mais nada.',
      generatePix: 'Gerar o PIX',
      generatePayment: 'Gerar os dados de pagamento',
      estimateReceive: 'O destinatário recebe cerca de {amount}. O valor exato aparece no próximo passo, com a cotação atualizada.',
      fxToleranceNote: 'Em {currency}, o valor que chega ao destinatário pode ficar até {currency} 0,99 abaixo do combinado, pela variação do câmbio até o envio.',
      estimatePay: 'Você paga cerca de {amount}. O valor exato aparece no próximo passo, com a cotação atualizada.',
      pixPaid: 'PIX pago',
      journeyConfirmed: 'Operação confirmada',
      journeySending: 'Enviando',
      journeySent: 'Enviado',
      journeyBuying: 'Compra do USDC',
      journeyDelivered: 'Entregue',
      journeyInWallet: 'Na sua carteira',
      journeyReceived: 'O recebedor recebeu',
      valueSent: 'Valor enviado ao recebedor',
      valueRefunded: 'Valor devolvido a você',
      termsClose: 'Fechar',
      termsAccept: 'Li e aceito',
      payWithMethod: 'Pague com {method}',
      // Débito automático (ACH pull): o valor sai da conta do cliente nos EUA, conectada por ele
      debit: {
        methodLabel: 'ACH (débito automático)',
        title: 'Como você quer pagar?',
        debitOption: 'Débito automático',
        debitHint: 'Nós puxamos o valor direto da sua conta nos EUA, sem transferência. Cada débito tem uma taxa de US$ 1,00, somada ao valor que você paga.',
        transferOption: 'Transferência bancária (ACH)',
        transferHint: 'Você mesmo transfere pelo app do seu banco, com os dados e o código que mostramos no fim.',
        accountLabel: 'Conta que vai pagar',
        accountText: '{bank} final {last4}',
        bankFallback: 'Conta nos EUA',
        accountTypes: { checking: 'Conta corrente', savings: 'Conta poupança' },
        noAccount: 'Nenhuma conta conectada ainda. Conecte a sua para pagar por débito.',
        connect: 'Conectar conta nos EUA',
        connectAnother: 'Conectar outra conta',
        secureHint: 'Você entra no seu banco pelo site seguro do nosso parceiro. Não vemos nem guardamos a sua senha.',
        refused: 'Seu banco não autorizou o débito e nenhum valor saiu da sua conta. Escolha outra conta ou pague por transferência.',
        unavailable: 'O débito automático não está disponível no momento. Pague por transferência bancária (ACH).',
        authorization: 'Autorizo debitar {amount} da minha conta {account} uma única vez, só para esta operação e com estes valores.',
        requestedTitle: 'Débito solicitado ao seu banco',
        requestedSubtitle: 'Você não precisa fazer mais nada. Avisamos por e-mail quando o valor chegar.',
        waiting: 'Aguardando o banco liberar o valor',
        receiptBank: 'Banco',
        receiptAccount: 'Conta',
        receiptAmount: 'Valor pedido',
        receiptRequestedAt: 'Pedido em',
        fee: 'Taxa do débito automático',
        feeHint: 'Cobrada em todo débito automático. Já está somada ao valor acima.'
      },
      pixInstructions: 'No app do seu banco, use PIX Copia e Cola ou escaneie o QR Code.',
      pixValidFor: 'Válido por {time}',
      copiedCode: 'Código copiado',
      copyPixCode: 'Copiar código PIX',
      generateNewPix: 'Gerar novo PIX',
      qrCodeAriaLabel: 'QR Code do PIX',
      pixTimerAriaLabel: 'Tempo restante do PIX',
      pixWaiting: 'Aguardando o pagamento do PIX',
      paymentWaiting: 'Aguardando o pagamento. Assim que ele for confirmado, esta tela muda sozinha.',
      pixExpired: 'Este PIX venceu. Gere um novo para pagar.',
      pixUnavailable: 'Este PIX não está mais disponível. Gere um novo para pagar.',
      progressTitle: 'Andamento do link',
      progressUnavailable: 'Não foi possível carregar o andamento agora. Vamos tentar de novo em instantes.',
      progressUpdatedAt: 'Atualizado às {time}',
      viewOperation: 'Ver operação',
      confirmSend: 'Confirme o envio',
      sendAnyway: 'Enviar mesmo assim',
      doNotSend: 'Não enviar',
      linkSentToCustomer: 'Link enviado ao cliente',
      copyLink: 'Copiar link',
      linkCopied: 'Link copiado',
      openLink: 'Abrir link',
      historyTitle: 'Histórico do link',
      historyUnavailable: 'Não foi possível carregar o histórico agora. Feche e abra de novo em instantes.',
      historyEmpty: 'Nenhum passo registrado neste link ainda.',
      historyAndProgressTitle: 'Andamento e histórico do link de {name}',
      historyAndProgressTitleGeneric: 'Andamento e histórico do link',
      linkValid: 'Link válido',
      linkCancelled: 'Link cancelado',
      linkExpired: 'Link vencido',
      pixNumber: 'Pagamento nº {id}',
      recipientLabel: 'Recebedor',
      transferType: 'Tipo de transferência',
      pixKeyLabel: 'Chave PIX',
      accountLabel: 'Conta',
      bankLabel: 'Banco',
      accountEnding: 'final {ending}',
      loadingLink: 'Gerando o link…',
      loadingLinkText: 'Estamos criando o link da operação e enviando ao e-mail do cliente. Leva alguns segundos.',
      errorLinkTitle: 'O link não foi gerado',
      linkGeneratedTitle: 'Link gerado',
      renewingLink: 'Reenviando o link…',
      renewingLinkText: 'Estamos renovando o prazo e enviando o link ao e-mail do cliente. Leva alguns segundos.',
      errorLinkRenewTitle: 'O link não foi reenviado',
      linkRenewedTitle: 'Prazo do link renovado',
      trackingHintWithProgress: 'Você pode fechar esta janela e acompanhar depois pelo botão "Ver andamento" ou pela Pré-venda.',
      trackingHintWithoutProgress: 'Acompanhe a aprovação em Pré-venda, na aba Operações Stablecoin.'
    },

    paymentStatus: {
      title: 'Status do Pagamento',
      payin: 'Entrada',
      payout: 'Saída',
      retry: 'Tentar novamente'
    },
    limits: {
      title: 'Meus Limites',
      increaseTitle: 'Solicitar Aumento de Limite',
      pendingIncrease: 'Solicitação pendente',
      rejectedIncrease: 'Solicitação recusada'
    },
    documents: {
      checklistTitle: 'Documentos necessários',
      analysisTitle: 'Análise de documentos'
    },
    provider: {
      choiceTitle: 'Escolher provedor',
      linkOnly: 'Vincular apenas',
      unknown: 'Desconhecido'
    },
    tos: {
      title: 'Termos de serviço',
      successTitle: 'Termos aceitos'
    },
    validation: {
      reactivateTitle: 'Reativar cadastro'
    },
    rfi: {
      title: 'Documentação adicional solicitada',
      removeFile: 'Remover arquivo'
    },
    // Modal único de pendência do provedor (TC-1727)
    providerPending: {
      // Códigos de recusa da UnblockPay (Sumsub): explicação no lugar do texto em inglês
      rejectionCodes: {
        INVALID_DOCUMENT: 'Documento inválido.',
        BAD_QUALITY: 'Imagem ruim ou ilegível.',
        LOW_QUALITY: 'Imagem ruim ou ilegível.',
        BLURRY: 'Imagem ruim ou ilegível.',
        EXPIRED: 'Documento vencido.',
        EXPIRED_DOCUMENT: 'Documento vencido.',
        EXPIRATION_DATE: 'Documento vencido.',
        DATA_MISMATCH: 'Os dados não batem com o cadastro.',
        REQUESTED_DATA_MISMATCH: 'Os dados não batem com o cadastro.',
        COMPANY_DATA_MISMATCH: 'O nome da empresa no documento não bate com o da ficha; confira a razão social.',
        SELFIE_MISMATCH: 'A selfie não confere com o documento.',
        BAD_FACE_MATCHING: 'A selfie não confere com o documento.',
        WRONG_ADDRESS: 'O endereço não confere.',
        FRAUDULENT: 'Documento recusado por suspeita de fraude.',
        BAD_PROOF_OF_ADDRESS: 'Comprovante de endereço não aceito: precisa ser de um tipo aceito, em nome do cliente e emitido nos últimos 3 meses.',
        GRAPHIC_EDITOR: 'Imagem editada: envie foto ou PDF original do documento, sem edição.',
        UNSATISFACTORY_PHOTOS: 'Foto sem qualidade: envie uma foto nítida e colorida do documento original.',
        SCREENSHOTS: 'Captura de tela não é aceita: envie o documento original.',
        BLACK_AND_WHITE: 'Cópia em preto e branco não é aceita: envie o documento colorido.',
        INCOMPLETE_DOCUMENT: 'Documento incompleto: envie todas as páginas e lados.',
        DOCUMENT_PAGE_MISSING: 'Documento incompleto: envie todas as páginas e lados.',
        FRONT_SIDE_MISSING: 'Falta a frente do documento.',
        BACK_SIDE_MISSING: 'Falta o verso do documento.',
        DOCUMENT_DAMAGED: 'Documento danificado ou ilegível.',
        NOT_DOCUMENT: 'O arquivo enviado não é o documento pedido.',
        BAD_PROOF_OF_IDENTITY: 'Documento de identidade não aceito.',
        BAD_SELFIE: 'Selfie não aceita: tire uma nova, com o rosto inteiro e bem iluminado.',
        INCOMPATIBLE_LANGUAGE: 'Documento em idioma não aceito: envie uma tradução.'
      },
      title: 'Cadastro em {provider}',
      titleFallback: 'Cadastro no provedor',
      close: 'Fechar',
      tryAgain: 'Tentar de novo',
      loadError: 'Não foi possível abrir o cadastro no provedor agora. Tente de novo em instantes.',
      actionError: 'Não foi possível concluir agora. Tente de novo em instantes.',
      operationsEnabled: 'Operações liberadas',
      steps: {
        sent: 'Cadastro enviado',
        request: 'Pendências',
        review: 'Em análise',
        result: 'Resultado'
      },
      actions: {
        respond: 'Responder ao provedor',
        submit: 'Enviar resposta ao provedor',
        saveAndSend: 'Salvar e enviar ao provedor',
        retry: 'Tentar de novo agora',
        retryWithTerms: 'Enviar de novo ao provedor',
        reonboard: 'Ver o motivo e recadastrar',
        refetch: 'Buscar o pedido de novo',
        copyLink: 'Copiar link para o cliente',
        openLink: 'Abrir o link'
      },
      itemStatus: {
        ready: 'Pronto',
        missing: 'Falta',
        optional: 'Opcional',
        error: 'Corrigir',
        withCustomer: 'Com o cliente'
      },
      notices: {
        requestChanged: 'O pedido mudou no provedor. Atualizamos a tela.',
        validationFailed: 'O provedor não aceitou a resposta. Nada foi enviado.',
        localCheck: 'A conferência do cadastro apontou:',
        errorDetail: 'O sistema registrou:'
      },
      form: {
        progress: '{ready} de {total} pedidos prontos',
        progressAria: 'Progresso da resposta ao provedor',
        archiveNotice: 'Os arquivos anexados também ficam na ficha do cliente, no tipo de documento correspondente ou em "Outros", com o nome do item.',
        missing: 'Falta preencher: {items}',
        allReady: 'Tudo pronto para enviar.',
        fixInFormFirst: 'Corrija na ficha os itens acima (botão Preencher na ficha) e depois envie.'
      },
      list: {
        headerRespond: 'O que responder',
        headerResolve: 'O que resolver',
        countOne: '1 pedido',
        countMany: '{count} pedidos',
        countWithTemplates: '{count} · {templates} com modelo para preencher',
        hasTemplate: 'Tem modelo para preencher',
        providerReason: 'Motivo do provedor: {reason}'
      },
      item: {
        providerMessage: 'Mensagem do provedor: {message}',
        reasonLabel: 'Motivo:',
        providerTextLabel: 'Texto do provedor:',
        fillInForm: 'Preencher na ficha',
        downloadTemplate: 'Baixar o modelo do provedor',
        linkCopied: 'Link copiado',
        copyFailed: 'Não foi possível copiar o link. Selecione e copie manualmente.',
        optionalSuffix: '{label} · opcional',
        patternInvalid: 'Formato não aceito pelo provedor',
        genericLabel: 'Informação pedida'
      },
      question: {
        liveness: {
          title: 'Verificação de vida',
          guidance: 'O cliente precisa abrir o link e fazer a verificação de vida. Copie o link e envie a ele. Depois que ele concluir, registre aqui e envie a resposta ao provedor.',
          answerLabel: 'Confirmação de que o cliente concluiu a verificação'
        },
        sourceOfFunds: {
          title: 'Origem dos recursos',
          guidance: 'Envie documentos que mostrem de onde vêm os recursos, como extratos bancários, demonstrações financeiras ou declaração de imposto. O texto do provedor abaixo diz o período e os documentos aceitos.'
        },
        idDocument: {
          title: 'Documento de identidade',
          guidance: 'Envie o documento de identidade pedido. O texto do provedor abaixo diz de quem é e o que corrigir.'
        },
        proofOfAddress: {
          title: 'Comprovante de endereço',
          guidance: 'Envie um comprovante de endereço recente. O texto do provedor abaixo diz em nome de quem ele deve estar e o que corrigir.'
        },
        relationship: {
          title: 'Relação com a empresa',
          guidance: 'Explique a relação citada pelo provedor no texto abaixo.'
        },
        shareholderRegistry: {
          title: 'Quadro de sócios',
          guidance: 'Envie o documento com os sócios da empresa e a participação de cada um.'
        },
        businessRegistration: {
          title: 'Registro da empresa',
          guidance: 'Envie o documento de registro da empresa, como o contrato social. O texto do provedor abaixo diz qual empresa e o que é exigido.'
        },
        website: {
          title: 'Site da empresa',
          guidance: 'Responda sobre o site da empresa conforme o texto do provedor abaixo.'
        },
        accountPurpose: {
          title: 'Finalidade da conta',
          guidance: 'Explique como o cliente vai usar a conta, conforme o texto do provedor abaixo.'
        },
        additionalMedia: {
          title: 'Presença on-line',
          guidance: 'Informe outros canais do cliente, como site ou redes sociais, conforme o texto do provedor abaixo.'
        },
        labels: {
          answer: 'Sua resposta',
          supportingDocuments: 'Documentos de apoio',
          explanation: 'Explicação',
          idDocumentType: 'Tipo de documento',
          idDocumentFile: 'Arquivo do documento',
          documentFront: 'Frente do documento',
          documentBack: 'Verso do documento',
          proofOfAddressType: 'Tipo de comprovante',
          proofOfAddressFile: 'Arquivo do comprovante',
          shareholderRegistryDocuments: 'Documentos do quadro de sócios',
          businessRegistrationDocuments: 'Documentos de registro da empresa'
        },
        options: {
          BANK_STATEMENT: 'Extrato bancário',
          DRIVERS_LICENSE: 'Carteira de motorista',
          GOVERNMENT_LETTER: 'Correspondência do governo',
          LEASE_AGREEMENT: 'Contrato de aluguel',
          NATIONAL_ID: 'Documento de identidade',
          PASSPORT: 'Passaporte',
          UTILITY_BILL: 'Conta de consumo'
        }
      },
      history: {
        title: 'Histórico com o provedor',
        requested: 'O provedor pediu mais informações',
        submitted: 'Resposta enviada ao provedor',
        cancelled: 'O provedor cancelou o pedido',
        expired: 'O prazo para responder venceu',
        approved: 'O provedor aprovou o cadastro'
      },
      rejection: {
        reasonLabel: 'Motivo do provedor:',
        reasonMissing: 'O provedor não informou o motivo.',
        checkBefore: 'Antes de recadastrar, confira:',
        checkDocument: 'Documento de identidade legível e dentro da validade (frente e verso)',
        checkSelfie: 'Selfie clara, ao vivo, em ambiente iluminado',
        checkAddress: 'Comprovante de endereço dos últimos 3 meses',
        checkData: 'Dados da ficha iguais aos do documento (nome, CPF, data de nascimento)'
      },
      technical: {
        title: 'Detalhes para o suporte',
        reference: 'Referência',
        attempts: 'Tentativas',
        firstAttempt: 'Primeira tentativa',
        lastAttempt: 'Última tentativa'
      },
      messages: {
        retried: 'Envio retomado',
        refetched: 'Pedido atualizado',
        submitted: 'Resposta enviada ao provedor',
        fixHint: 'Corrija os campos aqui ou na ficha. Ao salvar a ficha, o cadastro vai de novo ao provedor.',
        saved: 'Informações salvas. O cadastro vai de novo ao provedor.',
        reonboarded: 'Novo cadastro enviado ao provedor.',
        reonboardError: 'Não foi possível refazer o cadastro agora. Tente de novo em instantes.',
        reonboardUnavailable: 'Este provedor não permite refazer o cadastro pelo sistema. Corrija a ficha e fale com o suporte.'
      },
      chip: {
        requestDescription: 'Pedido do provedor',
        requestHint: 'Itens para responder',
        requestApprovedHint: 'Operações liberadas',
        requestApprovedUntil: 'Operações liberadas · responder até {day}',
        requestUntil: 'Responder até {day}',
        fixDescription: 'Pendência',
        fixHint: 'Itens para resolver',
        providerErrorHint: 'O provedor não respondeu'
      },
      kanban: {
        dataToFixTitle: 'Cadastro com dados para corrigir',
        dataToFixHint: 'Ao salvar a ficha corrigida, o cadastro vai de novo ao provedor.',
        requestExpired: 'O prazo do pedido do provedor venceu em {day}',
        requested: 'O provedor pediu mais informações',
        respondUntil: 'Responder até {day}.',
        rejectedFinal: 'O provedor recusou o cadastro de forma definitiva',
        rejected: 'O provedor recusou o cadastro',
        requestNotLoaded: 'O pedido do provedor não carregou',
        providerNoResponse: 'O provedor não respondeu ao envio',
        providerGeneric: 'Pendência com o provedor',
        bankGeneric: 'Pendência junto ao banco'
      },
      timeline: {
        requestOpened: 'O provedor pediu mais informações',
        responseSent: 'Resposta enviada ao provedor',
        requestExpired: 'O prazo do pedido do provedor venceu',
        requestCancelled: 'O provedor cancelou o pedido',
        requestClosedApproved: 'O provedor aprovou o cadastro e fechou o pedido',
        rejected: 'O provedor recusou o cadastro',
        dataToFix: 'Cadastro com dado para corrigir',
        requestNotLoaded: 'O pedido do provedor não carregou',
        providerError: 'O provedor não respondeu ao envio',
        issueResolved: 'Pendência resolvida',
        respondUntil: 'Responder até {day}',
        attempts: '{count} tentativas',
        respondedBy: 'Respondido por: {author}'
      },
      files: {
        defaultRfiMessage: 'O provedor pediu mais informações sobre o cadastro deste cliente.',
        upTo: 'Até {max} arquivos',
        invalidType: 'O arquivo "{name}" não é aceito. Envie PDF, JPG ou PNG.',
        tooLarge: 'O arquivo "{name}" passa de {max} MB. Envie um arquivo menor.'
      }
    },
    receiver: {
      pendingIssuesTitle: 'Pendências do cadastro'
    },

    paymentStatusModal: {
      title: 'Status de pagamentos',
      loading: 'Carregando pagamentos...',
      close: 'Fechar',
      clientPaid: 'Cliente pagou',
      clientReceived: 'Cliente recebeu',
      unknown: 'Desconhecido',
      notAvailable: 'N/A',
      paymentById: 'Pagamento #{id}',
      paymentByIndex: 'Pagamento {index}',
      receiptById: 'Recebimento #{id}',
      receiptByIndex: 'Recebimento {index}',
      boletoPayById: 'Pagamento de boleto #{id}',
      pixPayById: 'Pagamento de PIX #{id}',
      returnedToCustomer: 'Devolvido ao cliente',
      statusPayIn: {
        pending: 'Pendente',
        processing: 'Processando',
        completed: 'Liquidado',
        failed: 'Não concluído',
        expired: 'Expirado',
        cancelled: 'Cancelado',
        ignored: 'Ignorado',
        refunded: 'Reembolsado',
        onHold: 'Em Espera',
        awaitingDeposit: 'Aguardando pagamento'
      },
      statusPayOut: {
        pending: 'Pendente',
        approvalRequired: 'Aprovação Necessária',
        approved: 'Aprovado',
        processing: 'Processando',
        completed: 'Liquidado',
        failed: 'Não concluído',
        cancelled: 'Cancelado',
        ignored: 'Ignorado',
        refunded: 'Reembolsado',
        onHold: 'Em Espera',
        awaitingDeposit: 'Aguardando envio da carteira'
      }
    },

    paymentStatusPayIn: {
      paymentMethod: 'Método de Pagamento',
      pixCode: 'Código PIX',
      paymentDate: 'Data de Pagamento',
      completedDate: 'Data de Conclusão',
      transactionHash: 'Hash da Transação',
      pixCopied: 'Código PIX copiado!',
      pixNotCopied: 'O código PIX não foi copiado. Selecione o código e copie manualmente (Ctrl+C).',
      arsTransferRefunded: 'O valor voltou para a conta de origem. No peso argentino isso acontece quando a transferência sai de uma conta de outro CUIT/CUIL ou chega depois do prazo do pagamento. Confira com o cliente de qual conta ele pagou.'
    },

    paymentStatusPayOut: {
      receiptDate: 'Data de Recebimento',
      completedDate: 'Data de Conclusão',
      transactionHash: 'Hash da Transação',
      quoteDescription: 'Descrição da Cotação',
      returnedAlert: 'O valor foi devolvido ao cliente. Esta saída não será enviada de novo.',
      retryButton: 'Reenviar pagamento em {currency}'
    },

    paymentStatusBankAccount: {
      title: 'Dados da Conta Bancária',
      accountName: 'Nome da Conta',
      type: 'Tipo',
      accountNumber: 'Número da Conta',
      beneficiaryName: 'Nome do Beneficiário'
    },

    paymentStatusTracking: {
      imad: 'Código de rastreio (IMAD)',
      uetr: 'Código de rastreio (UETR)'
    },

    paymentStatusRetry: {
      title: 'Novo pagamento',
      amountLabel: 'Valor',
      accountLabel: 'Conta para recebimento',
      noAccount: 'Nenhuma conta disponível',
      quoteLabel: 'Cotação do PayOut',
      execute: 'Executar',
      cancel: 'Cancelar',
      loadError: 'As contas do cliente não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      retryError: 'O novo envio não foi feito. Confira a conta de destino e tente novamente; se continuar, fale com o suporte.'
    },

    receiverPendingIssues: {
      title: 'Pendências com o banco',
      loading: 'Carregando pendências...',
      retry: 'Tentar novamente',
      noIssues: 'Nenhuma pendência encontrada para este cliente.',
      noIssuesCaption: 'O cliente não possui pendências relacionadas ao cadastro no banco digital.',
      customerLabel: 'Cliente',
      bankLabel: 'Banco',
      pendingFieldsTitle: 'Campos a corrigir',
      firstAttempt: 'Primeira tentativa',
      lastAttempt: 'Última tentativa',
      instructionRfi: 'O banco pediu mais informações. Envie a resposta para o cadastro voltar à análise.',
      instructionFix: 'Após corrigir e salvar o cliente, o cadastro será reenviado automaticamente ao banco digital.',
      answerBank: 'Responder ao banco',
      resendToBank: 'Reenviar ao banco',
      resendToBankTooltip: 'Reenviar cadastro ao banco para nova análise',
      fixPending: 'Corrigir pendências',
      close: 'Fechar',
      noCustomer: 'Selecione um cliente para visualizar pendências.',
      loadError: 'As pendências não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      noDataMessage: 'Detalhe não disponível. Tente novamente ou entre em contato com o suporte.',
      categories: {
        missingData: 'Dados em falta',
        invalidData: 'Dados inválidos',
        kycRejected: 'Documentação reprovada pelo banco',
        apiError: 'Sem resposta do sistema',
        complianceRequest: 'Pedido de informação do banco',
        unknown: 'Pendência'
      },
      statuses: {
        failed: 'Não concluído',
        pending: 'Pendente',
        resolved: 'Resolvido'
      },
      noPayloadData: 'Sem dados disponíveis.',
      documentFields: {
        imageUrl: 'Foto do cliente',
        selfieFile: 'Selfie',
        idDocFrontFile: 'Documento de identificação (frente)',
        idDocBackFile: 'Documento de identificação (verso)',
        proofOfAddressDocFile: 'Comprovante de endereço',
        incorporationDocFile: 'Contrato social',
        proofOfOwnershipDocFile: 'Quadro societário',
        sourceOfFundsDocFile: 'Comprovante de origem dos recursos'
      }
    },

    documentChecklist: {
      saveBeforeResend: 'Salve o cadastro antes de reenviar',
      noDocuments: 'Nenhum documento anexado',
      missingDocumentsFooter: 'Anexe os documentos faltantes na aba Documentos'
    },

    limitsDialog: {
      title: 'Histórico de movimentações {provider}',
      entryLimits: 'Limites de Entrada',
      exitLimits: 'Limites de Saída',
      perTransaction: 'Por transação',
      daily: 'Diário',
      monthly: 'Mensal',
      historySubheader: 'Histórico de movimentações',
      noRecords: 'Nenhum registro no período selecionado.',
      requestIncrease: 'Solicitar aumento de limite',
      close: 'Fechar',
      noLimits: 'Este cliente ainda não possui limites aprovados na DolsPay.',
      noLimitsGeneric: 'Este cliente ainda não possui limites aprovados no {provider}.',
      loadError: 'Os limites do cliente não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadErrorGeneric: 'Não foi possível carregar os limites do {provider}.',
      loadTimeout: 'Limites demorando para carregar. Exibindo histórico disponível.',
      periods: {
        all: 'Todos',
        today: 'Hoje',
        yesterday: 'Ontem',
        thisWeek: 'Esta semana',
        thisMonth: 'Mês atual',
        lastMonth: 'Último mês',
        threeMonths: '3 meses',
        sixMonths: '6 meses',
        lastYear: 'Último ano',
        lastThreeMonths: 'Últimos 3 meses',
        lastSixMonths: 'Últimos 6 meses'
      },
      eventTypes: {
        syncSnapshot: 'Sincronização',
        limitIncreaseRequested: 'Solicitação de aumento',
        limitIncreaseApproved: 'Aumento aprovado',
        limitIncreaseRejected: 'Aumento reprovado',
        payinCompleted: 'Entrada',
        payoutCompleted: 'Saída'
      },
      statusLabels: {
        inReview: 'Em análise',
        approved: 'Aprovado',
        rejected: 'Reprovado'
      }
    },

    limitIncreaseDialog: {
      title: 'Solicitar aumento de limite',
      perTransactionLabel: 'Por transação*',
      dailyLabel: 'Diário*',
      monthlyLabel: 'Mensal*',
      documentSupportTitle: 'Documento de suporte',
      documentSupportSubtitle: 'Selecione um documento já anexado ao cadastro que ajude a aprovar sua solicitação.',
      requestNew: 'Solicitar novo aumento',
      close: 'Fechar',
      cancel: 'Cancelar',
      submit: 'Enviar solicitação',
      limitDailyBelowTx: 'Limite diário deve ser maior ou igual ao limite por transação.',
      limitMonthlyBelowDaily: 'Limite mensal deve ser maior ou igual ao limite diário.',
      limitPerTxBelowCurrent: 'Os novos limites devem ser maiores que os atuais. Informe valor por transação maior que o atual.',
      limitDailyBelowCurrent: 'Os novos limites devem ser maiores que os atuais. Informe limite diário maior que o atual.',
      limitMonthlyBelowCurrent: 'Os novos limites devem ser maiores que os atuais. Informe limite mensal maior que o atual.',
      ruleMinError: 'Deve ser maior que o limite atual (US$ {min}).',
      waitUpload: 'Aguarde o upload do documento ser concluído.',
      selectDocument: 'Selecione um tipo de documento ou faça upload de um novo documento.',
      submittedSuccess: 'Solicitação enviada para análise.',
      submitError: 'O pedido de aumento de limite não foi enviado. Confira os documentos anexados e tente novamente.',
      selectDocumentTypeFirst: 'Selecione o tipo de documento antes de fazer upload.',
      uploadSuccess: 'Documento enviado com sucesso!',
      uploadError: 'O documento não foi enviado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.',
      docTypes: {
        individualBankStatement: 'Extrato bancário',
        individualTaxReturn: 'Declaração de imposto de renda',
        individualProofOfIncome: 'Comprovante de renda',
        businessBankStatement: 'Extrato bancário empresarial',
        businessFinancialStatements: 'Demonstrações financeiras (Balanço/DRE)',
        businessTaxReturn: 'Declaração de imposto empresarial'
      },
      documentFoundLabel: 'Documento encontrado. Você pode fazer upload de um novo documento para substituir:',
      documentNotFoundLabel: 'Nenhum documento deste tipo foi encontrado. Faça o upload de um novo documento:'
    },

    pendingLimitIncrease: {
      title: 'Solicitação em análise',
      subtitle: 'Aguarde a análise da solicitação anterior antes de enviar uma nova.',
      requestedAt: 'Solicitado em {date}',
      perTransaction: 'Por transação',
      daily: 'Diário',
      monthly: 'Mensal'
    },

    rejectedLimitIncrease: {
      title: 'Solicitação rejeitada',
      subtitle: 'Sua solicitação anterior foi rejeitada. Você pode enviar uma nova solicitação.',
      requestedAt: 'Solicitado em {date}',
      rejectedAt: 'Rejeitado em {date}',
      perTransaction: 'Por transação',
      daily: 'Diário',
      monthly: 'Mensal'
    },

    technicalDetails: {
      header: 'Ver detalhes técnicos (para o suporte)',
      kycWarningsLabel: 'Alertas KYC:',
      operatorActionLabel: 'Ação sugerida:',
      payloadLabel: 'Dados enviados ao banco parceiro. Se precisar de ajuda, copie e envie ao suporte:',
      errorSources: {
        blindpayApi: 'Recusa do banco parceiro',
        localValidation: 'Validação local'
      }
    },

    documentAnalysis: {
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      highTooltip: 'Documento com boa qualidade',
      mediumText: 'Documento pode precisar de ajustes',
      lowText: 'Recomendamos trocar este documento'
    },

    rfiModal: {
      title: 'Responder ao banco',
      primaryButton: 'Enviar resposta',
      secondaryButton: 'Fechar',
      deadline: 'Prazo do banco: {deadline}',
      refreshButton: 'Buscar o pedido de novo no banco',
      defaultMessage: 'O banco pediu mais informações sobre o cadastro deste cliente.',
      loadError: 'Não foi possível abrir o pedido do banco. Tente novamente em alguns instantes.',
      refreshError: 'Não foi possível buscar o pedido no banco. Tente novamente em alguns instantes.',
      fillRequired: 'Preencha o que o banco pediu: {fields}.',
      submitSuccess: 'Resposta enviada ao banco. O cadastro volta para análise.',
      submitError: 'A resposta não foi enviada ao banco. Confira as informações e tente novamente.'
    },

    operationOrigin: {
      section: 'Operado por',
      user: 'Usuário',
      systemUser: 'Usuário do sistema',
      access: 'Acesso',
      profile: 'Perfil',
      channel: 'Canal',
      startedAt: 'Iniciada em',
      notRecorded: 'Não registrado',
      notRecordedHint: 'Operação anterior ao registro de quem opera',
      accessGoogle: 'Acessou com a conta Google {email}',
      accessPassword: 'Acessou com e-mail e senha',
      accessCode: 'Acessou com o código enviado ao e-mail',
      customerName: '{name} (App DolsPay)',
      profiles: { administrative: 'Administrativo', corban: 'Corban', customer: 'Cliente' },
      channels: { web: 'Tela de operação', app: 'App DolsPay' }
    },

    operationDetailCenter: {
      customerSection: 'Cliente',
      cpfCnpj: 'CPF/CNPJ',
      companyName: 'Razão social',
      personName: 'Nome',
      fantasyName: 'Nome fantasia',
      detailsSection: 'Detalhes da operação',
      type: 'Tipo',
      typeBuy: 'Compra',
      typeSell: 'Venda',
      nature: 'Natureza',
      status: 'Status',
      valuesSection: 'Valores',
      amountForeign: 'Valor M.E.',
      customerRate: 'Tx. cliente',
      totalValue: 'Valor total',
      spread: 'Spread',
      recipientSection: 'Destinatário',
      recipientName: 'Nome',
      recipientDocument: 'Documento',
      recipientPhone: 'Celular',
      bankSection: 'Banco e comissões',
      changeCorban: 'Trocar corban',
      bank: 'Banco',
      agent: 'Agente (Corban)',
      indicator: 'Corban indicador'
    },

    operationDetailDocuments: {
      documentsSection: 'Documentos',
      ccLabel: 'Contrato de câmbio (CC)',
      view: 'Visualizar',
      pending: 'Pendente',
      swiftLabel: 'Swift',
      paymentReceiptLabel: 'Comprovante de pagamento',
      boletoLabel: 'Boleto',
      authorizationLabel: 'Autorização',
      paymentSection: 'Pagamento',
      payInStatus: 'Status BRL (PayIn)',
      payOutStatus: 'Status ME (PayOut)',
      paymentFlow: 'Fluxo de pagamento',
      intermediaryBank: 'Banco intermediário',
      recipientAccountSection: 'Conta bancária do destinatário',
      account: 'Conta',
      beneficiary: 'Beneficiário',
      datesSection: 'Datas',
      createdAt: 'Criação',
      creditedAt: 'Crédito',
      updatedAt: 'Atualização'
    },

    moneyFlight: {
      ariaLabel: 'Rota do dinheiro: de {from} para {to}',
      europe: 'Europa',
      wallet: 'Carteira {token}'
    },
    moneyJourney: {
      title: 'Caminho do dinheiro',
      starting: 'Operação iniciada',
      current: 'Etapa atual: {stage}',
      complete: 'Operação concluída',
      verifying: 'Estamos verificando esta etapa'
    },
    operationDetailTimeline: {
      loadError: 'Não foi possível carregar a timeline da operação.',
      empty: 'Nenhum evento registrado para esta operação.',
      sections: {
        preSale: 'Pré-venda',
        paymentBrl: 'Pagamento em BRL',
        assetPurchase: 'Compra de ativos',
        settlement: 'Liquidação',
        operation: 'Operação'
      },
      stages: {
        preSale: 'Pré-venda',
        payment: 'Pagamento',
        assets: 'Ativos',
        settlement: 'Liquidação',
        quotation: 'Cotação',
        operation: 'Operação'
      }
    },
    validationModal: {
      title: 'Validação de cadastro para Stablecoin',
      correctPending: 'Corrigir pendências',
      sendToBank: 'Enviar ao banco',
      cancel: 'Cancelar',
      pendingsTitle: 'Pendências',
      pendingsHint: 'Corrija para continuar',
      clientLinkHint: 'Não impedem o envio: o cliente envia esses documentos pelo link da instituição.',
      filledFieldsTitle: 'Campos preenchidos',
      completionLabel: '{percent}% completo',
      stepsCount: '{count} etapas',
      confirmationMessage: 'Existem pendências obrigatórias que impedem o envio ao banco. Corrija os campos em destaque antes de continuar.',
      confirmationTitle: 'Continuar?',
      correctPendingButton: 'Corrigir pendência',
      notInformed: 'Não informado',
      summaryHasPending: 'Cadastro com pendências obrigatórias, revise as informações e tente novamente.',
      summaryValid: 'Cadastro validado e apto para envio ao DolsPay.'
    },
    pendingStepCard: {
      required: 'Obrigatório',
      partnerRequired: 'Sócio {index} · Obrigatório',
      lastSentValue: 'Último valor enviado:',
      requiredBy: 'Exigido por {name}',
      sentByClientLink: 'Cliente envia no link'
    },
    tosModal: {
      title: 'Termos de Serviço',
      loading: 'Carregando termos de serviço...',
      acceptRequired: 'Aceite Necessário',
      acceptDescription: 'Para utilizar este banco, é necessário aceitar os termos de serviço.',
      copyLink: 'Copiar Link para Aceite',
      or: 'ou',
      acceptTerms: 'Aceitar Termos de Serviço',
      newTabMessage: 'Uma nova aba será aberta para o aceite dos termos.',
      waitingAccept: 'Aguarde o aceite para continuar...',
      linkCopiedAlert: '✅ Link copiado! Envie para o cliente e aguarde o aceite.',
      monitoringAccept: 'Monitorando aceite do cliente...',
      loadError: 'Não foi possível carregar os termos de serviço. Tente novamente.',
      cancel: 'Cancelar',
      errorNoCustomerId: 'ID do cliente não encontrado.',
      errorGenerateTos: 'Não foi possível gerar termos de serviço. Tente novamente.',
      errorNoUrl: 'URL não disponível. Tente novamente.',
      linkCopiedSuccess: 'Link copiado! Envie para o cliente aceitar os termos.'
    },
    tosSuccess: {
      bankAdded: 'Banco adicionado!',
      termsAccepted: 'Termos aceitos!',
      bankAddedWithName: 'O banco {bankName} foi adicionado ao cadastro.',
      bankAddedNoName: 'O banco foi adicionado ao cadastro.',
      termsApprovedWithName: 'Os termos do banco {bankName} foram aprovados.',
      termsApprovedNoName: 'Os termos selecionados foram aprovados.',
      sentForAnalysis: 'O cadastro deste banco foi enviado para análise.',
      followProcess: 'Agora acompanhe todo o processo no fluxo cadastral.',
      sentWithDocuments: 'O cadastro vai ser enviado com os documentos. Acompanhe pelo painel Provedores.',
      saveAndGo: 'Salvar e ir para o fluxo cadastral',
      stayHere: 'Continuar nesta tela'
    },
    linkOnly: {
      title: 'Vinculação de conta',
      alreadyRegistered: 'O cliente já está cadastrado na DolsPay. Será feita apenas a vinculação da conta.',
      customerSection: 'Cliente',
      receiverSection: 'Receiver (DolsPay)',
      limitsSection: 'Limites',
      cpfCnpjLabel: 'CPF/CNPJ',
      emailLabel: 'E-mail',
      phoneLabel: 'Telefone',
      addressLabel: 'Endereço',
      kycLine: 'KYC: {status} · Tipo: {type} · {receiverType}',
      entryLimits: 'Entrada',
      exitLimits: 'Saída',
      perTransaction: 'Por transação',
      daily: 'Diário',
      monthly: 'Mensal',
      accountsTitle: 'Contas na DolsPay ({count})',
      noAccounts: 'Nenhuma conta cadastrada na DolsPay.',
      continue: 'Continuar',
      cancel: 'Cancelar',
      loadError: 'Não foi possível carregar as contas do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      kycStatuses: {
        approved: 'Aprovado',
        verifying: 'Em verificação',
        rejected: 'Rejeitado'
      },
      receiverTypes: {
        individual: 'Pessoa Física',
        business: 'Pessoa Jurídica'
      },
      bankAccountTypes: {
        pix: 'PIX',
        ach: 'ACH',
        wire: 'Wire',
        internationalSwift: 'SWIFT',
        pixSafe: 'PIX Safe'
      },
      recipientRelationships: {
        firstParty: 'Próprio',
        employee: 'Funcionário',
        independentContractor: 'Contratado',
        vendorOrSupplier: 'Fornecedor',
        subsidiaryOrAffiliate: 'Subsidiária',
        merchantOrPartner: 'Parceiro',
        customer: 'Cliente',
        landlord: 'Proprietário',
        family: 'Família',
        other: 'Outro'
      }
    },
    providerChoice: {
      title: 'Para onde enviar o cadastro?',
      intro: 'Escolha para quais instituições o cadastro do cliente vai ser enviado. Se você já sabe que uma delas vai recusar, envie só para a outra.',
      continue: 'Continuar',
      cancel: 'Cancelar',
      allProviders: 'Todas ({names})',
      singleProvider: 'Só {name}',
      joinSeparator: ' e ',
      withTermsHint: 'Pede o aceite do termo de serviço e a selfie do cliente.',
      withoutTermsHint: 'Sem termo de serviço: os dados e documentos do cadastro são enviados direto.'
    }
  },

  dashboard: {
    flowMap: {
      title: 'Fluxo por país',
      empty: 'Sem operações com país informado neste período'
    },
    chartDisplayLabelsUi: {
      weekdays: {
        monday: 'Segunda-feira',
        tuesday: 'Terça-feira',
        wednesday: 'Quarta-feira',
        thursday: 'Quinta-feira',
        friday: 'Sexta-feira',
        saturday: 'Sábado',
        sunday: 'Domingo'
      },
      months: {
        jan: 'Jan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Abr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Set',
        oct: 'Out',
        nov: 'Nov',
        dec: 'Dez'
      },
      cohortMonth: 'Mês {month}',
      individual: 'Pessoa Física',
      legalEntity: 'Pessoa Jurídica',
      segments: {
        frequent: 'Frequentes (>10 ops)',
        regular: 'Regulares (6-10 ops)',
        occasional: 'Ocasionais (2-5 ops)',
        oneTime: 'Únicos (1 op)'
      }
    },
    widgetPropsUi: {
      cards: {
        cardTarifaCliente: {
          description: 'Tarifa Paga pelo Cliente',
          info: 'Total que os clientes pagaram de tarifa bancária no período.'
        },
        cardTarifaBanco: {
          description: 'Tarifa Cobrada pelo Banco',
          info: 'Total que o banco cobrou de tarifa nas operações do período.'
        },
        cardSaldoTarifa: {
          description: 'Saldo de Tarifa',
          info: 'Diferença entre o que clientes pagaram e o que o banco cobrou. Negativo = contratante absorveu a diferença.'
        },
        cardVolumePayin: {
          description: 'Volume Pay In',
          info: 'Valor total dos depósitos (entradas) concluídos no período.'
        },
        cardVolumePayout: {
          description: 'Volume Pay Out',
          info: 'Valor total dos saques (saídas) concluídos no período, em USD.'
        },
        cardPayinsConcluidos: {
          description: 'Pay Ins concluídos'
        },
        cardPayoutsConcluidos: {
          description: 'Pay Outs concluídos'
        },
        cardDiasComOperacao: {
          description: 'Dias com operação',
          info: 'Quantidade de dias no período em que houve ao menos uma operação.'
        },
        cardMaiorVolumeDia: {
          description: 'Maior volume em um dia',
          info: 'Maior volume operado em um único dia no período.'
        },
        cardOperacaoMediaUsd: {
          description: 'Operação média (USD)',
          info: 'Valor médio por operação em USD.'
        },
        cardLucroLiquido: {
          description: 'Resultado Líquido',
          info: 'Resultado após dedução de PIS/COFINS. Calculado a partir do netProfit real das operações.'
        },
        cardMargemLiquida: {
          description: 'Margem Líquida',
          info: 'Percentual do resultado líquido sobre o resultado bruto. Indica eficiência tributária.'
        },
        cardTotalIof: {
          description: 'IOF Total',
          info: 'Soma do IOF cobrado em todas as operações do período.'
        },
        cardPisCofins: {
          description: 'PIS/COFINS',
          info: 'Custo tributário de PIS/COFINS incidente sobre o resultado bruto das operações.'
        },
        cardVolumePendente: {
          description: 'Volume Pendente',
          info: 'Volume financeiro de operações ainda não liquidadas no período.'
        },
        cardTaxaLiquidacao: {
          description: 'Taxa de Liquidação',
          info: 'Percentual de operações que foram liquidadas. Indica eficiência operacional.'
        },
        cardVetMedio: {
          description: 'VET Médio',
          info: 'Valor Efetivo Total médio das operações. Métrica regulatória exigida pelo Banco Central.'
        },
        cardSpreadMinimo: {
          description: 'Spread Mínimo',
          info: 'Menor spread praticado nas operações do período. Indica o piso de precificação.'
        },
        cardTotalIr: {
          description: 'IR Total',
          info: 'Soma do Imposto de Renda retido em todas as operações do período.'
        },
        cardTotalCide: {
          description: 'CIDE Total',
          info: 'Soma da CIDE (Contribuição de Intervenção no Domínio Econômico) das operações do período.'
        },
        cardCotacaoMedia: {
          description: 'Cotação Média',
          info: 'Cotação média ponderada das operações no período.'
        },
        cardVolumeMoedaEstrangeira: {
          description: 'Volume em Moeda Estrangeira',
          info: 'Soma do valor em moeda estrangeira de todas as operações do período.'
        },
        cardSaldoCompraVenda: {
          description: 'Saldo Compra vs Venda',
          info: 'Diferença entre o volume de compra e o volume de venda no período.'
        },
        cardVolumeVenda: {
          description: 'Volume de Venda',
          info: 'Volume total das operações de venda de moeda estrangeira no período.'
        },
        cardVolumeCompra: {
          description: 'Volume de Compra',
          info: 'Volume total das operações de compra de moeda estrangeira no período.'
        },
        cardTempoPreenchimentoFicha: {
          description: 'Tempo Médio Preenchimento',
          info: 'Tempo médio para o lead preencher a ficha cadastral. Média calculada sobre os clientes que completaram esta etapa específica. Como cada etapa pode ter um conjunto diferente de clientes, médias por etapa podem ser maiores que o tempo total.'
        },
        cardTempoAnaliseInterna: {
          description: 'Tempo Médio Análise',
          info: 'Tempo médio da análise interna do cadastro. Média calculada sobre os clientes que completaram esta etapa específica. Como cada etapa pode ter um conjunto diferente de clientes, médias por etapa podem ser maiores que o tempo total.'
        },
        cardTempoAprovacaoBanco: {
          description: 'Tempo Aprovação Banco',
          info: 'Tempo médio para o banco aprovar o cadastro. Média calculada sobre os clientes que completaram esta etapa específica. Como cada etapa pode ter um conjunto diferente de clientes, médias por etapa podem ser maiores que o tempo total.'
        },
        cardTempoTotalCadastro: {
          description: 'Tempo Total Cadastro',
          info: 'Tempo médio total do fluxo cadastral completo (do envio à finalização). Média calculada sobre os clientes que completaram todo o fluxo de cadastro. Como inclui apenas clientes que finalizaram todas as etapas, pode ser menor que médias de etapas individuais.'
        },
        cardTaxaConversaoCadastro: {
          description: 'Taxa de Conversão',
          info: 'Percentual de clientes que completaram o fluxo cadastral interno (enviado → finalizado).'
        },
        cardClientesParadosFluxo: {
          description: 'Clientes Parados',
          info: 'Clientes que iniciaram o cadastro mas não finalizaram no período.'
        },
        cardTaxaPendenciaBanco: {
          description: 'Taxa de Pendência Banco',
          info: 'Percentual de clientes que receberam pendência do banco (retrabalho).'
        },
        cardTaxaAprovacaoBanco: {
          description: 'Taxa Aprovação Banco',
          info: 'Percentual de clientes enviados ao banco que foram aprovados.'
        },
        cardLtvMedio: {
          description: 'LTV Médio',
          info: 'Valor médio de resultado bruto por cliente ao longo do tempo'
        },
        cardReceitaMediaCliente: {
          description: 'Receita Média/Cliente',
          info: 'Resultado bruto total dividido pelo número de clientes ativos no período'
        },
        cardFrequenciaMedia: {
          description: 'Frequência Média',
          info: 'Número médio de operações por cliente no período'
        },
        cardTempoVidaMedio: {
          description: 'Tempo de Vida Médio',
          info: 'Média de dias entre a primeira e a última operação de cada cliente'
        },
        cardTaxaRetencao: {
          description: 'Taxa de Retenção',
          info: 'Percentual de clientes que operaram em mais de um mês distinto'
        },
        cardTaxaChurn: {
          description: 'Perda de Clientes (Churn)',
          info: 'Percentual de clientes da base histórica que não operaram no período selecionado (quanto maior, pior a retenção)'
        },
        cardClientesAltoValor: {
          description: 'Clientes Alto Valor',
          info: 'Clientes com LTV no percentil 75 ou acima'
        },
        cardBaseClientesLtv: {
          description: 'Base Clientes LTV',
          info: 'Total de clientes considerados nas métricas de LTV no período'
        }
      },
      charts: {
        chartOperadoBanco: {
          title: 'Valor operado por banco'
        },
        chartOperadoMoeda: {
          title: 'Total operado por moeda'
        },
        chartOpsPorMoeda: {
          title: 'Distribuição de operações por moeda'
        },
        chartVolumePorBanco: {
          title: 'Volume por banco'
        },
        chartClientesRegiao: {
          title: 'Clientes por região'
        },
        chartTopClientes: {
          title: 'Top 10 clientes por volume'
        },
        chartDistribuicaoLucros: {
          title: 'Distribuição de resultados'
        },
        chartVolumeCorrespondente: {
          title: 'Volume por correspondente'
        },
        chartSegmentacaoClientes: {
          title: 'Segmentação de clientes'
        },
        chartAnaliseSpread: {
          title: 'Análise de spread por moeda'
        },
        chartEvolucaoVolume: {
          title: 'Evolução do volume'
        },
        chartRentabilidadeNatureza: {
          title: 'Rentabilidade por natureza de operação'
        },
        chartCargaTributaria: {
          title: 'Composição da carga tributária'
        },
        chartVolumeMensal: {
          title: 'Volume mensal'
        },
        chartLucroMensal: {
          title: 'Resultado mensal'
        },
        chartOpsPorNatureza: {
          title: 'Operações por natureza'
        },
        chartCompraVsVenda: {
          title: 'Compra vs Venda'
        },
        chartClientesPorMes: {
          title: 'Clientes ativos por mês'
        },
        chartTempoEtapasFluxo: {
          title: 'Tempo por etapa do fluxo'
        },
        chartEvolucaoTempoCadastro: {
          title: 'Evolução do tempo de cadastro'
        },
        chartFunilCadastral: {
          title: 'Funil de conversão cadastral'
        },
        chartDistribuicaoPfPj: {
          title: 'Distribuição PF vs PJ por etapa'
        },
        chartClientesPorStatus: {
          title: 'Clientes por status atual'
        },
        chartSegmentacaoLtv: {
          title: 'Segmentação por LTV'
        },
        chartEvolucaoLtv: {
          title: 'Evolução do LTV'
        },
        chartTopClientesLtv: {
          title: 'Top Clientes por LTV'
        },
        chartRetencaoCoorte: {
          title: 'Retenção por Coorte'
        },
        chartHeatmapOperacoes: {
          title: 'Mapa de Calor de Operações'
        },
        chartHistoricoCotacao: {
          title: 'Histórico de Cotação'
        }
      },
      columns: {
        bank: 'Banco',
        percentage: 'Percentual',
        currency: 'Moeda',
        value: 'Valor',
        volume: 'Volume',
        state: 'Estado',
        quantity: 'Quantidade',
        customer: 'Cliente',
        category: 'Categoria',
        correspondent: 'Correspondente',
        segment: 'Segmento',
        averageSpread: 'Spread médio',
        date: 'Data',
        nature: 'Natureza',
        margin: 'Margem',
        tax: 'Tributo',
        month: 'Mês',
        result: 'Resultado',
        type: 'Tipo',
        customers: 'Clientes',
        stage: 'Etapa',
        time: 'Tempo',
        typeStage: 'Tipo - Etapa',
        status: 'Status',
        averageLtv: 'LTV Médio',
        ltv: 'LTV',
        cohortMonth: 'Coorte - Mês',
        retention: 'Retenção',
        dayHour: 'Dia/Hora',
        operations: 'Operações',
        lastQuotation: 'Última Cotação'
      },
      values: {
        opsPerCustomer: '{n} ops/cliente',
        days: '{n} dias',
        cohortMonth: '{cohort} Mês {month}'
      },
      series: {
        averageTime: 'Tempo médio',
        total: 'Total'
      },
      totals: {
        banks: '{n} bancos',
        operations: '{n} operações',
        customers: '{n} clientes',
        correspondents: '{n} correspondentes',
        threeStages: '3 etapas',
        months: '{n} meses',
        segments: '{n} segmentos',
        cohorts: '{n} coortes',
        currencies: '{n} moedas'
      }
    },
    internationalMixinUi: {
      cards: {
        cardTotalOperado: {
          description: 'Total Operado',
          info: 'Soma do valor total de todas as operações no período (receita bruta).'
        },
        cardTotalOperacoes: {
          description: 'Total de operações',
          info: 'Número total de operações realizadas no período selecionado.'
        },
        cardClientesAtivos: {
          description: 'Clientes ativos',
          info: 'Quantidade de clientes que tiveram pelo menos uma operação no período.'
        },
        cardLucroBruto: {
          description: 'Resultado bruto total',
          info: 'Soma do resultado bruto de todas as operações (receita menos custos diretos).'
        },
        cardOpsPorCliente: {
          description: 'Operações por cliente ativo',
          info: 'Média de operações por cliente que operou no período.'
        },
        cardVolumePorBanco: {
          description: 'Volume médio por banco',
          info: 'Receita total dividida pelo número de bancos ativos no período.'
        },
        cardTicketMedio: {
          description: 'Ticket médio',
          info: 'Valor médio por operação (volume total dividido pelo número de operações).'
        },
        cardSpreadMedio: {
          description: 'Spread médio',
          info: 'Percentual médio de spread aplicado nas operações do período.'
        },
        cardMaiorOperacao: {
          description: 'Maior operação',
          info: 'Valor da maior operação (em receita) no período.'
        },
        cardMenorOperacao: {
          description: 'Menor operação',
          info: 'Valor da menor operação (em receita) no período.'
        },
        cardBancosAtivos: {
          description: 'Bancos ativos',
          info: 'Quantidade de bancos que tiveram pelo menos uma operação no período.'
        },
        cardMoedasOperadas: {
          description: 'Moedas operadas',
          info: 'Quantidade de moedas diferentes utilizadas nas operações do período.'
        },
        cardClientesTotais: {
          description: 'Clientes Ativos no Período',
          info: 'Quantidade de clientes que realizaram pelo menos uma operação no período selecionado.'
        },
        cardClientesAprovados: {
          description: 'Clientes aprovados',
          info: 'Clientes com cadastro aprovado em pelo menos um banco.'
        },
        cardClientesRecorrentes: {
          description: 'Clientes recorrentes',
          info: 'Clientes que realizaram mais de uma operação no período.'
        },
        cardTicketPorCliente: {
          description: 'Ticket médio por cliente',
          info: 'Valor médio operado por cliente ativo (volume total dividido pelo número de clientes ativos).'
        },
        cardLucroPorReal: {
          description: 'Resultado por Real Operado',
          info: 'Quanto de resultado bruto e gerado para cada real movimentado pelo cliente.'
        },
        cardComissaoMedia: {
          description: 'Comissão média por operação',
          info: 'Total de comissões dividido pelo número de operações no período.'
        },
        cardMargemBruta: {
          description: 'Margem bruta',
          info: 'Percentual do resultado bruto em relação à receita total.'
        },
        cardTotalComissoes: {
          description: 'Total comissões',
          info: 'Soma de todas as comissões: Corban, Indicador, TechCambio e Banco.'
        },
        cardLucroCorban: {
          description: 'Resultado PARCEIRO',
          info: 'Soma do resultado destinado ao Parceiro (agente) nas operações do período.'
        },
        cardLucroIndicador: {
          description: 'Resultado INDICADOR',
          info: 'Soma do resultado destinado ao Indicador nas operações do período.'
        },
        cardLucroMaster: {
          description: 'Resultado CORBAN',
          info: 'Soma do resultado da plataforma (TechCambio/Corban) nas operações do período.'
        },
        cardLucroBanco: {
          description: 'Resultado BANCOS',
          info: 'Soma do resultado destinado ao banco nas operações do período.'
        },
        cardSpreadMaximo: {
          description: 'Spread máximo',
          info: 'Maior spread aplicado em uma operação no período.'
        },
        cardLucroPorCliente: {
          description: 'Resultado por cliente ativo',
          info: 'Resultado bruto total dividido pelo número de clientes ativos no período.'
        },
        cardTaxaRecorrencia: {
          description: 'Taxa de recorrência',
          info: 'Percentual de clientes ativos que realizaram mais de uma operação no período.'
        },
        cardConcentracaoTop10: {
          description: 'Concentração Top 10',
          info: 'Percentual do volume total operado pelos 10 maiores clientes.'
        },
        cardVolumeRecorrentes: {
          description: 'Participação volume recorrentes',
          info: 'Percentual do volume operado por clientes que fizeram mais de uma operação no período.'
        },
        cardOpsPorDia: {
          description: 'Operações/dia (média)',
          info: 'Média de operações por dia (total de operações dividido por 30 dias).'
        },
        cardConcentracaoTop1: {
          description: 'Concentração top 1',
          info: 'Percentual do volume total operado pelo maior cliente no período.'
        },
        cardLucroPorOperacao: {
          description: 'Resultado/operação',
          info: 'Resultado bruto médio por operação no período.'
        },
        cardCorrespondentesAtivos: {
          description: 'Correspondentes ativos',
          info: 'Quantidade de correspondentes (Corbans) que tiveram pelo menos uma operação no período.'
        },
        cardVolumeCorrespondentes: {
          description: 'Volume correspondentes',
          info: 'Soma do volume operado por todos os correspondentes no período.'
        },
        cardComissoesPagas: {
          description: 'Comissões pagas',
          info: 'Total de comissões pagas aos correspondentes no período.'
        },
        cardMediaOpsCorresp: {
          description: 'Média ops/correspondente',
          info: 'Média de operações por correspondente (total de operações dividido pelo número de correspondentes ativos).'
        },
        cardClientesUnicos: {
          description: 'Clientes únicos',
          info: 'Clientes classificados como únicos na segmentação (realizaram apenas 1 operação).'
        },
        cardClientesFrequentes: {
          description: 'Clientes frequentes',
          info: 'Clientes classificados como frequentes na segmentação.'
        },
        cardClientesRegulares: {
          description: 'Clientes regulares',
          info: 'Clientes classificados como regulares na segmentação.'
        },
        cardClientesOcasionais: {
          description: 'Clientes ocasionais',
          info: 'Clientes classificados como ocasionais na segmentação.'
        }
      },
      series: {
        totalOperated: 'Total operado',
        volumeOperated: 'Volume operado',
        profitDistribution: 'Distribuição de resultados',
        averageSpread: 'Spread médio',
        volumeBrl: 'Volume (R$)',
        volume: 'Volume',
        customersByRegion: 'Clientes por região',
        resultBrl: 'Resultado (R$)',
        taxBurden: 'Carga tributária',
        grossResult: 'Resultado bruto',
        activeCustomers: 'Clientes ativos',
        volumeByNature: 'Volume por natureza',
        ltvSegmentation: 'Segmentação LTV',
        ltvBrl: 'LTV (R$)',
        buyRate: 'Taxa de Compra'
      },
      values: {
        noName: 'Sem nome',
        customerCount: '{n} cliente | {n} clientes'
      }
    },
    stablecoinMixinUi: {
      totals: {
        receivers: '{n} receivers',
        wallets: '{n} wallets',
        quotes: '{n} cotações'
      },
      profit: {
        bank: 'Lucro do Banco (USD)',
        master: 'Lucro {theme} (USD)',
        corban: 'Lucro do Corban (USD)',
        indicator: 'Lucro do Corban Indicador (USD)'
      },
      series: {
        profit: 'Lucro',
        receivers: 'Receivers',
        wallets: 'Wallets',
        volume: 'Volume',
        volumeOperated: 'Volume operado',
        grossProfit: 'Lucro bruto',
        quotes: 'Cotações'
      },
      wallets: {
        linked: 'Vinculadas',
        unlinked: 'Não vinculadas'
      },
      quotes: {
        active: 'Ativas',
        expired: 'Expiradas'
      },
      cards: {
        operationsInPeriod: 'Operações no período',
        activeCustomers: 'Clientes ativos',
        payInVolume: 'Volume Pay In',
        payInVolumeInfo: 'Valor total dos depósitos (entradas) concluídos no período. Pode ser maior que o total operado se clientes depositarem mais do que operaram.',
        payOutVolume: 'Volume Pay Out',
        payOutVolumeInfo: 'Valor total dos saques (saídas) concluídos no período, em USD. Costuma ser próximo do Total operado.',
        payInsCompleted: 'Pay Ins concluídos',
        payOutsCompleted: 'Pay Outs concluídos',
        daysWithOperation: 'Dias com operação',
        daysWithOperationInfo: 'Quantidade de dias no período em que houve ao menos uma operação.',
        maxDayVolume: 'Maior volume em um dia',
        maxDayVolumeInfo: 'Maior volume operado em um único dia no período.',
        totalOperated: 'Total Operado',
        totalOperatedInfo: 'Entradas (Fiat to Fiat e Pay-in). Saídas da carteira (Payout) no período: {value} — o mesmo dinheiro que já entrou, por isso fora da soma.',
        averageSpread: 'Spread Médio',
        averageOperation: 'Operação média',
        grossProfit: 'Lucro bruto',
        grossProfitInfo: 'Lucro bruto = Total da operação - Lucro do banco',
        corbanProfit: 'Lucro do Corban',
        corbanProfitInfo: 'Lucro do Corban em USD (OAS).',
        indicatorProfit: 'Lucro do Corban Indicador',
        indicatorProfitInfo: 'Lucro do Corban Indicador em USD (OAS).',
        masterProfit: 'Lucro {theme}',
        masterProfitInfo: 'Lucro {theme} = Lucro bruto - Lucro do banco + Cashback do contrato',
        bankProfit: 'Lucro do Banco',
        bankProfitInfo: 'Lucro do Banco = (1 - % da comissão) * Lucro bruto'
      }
    },
    calculationMemoryUi: {
      cardTotalOperado: {
        details: {
          d1: 'Considera apenas operacoes efetivadas (liquidadas).',
          d2: 'O valor de cada operacao ja esta convertido para reais pela taxa usada na hora da operacao.',
          d3: 'Esse e o volume movimentado pelo cliente, nao o lucro ou receita da empresa.'
        },
        title: 'Total Operado',
        description: 'Quanto dinheiro foi movimentado em todas as operacoes de cambio no periodo. Esse valor e do cliente, nao e receita da empresa.',
        formula: 'Total Operado = soma do valor em reais de cada operacao'
      },
      cardTotalOperacoes: {
        details: {
          d1: 'Respeita os filtros aplicados (tipo, status, banco, moeda).',
          d2: 'Cada operacao e contada uma unica vez, nao importa o valor.'
        },
        title: 'Total de Operacoes',
        description: 'Quantas operacoes de cambio foram feitas no periodo.',
        formula: 'Total de Operacoes = quantidade de operacoes realizadas'
      },
      cardClientesAtivos: {
        details: {
          d1: 'Se um cliente fez 5 operacoes, ele conta como 1 cliente ativo.',
          d2: 'Basta ter feito uma operacao no periodo para ser considerado ativo.'
        },
        title: 'Clientes Ativos',
        description: 'Quantos clientes diferentes fizeram pelo menos uma operacao no periodo.',
        formula: 'Clientes Ativos = quantidade de clientes diferentes que operaram'
      },
      cardLucroBruto: {
        details: {
          d1: 'Resultado bruto de cada operacao = receita da operacao - custos diretos - tarifa bancaria.',
          d2: 'A tarifa bancaria e descontada diretamente do resultado bruto antes de calcular PIS/COFINS e comissoes.',
          d3: 'Inclui as parcelas de todos os envolvidos: correspondente, indicador, plataforma e banco.',
          d4: 'Nao desconta impostos como IOF, PIS/COFINS, IR ou CIDE.'
        },
        title: 'Resultado Bruto Total',
        description: 'Quanto de resultado foi gerado por todas as operacoes, antes de descontar impostos. Ja considera a deducao da tarifa bancaria.',
        formula: 'Resultado Bruto = (diferenca de subtotais) - tarifa bancaria'
      },
      chartOperadoBanco: {
        details: {
          d1: 'Grafico de pizza com a fatia de cada banco.',
          d2: 'So aparecem bancos que tiveram operacoes no periodo.'
        },
        title: 'Valor Operado por Banco',
        description: 'Mostra como o volume total esta dividido entre os bancos.',
        formula: 'Percentual do banco = (valor operado pelo banco / valor total operado) x 100'
      },
      chartOperadoMoeda: {
        details: {
          d1: 'Ajuda a identificar quais moedas concentram mais negocios.'
        },
        title: 'Total Operado por Moeda',
        description: 'Mostra quanto foi operado em cada moeda estrangeira.',
        formula: 'Volume por moeda = soma do valor em reais das operacoes naquela moeda'
      },
      cardOpsPorCliente: {
        details: {
          d1: 'Quanto maior, mais engajados estao os clientes.'
        },
        title: 'Operacoes por Cliente',
        description: 'Em media, quantas operacoes cada cliente fez no periodo.',
        formula: 'Operacoes por Cliente = total de operacoes / clientes ativos'
      },
      cardVolumePorBanco: {
        details: {
          d1: 'Mostra a concentracao media de volume por banco.'
        },
        title: 'Volume por Banco',
        description: 'Em media, quanto cada banco movimentou no periodo.',
        formula: 'Volume por Banco = total operado / bancos ativos'
      },
      cardTicketMedio: {
        details: {
          d1: 'Ajuda a entender se as operacoes sao grandes ou pequenas em media.'
        },
        title: 'Ticket Medio',
        description: 'Valor medio de cada operacao realizada.',
        formula: 'Ticket Medio = total operado em reais / total de operacoes'
      },
      cardSpreadMedio: {
        details: {
          d1: 'O spread e a diferenca entre o preco de compra e o preco de venda da moeda.',
          d2: 'Representa a margem que a operacao gera.'
        },
        title: 'Spread Medio',
        description: 'Margem media cobrada nas operacoes, em percentual.',
        formula: 'Spread Medio = media da margem percentual de todas as operacoes'
      },
      cardMaiorOperacao: {
        details: {
          d1: 'Identifica a operacao de maior valor.'
        },
        title: 'Maior Operacao',
        description: 'Valor da operacao mais alta realizada no periodo.',
        formula: 'Maior Operacao = maior valor em reais dentre todas as operacoes'
      },
      cardMenorOperacao: {
        details: {
          d1: 'Identifica a operacao de menor valor.'
        },
        title: 'Menor Operacao',
        description: 'Valor da operacao mais baixa realizada no periodo.',
        formula: 'Menor Operacao = menor valor em reais dentre todas as operacoes'
      },
      cardBancosAtivos: {
        details: {
          d1: 'Cada banco e contado uma unica vez.'
        },
        title: 'Bancos Ativos',
        description: 'Quantos bancos diferentes foram usados nas operacoes.',
        formula: 'Bancos Ativos = quantidade de bancos diferentes nas operacoes'
      },
      cardMoedasOperadas: {
        details: {
          d1: 'Exemplo: se operou dolar e euro, sao 2 moedas.'
        },
        title: 'Moedas Operadas',
        description: 'Quantas moedas diferentes foram negociadas no periodo.',
        formula: 'Moedas Operadas = quantidade de moedas diferentes nas operacoes'
      },
      chartOpsPorMoeda: {
        details: {
          d1: 'Grafico de barras comparando o volume por moeda.'
        },
        title: 'Operacoes por Moeda',
        description: 'Quanto foi operado em cada moeda estrangeira.',
        formula: 'Volume por moeda = soma do valor em reais das operacoes naquela moeda'
      },
      chartVolumePorBanco: {
        details: {
          d1: 'Grafico de barras comparando o volume por banco.'
        },
        title: 'Volume por Banco',
        description: 'Quanto cada banco movimentou no periodo.',
        formula: 'Volume por banco = soma do valor em reais das operacoes daquele banco'
      },
      chartOpsPorNatureza: {
        details: {
          d1: 'Ajuda a ver quais tipos de operacao movimentam mais dinheiro.'
        },
        title: 'Operacoes por Natureza',
        description: 'Quanto foi operado em cada tipo de natureza (remessa, importacao, etc.).',
        formula: 'Volume por natureza = soma do valor em reais das operacoes daquela natureza'
      },
      chartCompraVsVenda: {
        details: {
          d1: 'Mostra o equilibrio entre compra e venda no periodo.'
        },
        title: 'Compra vs Venda',
        description: 'Comparacao entre o volume de compra e o volume de venda de cambio.',
        formula: 'Volume de Compra = soma das operacoes de compra | Volume de Venda = soma das operacoes de venda'
      },
      chartHeatmapOperacoes: {
        details: {
          d1: 'As areas mais escuras indicam os horarios com mais movimento.'
        },
        title: 'Mapa de Calor de Operacoes',
        description: 'Mostra em quais dias e horarios acontecem mais operacoes.',
        formula: 'Para cada dia e hora = quantidade de operacoes naquele momento'
      },
      cardClientesTotais: {
        details: {
          d1: 'Considera o periodo e os filtros selecionados.'
        },
        title: 'Clientes Totais',
        description: 'Quantos clientes fizeram operacoes no periodo.',
        formula: 'Clientes Totais = quantidade de clientes com ao menos uma operacao'
      },
      cardClientesAprovados: {
        details: {
          d1: 'O cliente precisa ter vinculo aprovado com o banco.'
        },
        title: 'Clientes Aprovados',
        description: 'Quantos clientes tem cadastro aprovado em pelo menos um banco.',
        formula: 'Clientes Aprovados = quantidade de clientes com aprovacao em banco'
      },
      cardClientesRecorrentes: {
        details: {
          d1: 'Indica fidelizacao: sao clientes que voltaram a operar.'
        },
        title: 'Clientes Recorrentes',
        description: 'Quantos clientes fizeram mais de uma operacao no periodo.',
        formula: 'Clientes Recorrentes = quantidade de clientes com 2 ou mais operacoes'
      },
      cardTicketPorCliente: {
        details: {
          d1: 'Mostra o volume medio movimentado por cliente (valor do cliente, nao receita).'
        },
        title: 'Ticket por Cliente',
        description: 'Em media, quanto cada cliente movimentou em reais.',
        formula: 'Ticket por Cliente = volume total operado / clientes ativos'
      },
      chartClientesRegiao: {
        details: {
          d1: 'Mostra a concentracao geografica dos clientes.'
        },
        title: 'Clientes por Regiao',
        description: 'Onde os clientes estao localizados, por estado.',
        formula: 'Clientes por estado = quantidade de clientes cadastrados naquele estado'
      },
      chartTopClientes: {
        details: {
          d1: 'Ordenado do maior para o menor volume.'
        },
        title: 'Top Clientes',
        description: 'Os 10 clientes que mais movimentaram dinheiro.',
        formula: 'Volume do cliente = soma do valor de todas as operacoes dele (mostra os 10 maiores)'
      },
      chartClientesPorMes: {
        details: {
          d1: 'Mostra a tendencia de crescimento ou queda ao longo do tempo.'
        },
        title: 'Clientes Ativos por Mes',
        description: 'Como a quantidade de clientes ativos variou mes a mes.',
        formula: 'Clientes no mes = quantidade de clientes diferentes que operaram naquele mes'
      },
      cardLucroPorReal: {
        details: {
          d1: 'Exemplo: se o valor e R$ 0,015, significa que a cada R$ 1,00 operado, a empresa gera 1,5 centavos de resultado.',
          d2: 'Quanto maior, mais eficiente e a operacao.'
        },
        title: 'Resultado por Real Operado',
        description: 'Quanto de resultado bruto e gerado para cada real que o cliente movimenta.',
        formula: 'Resultado por Real = Resultado Bruto / Volume Total Operado'
      },
      cardComissaoMedia: {
        details: {
          d1: 'Inclui todas as comissoes: correspondente, indicador, plataforma e banco.'
        },
        title: 'Comissao Media',
        description: 'Quanto de comissao foi paga, em media, por operacao.',
        formula: 'Comissao Media = total de comissoes / total de operacoes'
      },
      cardMargemBruta: {
        details: {
          d1: 'Indica quanto do volume movimentado se converteu em resultado.',
          d2: 'O volume operado e o valor do cliente, nao receita propria.'
        },
        title: 'Margem Bruta',
        description: 'Qual percentual do volume operado virou resultado bruto.',
        formula: 'Margem Bruta = (Resultado Bruto / Volume Total Operado) x 100'
      },
      cardTotalComissoes: {
        details: {
          d1: 'Inclui todas as parcelas distribuidas entre os envolvidos.'
        },
        title: 'Total de Comissoes',
        description: 'Quanto foi pago em comissoes no total.',
        formula: 'Total de Comissoes = comissao correspondente + comissao indicador + comissao plataforma + comissao banco'
      },
      cardLucroCorban: {
        details: {
          d1: 'Valor total pago ao correspondente no periodo.'
        },
        title: 'Resultado PARCEIRO',
        description: 'Quanto o correspondente cambial (Corban) recebeu de comissao.',
        formula: 'Resultado PARCEIRO = soma da parcela do correspondente em cada operacao'
      },
      cardLucroIndicador: {
        details: {
          d1: 'Valor total pago ao indicador no periodo.'
        },
        title: 'Resultado INDICADOR',
        description: 'Quanto o indicador recebeu de comissao.',
        formula: 'Resultado INDICADOR = soma da parcela do indicador em cada operacao'
      },
      cardLucroMaster: {
        details: {
          d1: 'Valor total retido pela plataforma no periodo.'
        },
        title: 'Resultado CORBAN',
        description: 'Quanto a plataforma reteve de comissao.',
        formula: 'Resultado CORBAN = soma da parcela da plataforma em cada operacao'
      },
      cardLucroBanco: {
        details: {
          d1: 'Valor total pago ao banco de cambio no periodo.'
        },
        title: 'Resultado BANCOS',
        description: 'Quanto o banco recebeu de comissao.',
        formula: 'Resultado BANCOS = soma da parcela do banco em cada operacao'
      },
      chartDistribuicaoLucros: {
        details: {
          d1: 'O grafico mostra a fatia de cada um no resultado total.'
        },
        title: 'Distribuicao de Resultados',
        description: 'Como o resultado bruto e dividido entre os envolvidos.',
        formula: 'Resultado Bruto = correspondente + indicador + plataforma + banco'
      },
      chartLucroMensal: {
        details: {
          d1: 'Mostra a tendencia do resultado ao longo do tempo.'
        },
        title: 'Resultado Mensal',
        description: 'Como o resultado bruto variou mes a mes.',
        formula: 'Resultado do mes = soma do resultado bruto das operacoes daquele mes'
      },
      chartVolumeMensal: {
        details: {
          d1: 'Mostra a evolucao do volume operado mes a mes.'
        },
        title: 'Volume Mensal',
        description: 'Quanto foi operado em cada mes.',
        formula: 'Volume do mes = soma do valor em reais das operacoes daquele mes'
      },
      cardCorrespondentesAtivos: {
        details: {
          d1: 'Cada correspondente e contado uma unica vez.'
        },
        title: 'Correspondentes Ativos',
        description: 'Quantos correspondentes (Corbans) tiveram operacoes no periodo.',
        formula: 'Correspondentes Ativos = quantidade de correspondentes diferentes nas operacoes'
      },
      cardVolumeCorrespondentes: {
        details: {
          d1: 'Valor total em reais operado por correspondentes.'
        },
        title: 'Volume Correspondentes',
        description: 'Quanto todos os correspondentes movimentaram juntos.',
        formula: 'Volume Correspondentes = soma do valor das operacoes vinculadas a correspondentes'
      },
      cardComissoesPagas: {
        details: {
          d1: 'Total de comissoes pagas a todos os correspondentes.'
        },
        title: 'Comissoes Pagas',
        description: 'Quanto foi pago em comissoes aos correspondentes.',
        formula: 'Comissoes Pagas = soma da comissao de cada correspondente'
      },
      cardMediaOpsCorresp: {
        details: {
          d1: 'Indica a produtividade media dos correspondentes.'
        },
        title: 'Media Ops/Correspondente',
        description: 'Em media, quantas operacoes cada correspondente fez.',
        formula: 'Media = total de operacoes de correspondentes / correspondentes ativos'
      },
      cardClientesUnicos: {
        details: {
          d1: 'Sao clientes que operaram uma unica vez.'
        },
        title: 'Clientes Unicos',
        description: 'Clientes que fizeram apenas 1 operacao no periodo.',
        formula: 'Clientes Unicos = quantidade de clientes com exatamente 1 operacao'
      },
      cardClientesFrequentes: {
        details: {
          d1: 'Sao clientes com frequencia moderada de operacoes.'
        },
        title: 'Clientes Frequentes',
        description: 'Clientes que fizeram entre 2 e 5 operacoes no periodo.',
        formula: 'Clientes Frequentes = quantidade de clientes com 2 a 5 operacoes'
      },
      cardClientesRegulares: {
        details: {
          d1: 'Sao clientes com alta frequencia de operacoes.'
        },
        title: 'Clientes Regulares',
        description: 'Clientes que fizeram entre 6 e 10 operacoes no periodo.',
        formula: 'Clientes Regulares = quantidade de clientes com 6 a 10 operacoes'
      },
      cardClientesOcasionais: {
        details: {
          d1: 'Sao os clientes mais ativos do periodo.'
        },
        title: 'Clientes Ocasionais',
        description: 'Clientes que fizeram mais de 10 operacoes no periodo.',
        formula: 'Clientes Ocasionais = quantidade de clientes com mais de 10 operacoes'
      },
      chartVolumeCorrespondente: {
        details: {
          d1: 'Grafico de barras comparando o volume de cada correspondente.'
        },
        title: 'Volume por Correspondente',
        description: 'Quanto cada correspondente movimentou no periodo.',
        formula: 'Volume do correspondente = soma do valor das operacoes dele'
      },
      chartSegmentacaoClientes: {
        details: {
          d1: 'O grafico mostra a proporcao de clientes em cada grupo.'
        },
        title: 'Segmentacao de Clientes',
        description: 'Como os clientes se dividem por frequencia de operacoes.',
        formula: 'Unico = 1 operacao | Frequente = 2 a 5 | Regular = 6 a 10 | Ocasional = mais de 10'
      },
      cardSpreadMaximo: {
        details: {
          d1: 'Mostra o teto de margem praticado.'
        },
        title: 'Spread Maximo',
        description: 'A maior margem percentual aplicada em uma operacao no periodo.',
        formula: 'Spread Maximo = maior margem dentre todas as operacoes'
      },
      cardLucroPorCliente: {
        details: {
          d1: 'Indica a rentabilidade media por cliente.'
        },
        title: 'Resultado por Cliente',
        description: 'Em media, quanto de resultado cada cliente gerou.',
        formula: 'Resultado por Cliente = Resultado Bruto Total / Clientes Ativos'
      },
      cardTaxaRecorrencia: {
        details: {
          d1: 'Quanto maior, melhor a fidelizacao dos clientes.'
        },
        title: 'Taxa de Recorrencia',
        description: 'Qual percentual dos clientes voltou a operar mais de uma vez.',
        formula: 'Taxa de Recorrencia = (Clientes Recorrentes / Clientes Ativos) x 100'
      },
      cardConcentracaoTop10: {
        details: {
          d1: 'Se esse numero for muito alto, significa dependencia de poucos clientes.'
        },
        title: 'Concentracao Top 10',
        description: 'Quanto do volume total esta concentrado nos 10 maiores clientes.',
        formula: 'Concentracao Top 10 = (volume dos 10 maiores / volume total) x 100'
      },
      cardVolumeRecorrentes: {
        details: {
          d1: 'Mostra quanto do negocio depende de clientes fieis.'
        },
        title: 'Volume Recorrentes',
        description: 'Quanto do volume total vem de clientes que operaram mais de uma vez.',
        formula: 'Volume Recorrentes = (volume dos clientes recorrentes / volume total) x 100'
      },
      cardOpsPorDia: {
        details: {
          d1: 'Usa 30 dias como referencia para a media diaria.'
        },
        title: 'Operacoes por Dia',
        description: 'Em media, quantas operacoes acontecem por dia.',
        formula: 'Operacoes por Dia = total de operacoes / 30 dias'
      },
      cardConcentracaoTop1: {
        details: {
          d1: 'Se esse numero for muito alto, ha grande dependencia de um unico cliente.'
        },
        title: 'Concentracao Top 1',
        description: 'Quanto do volume total esta no maior cliente.',
        formula: 'Concentracao Top 1 = (volume do maior cliente / volume total) x 100'
      },
      cardLucroPorOperacao: {
        details: {
          d1: 'Indica a rentabilidade media de cada operacao.'
        },
        title: 'Resultado por Operacao',
        description: 'Em media, quanto de resultado cada operacao gerou.',
        formula: 'Resultado por Operacao = Resultado Bruto Total / Total de Operacoes'
      },
      chartAnaliseSpread: {
        details: {
          d1: 'Grafico de barras comparando a margem media por moeda.'
        },
        title: 'Analise de Spread',
        description: 'Qual a margem media praticada em cada moeda.',
        formula: 'Spread por moeda = media da margem das operacoes naquela moeda'
      },
      chartEvolucaoVolume: {
        details: {
          d1: 'Mostra a tendencia de crescimento ou queda do volume.'
        },
        title: 'Evolucao do Volume',
        description: 'Como o volume operado variou ao longo do tempo.',
        formula: 'Volume por periodo = soma do valor em reais das operacoes naquele periodo'
      },
      cardLucroLiquido: {
        details: {
          d1: 'E o resultado real apos os descontos tributarios.'
        },
        title: 'Resultado Liquido',
        description: 'Quanto sobra de resultado depois de descontar os impostos (PIS/COFINS).',
        formula: 'Resultado Liquido = Resultado Bruto - PIS/COFINS'
      },
      cardMargemLiquida: {
        details: {
          d1: 'Quanto maior, menor o impacto dos impostos no resultado.'
        },
        title: 'Margem Liquida',
        description: 'Qual percentual do resultado bruto sobrou depois dos impostos.',
        formula: 'Margem Liquida = (Resultado Liquido / Resultado Bruto) x 100'
      },
      cardTotalIof: {
        details: {
          d1: 'IOF e o Imposto sobre Operacoes Financeiras, cobrado em operacoes de cambio.'
        },
        title: 'IOF Total',
        description: 'Quanto de IOF foi cobrado em todas as operacoes.',
        formula: 'IOF Total = soma do IOF de cada operacao'
      },
      cardPisCofins: {
        details: {
          d1: 'Esse imposto incide sobre o resultado bruto das operacoes.'
        },
        title: 'PIS/COFINS',
        description: 'Quanto de PIS/COFINS incidiu sobre o resultado das operacoes.',
        formula: 'PIS/COFINS = soma do PIS/COFINS de cada operacao'
      },
      cardVolumePendente: {
        details: {
          d1: 'Sao operacoes em andamento, aguardando finalizacao.'
        },
        title: 'Volume Pendente',
        description: 'Quanto dinheiro esta em operacoes que ainda nao foram liquidadas.',
        formula: 'Volume Pendente = soma do valor das operacoes nao liquidadas'
      },
      cardTaxaLiquidacao: {
        details: {
          d1: 'Quanto maior, mais eficiente esta o processo de liquidacao.'
        },
        title: 'Taxa de Liquidacao',
        description: 'Qual percentual das operacoes ja foi liquidado.',
        formula: 'Taxa de Liquidacao = (operacoes liquidadas / total de operacoes) x 100'
      },
      cardVetMedio: {
        details: {
          d1: 'VET = taxa de cambio + IOF + tarifas. E o custo total real para o cliente.'
        },
        title: 'VET Medio',
        description: 'Valor Efetivo Total medio das operacoes. E uma exigencia do Banco Central.',
        formula: 'VET Medio = media do VET de todas as operacoes'
      },
      cardSpreadMinimo: {
        details: {
          d1: 'Mostra o piso de margem praticado.'
        },
        title: 'Spread Minimo',
        description: 'A menor margem percentual praticada no periodo.',
        formula: 'Spread Minimo = menor margem dentre todas as operacoes'
      },
      cardTotalIr: {
        details: {
          d1: 'IR retido na fonte sobre operacoes de cambio.'
        },
        title: 'IR Total',
        description: 'Quanto de Imposto de Renda foi retido nas operacoes.',
        formula: 'IR Total = soma do IR de cada operacao'
      },
      cardTotalCide: {
        details: {
          d1: 'CIDE e a Contribuicao de Intervencao no Dominio Economico.'
        },
        title: 'CIDE Total',
        description: 'Quanto de CIDE foi cobrado nas operacoes.',
        formula: 'CIDE Total = soma da CIDE de cada operacao'
      },
      chartRentabilidadeNatureza: {
        details: {
          d1: 'Permite comparar quais tipos de operacao sao mais rentaveis.'
        },
        title: 'Rentabilidade por Natureza',
        description: 'Qual a margem de resultado de cada tipo de operacao.',
        formula: 'Margem por natureza = (resultado da natureza / volume da natureza) x 100'
      },
      chartCargaTributaria: {
        details: {
          d1: 'O grafico mostra a proporcao de cada tributo no custo total.'
        },
        title: 'Composicao Tributaria',
        description: 'Como os impostos se dividem entre IOF, PIS/COFINS, IR e CIDE.',
        formula: 'Total de Tributos = IOF + PIS/COFINS + IR + CIDE'
      },
      cardCotacaoMedia: {
        details: {
          d1: 'Reflete a taxa efetiva praticada no periodo.'
        },
        title: 'Cotacao Media',
        description: 'Qual foi a cotacao media da moeda estrangeira nas operacoes.',
        formula: 'Cotacao Media = media ponderada da cotacao (operacoes maiores pesam mais)'
      },
      cardVolumeMoedaEstrangeira: {
        details: {
          d1: 'Exemplo: se operou 10.000 dolares e 5.000 euros, mostra o total em moeda estrangeira.'
        },
        title: 'Volume em Moeda Estrangeira',
        description: 'Quanto foi operado no total em moeda estrangeira (sem converter para reais).',
        formula: 'Volume ME = soma do valor em moeda estrangeira de cada operacao'
      },
      cardSaldoCompraVenda: {
        details: {
          d1: 'Positivo = comprou mais do que vendeu.',
          d2: 'Negativo = vendeu mais do que comprou.'
        },
        title: 'Saldo Compra vs Venda',
        description: 'A diferenca entre o que foi comprado e o que foi vendido em cambio.',
        formula: 'Saldo = Volume de Compra - Volume de Venda'
      },
      cardVolumeVenda: {
        details: {
          d1: 'Considera apenas operacoes do tipo venda.'
        },
        title: 'Volume de Venda',
        description: 'Quanto foi movimentado em operacoes de venda de moeda estrangeira.',
        formula: 'Volume de Venda = soma do valor em reais das operacoes de venda'
      },
      cardVolumeCompra: {
        details: {
          d1: 'Considera apenas operacoes do tipo compra.'
        },
        title: 'Volume de Compra',
        description: 'Quanto foi movimentado em operacoes de compra de moeda estrangeira.',
        formula: 'Volume de Compra = soma do valor em reais das operacoes de compra'
      },
      cardVolumePayin: {
        details: {
          d1: 'Considera apenas depositos finalizados. Valor em reais.'
        },
        title: 'Volume Pay In',
        description: 'Quanto dinheiro entrou (depositos) no periodo.',
        formula: 'Volume Pay In = soma do valor dos depositos concluidos'
      },
      cardVolumePayout: {
        details: {
          d1: 'Considera apenas saques finalizados. Valor em dolares.'
        },
        title: 'Volume Pay Out',
        description: 'Quanto dinheiro saiu (saques) no periodo.',
        formula: 'Volume Pay Out = soma do valor dos saques concluidos'
      },
      cardPayinsConcluidos: {
        details: {
          d1: 'Apenas transacoes de entrada finalizadas.'
        },
        title: 'Pay Ins Concluidos',
        description: 'Quantos depositos foram finalizados com sucesso.',
        formula: 'Pay Ins Concluidos = quantidade de depositos finalizados'
      },
      cardPayoutsConcluidos: {
        details: {
          d1: 'Apenas transacoes de saida finalizadas.'
        },
        title: 'Pay Outs Concluidos',
        description: 'Quantos saques foram finalizados com sucesso.',
        formula: 'Pay Outs Concluidos = quantidade de saques finalizados'
      },
      cardDiasComOperacao: {
        details: {
          d1: 'Cada dia e contado uma unica vez.'
        },
        title: 'Dias com Operacao',
        description: 'Em quantos dias do periodo houve pelo menos uma operacao.',
        formula: 'Dias com Operacao = quantidade de dias com ao menos uma operacao'
      },
      cardMaiorVolumeDia: {
        details: {
          d1: 'Identifica o dia de pico.'
        },
        title: 'Maior Volume em um Dia',
        description: 'Qual foi o dia com mais dinheiro movimentado.',
        formula: 'Maior Volume = maior volume diario dentre todos os dias'
      },
      cardOperacaoMediaUsd: {
        details: {
          d1: 'Mostra o tamanho medio das operacoes stablecoin.'
        },
        title: 'Operacao Media (USD)',
        description: 'Em media, quanto vale cada operacao em dolares.',
        formula: 'Operacao Media = volume total em dolares / total de operacoes'
      },
      cardTempoPreenchimentoFicha: {
        details: {
          d1: 'Considera apenas clientes que finalizaram o preenchimento.',
          d2: 'A media de uma etapa pode ser maior que o tempo total, pois cada etapa tem um grupo diferente de clientes.'
        },
        title: 'Tempo Medio Preenchimento',
        description: 'Quanto tempo, em media, o cliente leva para preencher a ficha cadastral.',
        formula: 'Tempo Medio = media do tempo de preenchimento dos clientes que completaram a etapa'
      },
      cardTempoAnaliseInterna: {
        details: {
          d1: 'Considera apenas clientes que passaram por essa etapa.'
        },
        title: 'Tempo Medio Analise',
        description: 'Quanto tempo, em media, leva a analise interna do cadastro.',
        formula: 'Tempo Medio = media do tempo entre envio do cadastro e conclusao da analise'
      },
      cardTempoAprovacaoBanco: {
        details: {
          d1: 'Considera apenas clientes que receberam resposta do banco.'
        },
        title: 'Tempo Aprovacao Banco',
        description: 'Quanto tempo, em media, o banco leva para aprovar o cadastro.',
        formula: 'Tempo Medio = media do tempo entre envio ao banco e resposta'
      },
      cardTempoTotalCadastro: {
        details: {
          d1: 'Do envio da ficha ate a finalizacao completa.',
          d2: 'Pode ser menor que as medias individuais, pois so inclui quem terminou tudo.'
        },
        title: 'Tempo Total Cadastro',
        description: 'Quanto tempo, em media, leva todo o processo de cadastro do inicio ao fim.',
        formula: 'Tempo Total = media do tempo total dos clientes que completaram todas as etapas'
      },
      cardTaxaConversaoCadastro: {
        details: {
          d1: 'Mede a eficiencia do processo cadastral.'
        },
        title: 'Taxa de Conversao',
        description: 'Qual percentual dos clientes que iniciaram o cadastro conseguiu finalizar.',
        formula: 'Taxa de Conversao = (clientes finalizados / clientes que iniciaram) x 100'
      },
      cardClientesParadosFluxo: {
        details: {
          d1: 'Pode indicar problemas ou gargalos no processo.'
        },
        title: 'Clientes Parados',
        description: 'Quantos clientes comecaram o cadastro mas nao terminaram.',
        formula: 'Clientes Parados = quantidade de clientes com cadastro iniciado e nao finalizado'
      },
      cardTaxaPendenciaBanco: {
        details: {
          d1: 'Indica quanto retrabalho esta acontecendo na aprovacao bancaria.'
        },
        title: 'Taxa de Pendencia Banco',
        description: 'Qual percentual dos clientes recebeu pendencia do banco.',
        formula: 'Taxa de Pendencia = (clientes com pendencia / clientes enviados ao banco) x 100'
      },
      cardTaxaAprovacaoBanco: {
        details: {
          d1: 'Mede a efetividade do processo de aprovacao.'
        },
        title: 'Taxa Aprovacao Banco',
        description: 'Qual percentual dos clientes enviados ao banco foi aprovado.',
        formula: 'Taxa de Aprovacao = (clientes aprovados / clientes enviados ao banco) x 100'
      },
      chartTempoEtapasFluxo: {
        details: {
          d1: 'Grafico de barras comparando o tempo de cada etapa.'
        },
        title: 'Tempo por Etapa',
        description: 'Quanto tempo cada etapa do cadastro leva, em media.',
        formula: 'Tempo por etapa = media do tempo dos clientes que passaram por aquela etapa'
      },
      chartEvolucaoTempoCadastro: {
        details: {
          d1: 'Mostra se o processo esta ficando mais rapido ou mais lento.'
        },
        title: 'Evolucao Tempo Cadastro',
        description: 'Como o tempo total de cadastro variou mes a mes.',
        formula: 'Tempo no mes = media do tempo total dos cadastros finalizados naquele mes'
      },
      chartFunilCadastral: {
        details: {
          d1: 'O formato de funil mostra onde os clientes estao parando.'
        },
        title: 'Funil de Conversao',
        description: 'Quantos clientes chegaram em cada etapa do cadastro.',
        formula: 'Clientes por etapa = quantidade de clientes que atingiram aquele ponto'
      },
      chartDistribuicaoPfPj: {
        details: {
          d1: 'Grafico de barras mostrando a proporcao PF vs PJ por etapa.'
        },
        title: 'Distribuicao PF vs PJ',
        description: 'Quantos sao Pessoa Fisica e quantos sao Pessoa Juridica em cada etapa.',
        formula: 'PF e PJ por etapa = quantidade de cada tipo em cada etapa do cadastro'
      },
      chartClientesPorStatus: {
        details: {
          d1: 'Mostra a foto atual do fluxo cadastral.'
        },
        title: 'Clientes por Status Atual',
        description: 'Quantos clientes estao em cada status do cadastro agora.',
        formula: 'Clientes por status = quantidade de clientes em cada status atual'
      },
      cardLtvMedio: {
        details: {
          d1: 'LTV significa o valor que o cliente gera ao longo do tempo.',
          d2: 'Quanto maior, mais valioso e o cliente para o negocio.'
        },
        title: 'LTV Medio',
        description: 'Em media, quanto de resultado cada cliente gerou ao longo de todo o relacionamento.',
        formula: 'LTV Medio = resultado bruto total de todos os clientes / quantidade de clientes'
      },
      cardReceitaMediaCliente: {
        details: {
          d1: 'Mostra quanto cada cliente contribui em media.'
        },
        title: 'Receita Media/Cliente',
        description: 'Em media, quanto de receita cada cliente ativo gerou.',
        formula: 'Receita por Cliente = Resultado Bruto Total / Clientes Ativos'
      },
      cardFrequenciaMedia: {
        details: {
          d1: 'Quanto maior, mais engajados estao os clientes.'
        },
        title: 'Frequencia Media',
        description: 'Em media, quantas operacoes cada cliente fez no periodo.',
        formula: 'Frequencia Media = total de operacoes / clientes ativos'
      },
      cardTempoVidaMedio: {
        details: {
          d1: 'Mostra por quanto tempo os clientes permanecem ativos.'
        },
        title: 'Tempo de Vida Medio',
        description: 'Em media, quantos dias dura o relacionamento com cada cliente.',
        formula: 'Tempo de Vida = media dos dias entre a primeira e a ultima operacao de cada cliente'
      },
      cardTaxaRetencao: {
        details: {
          d1: 'Quanto maior, melhor a capacidade de manter clientes.'
        },
        title: 'Taxa de Retencao',
        description: 'Qual percentual dos clientes operou em mais de um mes.',
        formula: 'Taxa de Retencao = (clientes que operaram em 2+ meses / total de clientes) x 100'
      },
      cardTaxaChurn: {
        details: {
          d1: 'Quanto maior esse numero, pior a retencao de clientes.'
        },
        title: 'Perda de Clientes (Churn)',
        description: 'Qual percentual dos clientes parou de operar no periodo.',
        formula: 'Churn = (clientes que nao operaram no periodo / base historica de clientes) x 100'
      },
      cardClientesAltoValor: {
        details: {
          d1: 'Sao os clientes mais valiosos para o negocio.'
        },
        title: 'Clientes Alto Valor',
        description: 'Quantos clientes estao entre os 25% que mais geram resultado.',
        formula: 'Clientes Alto Valor = quantidade de clientes no topo dos 25% em resultado gerado'
      },
      cardBaseClientesLtv: {
        details: {
          d1: 'E a base usada para calcular todas as metricas de valor do cliente.'
        },
        title: 'Base Clientes LTV',
        description: 'Quantos clientes foram considerados no calculo de valor do cliente.',
        formula: 'Base = quantidade de clientes com ao menos uma operacao no periodo'
      },
      chartSegmentacaoLtv: {
        details: {
          d1: 'O grafico mostra a distribuicao dos clientes por faixa de valor.'
        },
        title: 'Segmentacao por Valor do Cliente',
        description: 'Como os clientes se dividem por faixa de valor gerado (alto, medio, baixo).',
        formula: 'Clientes por faixa = quantidade de clientes em cada faixa de valor'
      },
      chartEvolucaoLtv: {
        details: {
          d1: 'Mostra a tendencia do valor do cliente ao longo do tempo.'
        },
        title: 'Evolucao do Valor do Cliente',
        description: 'Como o valor medio gerado por cliente variou mes a mes.',
        formula: 'LTV no mes = resultado medio acumulado por cliente naquele mes'
      },
      chartTopClientesLtv: {
        details: {
          d1: 'Ranking dos clientes mais valiosos.'
        },
        title: 'Top Clientes por Valor',
        description: 'Os 10 clientes que mais geraram resultado ao longo do tempo.',
        formula: 'Valor do cliente = soma de todo o resultado gerado por ele (mostra os 10 maiores)'
      },
      chartRetencaoCoorte: {
        details: {
          d1: 'Agrupados pelo mes da primeira operacao. Areas mais escuras = maior retencao.'
        },
        title: 'Retencao por Grupo',
        description: 'Por quanto tempo os clientes continuam operando apos a primeira operacao.',
        formula: 'Retencao = (clientes que continuaram operando / clientes do grupo original) x 100'
      }
    },
    drilldownColumnsUi: {
      customer: 'Cliente',
      foreignAmount: 'Valor ME',
      valueBrl: 'Valor BRL',
      date: 'Data',
      name: 'Nome',
      city: 'Cidade',
      registrationDate: 'Data Cadastro',
      operationsCount: 'Qtd. Operações',
      totalVolume: 'Volume Total',
      grossProfit: 'Lucro Bruto',
      bank: 'Banco',
      commission: 'Comissão',
      marginPercent: 'Margem %',
      totalCommission: 'Comissão Total',
      correspondentProfit: 'Lucro Corresp.',
      indicatorProfit: 'Lucro Indicador',
      masterProfit: 'Lucro Master',
      bankProfit: 'Lucro Banco',
      correspondent: 'Correspondente',
      totalProfit: 'Lucro Total',
      profit: 'Lucro',
      netProfit: 'Lucro Líquido',
      iofValue: 'Valor IOF',
      irValue: 'Valor IR',
      cideValue: 'Valor CIDE',
      quotation: 'Cotação',
      type: 'Tipo',
      fillingTime: 'Tempo Preenchimento',
      analysisTime: 'Tempo Análise',
      approvalTime: 'Tempo Aprovação',
      totalTime: 'Tempo Total',
      currentStep: 'Etapa Atual',
      bankStatus: 'Status Banco',
      nature: 'Natureza',
      agent: 'Agente',
      segment: 'Segmento',
      tax: 'Tributo',
      taxValue: 'Valor Tributo',
      stageTime: 'Tempo na Etapa',
      cohort: 'Coorte',
      currency: 'Moeda',
      buyRate: 'Taxa de Compra',
      sellRate: 'Taxa de Venda',
      quotationType: 'Tipo de Cotação',
      dateTime: 'Data/Hora'
    },
    drilldownCardConfigsUi: {
      titles: {
        cardTotalOperado: 'Operações - Total Operado',
        cardTotalOperacoes: 'Operações - Total de Operações',
        cardLucroBruto: 'Operações - Lucro Bruto',
        cardClientesAtivos: 'Clientes Ativos',
        cardClientesTotais: 'Clientes Totais',
        cardClientesAprovados: 'Clientes Aprovados',
        cardClientesRecorrentes: 'Clientes Recorrentes',
        cardTicketPorCliente: 'Clientes - Ticket por Cliente',
        cardOpsPorCliente: 'Operações por Cliente',
        cardVolumePorBanco: 'Operações - Volume por Banco',
        cardTicketMedio: 'Operações - Ticket Médio',
        cardSpreadMedio: 'Operações - Spread Médio',
        cardBancosAtivos: 'Operações - Bancos Ativos',
        cardMoedasOperadas: 'Operações - Moedas Operadas',
        cardLucroPorReal: 'Lucro por Real Operado',
        cardComissaoMedia: 'Operações - Comissão Média',
        cardMargemBruta: 'Operações - Margem Bruta',
        cardTotalComissoes: 'Operações - Total Comissões',
        cardLucroCorban: 'Operações - Lucro Correspondente',
        cardLucroIndicador: 'Operações - Lucro Indicador',
        cardLucroMaster: 'Operações - Lucro Master',
        cardLucroBanco: 'Operações - Lucro Banco',
        cardCorrespondentesAtivos: 'Operações - Correspondentes Ativos',
        cardVolumeCorrespondentes: 'Operações - Volume por Correspondente',
        cardComissoesPagas: 'Operações - Comissões Pagas',
        cardMediaOpsCorresp: 'Operações - Média por Correspondente',
        cardClientesUnicos: 'Clientes Únicos',
        cardClientesFrequentes: 'Clientes Frequentes',
        cardClientesRegulares: 'Clientes Regulares',
        cardClientesOcasionais: 'Clientes Ocasionais',
        cardSpreadMaximo: 'Operações - Spread Máximo',
        cardLucroPorCliente: 'Clientes - Lucro por Cliente',
        cardTaxaRecorrencia: 'Clientes Recorrentes',
        cardConcentracaoTop10: 'Top 10 Clientes por Volume',
        cardVolumeRecorrentes: 'Volume de Clientes Recorrentes',
        cardOpsPorDia: 'Operações por Dia',
        cardConcentracaoTop1: 'Top 1 Cliente por Volume',
        cardLucroPorOperacao: 'Operações - Lucro por Operação',
        cardVolumePayin: 'Pay Ins - Volume',
        cardVolumePayout: 'Pay Outs - Volume',
        cardPayinsConcluidos: 'Pay Ins Concluídos',
        cardPayoutsConcluidos: 'Pay Outs Concluídos',
        cardDiasComOperacao: 'Operações - Dias com Operação',
        cardMaiorVolumeDia: 'Operações - Maior Volume em um Dia',
        cardOperacaoMediaUsd: 'Operações - Valor Médio (USD)',
        cardLucroLiquido: 'Operações - Lucro Líquido',
        cardMargemLiquida: 'Operações - Margem Líquida',
        cardTotalIof: 'Operações - Total IOF',
        cardTotalIr: 'Operações - Total IR',
        cardTotalCide: 'Operações - Total CIDE',
        cardPisCofins: 'Operações - PIS/COFINS',
        cardVolumePendente: 'Operações - Volume Pendente',
        cardTaxaLiquidacao: 'Operações - Taxa de Liquidação',
        cardVetMedio: 'Operações - VET Médio',
        cardSpreadMinimo: 'Operações - Spread Mínimo',
        cardCotacaoMedia: 'Operações - Cotação Média',
        cardVolumeMoedaEstrangeira: 'Operações - Volume em Moeda Estrangeira',
        cardSaldoCompraVenda: 'Operações - Saldo Compra vs Venda',
        cardVolumeVenda: 'Operações - Volume de Venda',
        cardVolumeCompra: 'Operações - Volume de Compra',
        cardTempoPreenchimentoFicha: 'Clientes - Tempo de Preenchimento',
        cardTempoAnaliseInterna: 'Clientes - Tempo de Análise',
        cardTempoAprovacaoBanco: 'Clientes - Tempo Aprovação Banco',
        cardTempoTotalCadastro: 'Clientes - Tempo Total Cadastro',
        cardTaxaConversaoCadastro: 'Clientes - Taxa de Conversão',
        cardClientesParadosFluxo: 'Clientes Parados no Fluxo',
        cardTaxaPendenciaBanco: 'Clientes - Pendência Banco',
        cardTaxaAprovacaoBanco: 'Clientes - Aprovação Banco',
        cardLtvMedio: 'Clientes - LTV Médio',
        cardReceitaMediaCliente: 'Clientes - Receita Média',
        cardFrequenciaMedia: 'Clientes - Frequência Média',
        cardTempoVidaMedio: 'Clientes - Tempo de Vida',
        cardTaxaRetencao: 'Clientes Retidos',
        cardTaxaChurn: 'Clientes Churned',
        cardClientesAltoValor: 'Clientes Alto Valor',
        cardBaseClientesLtv: 'Base Clientes LTV'
      }
    },
    drilldownChartConfigsUi: {
      titles: {
        chartOperadoBanco: 'Operações por Banco',
        chartOperadoMoeda: 'Operações por Moeda',
        chartOpsPorMoeda: 'Operações por Moeda',
        chartVolumePorBanco: 'Volume por Banco',
        chartOpsPorNatureza: 'Operações por Natureza',
        chartCompraVsVenda: 'Operações por Tipo',
        chartHeatmapOperacoes: 'Operações por Dia/Hora',
        chartClientesRegiao: 'Clientes por Região',
        chartTopClientes: 'Operações do Cliente',
        chartClientesPorMes: 'Clientes Ativos no Mês',
        chartDistribuicaoLucros: 'Operações por Agente',
        chartLucroMensal: 'Operações do Mês',
        chartVolumeCorrespondente: 'Operações do Correspondente',
        chartSegmentacaoClientes: 'Clientes por Segmento',
        chartAnaliseSpread: 'Operações por Faixa de Spread',
        chartEvolucaoVolume: 'Operações do Período',
        chartVolumeMensal: 'Operações do Mês',
        chartRentabilidadeNatureza: 'Operações por Natureza',
        chartCargaTributaria: 'Operações por Tipo de Tributo',
        chartTempoEtapasFluxo: 'Clientes por Etapa do Fluxo',
        chartEvolucaoTempoCadastro: 'Clientes por Mês de Cadastro',
        chartFunilCadastral: 'Clientes por Etapa do Funil',
        chartDistribuicaoPfPj: 'Clientes por Tipo e Etapa',
        chartSegmentacaoLtv: 'Clientes por Segmento LTV',
        chartEvolucaoLtv: 'Operações do Mês',
        chartTopClientesLtv: 'Operações do Cliente',
        chartRetencaoCoorte: 'Clientes da Coorte',
        chartHistoricoCotacao: 'Detalhes do Snapshot de Cotação'
      }
    },
    tabIconsUi: {
      dashboard: 'Dashboard',
      currency: 'Moeda',
      users: 'Usuários',
      wallet: 'Carteira',
      handshake: 'Parceria',
      chartLine: 'Gráfico de Linha',
      chartBar: 'Gráfico de Barras',
      chartPie: 'Gráfico de Pizza',
      trendUp: 'Tendência Alta',
      trendDown: 'Tendência Baixa',
      bank: 'Banco',
      receipt: 'Recibo',
      money: 'Dinheiro',
      percent: 'Percentual',
      target: 'Alvo',
      calendar: 'Calendário',
      clock: 'Relógio',
      globe: 'Globo',
      briefcase: 'Maleta',
      building: 'Prédio',
      star: 'Estrela',
      medal: 'Medalha',
      crown: 'Coroa',
      lightning: 'Raio',
      fire: 'Fogo'
    },
    widgetRegistryUi: {
      categories: {
        visaoGeral: {
          label: 'Visão Geral',
          description: 'Métricas gerais e resumo executivo'
        },
        operacoes: {
          label: 'Operações',
          description: 'Detalhes sobre operações realizadas'
        },
        clientes: {
          label: 'Clientes',
          description: 'Informações sobre clientes'
        },
        financeiro: {
          label: 'Financeiro',
          description: 'Análises financeiras e resultados'
        },
        correspondentes: {
          label: 'Correspondentes',
          description: 'Métricas de correspondentes'
        },
        performance: {
          label: 'Performance',
          description: 'Indicadores de performance'
        },
        tributario: {
          label: 'Tributário & Liquidação',
          description: 'Impostos, liquidações e saúde financeira'
        },
        stablecoin: {
          label: 'Stablecoin',
          description: 'Indicadores de operações com stablecoins'
        },
        fluxoCadastral: {
          label: 'Fluxo Cadastral',
          description: 'Métricas de tempo do fluxo cadastral'
        },
        ltv: {
          label: 'LTV & Retenção',
          description: 'Métricas de Lifetime Value e retenção de clientes'
        }
      },
      widgets: {
        cardTotalOperado: 'Total Operado',
        cardTotalOperacoes: 'Total de Operações',
        cardClientesAtivos: 'Clientes Ativos',
        cardLucroBruto: 'Resultado Bruto',
        chartOperadoBanco: 'Valor operado por Banco',
        chartOperadoMoeda: 'Percentual Operado por Moeda',
        chartHistoricoCotacao: 'Histórico de Cotação',
        cardOpsPorCliente: 'Operações por Cliente',
        cardVolumePorBanco: 'Volume por Banco',
        cardTicketMedio: 'Ticket Médio',
        cardSpreadMedio: 'Spread Médio',
        cardMaiorOperacao: 'Maior Operação',
        cardMenorOperacao: 'Menor Operação',
        cardBancosAtivos: 'Bancos Ativos',
        cardMoedasOperadas: 'Moedas Operadas',
        chartOpsPorMoeda: 'Operações por Moeda',
        chartVolumePorBanco: 'Volume por Banco',
        cardClientesTotais: 'Clientes Totais',
        cardClientesAprovados: 'Clientes Aprovados',
        cardClientesRecorrentes: 'Clientes Recorrentes',
        cardTicketPorCliente: 'Ticket por Cliente',
        chartClientesRegiao: 'Clientes por Região',
        chartTopClientes: 'Top Clientes',
        cardLucroPorReal: 'Resultado por Real Operado',
        cardComissaoMedia: 'Comissão Média',
        cardMargemBruta: 'Margem Bruta',
        cardTotalComissoes: 'Total de Comissões',
        cardLucroCorban: 'Resultado PARCEIRO',
        cardLucroIndicador: 'Resultado INDICADOR',
        cardLucroMaster: 'Resultado CORBAN',
        cardLucroBanco: 'Resultado BANCOS',
        cardTarifaCliente: 'Tarifa Paga pelo Cliente',
        cardTarifaBanco: 'Tarifa Cobrada pelo Banco',
        cardSaldoTarifa: 'Saldo de Tarifa',
        chartDistribuicaoLucros: 'Distribuição de Resultados',
        cardCorrespondentesAtivos: 'Correspondentes Ativos',
        cardVolumeCorrespondentes: 'Volume Correspondentes',
        cardComissoesPagas: 'Comissões Pagas',
        cardMediaOpsCorresp: 'Média Ops/Correspondente',
        cardClientesUnicos: 'Clientes Únicos',
        cardClientesFrequentes: 'Clientes Frequentes',
        cardClientesRegulares: 'Clientes Regulares',
        cardClientesOcasionais: 'Clientes Ocasionais',
        chartVolumeCorrespondente: 'Volume por Correspondente',
        chartSegmentacaoClientes: 'Segmentação de Clientes',
        cardSpreadMaximo: 'Spread Máximo',
        cardLucroPorCliente: 'Resultado por Cliente',
        cardTaxaRecorrencia: 'Taxa de Recorrência',
        cardConcentracaoTop10: 'Concentração Top 10',
        cardVolumeRecorrentes: 'Volume Recorrentes',
        cardOpsPorDia: 'Operações por Dia',
        cardConcentracaoTop1: 'Concentração Top 1',
        cardLucroPorOperacao: 'Resultado por Operação',
        cardVolumePayin: 'Volume Pay In',
        cardVolumePayout: 'Volume Pay Out',
        cardPayinsConcluidos: 'Pay Ins Concluídos',
        cardPayoutsConcluidos: 'Pay Outs Concluídos',
        cardDiasComOperacao: 'Dias com Operação',
        cardMaiorVolumeDia: 'Maior Volume em um Dia',
        cardOperacaoMediaUsd: 'Operação Média (USD)',
        chartAnaliseSpread: 'Análise de Spread',
        chartEvolucaoVolume: 'Evolução do Volume',
        cardLucroLiquido: 'Resultado Líquido',
        cardMargemLiquida: 'Margem Líquida',
        cardTotalIof: 'IOF Total',
        cardPisCofins: 'PIS/COFINS',
        cardVolumePendente: 'Volume Pendente',
        cardTaxaLiquidacao: 'Taxa de Liquidação',
        cardVetMedio: 'VET Médio',
        cardSpreadMinimo: 'Spread Mínimo',
        chartRentabilidadeNatureza: 'Rentabilidade por Natureza',
        chartCargaTributaria: 'Composição Tributária',
        cardTotalIr: 'IR Total',
        cardTotalCide: 'CIDE Total',
        cardCotacaoMedia: 'Cotação Média',
        cardVolumeMoedaEstrangeira: 'Volume em Moeda Estrangeira',
        cardSaldoCompraVenda: 'Saldo Compra vs Venda',
        cardVolumeVenda: 'Volume de Venda',
        cardVolumeCompra: 'Volume de Compra',
        chartVolumeMensal: 'Volume Mensal',
        chartLucroMensal: 'Resultado Mensal',
        chartOpsPorNatureza: 'Operações por Natureza',
        chartCompraVsVenda: 'Compra vs Venda',
        chartClientesPorMes: 'Clientes Ativos por Mês',
        cardTempoPreenchimentoFicha: 'Tempo Médio Preenchimento',
        cardTempoAnaliseInterna: 'Tempo Médio Análise',
        cardTempoAprovacaoBanco: 'Tempo Aprovação Banco',
        cardTempoTotalCadastro: 'Tempo Total Cadastro',
        chartTempoEtapasFluxo: 'Tempo por Etapa',
        chartEvolucaoTempoCadastro: 'Evolução Tempo Cadastro',
        cardTaxaConversaoCadastro: 'Taxa de Conversão',
        cardClientesParadosFluxo: 'Clientes Parados',
        cardTaxaPendenciaBanco: 'Taxa de Pendência Banco',
        cardTaxaAprovacaoBanco: 'Taxa Aprovação Banco',
        chartFunilCadastral: 'Funil de Conversão',
        chartDistribuicaoPfPj: 'Distribuição PF vs PJ',
        chartClientesPorStatus: 'Clientes por Status Atual',
        cardLtvMedio: 'LTV Médio',
        cardReceitaMediaCliente: 'Receita Média/Cliente',
        cardFrequenciaMedia: 'Frequência Média',
        cardTempoVidaMedio: 'Tempo de Vida Médio',
        cardTaxaRetencao: 'Taxa de Retenção',
        cardTaxaChurn: 'Perda de Clientes (Churn)',
        cardClientesAltoValor: 'Clientes Alto Valor',
        cardBaseClientesLtv: 'Base Clientes LTV',
        chartSegmentacaoLtv: 'Segmentação por LTV',
        chartEvolucaoLtv: 'Evolução do LTV',
        chartTopClientesLtv: 'Top Clientes por LTV',
        chartRetencaoCoorte: 'Retenção por Coorte',
        chartHeatmapOperacoes: 'Mapa de Calor de Operações'
      },
      simpleDescriptions: {
        cardLtvMedio: 'Valor médio de resultado gerado por cliente ao longo do relacionamento.',
        chartSegmentacaoLtv: 'Distribuição dos clientes por faixas de valor gerado ao longo do relacionamento.',
        chartEvolucaoLtv: 'Evolução do valor médio gerado por cliente ao longo do tempo.',
        chartTopClientesLtv: 'Clientes que mais geraram resultado no período.',
        cardVetMedio: 'Média do VET (valor final da operação), indicador regulatório exigido pelo Banco Central.',
        cardPisCofins: 'Total de PIS/COFINS cobrado nas operações do período.',
        cardTotalIof: 'Total de IOF cobrado nas operações do período.',
        cardTotalIr: 'Total de Imposto de Renda cobrado nas operações do período.',
        cardTotalCide: 'Total de CIDE cobrado nas operações do período.',
        cardTaxaChurn: 'Percentual de clientes que deixaram de operar no período.',
        chartRetencaoCoorte: 'Tempo de permanência dos clientes em operação após o início do relacionamento.'
      },
      defaultName: 'Indicador',
      chartDescription: 'Análise de {name} no período selecionado, facilitando comparações e tendências.',
      cardDescription: 'Resumo de {name} no período selecionado.'
    },
    scenarioValidationUi: {
      nameMaxLength: 'Nome deve ter no máximo 100 caracteres'
    },
    dashboardChartUi: {
      goal: 'Meta: {value}',
      series: 'Série',
      noData: 'Sem dados'
    },
    internationalDashboardUi: {
      customersSeries: 'Clientes',
      sharedScenario: 'Cenário compartilhado',
      cannotDeleteOnlyScenario: 'Não é possível deletar o único cenário disponível'
    },
    customerDashboard: {
      emptyTitle: 'Dashboard não configurado',
      emptyMessage: 'Nenhum dashboard foi configurado para o seu perfil. Entre em contato com o administrador.',
      errorLoadIndicators: 'Não foi possível carregar os indicadores do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadScenario: 'Não foi possível carregar o cenário do dashboard do seu perfil. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorApplyFilter: 'Não foi possível aplicar o filtro do dashboard. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    internationalDashboard: {
      btnEdit: 'Editar',
      btnFinish: 'Concluir',
      btnManageTabs: 'Gerenciar Abas',
      btnTheme: 'Tema',
      emptyTitle: 'Configure seu dashboard',
      emptyMessage: 'Selecione ou crie um cenário acima para personalizar suas abas e widgets. Todos os indicadores (cards e gráficos) estão disponíveis como widgets no modo "Personalizar Dashboard".',
      errorLoadIndicators: 'Não foi possível carregar os indicadores do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorApplyFilter: 'Não foi possível aplicar o filtro do dashboard. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorSaveFilter: 'Não foi possível salvar filtro no cenário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorSaveFilterScenario: 'Não foi possível salvar o filtro no cenário do dashboard. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      successSaveFilter: 'Filtro salvo no cenário',
      errorNoActiveScenario: 'Nenhum cenário ativo para salvar o filtro',
      errorNoUser: 'Não foi possível identificar usuário. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorTimeout: 'O servidor demorou para responder. Verifique se o backend está rodando e tente novamente.',
      errorLoadOperations: 'Não foi possível carregar as operações do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadFilterCustomers: 'Não foi possível carregar a lista de clientes do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCustomerCount: 'Não foi possível carregar a quantidade de clientes do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadTotals: 'Não foi possível carregar os totais do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadPeriodChart: 'Não foi possível carregar o gráfico de operações por período. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadBankChart: 'Não foi possível carregar o gráfico de operações por banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCurrencyChart: 'Não foi possível carregar o gráfico de operações por moeda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadTopCustomers: 'Não foi possível carregar a lista dos principais clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorbanIndicators: 'Não foi possível carregar os indicadores dos corbans. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCustomerSegmentation: 'Não foi possível carregar a segmentação de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadActiveScenario: 'Não foi possível carregar cenário ativo. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorChangeScenario: 'Não foi possível alterar cenário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorLoadDashboardData: 'Não foi possível carregar dados do dashboard. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadSharedScenario: 'Não foi possível carregar cenário compartilhado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadDefaultScenario: 'Não foi possível carregar cenário padrão do perfil. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      successCreateScenario: 'Cenário criado com sucesso',
      errorCreateScenario: 'Não foi possível criar cenário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      successRenameScenario: 'Cenário renomeado com sucesso',
      errorRenameScenario: 'Não foi possível renomear cenário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      successDeleteScenario: 'Cenário deletado com sucesso',
      errorDeleteScenario: 'Não foi possível excluir cenário. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorReloadTabs: 'Não foi possível recarregar abas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSaveLayout: 'Não foi possível salvar layout. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorSaveTheme: 'Não foi possível salvar tema do dashboard. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    cardDashboard: {
      tooltipOpenDetails: 'Abrir detalhes da operação',
      tooltipViewDetails: 'Clique para ver detalhes'
    },
    filterDrawer: {
      btnFilter: 'Filtrar',
      title: 'Filtro',
      labelPeriod: 'Período',
      labelStartDate: 'Data de início',
      labelEndDate: 'Data de fim',
      labelOperation: 'Operação',
      labelType: 'Tipo',
      labelCurrency: 'Moeda',
      labelBank: 'Banco',
      bankInactive: '(inativo)',
      labelCorban: 'Corban',
      labelPersonType: 'Tipo de Pessoa',
      labelCpfCnpj: 'CPF/CNPJ',
      btnClear: 'Limpar',
      btnSaveFilter: 'Salvar e filtrar',
      exchangeBuyLabel: 'Compra',
      exchangeSellLabel: 'Venda',
      errorLoadCurrencies: 'Não foi possível carregar a lista de moedas do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadBanks: 'Não foi possível carregar a lista de bancos do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorbans: 'Não foi possível carregar a lista de correspondentes do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    periodItems: {
      TODAY: 'Hoje',
      THIS_WEEK: 'Esta semana',
      THIS_MONTH: 'Este mês',
      LAST_12_MONTHS: 'Últimos 12 meses',
      LAST_MONTH: 'Mês passado',
      LAST_3_MONTHS: 'Últimos 3 meses',
      LAST_6_MONTHS: 'Últimos 6 meses',
      LAST_YEAR: 'Último ano',
      CUSTOM: 'Personalizado'
    },
    scenarioSelector: {
      fallbackName: 'Cenário',
      validationNameRequired: 'Nome do cenário é obrigatório',
      validationNameDuplicate: 'Já existe um cenário com este nome',
      deleteTitle: 'Deletar Cenário',
      deleteMessage: '<p>Tem certeza que deseja deletar o cenário <strong>{name}</strong>?</p>',
      deleteIrreversibleMessage: 'Esta ação não pode ser desfeita. Todas as abas e widgets deste cenário serão permanentemente removidos.',
      deleteKeyword: 'DELETAR',
      deleteInputPlaceholder: 'Digite "DELETAR" para confirmar',
      errorLimitReached: 'Você atingiu o limite de 10 cenários por usuário',
      warningNameUnchanged: 'O nome não foi alterado',
      duplicateSuffix: 'Cópia'
    },
    scenarioCreateDialog: {
      title: 'Criar Novo Cenário',
      labelName: 'Nome do Cenário',
      placeholder: 'Ex: Dashboard Executivo',
      warningLimit: 'Você está próximo do limite de 10 cenários por usuário. Atualmente você tem {count} cenário(s).',
      btnCancel: 'Cancelar',
      btnCreate: 'Criar cenário'
    },
    scenarioRenameDialog: {
      title: 'Renomear cenário',
      labelName: 'Nome do Cenário',
      btnCancel: 'Cancelar',
      btnRename: 'Renomear'
    },
    scenarioActionButtons: {
      btnNew: 'Novo',
      btnRename: 'Renomear',
      btnDuplicate: 'Duplicar',
      btnShare: 'Compartilhar',
      btnManageSharing: 'Gerenciar compartilhamentos',
      btnDelete: 'Deletar Cenário'
    },
    tabManagerDialog: {
      title: 'Gerenciar abas',
      sectionTitle: 'Minhas Abas',
      btnAddTab: 'Adicionar aba',
      dragHint: 'Arraste as abas para reordenar. As mudanças são salvas automaticamente.',
      btnClose: 'Fechar'
    },
    widgetLibrary: {
      title: 'Biblioteca de Widgets',
      searchLabel: 'Buscar widgets',
      searchPlaceholder: 'Digite o nome do widget...',
      allCategory: 'Todos',
      emptyTitle: 'Nenhum widget encontrado.',
      emptySubtitle: 'Tente ajustar os filtros ou termo de busca.',
      btnClose: 'Fechar',
      errorNoActiveTab: 'Nenhuma aba ativa para adicionar o widget',
      errorWidgetExists: 'Este widget já existe na aba atual'
    },
    tabFormDialog: {
      titleCreate: 'Criar Nova aba',
      titleEdit: 'Editar aba',
      labelName: 'Nome da aba',
      placeholder: 'Ex: Minhas Métricas',
      labelIcon: 'Ícone da aba',
      btnSave: 'Salvar Alterações',
      btnCreate: 'Criar aba',
      btnCancel: 'Cancelar',
      validationNameRequired: 'Nome é obrigatório',
      validationNameEmpty: 'Nome não pode estar vazio'
    },
    maxValueDialog: {
      title: 'Meta do indicador',
      descriptionPrefix: 'Defina o valor da meta para',
      labelTarget: 'Meta',
      btnConfirm: 'Confirmar',
      btnCancel: 'Cancelar',
      validationPositive: 'Valor deve ser maior que zero'
    },
    tabList: {
      orderLabel: 'Ordem: {n}',
      emptyTitle: 'Nenhuma aba criada ainda.',
      emptySubtitle: 'Clique em "Adicionar Aba" para criar sua primeira aba personalizada.'
    },
    tabManager: {
      deleteTitle: 'Deletar Aba',
      deleteMessage: 'Tem certeza que deseja deletar a aba <strong>{name}</strong>? Todos os widgets posicionados nela serão permanentemente removidos.',
      successDelete: 'Tab deletada com sucesso',
      errorDelete: 'Não foi possível excluir aba. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      successReorder: 'Ordem das tabs atualizada com sucesso',
      errorReorder: 'Não foi possível reordenar abas. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      validationNameRequired: 'Nome da tab é obrigatório',
      successCreate: 'Tab criada com sucesso',
      errorCreate: 'Não foi possível criar aba. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      successUpdate: 'Tab atualizada com sucesso',
      errorUpdate: 'Não foi possível atualizar aba. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    scenarioSelectInput: {
      fallbackName: 'Cenário',
      sharedWithMe: 'Compartilhados comigo',
      viaProfile: 'Via perfil: {name}'
    },
    sharingModal: {
      title: 'Compartilhar cenário',
      tabUsers: 'Usuários',
      tabProfiles: 'Perfis',
      searchLabel: 'Buscar usuário por nome ou e-mail',
      searchPlaceholder: 'Digite para buscar...',
      noUserFound: 'Nenhum usuário encontrado',
      searchMinChars: 'Digite ao menos 2 caracteres para buscar',
      recipientsTitle: 'Destinatários',
      noRecipients: 'Nenhum destinatário adicionado ainda.',
      loadingProfiles: 'Carregando perfis...',
      noProfiles: 'Nenhum perfil disponível para compartilhamento.',
      alreadyShared: 'Já compartilhado',
      btnConfirm: 'Confirmar',
      btnCancel: 'Cancelar',
      permissionView: 'Visualização',
      permissionEdit: 'Edição',
      duplicateUser: 'Este usuário já foi adicionado',
      successShared: 'Cenário compartilhado com sucesso',
      errorLoadProfiles: 'Não foi possível carregar perfis. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSearchUsers: 'Não foi possível buscar usuários. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorShare: 'Não foi possível compartilhar cenário. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    manageSharingsModal: {
      title: 'Gerenciar compartilhamentos',
      tabUsers: 'Usuários',
      tabProfiles: 'Perfis',
      noUsersShared: 'Cenário ainda não foi compartilhado com nenhum usuário',
      noProfilesShared: 'Cenário ainda não foi compartilhado com nenhum perfil',
      btnClose: 'Fechar',
      permissionView: 'Visualização',
      permissionEdit: 'Edição',
      errorLoadUserSharings: 'Não foi possível carregar compartilhamentos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorUpdatePermission: 'Não foi possível atualizar permissão. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorRevokeAccess: 'Não foi possível revogar acesso. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorLoadProfileSharings: 'Não foi possível carregar compartilhamentos por perfil. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    drilldownModal: {
      loadingText: 'Carregando dados...',
      emptyText: 'Nenhum registro encontrado para este filtro',
      btnExportCsv: 'Exportar CSV',
      btnClose: 'Fechar',
      errorLoad: 'Não foi possível carregar dados do detalhamento. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      defaultTitle: 'Detalhamento'
    },
    themePicker: {
      title: 'Selecionar tema',
      btnClose: 'Fechar'
    },
    calculationMemory: {
      whatIs: 'O que é',
      formula: 'Cálculo',
      details: 'Detalhes'
    },
    defaultTab: {
      colProfile: 'Perfil',
      colDefaultDashboard: 'Dashboard Padrão',
      colActions: 'Ações',
      noScenarioText: 'Nenhum cenário encontrado. Crie cenários no dashboard primeiro.',
      notConfigured: 'Não configurado',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      emptyProfiles: 'Nenhum perfil encontrado.',
      removeTitle: 'Remover Dashboard Padrão',
      removeMessage: 'Deseja remover o dashboard padrão do perfil <strong>{name}</strong>?',
      successSave: 'Dashboard padrão configurado com sucesso.',
      successRemove: 'Dashboard padrão removido com sucesso.',
      errorLoad: 'Não foi possível carregar os dashboards padrões. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadScenarios: 'Não foi possível carregar os cenários disponíveis. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSave: 'Não foi possível salvar a configuração. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorRemove: 'Não foi possível remover o dashboard padrão. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    gridLayout: {
      preparing: 'Preparando dashboard...'
    },
    widgetContentRenderer: {
      tooltipOpenOperation: 'Abrir operação'
    },
    chartTypeSelector: {
      title: 'Tipo de gráfico',
      titleNewWidget: 'Adicionar gráfico',
      subtitle: 'Escolha como este widget será exibido',
      subtitleNewWidget: 'Escolha como este gráfico será exibido no dashboard',
      tooltipDisabled: 'Inadequado para os dados deste gráfico',
      btnCancel: 'Cancelar',
      btnApply: 'Aplicar',
      typeBar: 'Colunas',
      typeHorizontalBar: 'Barras',
      typeFunnel: 'Funil',
      typeArea: 'Área',
      typeDonut: 'Rosca',
      typePie: 'Pizza',
      typeTreemap: 'Mapa de Área',
      typeRadar: 'Radar',
      typeRadialBar: 'Radial'
    },
    chart: {
      noDetailTitle: 'Detalhamento não disponível',
      noDetailMessage: 'Este elemento não possui dados detalhados para exibição.',
      noDetailIdentifyMessage: 'Não foi possível identificar o item clicado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    }
  },

  reports: {
    duimpDueOperationReportUi: {
      totalMe: 'Total ME',
      pendingDuimp: 'Pendente DUIMP'
    },
    exchangeOperationReportUi: {
      totalValue: 'Valor Total'
    },
    approvalActionsUi: {
      renewLink: 'Renovar e reenviar link',
      remind: 'Reenviar lembrete',
      history: 'Ver andamento e histórico',
      resumeForeign: 'Retomar envio ao exterior'
    },
    stablecoinRemittanceOperationReportUi: {
      payment: 'Pagamento',
      tooltipPayIn: 'Valor em {token} recebido na wallet do cliente após o pagamento fiat',
      tooltipPayOut: 'Valor em {token} enviado da wallet do cliente para o destino fiat',
      tooltipFull: 'Valor em {token} processado na operação completa (entrada e saída)',
      tooltipBoleto: 'Pagamento de boleto bancário realizado com stablecoin da wallet do cliente',
      tooltipPix: 'Pagamento PIX realizado com stablecoin da wallet do cliente',
      tooltipForeign: 'Valor em moeda estrangeira da operação',
      payableDescription: 'Pagamento de {kind}',
      payableDescriptionTo: 'Pagamento de {kind} para {beneficiary}'
    },
    remittanceOperationManagementReportUi: {
      operationalExpense: 'Despesa operacional',
      operationalExpenseTooltip: 'Total de tarifas bancárias cobradas pelo banco de câmbio ao contratante no período, nas operações onde o cliente não pagou a tarifa.',
      customerPaidExpense: 'Despesa paga pelo cliente',
      customerPaidExpenseTooltip: 'Total de tarifas bancárias pagas pelos clientes no período. Representa receita para o contratante.',
      residualExpense: 'Despesa residual',
      residualExpenseTooltip: 'Diferença entre o que o contratante recebeu de tarifa dos clientes e o que pagou ao banco. Negativo indica que o contratante pagou mais do que recebeu.',
      corbanMaster: 'Corban master'
    },
    managementExportUi: {
      title: 'LUCRO / REMESSAS INTERNACIONAIS',
      period: 'Período: {start} a {end}',
      exportedAt: 'Exportado em: {date}',
      summary: 'RESUMO',
      indicator: 'Indicador',
      value: 'Valor',
      operations: 'OPERAÇÕES',
      currency: 'Moeda',
      amountMe: 'Valor ME',
      spreadPercent: 'Spread (%)',
      grossProfit: 'Lucro Bruto',
      corbanMasterProfit: 'Lucro Corban Master',
      corbanProfit: 'Lucro Corban',
      bankCommission: 'Comissão Banco (%)',
      corbanCommission: 'Comissão Corban (%)',
      indicatorCommission: 'Comissão Indicador (%)'
    },
    searchPlaceholder: 'Pesquisar em todos os campos (cliente, banco, valores, documentos, etc.)',
    stablecoinSearchPlaceholder: 'Pesquisar em todos os campos...',
    customerApproval: 'Aprovação do cliente',
    lastUpdated: 'Última atualização: {date}',
    exchangeBuy: 'Compra',
    exchangeSell: 'Venda',
    emptyTitle: 'Nenhum registro encontrado',
    actions: 'Ações',
    options: 'Opções',
    editing: 'Em edição por {user}',
    pixExpired: 'Expirado',
    tooltips: {
      downloadBankProduct: 'Baixar documento de produto bancário',
      manageDuimp: 'Gerenciar DUIMPs',
      downloadDoc: 'Baixar documento',
      viewRefusal: 'Ver motivo da recusa',
      manageInvoices: 'Gerenciar Invoices',
      editShippingDate: 'Editar data de embarque',
      edit: 'Editar'
    },
    expand: {
      operation: 'Operação',
      taxes: 'Taxas e valores',
      taxesAndTributes: 'Taxas e tributos',
      taxesAndResult: 'Taxas e resultado',
      result: 'Resultado',
      tributes: 'Tributos',
      parties: 'Partes envolvidas',
      operationNum: 'Nº da OP',
      opNum: 'N° da OP',
      nature: 'Natureza da operação',
      natureShort: 'Natureza',
      bankProduct: 'Produto bancário',
      originDestination: 'Origem / Destino',
      noTaxRate: 'Taxa sem IOF',
      customerRate: 'Taxa do Cliente',
      subtotal: 'Subtotal',
      vet: 'VET',
      vetTooltip: 'Valor efetivo total',
      deliveryCost: 'Custo de delivery',
      corban: 'Corban',
      corbanIndicator: 'Corban Indicador',
      bank: 'Banco',
      agent: 'Agente',
      observation: 'Observação',
      delivery: 'Entrega',
      profit: 'Lucro',
      currentProfit: 'Lucro Atual',
      spotForecast: 'SPOT Previsto',
      spotCurrent: 'SPOT Atual',
      updatingIn: 'Atualizando em {seconds}s',
      tariff: 'Tarifa',
      iof: 'IOF',
      ir: 'IR',
      bankAccount: 'Conta Bancária',
      accountType: 'Tipo',
      accountName: 'Nome',
      accountNumber: 'Número da Conta',
      routingNumber: 'Routing Number',
      beneficiaryName: 'Nome do Beneficiário',
      quoteDescription: 'Descrição da Cotação',
      loadingAccount: 'Carregando dados da conta...',
      loadingDescription: 'Carregando descrição...',
      tariffPaidByClient: 'Tarifa paga pelo cliente',
      tariffPaidByContractor: 'Tarifa paga pelo contratante',
      balance: 'Saldo'
    },
    columns: {
      bank: 'Banco',
      date: 'Data',
      customer: 'Cliente',
      deliveryType: 'Entrega',
      type: 'Tipo',
      currency: 'M.E.',
      amountMe: 'Valor M.E.',
      valueME: 'Valor M.E',
      subtotal: 'Subtotal',
      totalValue: 'Valor total',
      commission: 'Comissão',
      bankSlip: 'Boleto',
      paySlip: 'Comp. pagamento',
      authDoc: 'Autorização',
      status: 'Status',
      actions: 'Ações',
      liquidation: 'Liquidação',
      sourceAmount: 'Moeda origem',
      destAmount: 'Moeda destino',
      clientRate: 'Tx. cliente.',
      clientRateShort: 'Tx. cliente',
      clientRateFull: 'Taxa do cliente',
      nature: 'Natureza',
      cc: 'C.C.',
      swift: 'SWIFT',
      code: 'Código',
      duimpCoverage: 'Cobertura DUIMP',
      delay: 'Atraso (dias)',
      duimpStatus: 'Status DUIMP',
      supplier: 'Fornecedor',
      bankRate: 'Taxa do banco',
      grossProfit: 'Lucro bruto',
      corbanMasterProfit: 'Lucro corban master',
      extraCosts: 'Custos extras',
      adjustedProfit: 'Lucro ajustado',
      corbanProfit: 'Lucro corban',
      indicatorProfit: 'Lucro Indicador',
      pixExpiration: 'Expiração PIX',
      netProfit: 'Lucro líquido',
      sourceStatus: 'Status origem',
      destStatus: 'Status destino',
      contract: 'Contrato',
      duimpNumber: 'DUIMP/DU-E'
    },
    menu: {
      viewOperation: 'Visualizar operação',
      registerPendencies: 'Registrar pendências',
      analysisPendencies: 'Análise de pendências',
      viewHistory: 'Ver histórico',
      cancelOperation: 'Cancelar Operação',
      relaunchOperation: 'Relançar operação',
      documents: 'Documentos',
      edit: 'Editar',
      editAndFinish: 'Editar e Concluir',
      copySimulation: 'Copiar simulação do cliente',
      changeHistory: 'Histórico de alterações',
      newOperationSameValues: 'Nova operação com mesmos valores',
      finish: 'Concluir',
      noSolution: 'Sem Solução',
      resendDocumentsToBank: 'Reenviar documentos para o banco',
      resendDuimpRequest: 'Reenviar solicitação de DUIMPs/DUEs',
      chargeHistory: 'Histórico de cobrança',
      responseHistory: 'Histórico de respostas',
      timeline: 'Linha do Tempo',
      consultPayments: 'Consultar pagamentos',
      returnedToCustomer: 'Devolvida ao cliente',
      createPixOperation: 'Criar operação PIX'
    },
    duimp: {
      sectionTitle: 'DUIMPs',
      noDuimp: 'Nenhum DUIMP registrado',
      approved: 'Aprovado',
      rejected: 'Reprovado',
      columnKey: 'Chave de acesso',
      columnDate: 'Data inserção',
      columnValue: 'Valor M.E.',
      columnDoc: 'Doc.',
      columnApproval: 'Aprovação',
      columnDetails: 'Detalhes'
    },
    invoice: {
      sectionTitle: 'Invoices',
      noInvoice: 'Nenhuma Invoice registrada',
      columnNumber: 'Número',
      columnDate: 'Data',
      columnShipping: 'Prev. Embarque',
      columnDoc: 'Doc.'
    },
    openOps: {
      emptySubtitle: 'Não há operações em aberto para o dia de hoje.',
      bankDigital: 'Operação com Banco Digital'
    },
    preSale: {
      internalTab: 'Operações internas',
      externalTab: 'Operações externas',
      customerTab: 'Operações de clientes',
      stablecoinTab: 'Operações Stablecoin'
    },
    operationPendency: {
      title: 'Pendências da operação',
      history: 'Histórico de pendências',
      empty: 'Nenhuma pendência registrada para esta operação.',
      newLabel: 'Nova pendência',
      placeholder: 'Descreva o que falta para a operação seguir',
      sendEmail: 'Enviar e-mail ao cliente',
      register: 'Registrar pendência',
      required: 'Descreva a pendência antes de registrar.',
      loadError: 'Não foi possível carregar as pendências da operação. Tente novamente em alguns instantes.',
      emailSent: 'E-mail enviado ao cliente',
      noEmail: 'Sem e-mail ao cliente',
      registered: 'Pendência registrada.',
      inAnalysis: 'Em análise de pendências'
    },
    exchange: {
      emptySubtitle: 'Não há operações de Câmbio Turismo para o período selecionado.',
      delivery: 'Delivery',
      storePickup: 'Retirada em loja',
      cancelTitle: 'Cancelar operação?',
      pendencyModalTitle: 'Informação complementar',
      complementaryInfo: 'Informações complementares'
    },
    remittance: {
      emptySubtitle: 'Não há operações de Câmbio Remessa para o período selecionado.',
      updateCommissionsMass: 'Atualizar comissões em massa',
      exportExcel: 'Exportar Excel',
      tariffTitle: 'Detalhamento de tarifa',
      tariffCustomerLabel: 'Tarifa paga pelo cliente',
      tariffContractorLabel: 'Tarifa paga pelo contratante',
      tariffBalanceLabel: 'Saldo',
      tariffCustomerHint: 'valor cobrado do cliente na operação (campo "Taxa do cliente").',
      tariffContractorHint: 'valor que o banco de câmbio cobra por operação quando o cliente não paga a tarifa.',
      tariffBalanceHint: 'diferença entre o que foi recebido dos clientes e o que foi pago ao banco. Positivo = lucro, negativo = prejuízo.',
      updateModalTitle: 'Atualizar comissões em massa',
      commissionLabel: 'Comissão(%)',
      updateBtn: 'Atualizar'
    },
    management: {
      fantasyName: 'Nome fantasia:',
      name: 'Nome:',
      date: 'Data:',
      amountME: 'Valor ME:',
      clientRate: 'Taxa do cliente:',
      grossProfit: 'Lucro bruto:',
      bankRate: 'Taxa do banco:',
      corbanProfit: 'Lucro Corban:',
      indicatorProfit: 'Lucro indicador:',
      bankRateLabel: 'Taxa do Banco',
      comissionBank: 'Comissão do Banco: {value}%',
      comissionCorban: 'Comissão do Corban: {value}',
      comissionIndicator: 'Comissão do Corban Indicador: {value}'
    },
    duimpReport: {
      emptySubtitle: 'Não há operações de DUIMP/DU-E para o período selecionado.',
      operationData: 'Dados da operação',
      confirmResendTitle: 'Confirmar reenvio',
      confirmResendMessage: 'Deseja reenviar a solicitação de DUIMPs/DUEs ao cliente?',
      rejectionModalTitle: 'Motivo da recusa',
      sendRejectionEmailBtn: 'Enviar email de rejeição ao cliente',
      close: 'Fechar',
      duimpLabel: 'DUIMP',
      dateTimeRefusal: 'Data/hora da recusa',
      originalValue: 'Valor original (antes da recusa)',
      rejectionMessageLabel: 'Mensagem para o cliente'
    },
    stablecoin: {
      deskClosingTab: 'Fechamento pela mesa',
      customerClosingTab: 'Fechamento pelo cliente',
      noContractTooltip: 'Operação do app não possui contrato de câmbio',
      noContractIsolatedTooltip: 'Operação só de entrada ou só de saída não possui contrato de câmbio'
    },
    cards: {
      operations: 'Operações',
      totalOperated: 'Total operado',
      spread: 'Spread',
      netProfit: 'Lucro líquido',
      corban: 'Corban',
      corbanIndicator: 'Corban indicador',
      bankProfit: 'Lucro banco'
    },
    errors: {
      loadCurrencies: 'Não foi possível carregar a lista de moedas do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadBanks: 'Não foi possível carregar a lista de bancos do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      attachmentNotAdded: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.',
      noPermissionAttachment: 'Você não possui permissão para adicionar esse anexo!',
      copyError: 'O texto não foi copiado. Selecione e copie manualmente (Ctrl+C).',
      cancelOperation: 'Não foi possível cancelar a operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      pendencyEmail: 'Não foi possível enviar o e-mail de pendência da operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      addCustomerDoc: 'Não foi possível anexar o documento operacional do cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      removeCustomerDoc: 'Não foi possível remover o documento operacional do cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      registerDocReceipt: 'Não foi possível registrar o recebimento dos documentos da operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      sendDuimpRequest: 'Não foi possível enviar a solicitação de DUIMP/DU-E ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      noSolution: 'Não foi possível marcar a DUIMP da operação como sem solução. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      sendDocumentsToBank: 'Não foi possível enviar documentos para o banco. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      loadDuimp: 'Não foi possível carregar o relatório de DUIMP/DU-E. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadExchange: 'Não foi possível carregar o relatório de operações de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadRemittance: 'Não foi possível carregar o relatório de operações de remessa. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadManagement: 'Não foi possível carregar o relatório de gestão de remessas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadStablecoin: 'Não foi possível carregar o relatório de operações em stablecoin. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadOperationCount: 'Não foi possível carregar a quantidade de operações do relatório. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadManagementTotals: 'Não foi possível carregar os totais do relatório de gestão de remessas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      saveOperation: 'Não foi possível salvar as alterações da operação. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      updateCommissions: 'Não foi possível atualizar as comissões das operações selecionadas. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      loadHistory: 'Não foi possível carregar histórico de status. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadNatures: 'Não foi possível carregar a lista de naturezas de operação do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadPreSale: 'Não foi possível carregar a lista de pré-vendas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      finishOperation: 'Não foi possível concluir a operação. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      lockPreSale: 'Não foi possível bloquear esta pré-venda para edição. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      sendFinishEmail: 'Não foi possível enviar o e-mail de fechamento da operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      sendIndicationEmail: 'Não foi possível enviar o e-mail de ciência da indicação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      fetchQuoteUsd: 'Não foi possível buscar cotação USD. Tente novamente.',
      usdParity: 'Não foi possível calcular a paridade USD. Tente novamente.',
      noServerConnection: 'Não foi possível conectar ao servidor. Tente recarregar a página.',
      operationConcludedSketchRemove: 'A operação foi concluída, mas não foi possível remover a pré-venda da lista. Atualize a página (F5) para conferir; se continuar, fale com o suporte.',
      operationConcludedDocAttach: 'A operação foi concluída, mas não foi possível anexar os documentos. Abra a operação, confira os documentos e anexe de novo o que faltar; se continuar, fale com o suporte.',
      loadPreSaleData: 'Não foi possível carregar os dados da pré-venda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      savePreSale: 'Não foi possível salvar as alterações da pré-venda. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      rejectionEmail: 'Não foi possível enviar o email de rejeição. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      downloadDocument: 'Não foi possível baixar o documento. Tente baixar novamente; se continuar, fale com o suporte.'
    },
    success: {
      documentSent: 'Documento enviado com sucesso!',
      duimpSentToCustomer: 'Solicitação de envio de DUIMP/DU-E enviada com sucesso!',
      pendencyEmailSent: 'E-mail de pendência documental enviado com sucesso!',
      operationCancelled: 'A operação foi cancelada!',
      noSolutionSet: 'Status DUIMP atualizado para Sem Solução.',
      documentsSentToBank: 'Documentos enviados para o banco com sucesso!',
      downloading: 'Baixando documento',
      observationSaved: 'Observação salva com sucesso!',
      copiedToClipboard: 'Mensagem copiada para a área de transferência',
      rejectionEmailSent: 'Email de rejeição enviado ao cliente com sucesso.'
    },
    openOperations: {
      templateNotConfigured: 'Template não configurado. Acesse Configurações > Mensagem de Operação.',
      copyMessageError: 'Não foi possível copiar a mensagem. Selecione o texto e copie manualmente (Ctrl+C).',
      preSaleBeingEdited: 'Esta pré-venda está sendo editada por {userName}. Aguarde até que seja liberada.',
      editingBy: 'Em edição por {userName}',
      editAction: 'Editar',
      editAndFinish: 'Editar e Concluir'
    }
  },

  configurations: {
    operationMessageTitlesUi: {
      customerRemittancePurchase: 'Cliente - Remessa Compra',
      customerRemittanceSaleSameOwner: 'Cliente - Remessa Venda (mesma titularidade)',
      customerRemittanceSaleOtherOwner: 'Cliente - Remessa Venda (outra titularidade)',
      customerExchangePurchaseCash: 'Cliente - Câmbio Compra (dinheiro)',
      customerExchangePurchaseOtherPayments: 'Cliente - Câmbio Compra (outros pagamentos)',
      customerExchangeSalePickupCash: 'Cliente - Câmbio Venda Retirada (dinheiro)',
      customerExchangeSalePickupOtherPayments: 'Cliente - Câmbio Venda Retirada (outros pagamentos)',
      customerExchangeSaleDelivery: 'Cliente - Câmbio Venda Entrega',
      customerWhatsappSwiftSettlement: 'Cliente — WhatsApp liquidação SWIFT',
      bankRemittancePurchase: 'Banco - Remessa Compra',
      bankRemittanceSaleWithoutFfc: 'Banco - Remessa Venda (sem FFC)',
      bankRemittanceSaleWithFfc: 'Banco - Remessa Venda (com FFC)',
      bankExchangePurchase: 'Banco - Câmbio Compra',
      bankExchangeSalePickup: 'Banco - Câmbio Venda Retirada',
      bankExchangeSaleDelivery: 'Banco - Câmbio Venda Entrega'
    },
    configurationsMenuUi: {
      remittance: 'Remessa',
      remittanceEmailTemplates: 'Templates de e-mail - Remessa',
      customer: 'Cliente',
      individual: 'Pessoa Física',
      legalEntity: 'Pessoa Jurídica',
      bank: 'Banco',
      corban: 'Corban',
      user: 'Usuário',
      users: 'Usuários',
      tourism: 'Turismo',
      tourismEmailTemplates: 'Templates de e-mail - Câmbio Turismo',
      buyPickup: 'Compra retirada',
      sellPickup: 'Venda retirada',
      sellDelivery: 'Venda delivery',
      receiptSending: 'Envio comprovante',
      general: 'Geral',
      signatures: 'Assinaturas',
      termsAndConditions: 'Termos e Condições',
      emailProvider: 'Provedor de e-mails',
      emailLayout: 'Layout de E-mail',
      operationMessages: 'Mensagens de Operação',
      defaultDashboard: 'Dashboard Padrão',
      holidays: 'Feriados',
      notices: 'Informativos',
      categoryCommunication: 'Comunicação',
      categoryTransactionalEmails: 'E-mails transacionais',
      categoryDocuments: 'Documentos',
      categoryIntegrations: 'Integrações',
      categorySystem: 'Sistema'
    },
    pageRegistryUi: {
      noItemSelected: 'Nenhum item de configuração selecionado.',
      pageNotFound: 'Página de configuração não encontrada para "{identifier}". Verifique o registro de páginas.'
    },
    signatureCredentialsUi: {
      fallbackTitle: 'Assinaturas',
      hint: 'Players usados para enviar fichas cadastrais para assinatura eletrônica. Marque um deles como padrão — cada banco ainda pode usar um player específico no seu cadastro.',
      playerDescription: 'Assinatura eletrônica de fichas cadastrais',
      autentiqueNotConfigured: 'Configure as credenciais do Autentique para usá-lo como player de assinatura.',
      docusignNotConfigured: 'Configure as credenciais do Docusign para usá-lo como player de assinatura.',
      defaultSwitch: 'Padrão'
    },
    stablecoinConfigurationUi: {
      payInTitle: 'Spread stablecoins — PayIn (App Mobile)',
      payInLabel: 'Spread stablecoins — PayIn',
      payInDescription: 'Selecione o spread utilizado nos PayIns do app mobile DolsPay. Deixe vazio para usar o primeiro spread ativo automaticamente.',
      payOutTitle: 'Spread stablecoins — PayOut (App Mobile)',
      payOutLabel: 'Spread stablecoins — PayOut',
      payOutDescription: 'Selecione o spread utilizado nos PayOuts do app mobile DolsPay. Deixe vazio para usar o primeiro spread ativo automaticamente.',
      defaultAgentTitle: 'Corban padrão (App Mobile)',
      defaultAgentDescription: 'Selecione o corban das pré-vendas e operações feitas pelo cliente no app. Deixe vazio para que elas fiquem sem corban.',
      defaultAgentLabel: 'Corban padrão',
      defaultAgentLoadError: 'Não foi possível carregar a lista de corbans. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      corbanSpreadTitle: 'Faixa de spread do corban',
      corbanSpreadDescription: 'Digite o percentual e a vírgula entra sozinha: 15 vira 1,5%. Deixe em 0,0 para não ter limite.',
      corbanSpreadNoLimit: 'Sem limite: o corban pode usar todos os spreads.',
      corbanSpreadAllowed: 'O corban poderá usar: {spreads}',
      corbanSpreadNoneAllowed: 'Nenhum spread cadastrado entra nesta faixa: o corban ficará sem spread para operar.',
      corbanSpreadMinLabel: 'Spread mínimo',
      corbanSpreadMaxLabel: 'Spread máximo',
      corbanSpreadInvalidRange: 'O spread mínimo não pode ser maior que o máximo.',
    },
    webhookStablecoinUi: {
      noResponse: 'sem resposta'
    },
    breadcrumb: {
      root: 'Configurações'
    },
    emailAlert: 'Para que um e-mail transacional seja enviado, o gatilho correspondente precisa estar configurado como "Ativo" nesta tela, assim como possuir um template configurado. Certifique-se de que todos os gatilhos desejados estejam ativados para garantir o envio correto das comunicações.',
    credentialsAlert: 'Certifique-se de que, ao alterar alguma credencial, a nova credencial informada seja válida, para que o envio de e-mails e de documentos para assinatura continue funcionando.',
    editBtn: 'Editar',
    closeBtn: 'Fechar',
    credential: {
      smtpTitle: 'Credenciais SMTP',
      autentiqueTitle: 'Credenciais Autentique',
      docusignTitle: 'Credenciais Docusign',
      descriptionLabel: 'Descrição',
      urlBase: 'Url base',
      method: 'Método',
      apiKey: 'Chave da api',
      sandboxEnv: 'Ambiente sandbox',
      integrationKey: 'Chave de integração',
      accountId: 'Id da conta',
      userId: 'Id do usuário',
      authServer: 'Servidor de autenticação',
      privateKey: 'Chave privada',
      smtpSaveError: 'Não foi possível salvar as credenciais de SMTP. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      autentiqueSaveError: 'Não foi possível salvar as credenciais da Autentique. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      docusignSaveError: 'Não foi possível salvar as credenciais da DocuSign. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    general: {
      valueLabel: 'Valor',
      percentLabel: 'Percentual',
      allowedSitesLabel: 'Sites autorizados',
      allowedSitesSaveBtn: 'Salvar sites',
      allowedSitesPlaceholder: 'https://www.seusite.com.br',
      invalidSiteError: 'Endereço não aceito: {sites}. Use o endereço completo com https, sem caminho. Exemplo: https://www.seusite.com.br',
      maxSitesError: 'Informe no máximo {max} sites.',
      sitesSavedWithItems: 'Sites salvos. Em até 1 minuto o cadastro já pode ser exibido neles.',
      sitesSavedEmpty: 'Lista vazia salva. Em até 1 minuto o cadastro só abre no próprio sistema.',
      defaultCorrespondentLabel: 'Corban padrão',
      defaultCorrespondentDescription: 'Corban que recebe os clientes cadastrados pelo link geral ou pelo app, quando o cadastro chega sem corban. Vazio: o cliente fica sem corban.',
      defaultCorrespondentSaved: 'Corban padrão salvo. Os próximos cadastros sem corban vão para ele.',
      defaultCorrespondentRemoved: 'Corban padrão removido. Os próximos cadastros sem corban ficam sem corban.',
      defaultCorrespondentSaveError: 'Não foi possível salvar o corban padrão. Tente de novo.',
      saveError: 'Não foi possível salvar os sites. Confira os endereços e tente de novo.',
      percentRangeError: 'Informe um percentual entre {min} e {max}.'
    },
    emailProvider: {
      defaultTitle: 'Provedor de e-mails',
      sectionHint: 'Servidor SMTP usado em todos os e-mails transacionais: operações, fichas cadastrais, cobranças e redefinição de senha.',
      smtpDescription: 'Servidor de envio de e-mails',
      smtpNotConfigured: 'Sem essas credenciais o sistema não envia e-mails: envios de operação, fichas cadastrais e redefinição de senha ficam indisponíveis.',
      fieldServer: 'Servidor',
      fieldPort: 'Porta',
      fieldTls: 'Conexão segura (TLS)',
      fieldUser: 'Usuário / conta',
      fieldPassword: 'Senha',
      fieldSender: 'Remetente',
      yes: 'Sim',
      no: 'Não',
      loadError: 'Não foi possível carregar as credenciais de SMTP. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    emailLayout: {
      alertText: 'Configure o cabeçalho e rodapé aplicados automaticamente nos e-mails transacionais. Monte o layout arrastando os blocos do editor: o resultado segue a mesma estrutura dos templates de e-mail e não quebra nos clientes de e-mail.',
      title: 'Layout Global de E-mail',
      saveBtn: 'Salvar Configurações',
      headerLabel: 'Cabeçalho de E-mail',
      footerLabel: 'Rodapé de E-mail',
      savedSuccess: 'Configurações salvas com sucesso!',
      loadError: 'Não foi possível carregar configurações do layout do email. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      saveError: 'Não foi possível salvar configurações. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      editorError: 'Não foi possível carregar o editor de e-mail.'
    },
    webhookConfig: {
      tabGeneral: 'Geral',
      tabStablecoin: 'Stablecoin',
      tabHistory: 'Histórico',
      urlLabel: 'URL do Webhook',
      urlPlaceholder: 'https://exemplo.com/webhook'
    },
    webhookHistory: {
      eventLabel: 'Evento',
      statusLabel: 'Status',
      startLabel: 'Início',
      endLabel: 'Fim',
      filterBtn: 'Filtrar',
      headerDate: 'Data/Hora',
      headerEvent: 'Evento',
      headerUrl: 'URL',
      headerStatus: 'Status',
      headerActions: 'Ações',
      payloadTitle: 'Payload do webhook',
      closeBtn: 'Fechar',
      statusSent: 'Enviado',
      statusFailed: 'Não concluído',
      statusTimeout: 'Timeout',
      statusPending: 'Aguardando',
      loadError: 'Não foi possível carregar histórico. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      resendSuccess: 'Webhook reenviado com sucesso!',
      resendError: 'Não foi possível reenviar webhook. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    webhookStablecoin: {
      urlLabel: 'URL do Webhook',
      urlPlaceholder: 'https://exemplo.com/webhook',
      exampleBtn: 'Exemplo',
      testBtn: 'Testar',
      payloadExampleTitle: 'Payload de exemplo',
      payloadHint: 'Este é o formato JSON que será enviado via POST para a URL configurada.',
      copyBtn: 'Copiar',
      closeBtn: 'Fechar',
      copiedSuccess: 'Payload copiado!',
      loadExampleError: 'Não foi possível carregar exemplo. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      sentSuccess: 'Webhook enviado com sucesso!',
      sentFailed: 'Não concluído: {error}'
    },
    whatsapp: {
      loading: 'Carregando informações do WhatsApp...',
      deviceTitle: 'Informações do Dispositivo',
      disconnectBtn: 'Desconectar',
      profilePhotoAlt: 'Foto de perfil',
      noName: 'Sem nome',
      business: 'Business',
      personal: 'Pessoal',
      labelPhone: 'Número',
      labelDevice: 'Dispositivo',
      labelMessage: 'Recado',
      noDeviceAlert: 'Nenhum dispositivo conectado. Gere um QR Code para conectar.',
      deviceLoadError: 'Não foi possível carregar os dados do aparelho.',
      disconnectSuccess: 'Instância desconectada com sucesso.',
      disconnectError: 'Não foi possível desconectar o WhatsApp. Tente novamente.',
      instanceTitle: 'Ambiente e Status da Instância',
      refreshBtn: 'Atualizar',
      labelInstance: 'Instância',
      labelPlan: 'Plano',
      labelExpiration: 'Validade',
      labelConnection: 'Conexão',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      labelSmartphone: 'Smartphone',
      instanceLoadError: 'Não foi possível carregar os dados da conexão.',
      qrcodeTitle: 'QR Code',
      generateQr: 'Gerar QR Code',
      qrHint: 'Escaneie o QR code com o WhatsApp do dispositivo dentro de 20 segundos.',
      generateNewQr: 'Gerar Novo QR Code',
      qrError: 'Não foi possível gerar o QR code. Tente novamente.',
      confirmDisconnectTitle: 'Desconectar Instância',
      confirmDisconnectMessage: 'Tem certeza que deseja desconectar o WhatsApp desta instância? Todas as funcionalidades de WhatsApp ficarão indisponíveis até reconectar.',
      confirmDisconnectPrimary: 'Desconectar',
      confirmDisconnectSecondary: 'Cancelar'
    },
    credentialCard: {
      statusVerifying: 'Verificando…',
      statusConfigured: 'Configurado',
      statusNotConfigured: 'Não configurado',
      statusUnavailable: 'Serviço indisponível',
      editBtn: 'Editar',
      retryBtn: 'Verificar novamente',
      configureBtn: 'Configurar',
      unavailableText: 'Não foi possível verificar as credenciais: o serviço não respondeu. Você ainda pode editá-las.',
      defaultNotConfiguredText: 'Ainda não configurado. Configure para ativar a integração.'
    },
    smtpWizard: {
      stepServer: 'Servidor',
      stepAccount: 'Conta e remetente',
      stepTest: 'Teste e conclusão',
      step1Hint: 'Dados do servidor de envio fornecidos pelo seu provedor de e-mail (ex.: SendGrid, SendPulse, Gmail).',
      step2Hint: 'Credenciais de autenticação no servidor e identidade que aparece para quem recebe os e-mails.',
      step3Hint: 'Revise os dados e teste a conexão antes de salvar.',
      tlsLabel: 'Forçar conexão segura (TLS) — normalmente usada com a porta 465',
      testAlertInfo: 'Recomendamos testar a conexão antes de salvar, para garantir que os e-mails do sistema serão enviados.',
      backBtn: 'Voltar',
      deleteBtn: 'Excluir credenciais',
      closeBtn: 'Fechar',
      continueBtn: 'Continuar',
      testBtn: 'Testar conexão',
      saveBtn: 'Salvar',
      deleteConfirmTitle: 'Excluir credenciais de SMTP',
      deleteConfirmMessage: 'O servidor de envio deixará de estar configurado e o sistema não enviará nenhum e-mail até que novas credenciais sejam informadas.',
      deleteConfirmPrimary: 'Excluir',
      deleteConfirmSecondary: 'Cancelar',
      testSuccess: 'Conexão estabelecida com sucesso! As credenciais são válidas.',
      testError: 'Não foi possível conectar ao servidor SMTP. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      missingConfigsError: 'As chaves de configuração SMTP não foram encontradas no banco. Execute as migrations do backend.',
      savedSuccess: 'Credenciais de SMTP salvas!',
      saveError: 'Não foi possível salvar as credenciais de SMTP. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      deletedSuccess: 'Credenciais de SMTP excluídas.',
      deleteError: 'Não foi possível excluir as credenciais de SMTP. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      summaryServer: 'Servidor',
      summaryPort: 'Porta',
      summaryTls: 'Conexão segura (TLS)',
      summaryUser: 'Usuário / conta',
      summarySender: 'Remetente',
      yes: 'Sim',
      no: 'Não'
    },
    signatureModal: {
      note: 'Os dados não são validados ao salvar — se estiverem incorretos, o aviso só aparece no próximo envio de ficha para assinatura.',
      savedSuccess: 'Credenciais do {player} salvas!',
      saveError: 'Não foi possível salvar as credenciais do {player}. Verifique se o serviço de assinaturas está no ar.',
      hintAutentique: 'Chave da API do Autentique, usada para enviar fichas cadastrais para assinatura eletrônica.',
      hintDocusign: 'Credenciais da integração JWT do Docusign, usadas para enviar fichas cadastrais para assinatura eletrônica.'
    },
    templateItem: {
      markAllHeaders: 'Marcar todos cabeçalhos',
      unmarkAllHeaders: 'Desmarcar todos cabeçalhos',
      markAllFooters: 'Marcar todos rodapés',
      unmarkAllFooters: 'Desmarcar todos rodapés',
      useHeader: 'Usar cabeçalho',
      useFooter: 'Usar rodapé',
      closeBtn: 'Fechar',
      saveBtn: 'Salvar',
      templateNotFound: 'Template não encontrado.',
      loadError: 'Não foi possível carregar a lista de templates. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      updateError: 'Não foi possível atualizar template. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      noneLoaded: 'Nenhuma configuração carregada para salvar.',
      termsSaved: 'Termos e condições salvos com sucesso.',
      termsError: 'Não foi possível salvar termos e condições. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    smtp: {
      title: 'Configuração de SMTP',
      server: 'Servidor SMTP',
      port: 'Porta',
      tls: 'Forçar conexão segura (TLS)',
      user: 'Usuário / conta SMTP',
      password: 'Senha',
      senderName: 'Nome do remetente',
      senderEmail: 'E-mail do remetente',
      serverPlaceholder: 'smtp.exemplo.com',
      senderNamePlaceholder: 'Minha Corretora',
      senderEmailPlaceholder: 'contato@exemplo.com',
      deleteTitle: 'Excluir credenciais de SMTP',
      savedSuccess: 'Credenciais de SMTP salvas!',
      deletedSuccess: 'Credenciais de SMTP excluídas.'
    },
    signature: {
      playerPlaceholder: 'Selecione um player ...',
      toggleDefaultHint: 'Para trocar o player padrão, ative-o no outro player.',
      playerNotFound: 'Configuração de player padrão não encontrada. Recarregue a página.',
      playerSetDefault: '{player} definido como player padrão.',
      changeDefaultError: 'Não foi possível alterar o player padrão. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    template: {
      selectPlaceholder: 'Selecione um template ...',
      previewTooltip: 'Visualizar template'
    },
    webhook: {
      viewPayload: 'Ver payload',
      resend: 'Reenviar'
    }
  },

  customers: {
    kanbanColumnsUi: {
      customer: {
        '1': 'Cadastro enviado',
        '2': 'Cadastro em andamento',
        '3': 'Aguardando análise',
        '4': 'Cadastro em análise',
        '5': 'Pendência',
        '6': 'Finalizado'
      },
      bank: {
        '1': 'Aguardando assinatura',
        '2': 'Enviado ao banco',
        '3': 'Pendência',
        '4': 'Limite pré-aprovado',
        '5': 'Finalizado',
        '6': 'Bloqueado'
      }
    },
    bankCustomerAuthorizationUi: {
      updateStatusError: 'Não foi possível alterar a situação do cadastro do cliente no banco. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      sendLimitApprovalMessage: 'Deseja enviar a aprovação de limite ao cliente?',
      sendLimitApprovalTitle: 'Enviar aprovação de limite?',
      limitApprovalSent: 'Aprovação de limite enviada com sucesso!',
      sendLimitApprovalError: 'Não foi possível enviar a aprovação de limite do cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    customerAuthorizationUi: {
      sendAccessEmailError: 'Não foi possível enviar o e-mail de acesso ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      updateStatusError: 'Não foi possível alterar a situação do cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    corbanSignupLinkUi: {
      linkUnavailable: 'O link de cadastro ainda não está disponível. Fale com o suporte.',
      linkCopied: 'Link de cadastro copiado! Envie para o seu cliente.',
      copyFailed: 'Não foi possível copiar automaticamente. Link: {link}'
    },
    formCustomerFinallyUi: {
      successAlt: 'Cadastro finalizado com sucesso'
    },
    customerDocumentsExternalAccessUi: {
      complementaryTitle: 'Documentos Complementares'
    },
    timeline: {
      noStatusHistory: 'Nenhuma mudança de status registrada',
      historyTitle: 'Histórico do Cliente',
      banksTitle: 'Histórico dos Bancos',
      noBanks: 'Nenhum banco cadastrado',
      observationLabel: 'Observação:',
      changedBy: 'Alterado por: {name}',
      changedByCustomer: 'Alterado pelo cliente'
    },
    bankTimeline: {
      unknownStatus: 'Status desconhecido',
      sentDocumentsCount: 'nenhum documento enviado | {count} documento enviado | {count} documentos enviados',
      customerDocuments: 'Documentos do cliente',
      operationalDocuments: 'Documentos operacionais',
      partnerDocuments: 'Documentos dos sócios',
      unnamedDocument: 'Documento sem nome',
      viewDocument: 'Ver documento',
      downloadDocument: 'Baixar documento',
      downloadError: 'Não foi possível baixar o documento. Atualize a página (F5) e tente de novo; se continuar, fale com o suporte.'
    },
    unifiedTimeline: {
      turismo: 'Turismo',
      remessa: 'Remessa',
      unknown: 'Desconhecido'
    },
    timelineDetail: {
      type: 'Tipo',
      bank: 'Banco',
      nameOrCompanyName: 'Nome / Razão social',
      phone: 'Telefone',
      email: 'E-mail',
      statusHistoryTitle: 'Histórico de mudanças de status',
      openFullDetails: 'Acessar ficha completa',
      errorLoadCustomerHistory: 'Não foi possível carregar o histórico de status do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadBankHistory: 'Não foi possível carregar o histórico de status do banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    kanbanSearch: 'Digite para pesquisar...',
    selfieCapture: 'Capturar selfie',
    kanbanSearchBar: {
      refresh: 'Atualizar dados',
      searchPlaceholder: 'Digite para pesquisar...',
      filterByType: 'Filtrar por tipo:',
      individual: 'Pessoa Física',
      company: 'Pessoa Jurídica'
    },
    kanbanBoard: {
      emptyColumn: 'Nenhum item nesta coluna'
    },
    cardActions: {
      whatsapp: 'Conversar no WhatsApp',
      statusHistory: 'Histórico de status',
      viewRegistration: 'Visualizar cadastro',
      registerPendency: 'Registrar pendência',
      resendRegistration: 'Reenviar ficha cadastral',
      moveTo: 'Mover para',
      editObservation: 'Editar observação',
      addObservation: 'Adicionar observação'
    },
    kanbanCard: {
      emailUnavailable: 'E-mail não disponível para cópia.',
      emailCopied: 'E-mail copiado para a área de transferência!',
      emailCopyError: 'Não foi possível copiar e-mail. Selecione o texto e copie manualmente (Ctrl+C).',
      phoneUnavailable: 'Telefone não disponível para cópia.',
      phoneCopied: 'Telefone copiado para a área de transferência!',
      phoneCopyError: 'Não foi possível copiar telefone. Selecione o texto e copie manualmente (Ctrl+C).',
      whatsappPhoneUnavailable: 'Telefone não disponível para abrir WhatsApp.'
    },
    control: {
      addButton: 'Adicionar',
      preRegistrationButton: 'Enviar pré-cadastro',
      loadingDetails: 'Carregando informações do cliente',
      optionsTooltip: 'Opções',
      operate: 'Operar',
      viewPendencies: 'Ver pendências',
      viewPendenciesOf: 'Ver pendências - {provider}',
      updateRegistration: 'Atualização cadastral',
      resendForm: 'Reenviar ficha',
      deactivateTitle: 'Inativar cliente?',
      deactivateMessage: 'Deseja realmente inativar o cliente <strong>{name}</strong>?',
      complementaryInfoTitle: 'Informação complementar',
      complementaryInfoLabel: 'Informações complementares',
      cellphone: 'Cel.:',
      landline: 'Fixo:',
      unknownStatus: 'Status desconhecido',
      columns: {
        id: 'Código',
        customer: 'Cliente',
        email: 'E-mail',
        phone: 'Telefone',
        status: 'Status',
        createdAt: 'Data de cadastro',
        actions: 'Ações'
      },
      expandedColumns: {
        status: 'Status',
        type: 'Tipo',
        linkedBank: 'Banco vinculado',
        approvedNatures: 'Naturezas aprovadas',
        incoming: 'Entrada',
        outgoing: 'Saída',
        validity: 'Validade',
        actions: 'Ações'
      },
      errorLoadDetails: 'Não foi possível carregar os detalhes do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorbans: 'Não foi possível carregar a lista de corbans do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCustomers: 'Não foi possível carregar a lista de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCount: 'Não foi possível carregar a quantidade de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      preSaveSavedSuccess: 'Cliente salvo com sucesso!',
      preSaveSaveError: 'Não foi possível salvar o pré-cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      statusUpdatedSuccess: 'Status atualizado com sucesso!',
      statusUpdateError: 'Não foi possível alterar a situação do cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      complementaryInfoSentSuccess: 'Solicitação de atualização cadastral enviada com sucesso!',
      resendSuccess: 'Cadastro reenviado ao banco com sucesso!',
      resendError: 'Não foi possível reenviar. Verifique os dados e tente novamente.'
    },
    bankBoard: {
      cannotMoveStatus: 'Não é possível mover para este status',
      integrate: 'Integrar',
      integrated: 'Integrado',
      editObservation: 'Editar observação',
      addObservation: 'Adicionar observação',
      update: 'Atualizar',
      observationLabel: 'Observação',
      confirmationTitle: 'Confirmação',
      confirmYes: 'Sim',
      confirmUnderstood: 'Entendi',
      editPendency: 'Editar pendência',
      saveObservationSuccess: 'Observação salva com sucesso!',
      saveObservationError: 'Não foi possível salvar a observação. Tente novamente; se continuar, fale com o suporte.',
      loadError: 'Não foi possível atualizar o quadro de bancos dos clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadBankCustomersError: 'Não foi possível carregar os bancos dos clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCustomerDataError: 'Os dados do cliente não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      saveLimitError: 'Não foi possível salvar o limite do cliente. Confira os valores e tente novamente; se continuar, fale com o suporte.',
      changeBankStatusError: 'Não foi possível mudar o status do banco do cliente. Tente novamente; se continuar, fale com o suporte.',
      changeBankStatusRevertError: 'Não foi possível mudar o status do banco do cliente e o card voltou para a coluna anterior. Tente novamente; se continuar, fale com o suporte.',
      sendPendencyEmailSuccess: 'Email de pendência cadastral enviado com sucesso!',
      registerPendencySuccess: 'Pendência registrada com sucesso!',
      registerPendencyError: 'Não foi possível registrar a pendência do banco. Confira o texto da pendência e tente novamente; se continuar, fale com o suporte.',
      resendAccessEmailSuccess: 'E-mail de primeiro acesso reenviado',
      resendAccessEmailError: 'Não foi possível reenviar o e-mail de primeiro acesso. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      integrationSuccess: 'Cliente integrado com sucesso!',
      integrationOnlineUnavailableTitle: 'Integração online indisponível',
      integrationOnlineUnavailableMessage: 'O processo de integração online não está disponível para clientes estrangeiros. O cadastro será realizado pelo fluxo offline.',
      integrationFailedTitle: 'Integração bancária não concluída',
      integrationFailedMessage: 'A integração bancária não foi concluída. Deseja manter o banco cadastrado pelo fluxo manual?',
      integrationRequest: 'Enviar para integração bancária?',
      rfiPending: 'Pendência de compliance (RFI) aguardando resolução.',
      rfiRejected: 'O banco não aceitou o cadastro. Revise os dados e documentos do cliente.'
    },
    formAuthorization: {
      cancelar: 'Cancelar',
      registerPendency: 'Registrar pendência',
      statusUpdatedSuccess: 'Status atualizado com sucesso!',
      statusUpdateError: 'Não foi possível alterar a situação do cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      bankStatusUpdateError: 'Não foi possível alterar a situação do cadastro do cliente no banco. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      pendencyEmailSentSuccess: 'Email de pendência cadastral enviado com sucesso!',
      pendencyEmailError: 'Não foi possível enviar o e-mail de pendência do cadastro ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    statusChange: {
      selectLabel: 'Selecione o status desejado',
      noDataText: 'Selecione um status',
      additionalInfo: 'Informações adicionais',
      defaultTitle: 'Alterar status'
    },
    addLimit: {
      title: 'Limite aprovado',
      valueIn: 'Valor entrada',
      valueOut: 'Valor saída',
      expireAt: 'Data de validade'
    },
    filterDrawer: {
      title: 'Filtro'
    },
    authorization: {
      internalOnboarding: 'Onboarding interno',
      bankOnboarding: 'Onboarding nos Bancos',
      confirmationTitle: 'Confirmação',
      loadListError: 'Não foi possível carregar a lista de clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCountError: 'Não foi possível carregar a quantidade de clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      dataNotFound: 'Dados do banco ou cliente não encontrados.',
      limitAdded: 'Limite adicionado com sucesso!',
      limitAddError: 'Não foi possível adicionar o limite do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      updateError: 'Os dados não foram atualizados. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    selfie: {
      loadingCamera: 'Carregando câmera...',
      positionFace: 'Posicione seu rosto na área indicada',
      faceDetectedMsg: 'Perfeito! Clique no botão para tirar a foto',
      cameraError: 'Não foi possível acessar a câmera',
      permissionDeniedHint: 'Se você negou o acesso, clique no ícone de cadeado ou informações na barra de endereço do navegador e permita o uso da câmera para este site.',
      noCameraBtn: 'Não tenho câmera (usar celular)',
      photoPreviewTitle: 'Sua selfie:',
      photoAlt: 'Selfie capturada',
      retake: 'Tirar novamente',
      errors: {
        notAllowed: 'Permissão para acessar a câmera foi negada. Clique em "Tentar novamente" e permita o acesso à câmera.',
        notFound: 'Nenhuma câmera foi encontrada no seu dispositivo. Verifique se há uma câmera conectada.',
        notReadable: 'A câmera está sendo usada por outro aplicativo. Feche outros programas que possam estar usando a câmera.',
        overconstrained: 'As configurações da câmera não são suportadas. Tente usar um navegador mais recente.',
        generic: 'Não foi possível acessar a câmera. Verifique se seu navegador permite o acesso à câmera e tente novamente.'
      }
    },
    selfiePage: {
      title: 'Verificação de Identidade',
      subtitle: 'Para finalizar seu cadastro, precisamos confirmar sua identidade',
      instructionsStep: 'Instruções',
      selfieStep: 'Selfie',
      confirmationStep: 'Confirmação',
      howToTitle: 'Como tirar a sua selfie?',
      captureTitle: 'Capture sua selfie',
      yourSelfieTitle: 'Sua selfie enviada:',
      startCapture: 'Iniciar captura',
      noCamera: 'Não tenho câmera',
      tips: {
        removeAccessories: 'Remova óculos, bonés ou acessórios',
        goodLighting: 'Fique em um local bem iluminado',
        centerFace: 'Mantenha o rosto centralizado',
        neutralExpression: 'Mantenha uma expressão neutra'
      }
    },
    documents: {
      title: 'Documentos',
      partnersTitle: 'Documentos dos Sócios',
      nestedPartnersTitle: 'Documentos dos Sócios dos Sócios'
    },
    finally: {
      successTitle: 'Cadastro enviado com sucesso!',
      goToSite: 'Ir para ao site'
    },
    reactivationModal: {
      title: 'Reativar cadastro',
      hint: 'Escolha para onde o cadastro volta. Não é preciso refazer a atualização cadastral nem passar pelo fluxo de novo.',
      primaryButton: 'Reativar cadastro',
      cancel: 'Cancelar',
      reasonLabel: 'Motivo da reativação',
      reasonHint: 'Fica registrado no histórico de status do cliente.',
      reactivated: 'Cadastro reativado. Agora está em "{status}".',
      reactivateError: 'Não foi possível reativar o cadastro. Tente novamente.',
      reasonRequired: 'Informe o motivo da reativação',
      targetOptions: {
        finalized: {
          title: 'Finalizado',
          hint: 'Libera o cliente para operar. Use quando o cadastro já foi conferido e aprovado no banco.'
        },
        inAnalysis: {
          title: 'Cadastro em análise',
          hint: 'Volta para a fila de análise da equipe, sem pedir nada ao cliente.'
        }
      }
    }
  },

  registrations: {
    templatesUi: {
      typeFallback: 'Tipo {id}'
    },
    formTemplateUi: {
      example1Start: 'Olá',
      example1Middle: 'sua operação',
      example1End: 'foi aprovada',
      example2Start: 'Operação de compra gerada para o',
      example3Start: 'Aprovação para o cliente',
      example3Middle: 'na natureza'
    },
    operationNature: {
      examplePlaceholder: 'Ex.: Serv. Téc./Prof./Adm. Saída'
    },
    common: {
      btnAdd: 'Adicionar',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      btnClose: 'Fechar',
      btnBack: 'Voltar',
      colActions: 'Ações',
      tooltipEdit: 'Editar'
    },
    exchangeBanks: {
      colLogo: 'Logo',
      colCreatedAt: 'Data de cadastro',
      colCompanyName: 'Razão social',
      colFantasyName: 'Nome fantasia',
      colCnpj: 'CNPJ',
      colProfitPercentage: '% Lucro comissões',
      colStatus: 'Status',
      colActions: 'Ações',
      tooltipExternalId: 'Banco importado com ID externo {id}',
      tooltipEdit: 'Editar',
      tooltipView: 'Visualizar',
      labelProfitPercentage: '% Lucro comissões',
      editDialogSave: 'Salvar',
      editDialogCancel: 'Cancelar',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      btnBack: 'Voltar',
      successSaveProfitPercentage: 'Percentual de lucro para comissões atualizado com sucesso.',
      errorLoad: 'Não foi possível carregar a lista de bancos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSaveProfitPercentage: 'Não foi possível salvar o percentual de lucro em stablecoin do banco. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorLoadFormData: 'Não foi possível carregar os dados do banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCurrencies: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorBankHours: 'Preencha o horário de funcionamento do banco antes de salvar.',
      errorLiquidationHours: 'Preencha o horário limite D+0 para todas as moedas antes de salvar.',
      successSaveBank: 'Banco salvo com sucesso!',
      errorCreateBank: 'Não foi possível cadastrar o banco. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpdateBank: 'Não foi possível salvar as alterações do banco. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    rateApiRoutes: {
      colName: 'Nome',
      colActive: 'Ativo',
      colActions: 'Ações',
      tooltipSetActive: 'Definir como ativo',
      errorLoad: 'Não foi possível carregar a lista de rotas de cotação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSetActive: 'Não foi possível ativar a rota de cotação. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    bilateralAgreements: {
      title: 'Países com acordo bilateral',
      colCountry: 'País',
      colIr: 'IR venda(%)',
      colActions: 'Ações',
      tooltipEdit: 'Editar',
      modalTitle: 'Acordo bilateral',
      labelCountry: 'País',
      labelIr: 'IR venda(%)',
      errorAdd: 'Não foi possível cadastrar o país do acordo bilateral. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpdate: 'Não foi possível salvar as alterações do país do acordo bilateral. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    currencies: {
      colCode: 'Código',
      colPriority: 'Prioridade',
      colName: 'Nome',
      colMinSell: 'Mínimo venda remessa(%)',
      colRecSell: 'Recomendado venda remessa(%)',
      colMaxSell: 'Máximo venda remessa(%)',
      colMinBuy: 'Mínimo compra remessa(%)',
      colRecBuy: 'Recomendado compra remessa(%)',
      colMaxBuy: 'Máximo compra remessa(%)',
      colPrecision: 'Casas decimais',
      colActions: 'Ações',
      tooltipEdit: 'Editar',
      priorityMax: 'Máxima',
      priorityHigh: 'Alta',
      priorityMedium: 'Média',
      priorityLow: 'Baixa',
      priorityMin: 'Mínima',
      modalTitle: 'Moedas',
      labelCode: 'Código',
      labelName: 'Nome',
      labelPrecision: 'Casas decimais',
      labelPriority: 'Prioridade',
      labelMinSell: 'Spread mínimo venda remessa(%)',
      labelRecSell: 'Spread recomendado venda remessa(%)',
      labelMaxSell: 'Spread máximo venda remessa(%)',
      labelMinBuy: 'Spread mínimo compra remessa(%)',
      labelRecBuy: 'Spread recomendado compra remessa(%)',
      labelMaxBuy: 'Spread máximo compra remessa(%)',
      errorLiquidation: 'Preencha os horários de liquidação para todos os bancos antes de salvar.',
      errorLoad: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadBanks: 'Não foi possível carregar a lista de bancos ativos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorAdd: 'Não foi possível cadastrar a moeda. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpdate: 'Não foi possível salvar as alterações da moeda. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    operationNatures: {
      colCode: 'Código',
      colName: 'Nome',
      colIofBuy: 'IOF compra(%)',
      colIof: 'IOF venda(%)',
      colIrBuy: 'IR compra(%)',
      colIr: 'IR venda(%)',
      colCideBuy: 'CIDE compra(%)',
      colCide: 'CIDE venda(%)',
      colDuimp: 'DUIMP/DU-E',
      colActions: 'Ações',
      tooltipEdit: 'Editar',
      modalTitle: 'Naturezas de Operação',
      labelCode: 'Código',
      labelName: 'Nome',
      labelShortName: 'Nome curto',
      labelUseDiDue: 'Usa DUIMP/DU-E?',
      radioYes: 'SIM',
      radioNo: 'NÃO',
      labelIofBuy: 'IOF compra(%)',
      labelIof: 'IOF venda(%)',
      labelIrBuy: 'IR compra(%)',
      labelIr: 'IR venda(%)',
      labelCide: 'CIDE venda(%)',
      labelCideBuy: 'CIDE compra(%)',
      labelObservation: 'Observações',
      errorLoad: 'Não foi possível carregar a lista de naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorAdd: 'Não foi possível cadastrar a natureza de operação. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpdate: 'Não foi possível salvar as alterações da natureza de operação. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorLoadBilateral: 'Não foi possível carregar a lista de países com acordo bilateral. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    paymentMethodsReg: {
      colCode: 'Código',
      colName: 'Nome',
      colActions: 'Ações',
      tooltipEdit: 'Editar',
      modalTitle: 'Métodos de pagamento',
      labelName: 'Nome',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      errorLoad: 'Não foi possível carregar a lista de formas de pagamento. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorAdd: 'Não foi possível cadastrar a forma de pagamento. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpdate: 'Não foi possível salvar as alterações da forma de pagamento. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    templates: {
      labelDescription: 'Descrição',
      labelSubject: 'Assunto',
      labelFormat: 'Formato',
      labelOrientation: 'Orientação',
      typeUndefined: 'Tipo não definido',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      btnClose: 'Fechar',
      requiredField: 'Informação obrigatória',
      variablesDialogTitle: 'Variáveis para assunto',
      variablesDialogText: 'Temos algumas variáveis disponíveis para serem utilizadas no campo assunto',
      variablesExamples: 'Alguns exemplos de utilização:',
      variableFullName: 'Nome completo ou razão social do cliente',
      variableFirstName: 'Primeiro nome do cliente pessoa fisica',
      variableFantasyName: 'Nome fantasia do cliente',
      variableCpfCnpj: 'Cpf ou Cnpj do cliente',
      variableNature: 'Nome da natureza na operação',
      variableNatureCode: 'Código da natureza na operação',
      variableOperationCode: 'Código da operação',
      successUpdate: 'Template atualizado',
      errorUpdate: 'Não foi possível atualizar o template. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUnlayer: 'Não foi possível carregar o editor de e-mail. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      warningLegacyEmail: 'Este template foi criado no editor anterior. A re-edição no novo editor pode alterar a formatação original.',
      errorLoadTemplate: 'Não foi possível obter o template para edição. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      successAdd: 'Template cadastrado',
      errorAdd: 'Não foi possível cadastrar o template. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      confirmAbandonEdit: 'Há dados preenchidos, deseja realmente abandonar a edição?',
      confirmAbandonCreate: 'Há dados preenchidos, deseja realmente abandonar o cadastro?',
      confirmAbandonPrimary: 'Sim, abandonar',
      confirmAbandonSecondary: 'Não',
      confirmAbandonTitle: 'Abandonar alterações?',
      typeSelectorTitle: 'Qual tipo de template deseja criar?',
      typeEmail: 'E-mails',
      typeOperationMessage: 'Mensagem de Operação',
      typeCustomerSheet: 'Ficha do Cliente',
      typeIssuedDocuments: 'Documentos Emitidos',
      inUseTitle: 'Template em uso',
      inUseSingle: 'está vinculado ao item abaixo',
      inUseMultiple: 'está vinculado a {n} itens',
      inUseRemoveHint: 'Remova o vínculo antes de excluir.',
      inUseBankHint: 'Vínculos de ficha cadastral são alterados no cadastro do banco, não em Configurações.',
      inUseVerify: 'Verificar configuração',
      inUseBankBadge: 'cadastro de banco',
      colCode: 'Código',
      colDescription: 'Descrição',
      colSubject: 'Assunto',
      colCreatedAt: 'Data de cadastro',
      colActions: 'Ações',
      tabAll: 'Todos',
      tooltipOptions: 'Opções',
      menuEdit: 'Editar',
      menuPreview: 'Pré-visualizar',
      menuDuplicate: 'Duplicar',
      menuDelete: 'Excluir',
      deleteTitle: 'Excluir template?',
      deleteMessage: 'O template "{name}" será excluído.',
      deletePrimary: 'Excluir',
      successDelete: 'Template excluído com sucesso!',
      successDuplicate: 'Template duplicado com sucesso!',
      errorDelete: 'Não foi possível excluir o template. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorDuplicate: 'Não foi possível duplicar o template. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorCheckUsage: 'Não foi possível conferir onde o template é usado antes de excluir. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorLoad: 'Não foi possível carregar a lista de templates. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadTypes: 'Não foi possível carregar os tipos de template. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    }
  },

  operations: {
    bankLedger: {
      optionalHint: 'Opcional',
      modalTitle: 'Lançar variação',
      launchButton: 'Lançar',
      hintText: 'Variação na conta do banco. Positivo é crédito e aumenta o lucro ajustado da operação; negativo é custo cobrado pelo banco e reduz o lucro.',
      operationLabel: 'Operação (nº)',
      bankLabel: 'Banco',
      descriptionLabel: 'Descrição',
      positive: 'Positivo',
      negative: 'Negativo',
      amountLabel: 'Valor',
      competenceDateLabel: 'Data de competência',
      requiredField: 'Campo obrigatório',
      bankOrOperationRequired: 'Informe o banco ou a operação',
      amountRequired: 'Informe um valor maior que zero.',
      saveSuccess: 'Lançamento feito na conta do banco.',
      saveError: 'Não foi possível lançar o custo. Confira a operação ou o banco, a descrição, o valor e a data, e tente de novo.'
    },
    ledgerTable: {
      dateHeader: 'Data',
      typeHeader: 'Tipo',
      descriptionHeader: 'Descrição',
      operationHeader: 'Operação',
      userHeader: 'Usuário',
      valueHeader: 'Valor',
      balanceHeader: 'Saldo',
      empty: 'Nenhum lançamento no período.',
      system: 'Sistema'
    },
    ledgerCard: {
      title: 'Custos e lucro da operação',
      launchVariation: 'Lançar variação',
      profitCredited: 'Lucro creditado',
      variations: 'Variações',
      adjustedProfit: 'Lucro ajustado',
      loadError: 'Não foi possível carregar a conta corrente da operação. Atualize a página; se continuar, fale com o suporte.'
    },
    cancelNotify: {
      notifyCustomer: 'Enviar e-mail de cancelamento para o cliente',
      notifyBank: 'Enviar e-mail de cancelamento para o banco'
    },
    changeCorban: {
      title: 'Trocar corban',
      primaryButton: 'Trocar',
      hintText: 'As comissões de agente e indicador são recalculadas com os percentuais do cadastro do novo corban.',
      newCorbanLabel: 'Novo corban',
      selectCorbanRequired: 'Escolha o novo corban',
      loadCorbansError: 'Não foi possível carregar a lista de corbans. Feche e abra de novo esta janela; se continuar, fale com o suporte.',
      saveSuccess: 'Corban trocado e comissões recalculadas.',
      saveError: 'Não foi possível trocar o corban. Atualize a página para conferir o corban atual da operação e tente de novo.'
    },
    bankMark: {
      unknown: 'Banco não informado'
    },
    bankIntegration: {
      title: 'Banco integrado',
      ticketLabel: 'Ticket no banco',
      contractLabel: 'Contrato de câmbio',
      updatedAtLabel: 'Atualizado em',
      resendExpired: 'O reenvio ao banco só vale no dia em que a operação foi criada. Cancele a operação e crie outra.',
      notConfirmed: 'A operação foi gravada, mas o banco não confirmou o envio. Use Resincronizar status para ver se ela chegou ao banco.',
      registerError: 'O banco teve um erro ao registrar a operação e está analisando. Acione o suporte do banco com o ticket {ticket}. O status volta a ser atualizado sozinho quando o banco resolver.',
      overduePending: 'A data de liquidação informada pelo banco ({date}) já passou e a operação continua aguardando o banco. O banco não cancela pela data: fale com o backoffice do banco com o ticket {ticket}.',
      syncButton: 'Resincronizar status',
      resendButton: 'Reenviar ao banco',
      syncSuccess: 'Status conferido no banco.',
      syncError: 'Não foi possível conferir o status no banco. Tente de novo em alguns instantes.',
      resendSuccess: 'Operação reenviada ao banco.',
      resendError: 'Não foi possível reenviar a operação ao banco. Tente de novo em alguns instantes.',
      status: {
        submissionError: 'Envio não concluído',
        pending: 'Aguardando o banco',
        registered: 'Registrada no banco',
        completed: 'Liquidada pelo banco',
        cancelled: 'Cancelada no banco',
        failed: 'Recusada pelo banco',
        registerError: 'Erro no registro do banco'
      },
      resendModal: {
        title: 'Reenviar ao banco',
        confirmButton: 'Gravar e reenviar',
        intro: 'A operação não chegou ao banco. Confira a taxa nova e as contas antes de reenviar.',
        loadError: 'Não foi possível carregar os dados para reenviar a operação. Tente de novo em alguns instantes.',
        quotationError: 'Não foi possível cotar no {bankName}. Tente atualizar a cotação.',
        quotationRequired: 'Escolha uma cotação do banco antes de reenviar.',
        resendError: 'Não foi possível reenviar a operação ao banco. Confira os dados e tente de novo.'
      },
      documents: {
        contract: 'Contrato',
        swift: 'SWIFT',
        notDownloaded: 'O documento do banco ainda não foi baixado. Tente de novo em alguns minutos.',
        downloadError: 'Não foi possível baixar o documento do banco. Tente de novo em alguns minutos.',
        uploadBlocked: 'O contrato e o SWIFT desta operação vêm do banco integrado. Use Resincronizar status na operação.'
      }
    },
    changeHistory: {
      emptyTitle: 'Nenhuma alteração registrada',
      changedBy: 'Alterado por: {name}',
      preSale: 'Pré-venda'
    },
    timeline: {
      emptyTitle: 'Nenhuma mudança de status registrada',
      changedBy: 'Alterado por: {name}',
      observation: 'Observação:',
      addObservation: 'Adicionar observação'
    },
    timelineDetail: {
      title: 'Histórico de Status',
      operationLabel: 'Operação #{id}',
      editObservation: 'Editar observação',
      addObservation: 'Adicionar observação',
      loadError: 'Não foi possível carregar histórico. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      saveObservationSuccess: 'Observação salva com sucesso!',
      saveObservationError: 'Não foi possível salvar observação. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    sketchHistory: {
      title: 'Histórico de alterações',
      preSaleLabel: 'Pré-venda #{id}',
      loadError: 'Não foi possível carregar o histórico da pré-venda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    }
  },

  commissions: {
    commissionPaymentOrderDialogUi: {
      aboveBalance: 'Valor acima do saldo disponível ({balance})',
      remainingBalance: 'Após esta solicitação, seu saldo disponível ficará em {balance}',
      insufficientBalance: 'Saldo insuficiente. Disponível: {balance}',
      minimumValue: 'O valor mínimo para solicitação de pagamento é {min}',
      exceedsBalance: 'O valor informado excede o saldo disponível do correspondente. Saldo: {balance}'
    },
    corbanComissionsControlUi: {
      noRequest: 'Pagamento sem requisição',
      paymentPending: 'Pagamento pendente'
    },
    search: 'Pesquisar',
    emptyTitle: 'Nenhum registro encontrado',
    noCredited: 'Não há operações creditadas para o período selecionado.',
    noRequests: 'Não há solicitações de pagamento para o período selecionado.',
    paymentOrder: {
      brazil: 'Brasil',
      abroad: 'Exterior',
      brazilAccount: 'Conta Brasil',
      abroadAccount: 'Conta exterior',
      requestedValue: 'Valor Solicitado',
      invoice: 'Nota Fiscal',
      paidValue: 'Valor Pago',
      paymentProof: 'Comprovante de Pagamento',
      titleAdmin: 'Criar ordem de pagamento - {name}',
      titleCorban: 'Solicitar pagamento',
      step1: 'Conta de Recebimento',
      step2: 'Valor e Documentos',
      legendAccount: 'Deseja receber em qual conta?',
      accountBrazilTitle: 'Conta bancária do Brasil',
      accountAbroadTitle: 'Conta bancária no exterior - {name}',
      fieldBank: 'Banco - {val}',
      fieldAgency: 'Agência - {val}',
      fieldAccount: 'Conta - {val}',
      fieldDigit: 'Digito - {val}',
      fieldPix: 'Pix - {val}',
      fieldIban: 'IBAN - {val}',
      fieldSwift: 'Código Swift/BIC - {val}',
      fieldRouting: 'Número ABA/Routing - {val}',
      fieldFfc: 'FFC - {val}',
      fieldOwner: 'Nome do titular - {val}',
      insufficientBalanceAlert: 'Saldo insuficiente. Mínimo: {min}',
      minimumAmountAlert: 'Valor mínimo para solicitar: {min}',
      summaryTitle: 'Resumo da solicitação',
      btnCancel: 'Cancelar',
      btnNext: 'Próximo',
      btnBack: 'Voltar',
      btnSave: 'Salvar'
    },
    filters: {
      startDate: 'Data Inicial',
      endDate: 'Data Final',
      periodLabel: 'Período rápido',
      periodCurrentMonth: 'Mês Atual',
      periodLastMonth: 'Mês Anterior',
      periodLast3Months: 'Últimos 3 Meses',
      periodLast6Months: 'Últimos 6 Meses',
      periodCurrentYear: 'Este Ano'
    },
    administrative: {
      alertCredit: 'O crédito mensal das comissões agora é feito no',
      alertCreditLink: 'Fechamento mensal',
      tabCorrespondents: 'Correspondentes',
      tabOpenRequests: 'Solicitações em aberto',
      colCode: 'Código',
      colName: 'Nome',
      colType: 'Tipo',
      colMasterCorban: 'Corban Master Vinculado',
      colLinkedIndicators: 'Indicadores vinculados',
      colBalance: 'Saldo',
      colLastPayment: 'Último Pagamento',
      colLastCredit: 'Data de Crédito',
      colActions: 'Ações',
      colRequestDate: 'Data de Solicitação',
      colCorbanName: 'Nome/Razão Social',
      colValue: 'Valor',
      colNF: 'NF',
      colProof: 'Comprovante',
      loadingAccounts: 'Carregando contas...',
      loadingRequests: 'Carregando solicitações...',
      tooltipOptions: 'Opções',
      menuStatement: 'Extrato de Movimentação',
      menuAddPayment: 'Adicionar Pagamento',
      urgent: 'Urgente',
      indicatorsCount: '{n} indicadores',
      noData: 'Não há informações',
      errorLoadCorrespondents: 'Não foi possível carregar a lista de correspondentes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadAccounts: 'Não foi possível carregar as contas de comissão dos correspondentes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      successCreatePaymentOrder: 'Ordem de pagamento criada com sucesso!',
      errorCreatePaymentOrder: 'Não foi possível registrar a ordem de pagamento da comissão. Confira os dados e os anexos e tente novamente; se continuar, fale com o suporte.',
      errorAddDocument: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.'
    },
    corban: {
      cardBalanceDesc: 'Saldo Disponível',
      cardPeriodTotalDesc: 'Total do Período',
      colType: 'Tipo',
      typeTourism: 'Turismo',
      typeRemittance: 'Remessa',
      tourismShare: 'Inclui {value} de câmbio turismo',
      btnRequestPayment: 'Solicitar pagamento',
      insufficientBalanceTooltip: 'Saldo insuficiente. Mínimo: {min}',
      tabCreditedOps: 'Operações creditadas',
      tabPaymentRequests: 'Solicitações de pagamento',
      colDate: 'Data',
      colCustomerName: 'Nome / Razão Social',
      colOperationCode: 'Código Operação',
      colCommission: 'Comissão',
      colRequestDate: 'Data de Solicitação',
      colPaymentDate: 'Data de Pagamento',
      colValue: 'Valor',
      colNF: 'NF',
      colProof: 'Comprovante',
      drawerTitle: 'Filtro',
      btnClearFilter: 'Limpar',
      btnFilter: 'Filtrar',
      loadingOps: 'Carregando operações...',
      loadingRequests: 'Carregando solicitações...',
      noData: 'Não há informações',
      errorLoadAccount: 'Não foi possível carregar o saldo de comissões. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorban: 'Não foi possível carregar os dados do seu correspondente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      successPaymentRequest: 'Solicitação aberta com sucesso!',
      errorCreatePaymentOrder: 'Não foi possível solicitar o pagamento da comissão. Confira o valor e a nota fiscal e tente novamente; se continuar, fale com o suporte.',
      errorAddDocumentNf: 'Você só pode adicionar documentos do tipo NF!',
      errorAddDocument: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.'
    },
    statement: {
      title: 'Extrato de Comissões - {name}',
      cardPeriodTotal: 'Total do Período',
      colType: 'Tipo',
      typeTourism: 'Turismo',
      typeRemittance: 'Remessa',
      tourismShare: 'Inclui {value} de câmbio turismo',
      cardBalance: 'Saldo Disponível',
      colOperation: 'Operação',
      colCustomer: 'Cliente',
      colDate: 'Data',
      colCorbanCommission: 'Comissões Corban',
      colIndicatorCommission: 'Comissões Indicador',
      colWithdrawals: 'Saques',
      colNF: 'NF',
      colProof: 'Comprovante',
      noData: 'Não há informações',
      btnClose: 'Fechar',
      errorLoad: 'Não foi possível carregar dados do extrato. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorAddDocument: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.'
    }
  },

  exchangeClosing: {
    exchangeClosingDateModalUi: {
      operation: 'Operação'
    },
    intro: 'Passo a passo do fechamento mensal: conferir com os bancos, creditar as comissões dos corbans e conferir o resumo do mês.',
    steps: {
      check: 'Conferência',
      creditCommissions: 'Creditar comissões',
      summary: 'Resumo do mês'
    },
    situations: {
      running: 'Mês em andamento',
      open: 'Em fechamento',
      checked: 'Conferido',
      credited: 'Comissões creditadas',
      closed: 'Fechado'
    },
    stepLabel: 'Passo {current} de {total}',
    confirmCheckButton: 'Confirmar conferência e avançar',
    closeButton: 'Concluir fechamento',
    sendReportTitle: 'Enviar relatório de comissões?',
    sendReportMessage: 'Comissões creditadas. Deseja enviar o relatório de fechamento aos corbans com crédito de comissão disponível?',
    sendReportConfirm: 'Enviar',
    sendReportLater: 'Agora não',
    messages: {
      commissionsCredited: 'Comissões creditadas na conta dos corbans.',
      loadError: 'O fechamento do mês não carregou. Atualize a página (F5) e tente novamente.',
      reloadError: 'O fechamento do mês não recarregou. Clique em Atualizar.',
      saveBankCheckError: 'Não foi possível salvar a conferência do banco. Confira se o valor está preenchido corretamente e tente de novo.',
      actError: 'Não foi possível concluir esta etapa do fechamento. Atualize a página para ver a situação atual do mês e tente de novo.',
      confirmCheckSuccess: 'Conferência confirmada.',
      closeSuccess: 'Fechamento do mês concluído.',
      reportsSent: 'Relatórios de comissões enviados aos corbans com crédito disponível.',
      reportsError: 'Não foi possível enviar os relatórios de comissões aos corbans. Tente de novo em alguns minutos; se continuar, fale com o suporte.'
    },
    header: {
      competence: 'Mês de competência',
      situation: 'Situação',
      lastUpdate: 'Última atualização',
      refresh: 'Atualizar'
    },
    bankCheck: {
      descriptionBefore: 'O que {company} apurou no mês, por banco, com as operações liquidadas. Abra o extrato de cada banco, digite ao lado o valor que ele mostra e confira.',
      descriptionHighlight: 'Só avance quando tudo bater.',
      descriptionAfter: 'Uma diferença se corrige na origem ou fica registrada com justificativa. Tudo fica salvo e pode ser alterado até concluir o fechamento.',
      stablecoinCommission: 'inclui {amount} de stablecoin pela paridade do dia',
      commissionEstimate: 'estimativa até o crédito',
      defaultCompany: 'a empresa',
      banksTitle: 'Bancos do mês',
      tableHeaders: {
        bank: 'Banco',
        operations: 'Operações',
        houseProfitLabel: 'Lucro da casa',
        houseProfitLabelBranded: 'Lucro da {name}',
        informedByBank: 'Informado pelo banco',
        check: 'Conferência',
        corbanCommission: 'Comissão corbans'
      },
      noOperations: 'Nenhuma operação liquidada neste mês.',
      collapseOperations: 'Recolher operações',
      expandOperations: 'Expandir operações',
      justificationPlaceholder: 'Justificativa da diferença',
      startCheckButton: 'Iniciar conferência',
      filterSearch: 'Pesquisar',
      filterSituation: 'Situação',
      filterCurrency: 'Moeda',
      filterVariation: 'Variações',
      filterDateFrom: 'De',
      filterDateTo: 'Até',
      clearFilters: 'Limpar filtros',
      filterAll: 'Todas',
      situationChecked: 'Conferidas',
      situationPending: 'Pendentes',
      variationWith: 'Com variação',
      variationWithout: 'Sem variação',
      checkedCount: '{checked} de {total} conferidas',
      deselectAll: 'Desmarcar todas',
      selectAll: 'Marcar todas',
      confirmButton: 'Confirmar',
      noOperationsWithFilters: 'Nenhuma operação encontrada com esses filtros.',
      movedTo: 'movida para {date}',
      movedToTooltip: 'Estava neste mês em {from}. Movida para {to} por {user} em {changedAt}. Não entra nos totais deste mês.',
      cameFrom: 'veio de {date}',
      cameFromTooltip: 'Data alterada de {from} para {to} por {user}',
      checkedChip: 'Conferida',
      variationsCaption: 'Variações',
      missingItemsTitle: 'Para confirmar a conferência, falta:',
      kpis: {
        grossProfit: 'Lucro bruto',
        operations: 'Operações',
        houseProfit: 'Lucro da casa',
        corbanCommission: 'Comissão dos corbans'
      },
      launchVariation: 'Lançar variação',
      changeDate: 'Alterar data',
      checkStatus: {
        pending: 'Aguardando o valor',
        match: 'Confere',
        bankHigher: 'banco maior',
        bankLower: 'banco menor',
        difference: 'Diferença de {amount} ({side})'
      }
    },
    commissions: {
      creditedTitle: 'Comissões creditadas',
      notCreditedTitle: 'Comissões ainda não creditadas',
      subtitle: 'Ao creditar, a comissão de cada corban nas operações liquidadas do mês entra no saldo dele.',
      creditButton: 'Creditar comissões',
      creditedMessage: '{amount} de comissão de {who} creditados{when}. O valor já está no saldo de comissão de cada corban.',
      creditedWhen: ' em {date}',
      corban: '{count} corban | {count} corbans'
    },
    summary: {
      description: 'Desempenho do mês nas operações liquidadas, comparado com o mês anterior, e a situação de cada corban. Confira e conclua o fechamento.',
      corbansTitle: 'Corbans do mês',
      tourismShare: '{value} de câmbio turismo',
      tableHeaders: {
        corban: 'Corban',
        generatedCommission: 'Comissão gerada',
        monthProfit: 'Lucro do mês',
        previousBalance: 'Saldo anterior',
        totalBalance: 'Saldo total'
      },
      noCorbans: 'Nenhum corban com comissão neste mês.',
      closedNote: 'Conferência e crédito das comissões deste mês estão registrados.',
      closedTitle: 'Fechamento concluído em {date}.',
      missingItemsTitle: 'Para concluir o fechamento, falta:',
      kpis: {
        operations: 'Operações',
        volume: 'Volume em reais',
        houseProfit: 'Lucro da casa',
        houseProfitBranded: 'Lucro da {name}',
        corbanCommission: 'Comissão dos corbans'
      },
      comparison: {
        noHistory: 'sem operações no mês anterior',
        same: 'igual ao mês anterior',
        change: '{sign}{percent}% vs. mês anterior'
      },
      operation: '{count} operação | {count} operações',
      ticketMedioLabel: 'ticket médio {amount}',
      spreadMedioLabel: 'spread médio {spread}%',
      stablecoinCommission: 'inclui {amount} de stablecoin pela paridade do dia',
      commissionEstimate: 'estimativa até o crédito',
      stablecoinProfit: '+ {amount} em stablecoin'
    },
    dateModal: {
      title: 'Alterar data da operação',
      description: 'A data da operação define o mês em que ela entra no fechamento.',
      currentDate: 'Data atual',
      newDate: 'Nova data',
      historyTitle: 'Histórico de datas',
      historyEmpty: 'A data desta operação nunca foi alterada.',
      changedBy: 'por {user} em {date}',
      messages: {
        noDateError: 'Informe a nova data.',
        savedSuccess: 'Data da operação #{id} alterada.',
        saveError: 'Não foi possível alterar a data da operação. Tente novamente; se continuar, fale com o suporte.'
      }
    }
  },

  correspondents: {
    correspondentsControlUi: {
      preRegisterError: 'Não foi possível cadastrar o corban. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    correspondentTypeSelectorUi: {
      title: 'Qual tipo de cadastro deseja realizar?'
    },
    publicSignup: {
      emailHint: 'Você recebe nele o link da ficha, para continuar o cadastro quando quiser.'
    },
    control: {
      add: 'Adicionar',
      sendPreRegister: 'Enviar pré-cadastro',
      colCorban: 'Corban / Indicador',
      colEmail: 'E-mail de acesso',
      colType: 'Tipo',
      colRegistration: 'Cadastro',
      colSignupLink: 'Link de cadastro',
      colActions: 'Ações',
      colCode: 'Código',
      colName: 'Nome',
      colDate: 'Data de cadastro',
      empty: 'Nenhum corban encontrado para esta busca.',
      collapseIndicators: 'Recolher indicadores',
      expandIndicators: 'Expandir indicadores',
      externalIdTooltip: 'Corban importado com ID externo {id}',
      indicator: 'indicador | indicadores',
      typeIndicator: 'Indicador',
      typeMaster: 'Corban master',
      copyLink: 'Copiar link de cadastro',
      edit: 'Editar',
      errors: {
        loadList: 'Não foi possível carregar a lista de corbans. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadPersonTypes: 'Não foi possível carregar os tipos de pessoa do corban. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      }
    },
    form: {
      cancel: 'Cancelar',
      save: 'Salvar',
      requiredFields: 'Existem campos obrigatórios não preenchidos',
      successSave: 'Salvo com sucesso!',
      successSaveCorban: 'Corban salvo com sucesso!',
      errors: {
        loadCorban: 'Não foi possível carregar os dados do corban. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadPersonTypes: 'Não foi possível carregar os tipos de pessoa do corban. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        createCorban: 'Não foi possível cadastrar o corban. Confira os dados e tente novamente; se continuar, fale com o suporte.',
        createIndicated: 'Não foi possível cadastrar o corban indicado. Confira os dados e tente novamente; se continuar, fale com o suporte.',
        updateCorban: 'Não foi possível salvar as alterações do corban. Confira os dados e tente novamente; se continuar, fale com o suporte.',
        sendTrigger: 'Não foi possível enviar o e-mail de acesso ao corban. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
      }
    },
    signup: {
      unavailableTitle: 'Link de cadastro indisponível',
      unavailableText: 'Este link não existe ou foi desativado. Peça um novo link a quem te enviou.',
      title: 'Como você quer se cadastrar?',
      profileSubtitle: 'Qual o seu perfil?',
      submitButton: 'Continuar para a ficha',
      externalAccessTitle: 'Cadastro de cliente',
      personKind: {
        pf: { title: 'Pessoa Física', description: 'Cadastro em seu nome' },
        pj: { title: 'Pessoa Jurídica', description: 'Cadastro da sua empresa' }
      },
      registerType: {
        1: 'Operações de turismo e viagens',
        2: 'Remessas básicas para o exterior',
        3: 'Remessas completas para o exterior',
        default: 'Cadastro de cliente'
      },
      registerTypeLimit: {
        2: 'Até 100 mil reais',
        3: 'Acima de 100 mil reais'
      },
      errors: {
        signup: 'Não foi possível enviar o seu cadastro. Confira os dados e tente novamente; se continuar, fale com o suporte.'
      }
    }
  },

  formExchangeBank: {
    bankBrandAssetsUi: {
      title: 'Identidade visual',
      iconLabel: 'O ícone da marca',
      iconFileLabel: 'Ícone da marca (.svg)',
      iconMarkupLabel: 'SVG do ícone',
      iconHint: 'Símbolo compacto do banco, usado em listas e cards',
      logoLabel: 'O logotipo da marca',
      logoFileLabel: 'Logotipo da marca (.svg)',
      logoMarkupLabel: 'SVG do logotipo',
      logoHint: 'Logotipo completo do banco, usado em telas e documentos'
    },
    bankCoverUi: {
      title: 'Dados cadastrais',
      operationTypes: 'Tipos de operação',
      companyName: 'Razão social',
      fantasyName: 'Nome fantasia',
      useRegisterForm: 'Trabalha com ficha de cadastro?',
      pfRegisterForm: 'Ficha de registro PF',
      pjRegisterForm: 'Ficha de registro PJ',
      hasBankingIntegration: 'Possui integração bancária',
      businessHours: 'Horário de funcionamento',
      openingTime: 'Abertura',
      closingTime: 'Encerramento',
      integrationPlayerRequired: 'Selecione o player de integração'
    },
    bankContactEmailUi: {
      title: 'E-mails de contato',
      missingEmailPrefix: 'Sem e-mail configurado em',
      missingEmailSuffix: '. O banco não recebe as mensagens desses assuntos.',
      individualTab: 'Pessoa Física',
      companyTab: 'Pessoa Jurídica',
      copyFromIndividual: 'Copiar dos e-mails de Pessoa Física',
      duimpChargeTitle: 'Cobrança DUIMP/DU-E',
      enableDuimpCharge: 'Habilitar cobrança de DUIMP/DU-E por e-mail',
      initialDaysLabel: 'Dias para primeiro envio',
      resendDaysLabel: 'Dias entre reenvios',
      deadlineTitle: 'Prazo de envio',
      deadlinePrefix: 'O prazo de',
      deadlineDays: '{days} dias',
      deadlineMiddle: 'começa a contar a partir da',
      deadlineShipmentDate: 'data prevista de embarque',
      deadlineSuffix: 'informada na invoice no fechamento do câmbio.',
      deadlineNewDate: 'Caso o cliente informe uma nova data de embarque o sistema irá acatar a ultima data informada, para iniciar as cobranças.',
      deadlineExample: 'Exemplo: embarque previsto em 01/06/2025 → primeiro e-mail enviado em {date}.',
      sectionRegister: 'Cadastro',
      sectionOperation: 'Operação',
      sectionDocuments: 'Documentos operacionais',
      sectionDuimp: 'DUIMP/DU-E',
      sectionFinancial: 'Financeiro',
      firstEmail: 'Primeiro e-mail',
      secondEmail: 'Segundo e-mail',
      thirdEmail: 'Terceiro e-mail',
      listJoin: '{list} e {last}'
    },
    bankFinancialUi: {
      title: 'Dados bancários',
      usePaymentAccount: 'Utiliza conta de pagamento',
      linkedBank: 'Banco vinculado',
      inOutLimit: 'Limite de entrada e saída?',
      limitCurrency: 'Limite em qual moeda?',
      feeCurrency: 'Tarifa em qual moeda?',
      feeCashback: 'Cashback de tarifa?',
      usdOption: 'Dólar americano - USD',
      brlOption: 'Real - BRL',
      fee: 'Tarifa',
      commission: 'Comissão(%)',
      profitPercentage: '% Lucro p/ Comissões',
      profitPercentageHint: '0-100%. Define quanto do lucro Corban entra no cálculo de comissões',
      paymentMethodsTitle: 'Métodos de pagamento internacionais habilitados',
      paymentMethodsHint: 'Selecione os métodos disponíveis no cadastro de contas no exterior. Se nenhum método for selecionado, todos os métodos serão habilitados.',
      profitRequired: 'Campo obrigatório para bancos digitais',
      profitRange: 'Deve estar entre 0 e 100'
    },
    exchangeBankLiquidationConfigUi: {
      title: 'Controle de Horários de Liquidação',
      subtitle: 'Define o horário limite para operações com liquidação no mesmo dia (D+0).',
      bulkFillTitle: 'Preencher todas as moedas',
      sell: 'Venda',
      buy: 'Compra',
      applyToAll: 'Aplicar a todos',
      bulkFillHint: 'Os horários informados irão sobrescrever os valores já preenchidos em todas as moedas.',
      emptyState: 'Nenhuma moeda disponível. As moedas são carregadas automaticamente ao abrir o formulário.',
      afterBankEnd: 'O horário limite não pode ser posterior ao encerramento do expediente do banco ({time}).',
      beforeBankStart: 'O horário limite não pode ser anterior à abertura do expediente do banco ({time}).'
    },
    bankContactNumberUi: {
      title: 'Telefones de contato',
      contactName: 'Nome do contato',
      department: 'Departamento',
      landline: 'Telefone fixo',
      cellphone: 'Celular'
    },
    spreadsUi: {
      title: 'Spreads',
      sell: 'Venda',
      buy: 'Compra',
      costSell: 'Custo da ME Venda(%)',
      deliveryExemption: 'Valor Para Isenção de Delivery',
      minProfitSell: 'Lucro Mínimo Venda(%)',
      recProfitSell: 'Lucro Recomendado Venda(%)',
      maxProfitSell: 'Lucro Máximo Venda(%)',
      costBuy: 'Custo da ME Compra(%)',
      minProfitBuy: 'Lucro Mínimo Compra(%)',
      recProfitBuy: 'Lucro Recomendado Compra(%)',
      maxProfitBuy: 'Lucro Máximo Compra(%)'
    },
    exchangeStoresUi: {
      title: 'Lojas / Spreads',
      modalTitle: 'Loja',
      companyName: 'Razão Social',
      storeName: 'Nome da Loja',
      landline: 'Telefone Fixo',
      cellphone: 'Celular',
      deliveryTypes: 'Tipos de entrega',
      withdrawalTime: 'Tempo para retirada',
      withdrawalDays: 'Dias de retirada',
      deliveryDays: 'Dias de delivery',
      weekdays: 'Dias de semana',
      sunday: 'Domingo',
      monday: 'Segunda',
      tuesday: 'Terça',
      wednesday: 'Quarta',
      thursday: 'Quinta',
      friday: 'Sexta',
      saturday: 'Sábado',
      businessHours: 'Horário de funcionamento',
      deliveryTime: 'Horário do delivery',
      deliveryCost: 'Custo do delivery',
      observations: 'Observações',
      colCreatedAt: 'Criado Em',
      colEmail: 'Email',
      colActions: 'Ações'
    },
    cover: {
      playerPlaceholder: 'Selecione um player ...',
      openHoursHint: 'Início do expediente do banco',
      closeHoursHint: 'Fim do expediente do banco'
    },
    financial: {
      requiredHint: 'Este campo é obrigatório',
      percentageHint: '0-100%'
    },
    stores: {
      editTooltip: 'Editar',
      duplicateTooltip: 'Duplicar'
    },
    digitalSignatureTitle: 'Assinatura digital',
    creationFlow: {
      signatureTitle: 'Assinatura digital',
      signatureMessage: 'Deseja enviar a ficha cadastral para assinatura digital do cliente?',
      bankRegisterSuccess: 'Ficha de cadastro enviada ao banco com sucesso!',
      signatureSuccess: 'Ficha de cadastro enviada para assinatura do cliente!',
      invalidCustomer: 'Cliente inválido. Não é possível enviar documentos.',
      sendBankRegisterError: 'Não foi possível enviar a ficha de cadastro ao banco. Confira os documentos escolhidos e tente novamente; se continuar, fale com o suporte.',
      sendSignatureError: 'Não foi possível enviar a ficha de cadastro para o cliente assinar. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    }
  },

  auth: {
    identities: {
      title: 'Formas de acesso',
      emptyTitle: 'Nenhuma conta vinculada',
      emptySubtitle: 'Para vincular, saia do sistema e clique em Fazer login com o Google na tela de entrada.',
      intro: 'Formas que você pode usar para entrar no sistema.',
      emailAndPassword: 'E-mail e senha',
      alwaysActive: 'Sempre ativo',
      unlink: 'Desvincular',
      confirmUnlinkTitle: 'Desvincular conta {label}?',
      confirmUnlinkAccountRef: 'essa conta {label}',
      confirmUnlinkMessage: 'Você não vai mais conseguir entrar com {accountRef}. Seu e-mail e senha continuam funcionando. Se quiser, pode vincular de novo depois.',
      linkedAt: 'Vinculada em {date}',
      notYetUsed: 'Ainda não usada para entrar',
      lastLogin: 'Último acesso em {date} às {time}',
      loadError: 'Não foi possível carregar suas formas de acesso. Tente de novo.',
      unlinkedSuccess: 'Conta {label} desvinculada.'
    },
    googleButton: 'Fazer login com o Google',
    googleAriaLabel: 'Google',
    emailLabel: 'E-mail',
    passwordLabel: 'Senha',
    divider: 'ou',
    checkingAccount: 'Conferindo sua conta {name}…',
    linkStep: {
      title: 'Vincule sua conta {label}',
      instruction: 'Para sua segurança, confirme o e-mail e a senha que você já usa no sistema.',
      submitButton: 'Vincular e entrar',
      hint: 'Nas próximas vezes, é só clicar em Fazer login com o {label}.',
      forgotPassword: 'Esqueci minha senha',
      emailPasswordRequired: 'Informe o e-mail e a senha que você usa no sistema.',
      linkedSuccess: 'Conta {label} vinculada. Nas próximas vezes, é só clicar em Fazer login com o {label}.',
      accountFallback: 'Conta {label}'
    }
  },

  currencyHolidays: {
    emptyTitle: 'Nenhuma moeda cadastrada',
    labelYear: 'Ano',
    btnExclusions: 'Excluídos',
    tabHolidays: 'Feriados',
    tabCurrencyConfig: 'Configuração de Moedas',
    errorLoadHolidays: 'Não foi possível carregar os feriados. Atualize a página; se continuar, fale com o suporte.',
    errorLoadExclusions: 'Não foi possível carregar os feriados excluídos. Atualize a página; se continuar, fale com o suporte.',
    errorAddHoliday: 'Não foi possível adicionar o feriado. Confira a moeda, a data e o nome do feriado e tente de novo.',
    errorRemoveHoliday: 'Não foi possível remover o feriado. Atualize a página para conferir a lista e tente de novo.',
    errorRenameHoliday: 'Não foi possível renomear o feriado. Confira se o nome está preenchido e tente de novo.',
    errorUpdateCountry: 'Não foi possível atualizar o país da moeda. Confira o país escolhido e tente de novo.',
    errorRestoreExclusion: 'Não foi possível restaurar o feriado. Atualize a página para conferir a lista e tente de novo.',
    card: {
      dateLabel: 'Data do feriado',
      nameLabel: 'Nome do feriado',
      saveTooltip: 'Salvar nome',
      cancelTooltip: 'Cancelar edição',
      editTooltip: 'Editar nome',
      removeTooltip: 'Remover feriado',
      deleteTitle: 'Excluir feriado',
      addBtn: 'Adicionar',
      emptyNoHolidays: 'Nenhum feriado cadastrado para {year}.',
      deleteConfirmMessage: 'Tem certeza que deseja excluir o feriado {text}?',
      deleteConfirmBtn: 'Excluir',
      cancelBtn: 'Cancelar',
      errorSelectDate: 'Selecione uma data para o feriado.',
      errorNameRequired: 'Informe o nome do feriado.',
      errorDateExists: 'Já existe um feriado cadastrado nesta data para esta moeda.',
      errorEditNameRequired: 'Informe um nome para o feriado.'
    },
    exclusions: {
      title: 'Feriados Excluídos',
      emptyTitle: 'Nenhum feriado excluído',
      closeBtn: 'Fechar',
      colCountry: 'País',
      colDate: 'Data',
      colName: 'Nome',
      colDeletedAt: 'Excluído em',
      colActions: 'Ações',
      restoreBtn: 'Restaurar'
    },
    searchCountry: 'Pesquisar país',
    noCountryFound: 'Nenhum país encontrado para "{search}".',
    countryConfig: {
      searchCurrency: 'Pesquisar moeda',
      colCode: 'Código',
      colName: 'Nome',
      colCountry: 'País',
      colHolidays: 'Feriados em {year}',
      saveBtn: 'Salvar',
      editTooltip: 'Editar',
      emptyMsg: 'Nenhuma moeda cadastrada'
    },
    countryCard: {
      errorDateExists: 'Já existe um feriado nesta data para este país.',
      errorLoadHolidays: 'Não foi possível carregar os feriados. Atualize a página e tente de novo.',
      errorAddHoliday: 'Não foi possível adicionar o feriado. Confira a data e o nome e tente de novo.',
      errorRenameHoliday: 'Não foi possível renomear o feriado. Tente de novo.',
      errorRemoveHoliday: 'Não foi possível remover o feriado. Atualize a página e tente de novo.'
    },
    modal: {
      title: 'Países vinculados — {name} ({code})',
      titleFallback: 'Países vinculados',
      addCountryLabel: 'Adicionar país',
      saveBtn: 'Salvar',
      cancelBtn: 'Cancelar',
      removeTooltip: 'Remover país',
      emptyCountries: 'Nenhum país vinculado',
      colCountry: 'País',
      errorSave: 'Não foi possível salvar os países. Tente de novo.'
    }
  },

  audit: {
    beforeAfterBlockUi: {
      arrayItem: 'Item {n}',
      others: 'Outros'
    },
    auditConstantsUi: {
      removedItemsSection: 'Itens removidos no salvamento',
      removedItems: 'Listas que diminuíram (antes e depois)',
      agency: 'Agência',
      mainActivity: 'Atividade Principal',
      active: 'Ativo',
      updatedAt: 'Atualizado em',
      neighborhood: 'Bairro',
      bank: 'Banco',
      linkedBank: 'Banco Vinculado',
      exchangeBankSection: 'Banco de câmbio',
      bankAndCorban: 'Banco e Corban',
      internationalBanks: 'Bancos Internacionais',
      nationalBanks: 'Bancos Nacionais',
      exchangeBanks: 'Bancos de Câmbio',
      exchangeBanksSection: 'Bancos de câmbio',
      bankCnpj: 'CNPJ do Banco',
      publicAgentCpf: 'CPF do Agente Público',
      spouseCpf: 'CPF do Cônjuge',
      customerCpfCnpj: 'CPF/CNPJ do Cliente',
      corbanCpfCnpj: 'CPF/CNPJ do Corban',
      correspondentCpfCnpj: 'CPF/CNPJ do Correspondente',
      bankingChannels: 'Canais bancários',
      paidInCapital: 'Capital Social Integralizado',
      position: 'Cargo',
      publicAgentPosition: 'Cargo do Agente Público',
      registrationResponsiblePosition: 'Cargo do Responsável pelo Cadastro',
      positionTitle: 'Cargo/Posição',
      exchangeStores: 'Casas de Câmbio',
      linkedExchangeStores: 'Casas de câmbio vinculadas',
      contractCashback: 'Cashback do Contrato',
      exchangeContractCashback: 'Cashback do Contrato de Câmbio',
      cellphone: 'Celular',
      internationalCellphone: 'Celular Internacional',
      correspondentCellphone: 'Celular do Correspondente',
      registrationResponsibleCellphone: 'Celular do Responsável pelo Cadastro',
      pixKey: 'Chave PIX',
      city: 'Cidade',
      customer: 'Cliente',
      commission: 'Comissão',
      corbanCommission: 'Comissão do Corban',
      indicatorCommission: 'Comissão do Indicador',
      commissions: 'Comissões',
      commissionsAndCosts: 'Comissões e custos',
      complement: 'Complemento',
      complianceUpdatedAt: 'Compliance Atualizado em',
      complianceCreatedAt: 'Compliance Criado em',
      exchangeBuy: 'Compra de Câmbio',
      settings: 'Configurações',
      spreadSettings: 'Configurações de spread',
      account: 'Conta',
      internationalAccount: 'Conta Internacional',
      paymentAccount: 'Conta de Pagamento',
      paymentAccountSection: 'Conta de pagamento',
      customerAccount: 'Conta do cliente',
      accounts: 'Contas',
      foreignAccounts: 'Contas no exterior',
      contacts: 'Contatos',
      corban: 'Corban',
      currencyQuotation: 'Cotação da Moeda',
      creditedAt: 'Creditado em',
      createdAt: 'Criado em',
      deliveryCost: 'Custo de Entrega',
      exchangeContractCost: 'Custo do Contrato de Câmbio',
      contractCostBrl: 'Custo do Contrato em BRL',
      costs: 'Custos',
      financialCalculations: 'Cálculos financeiros',
      code: 'Código',
      intermediaryAbaSwiftCode: 'Código ABA/SWIFT do Intermediário',
      swiftBicCode: 'Código SWIFT/BIC',
      currencyCode: 'Código da Moeda',
      natureCode: 'Código da Natureza',
      operationNatureCode: 'Código da Natureza de Operação',
      bankCode: 'Código do Banco',
      positionCode: 'Código do Cargo',
      countryCode: 'Código do País',
      cellphoneDdi: 'DDI Celular',
      landlineDdi: 'DDI Telefone Fixo',
      fatcaCrsData: 'Dados FATCA/CRS (campos derivados)',
      administrativeData: 'Dados administrativos',
      bankData: 'Dados bancários',
      brazilBankData: 'Dados bancários no Brasil',
      basicData: 'Dados básicos',
      registrationData: 'Dados cadastrais',
      companyData: 'Dados da empresa',
      complianceData: 'Dados de compliance',
      systemData: 'Dados de sistema',
      positionData: 'Dados do cargo/função exercida',
      customerData: 'Dados do cliente',
      financialData: 'Dados financeiros',
      legalEntityData: 'Dados para Pessoa Jurídica',
      effectiveOperationDate: 'Data Efetiva da Operação',
      lastChangeDate: 'Data da Última Alteração',
      approvalDate: 'Data de Aprovação',
      boardElectionDate: 'Data de Eleição da Diretoria',
      documentIssueDate: 'Data de Emissão do Documento',
      deliveryDate: 'Data de Entrega',
      practiceEndDate: 'Data de Fim do Exercício',
      foundingDate: 'Data de Fundação',
      practiceStartDate: 'Data de Início do Exercício',
      birthDate: 'Data de Nascimento',
      documentDueDate: 'Data de Vencimento do Documento',
      purposeDescription: 'Descrição do Propósito',
      customerDescription: 'Descrição para Cliente',
      identificationDocument: 'Documento de identificação',
      documents: 'Documentos',
      customerOperationalDocuments: 'Documentos Operacionais do Cliente',
      operationDocuments: 'Documentos da Operação',
      operationDocumentsSection: 'Documentos da operação',
      operationalDocuments: 'Documentos operacionais',
      taxDomicileSection: 'Domicílio Fiscal (TC-1662)',
      taxDomicileAbroad: 'Domicílio fiscal no exterior (CRS derivado)',
      usPerson: 'Domicílio fiscal nos EUA (FATCA derivado)',
      taxDomiciles: 'Domicílios Fiscais',
      digit: 'Dígito',
      email: 'E-mail',
      registrationResponsibleEmail: 'E-mail do Responsável pelo Cadastro',
      diDueEmails: 'E-mails DUIMP/DU-E',
      registerEmails: 'E-mails de cadastro',
      documentationEmails: 'E-mails de documentação',
      notificationEmails: 'E-mails de notificação',
      operationEmails: 'E-mails de operação',
      financialEmails: 'E-mails financeiro',
      company: 'Empresa',
      companyPublicAgency: 'Empresa/Órgão Público',
      address: 'Endereço',
      state: 'Estado',
      maritalStatus: 'Estado Civil',
      issuingState: 'Estado Emissor',
      politicallyExposedPerson: 'Exerce ou exerceu cargo ou função relevante?',
      formOfIncorporation: 'Forma de Constituição',
      formsAndServices: 'Formulários e serviços',
      suppliers: 'Fornecedores',
      dependentKinship: 'Grau de Parentesco do Dependente',
      additionalId: 'ID Adicional',
      externalId: 'ID Externo',
      exchangeTypeId: 'ID Tipo de Câmbio',
      exchangeStoreId: 'ID da Casa de Câmbio',
      accountId: 'ID da Conta',
      currencyId: 'ID da Moeda',
      natureId: 'ID da Natureza',
      operationNatureId: 'ID da Natureza de Operação',
      operationId: 'ID da Operação',
      bankId: 'ID do Banco',
      customerId: 'ID do Cliente',
      contactId: 'ID do Contato',
      corbanId: 'ID do Corban',
      documentId: 'ID do Documento',
      countryId: 'ID do País',
      purposeId: 'ID do Propósito',
      spreadId: 'ID do Spread',
      iofBuy: 'IOF Compra',
      irBuy: 'IR Compra',
      cideBuy: 'CIDE Compra',
      usItin: 'ITIN Americano (legado)',
      taxes: 'Impostos',
      buyTaxes: 'Impostos de compra',
      sellTaxes: 'Impostos de venda',
      additionalInformation: 'Informações Adicionais',
      additionalInformationSection: 'Informações adicionais',
      basicInformation: 'Informações básicas',
      currencyInformation: 'Informações da moeda',
      contactInformation: 'Informações de contato',
      generalInformation: 'Informações gerais',
      initialInformation: 'Informações iniciais',
      personalInformation: 'Informações pessoais',
      intermediary: 'Intermediário',
      importedOrExportedBefore: 'Já Importou/Exportou Antes',
      reducedLimit: 'Limite Reduzido',
      limits: 'Limites',
      limitsAndControl: 'Limites e controle',
      limitsAndControls: 'Limites e controles',
      liquidationBrlDays: 'Liquidação BRL (D+)',
      liquidationFxDays: 'Liquidação ME (D+)',
      exchangeStoreList: 'Lista de casas de câmbio',
      contactList: 'Lista de contatos',
      countryList: 'Lista de países',
      birthplace: 'Local de Nascimento',
      location: 'Localização',
      grossProfit: 'Lucro Bruto',
      netProfit: 'Lucro Líquido',
      habilitationMode: 'Modo de Habilitação',
      operatingMode: 'Modo de Operação',
      paymentMode: 'Modo de Pagamento',
      operationalModes: 'Modos operacionais',
      currency: 'Moeda',
      intendedCurrency: 'Moeda pretendida',
      operationNatureSection: 'Natureza da operação',
      operationNatureUpdatedAt: 'Natureza de Operação Atualizada em',
      operationNatureCreatedAt: 'Natureza de Operação Criada em',
      operationNature: 'Natureza de operação',
      natureAndCurrency: 'Natureza e moeda',
      name: 'Nome',
      fantasyName: 'Nome Fantasia',
      bankFantasyName: 'Nome Fantasia do Banco',
      exchangeStoreName: 'Nome da Casa de Câmbio',
      accountName: 'Nome da Conta',
      currencyName: 'Nome da Moeda',
      motherName: 'Nome da Mãe',
      natureName: 'Nome da Natureza',
      operationNatureName: 'Nome da Natureza de Operação',
      relatedPublicAgentName: 'Nome do Agente Público Relacionado',
      bankName: 'Nome do Banco',
      intermediaryBankName: 'Nome do Banco Intermediário',
      customerName: 'Nome do Cliente',
      corbanName: 'Nome do Corban',
      correspondentName: 'Nome do Correspondente',
      spouseName: 'Nome do Cônjuge',
      dependentName: 'Nome do Dependente',
      documentName: 'Nome do Documento',
      fatherName: 'Nome do Pai',
      countryName: 'Nome do País',
      registrationResponsibleName: 'Nome do Responsável pelo Cadastro',
      ownerName: 'Nome do Titular',
      newInternationalAccount: 'Nova Conta Internacional',
      number: 'Número',
      ibanNumber: 'Número IBAN',
      numberEmployees: 'Número de Funcionários',
      routingNumber: 'Número de Roteamento',
      documentNumber: 'Número do Documento',
      tinDocumentNumber: 'Número do Documento (TIN)',
      observation: 'Observação',
      operationNatureObservation: 'Observação da Natureza de Operação',
      occupation: 'Ocupação',
      occupationUpdatedAt: 'Ocupação Atualizada em',
      occupationCreatedAt: 'Ocupação Criada em',
      otherBusinessPurpose: 'Outro Propósito de Relacionamento Comercial',
      pep: 'PEP - Pessoa Politicamente Exposta',
      forFurtherCredit: 'Para Crédito Adicional',
      parity: 'Paridade',
      assets: 'Patrimônio',
      country: 'País',
      birthCountry: 'País de Nascimento',
      destinationCountry: 'País de destino dos fundos',
      taxDomicileCountry: 'País do Domicílio Fiscal (legado)',
      intermediaryCountry: 'País do Intermediário',
      bilateralAgreementCountries: 'Países do Acordo Bilateral',
      bilateralAgreementCountriesSection: 'Países do acordo bilateral',
      relationshipPublicAgent: 'Possui relacionamento com agente público?',
      precision: 'Precisão',
      currencyPrecision: 'Precisão da Moeda',
      firstDiDueEmail: 'Primeiro E-mail DUIMP/DU-E',
      firstFinancialEmail: 'Primeiro E-mail Financeiro',
      firstRegisterEmail: 'Primeiro E-mail de Cadastro',
      firstDocumentationEmail: 'Primeiro E-mail de Documentação',
      firstOperationEmail: 'Primeiro E-mail de Operação',
      priority: 'Prioridade',
      currencyPriority: 'Prioridade da Moeda',
      products: 'Produtos',
      profession: 'Profissão',
      businessPurposeSection: 'Propósito de relacionamento comercial',
      businessPurposes: 'Propósitos de Relacionamento Comercial',
      companyName: 'Razão Social',
      bankCompanyName: 'Razão Social do Banco',
      annualGrossRevenue: 'Receita Bruta Anual',
      marriageSystem: 'Regime de Casamento',
      registeredDiLast6Months: 'Registrado DI nos Últimos 6 Meses',
      publicAgentRelationship: 'Relacionamento com agente público',
      averageMonthlyIncome: 'Renda Mensal Média',
      answerCrimes: 'Resposta sobre Crimes',
      street: 'Rua',
      secondEmail: 'Segundo E-mail',
      secondDiDueEmail: 'Segundo E-mail DUIMP/DU-E',
      secondFinancialEmail: 'Segundo E-mail Financeiro',
      secondRegisterEmail: 'Segundo E-mail de Cadastro',
      secondDocumentationEmail: 'Segundo E-mail de Documentação',
      secondOperationEmail: 'Segundo E-mail de Operação',
      signatureService: 'Serviço de Assinatura',
      sector: 'Setor',
      sectorActivity: 'Setor de Atividade',
      sex: 'Sexo',
      maximumSpreadBuy: 'Spread Máximo de Compra',
      maximumSpreadSell: 'Spread Máximo de Venda',
      minimumSpreadBuy: 'Spread Mínimo de Compra',
      minimumSpreadSell: 'Spread Mínimo de Venda',
      recommendedSpreadBuy: 'Spread Recomendado de Compra',
      recommendedSpreadSell: 'Spread Recomendado de Venda',
      buySpread: 'Spread de compra',
      sellSpread: 'Spread de venda',
      currencySpreads: 'Spreads de moedas',
      status: 'Status',
      operationStatus: 'Status da Operação',
      registerStatus: 'Status do Cadastro',
      statusAndLiquidation: 'Status e liquidação',
      operationSubTotal: 'Subtotal da Operação',
      bankSubTotal: 'Subtotal do Banco',
      taxDomicileAbroadTin: 'TIN do Domicílio Fiscal no Exterior (legado)',
      bankRate: 'Taxa do Banco',
      customerRate: 'Taxa do Cliente',
      customerRateNoIof: 'Taxa do Cliente sem IOF',
      customerRates: 'Taxas do cliente',
      ratesAndTaxes: 'Taxas e impostos',
      landline: 'Telefone Fixo',
      internationalLandline: 'Telefone Fixo Internacional',
      pfRegisterFormTemplate: 'Template Formulário PF',
      pjRegisterFormTemplate: 'Template Formulário PJ',
      thirdDiDueEmail: 'Terceiro E-mail DUIMP/DU-E',
      thirdFinancialEmail: 'Terceiro E-mail Financeiro',
      thirdRegisterEmail: 'Terceiro E-mail de Cadastro',
      thirdDocumentationEmail: 'Terceiro E-mail de Documentação',
      thirdOperationEmail: 'Terceiro E-mail de Operação',
      timestamps: 'Timestamps',
      registerType: 'Tipo de Cadastro',
      exchangeType: 'Tipo de Câmbio',
      documentTypeShort: 'Tipo de Documento',
      personType: 'Tipo de Pessoa',
      exportedProductsType: 'Tipo de Produtos Exportados',
      relationshipType: 'Tipo de Relacionamento',
      documentType: 'Tipo do Documento',
      identificationDocumentType: 'Tipo do Documento de Identificação',
      levies: 'Tributos',
      useUsdContract: 'Usar Contrato USD',
      useUsdExchangeContract: 'Usar Contrato de Câmbio USD',
      useDiDue: 'Usar DUIMP/DU-E',
      useRegisterForm: 'Usar Formulário de Cadastro',
      useUsdLimit: 'Usar Limite USD',
      useInOutLimit: 'Usar Limite de Entrada/Saída',
      amount: 'Valor',
      estimatedAmount: 'Valor Estimado',
      totalValue: 'Valor Total',
      cambioHojeCommissionValue: 'Valor da Comissão Câmbio Hoje',
      bankCommissionValue: 'Valor da Comissão do Banco',
      corbanCommissionValue: 'Valor da Comissão do Corban',
      indicatorCommissionValue: 'Valor da Comissão do Indicador',
      cideValue: 'Valor do CIDE',
      cashbackValue: 'Valor do Cashback',
      iofValue: 'Valor do IOF',
      irValue: 'Valor do IR',
      estimatedAnnualVolumeUsd: 'Volume anual estimado (USD)',
      website: 'Website',
      isBrazilian: 'É Brasileiro',
      issuingAgency: 'Órgão Emissor'
    },
    showAll: 'Exibir todos os dados',
    hideEmpty: 'Ocultar campos não preenchidos',
    control: {
      filter: 'Filtrar',
      viewRecord: 'Visualizar registro',
      viewRecordTitle: 'Visualizar registro: {entity} {id}',
      drawerTitle: 'Filtro',
      startDate: 'Data de início',
      endDate: 'Data de fim',
      userLabel: 'Usuário',
      entityLabel: 'Entidade',
      clearBtn: 'Limpar',
      applyFilter: 'Filtrar',
      externalAccess: 'Acesso externo',
      beforeCreate: 'Antes da criação',
      beforeUpdate: 'Antes da alteração',
      afterCreate: 'Depois da criação',
      afterUpdate: 'Dados alterados',
      colDate: 'Data de cadastro',
      colEntity: 'Entidade',
      colLinkedEntity: 'Entidade vinculada',
      colAction: 'Ação',
      colLinkedUser: 'Usuário vinculado',
      colObservation: 'Observação',
      colActions: 'Ações',
      errors: {
        loadUsers: 'Não foi possível carregar a lista de usuários do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadAudit: 'Não foi possível carregar o histórico de auditoria. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      }
    },
    block: {
      linkedUser: 'Usuário vinculado',
      entity: 'Entidade',
      linkedEntity: 'Entidade vinculada',
      action: 'Ação',
      date: 'Data',
      observation: 'Observação',
      externalAccess: 'Acesso externo'
    },
    section: {
      lastUpdate: 'Última atualização em {date}'
    }
  },

  whatsapp: {
    chatMessageInputUi: {
      previewAlt: 'Preview',
      fileTooLarge: 'Arquivo excede o limite de 10MB'
    },
    searchPlaceholder: 'Buscar conversa...',
    phoneDdiHint: 'DDI + número (ex: 5521999999999)',
    inbox: {
      serviceDisabled: 'O serviço WhatsApp não está configurado. Entre em contato com o administrador.',
      connecting: 'Conectando ao servidor...',
      imageContent: '[Imagem]',
      documentContent: '[Documento: {name}]',
      errorLoadConversations: 'Não foi possível carregar conversas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadMessages: 'Não foi possível carregar mensagens. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSelectFile: 'Não foi possível selecionar arquivo. Confira se o arquivo é JPG, PNG ou PDF e tente novamente.'
    },
    indicator: {
      verifying: 'Verificando...',
      verified: 'WhatsApp verificado',
      notWhatsapp: 'Não é WhatsApp',
      clickToVerify: 'Clique para verificar WhatsApp'
    },
    newConversation: {
      title: 'Nova conversa',
      phoneLabel: 'Número de telefone',
      errorVerify: 'Não foi possível verificar o número. Tente novamente.',
      errorNoWhatsapp: 'Este número não possui WhatsApp.'
    },
    messagePanel: {
      noConversationTitle: 'Nenhuma conversa selecionada',
      noConversationSubtitle: 'Selecione uma conversa ao lado ou inicie uma nova.',
      loadMore: 'Carregar anteriores',
      imageAlt: 'Imagem',
      document: 'Documento',
      today: 'Hoje',
      yesterday: 'Ontem'
    },
    conversationList: {
      title: 'Conversas',
      empty: 'Nenhuma conversa encontrada'
    },
    messageInput: {
      placeholderCaption: 'Adicione uma legenda...',
      placeholderMessage: 'Digite uma mensagem...'
    }
  },

  clara: {
    chatMessageUi: {
      addBank: 'Enviar cadastro para um novo banco',
      viewCustomer: 'Consultar dados do cliente',
      operateWithBank: 'Operar com {bank}',
      createOperation: 'Realizar operação',
      viewOperation: 'Consultar operação'
    },
    claraPanelUi: {
      panelAriaLabel: 'Clara AI, assistente',
      resizeAriaLabel: 'Redimensionar a Clara',
      todayAt: 'Hoje {time}',
      processError: 'Não foi possível processar sua pergunta. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      responseInterrupted: 'Resposta interrompida',
      connectionError: 'Não foi possível conectar à Clara. Verifique sua conexão e tente novamente.'
    },
    customerPickerPlaceholder: 'Nome ou CPF/CNPJ',
    chatInput: {
      placeholder: 'Pergunte sobre o sistema...',
      cancelResponse: 'Cancelar resposta',
      speakQuestion: 'Falar a pergunta',
      send: 'Enviar',
      cancelRecording: 'Cancelar gravação'
    },
    chatMessage: {
      copyResponse: 'Copiar resposta',
      sourcesLabel: 'Fontes: ',
      usefulResponse: 'Resposta útil',
      notUsefulResponse: 'Resposta não útil'
    },
    panel: {
      aiSubtitle: 'Inteligência Artificial',
      historyTooltip: 'Conversas anteriores',
      newChatTooltip: 'Limpa a conversa e recomeça',
      closeTooltip: 'Fechar',
      historyTitle: 'Conversas anteriores',
      historyBack: 'Voltar',
      historyLoading: 'Carregando...',
      historyError: 'Não foi possível carregar o histórico. Tente novamente.',
      historyEmpty: 'Nenhuma conversa anterior por aqui. As próximas conversas aparecem nesta lista automaticamente.',
      operationPrefix: 'Operação #',
      emptyTitle: 'Como posso ajudar?',
      emptyText: 'Tire dúvidas sobre o sistema, analise dados de clientes e resolva pendências.',
      lastCustomerLabel: 'Último cliente',
      streamingDefault: 'Analisando...',
      disclaimer: 'Gerado por IA a partir da base de conhecimento. Confirme informações críticas com o suporte.',
      toolStatus: {
        searchCustomers: 'Buscando clientes...',
        getCustomerInfo: 'Carregando dados do cliente...',
        getCustomerOperations: 'Consultando operações...',
        getOperationDetail: 'Carregando detalhes da operação...',
        getStablecoinStatus: 'Verificando status DolsPay...',
        getIntegrationLogs: 'Consultando logs de integração...',
        checkCustomerReadiness: 'Verificando prontidão do cliente...',
        getCustomerLimits: 'Consultando limites do cliente...',
        getReceiverDiagnostic: 'Verificando cadastro DolsPay...',
        getOnboardingTimeline: 'Carregando timeline de onboarding...',
        getOperationBlockReason: 'Identificando bloqueios...',
        default: 'Consultando dados...'
      },
      suggestions: {
        whatsMissing: 'O que falta pro cliente operar?',
        customerLimit: 'Qual o limite do cliente?',
        receiverRejected: 'Por que o receiver foi rejeitado?',
        howDolspay: 'Como funciona o DolsPay?',
        howCreateStablecoin: 'Como crio uma operação stablecoin?',
        whySendNotComplete: 'Por que o envio ao exterior não foi concluído?',
        howResendEmail: 'Como reenvio um e-mail pro cliente?',
        howFollowOperation: 'Como acompanho minha operação?',
        paymentConfirmed: 'O pagamento foi confirmado?',
        howGenerateSwift: 'Como gero o recibo SWIFT?',
        howLongToSend: 'Quanto tempo demora o envio?',
        howCreateOperation: 'Como criar uma operação?',
        whatOperationStatus: 'Qual status da operação?',
        availableLimits: 'Quais limites disponíveis?',
        whatMissingToOperate: 'O que falta para o cliente operar?',
        whyBankRejected: 'Qual foi a rejeição do banco?',
        myProfit: 'Qual meu lucro?',
        operationDetails: 'Detalhes da operação?'
      }
    },
    intro: {
      tagline: 'Nova agente de inteligência artificial do Tech Câmbio',
      lead: 'A Clara é a especialista do Tech Câmbio. Ela consulta os dados reais da sua operação e explica como o sistema funciona, no painel ao lado da tela em que você já está.',
      highlights: {
        knowsYourOp: {
          title: 'Conhece sua operação',
          text: 'Está com dúvidas se um cliente possui limite ou está pronto para operar Câmbio? Pergunte a Clara'
        },
        systemHelp: {
          title: 'Ajuda sobre o sistema',
          text: 'Seu guia de ajuda sobre como utilizar o sistema. Do cadastro de clientes ao fechamento de operações.'
        },
        secure: {
          title: 'Totalmente seguro',
          text: 'Ela não cria nem altera informações sem sua permissão. A Clara te avisa quando não tem a informação em vez de arriscar um palpite.'
        }
      },
      dontShowToday: 'Não mostrar novamente hoje',
      laterBtn: 'Agora não',
      startBtn: 'Conhecer agora'
    },
    contextBar: {
      talkingAbout: 'Conversando sobre',
      clearLabel: 'Limpar o contexto da conversa',
      clickToChange: '. Clique para trocar.',
      operationDesc: 'Operação #{id}',
      operationAndCustomerDesc: 'Operação #{id} · {name}'
    },
    customerPicker: {
      title: 'Sobre qual cliente?',
      loading: 'Buscando...',
      empty: 'Nenhum cliente encontrado para "{term}".',
      cancel: 'Cancelar'
    },
    operationPicker: {
      title: 'Qual operação de {name}?',
      loading: 'Carregando operações...',
      empty: 'Nenhuma operação encontrada para este cliente.',
      cancel: 'Cancelar'
    },
    spotlight: {
      step: 'Passo 1 de 1',
      closeLabel: 'Fechar o guia',
      title: 'A Clara mora aqui em cima',
      text: 'Clique no ícone destacado, no topo da tela, para abrir o painel da Clara IA. Você pode conversar com ela enquanto continua trabalhando.',
      finishBtn: 'Entendi',
      openBtn: 'Conversar com a Clara'
    },
    launcher: {
      openLabel: 'Abrir a Clara',
      closeLabel: 'Fechar a Clara',
      openTooltip: 'Clara AI · assistente'
    }
  },

  logger: {
    email: {
      title: 'Logs de E-mail',
      preview: 'Visualizar e-mail',
      colDate: 'Data de cadastro',
      colSubject: 'Assunto',
      colCustomer: 'Cliente',
      colCorban: 'Corban',
      colBank: 'Banco',
      colActions: 'Ações',
      searchPlaceholder: 'Pesquisar por assunto ou destinatário',
      optionsTooltip: 'Opções',
      viewBtn: 'Visualizar',
      resendBtn: 'Reenviar para destinatário',
      resendToOtherBtn: 'Reenviar para outro e-mail',
      closeBtn: 'Fechar',
      resendModalTitle: 'Reenviar para outro destinatário',
      sendBtn: 'Enviar',
      cancelBtn: 'Cancelar',
      newEmailLabel: 'Novo e-mail',
      resentSuccess: 'E-mail reenviado!',
      sentSuccess: 'E-mail enviado com sucesso!',
      invalidEmailError: 'Por favor, informe um e-mail válido!',
      noSubject: 'Sem assunto',
      selectTitle: 'Selecione um e-mail',
      selectText: 'Escolha um envio na lista ao lado para ver o conteúdo enviado.',
      fromLabel: 'De',
      toLabel: 'Para',
      resendPreviewBtn: 'Reenviar',
      otherRecipientBtn: 'Outro destinatário',
      errors: {
        loadList: 'Não foi possível carregar a lista de e-mails enviados. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadLogs: 'Não foi possível obter os logs de e-mails enviados. Tente novamente mais tarde!',
        loadCount: 'Não foi possível carregar a quantidade de e-mails enviados. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadPreview: 'Não foi possível carregar o preview do e-mail. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        resend: 'Não foi possível reenviar o e-mail. Tente novamente mais tarde!',
        send: 'Não foi possível enviar o e-mail. Tente novamente mais tarde!'
      }
    },
    whatsapp: {
      title: 'Logs de WhatsApp',
      preview: 'Visualizar mensagem',
      colDate: 'Data de cadastro',
      colPhone: 'Telefone',
      colCustomer: 'Cliente',
      colCorban: 'Corban',
      colUser: 'Usuário',
      colOperation: 'Operação',
      colActions: 'Ações',
      optionsTooltip: 'Opções',
      viewMessageBtn: 'Ver mensagem',
      closeBtn: 'Fechar',
      defaultModalTitle: 'Mensagem WhatsApp',
      selectMessage: 'Selecione uma mensagem para visualizar',
      phoneLabel: 'Telefone:',
      statusLabel: 'Status:',
      customerLabel: 'Cliente:',
      corbanLabel: 'Corban:',
      userLabel: 'Usuário:',
      operationLabel: 'Operação:',
      sentAtLabel: 'Enviado em:',
      errors: {
        loadList: 'Não foi possível carregar a lista de mensagens de WhatsApp enviadas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadCount: 'Não foi possível carregar a quantidade de mensagens de WhatsApp enviadas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadMessage: 'Não foi possível carregar o texto da mensagem. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadMessages: 'Não foi possível obter as mensagens WhatsApp enviadas. Tente novamente mais tarde!'
      }
    }
  },

  access: {
    profiles: {
      title: 'Perfis de acesso',
      newProfile: 'Novo perfil',
      add: 'Adicionar',
      options: 'Opções',
      edit: 'Editar',
      delete: 'Excluir',
      colCode: 'Código',
      colName: 'Nome',
      colObservation: 'Observação',
      colActions: 'Ações',
      deleteConfirmTitle: 'Excluir perfil?',
      deleteMessage: 'Deseja realmente excluir o perfil <strong>"{name}"</strong>?',
      successDelete: 'Perfil {id} excluído com sucesso',
      notUsedError: 'Perfil não pode ser excluído, pois está sendo utilizado.',
      errors: {
        loadList: 'Não foi possível carregar a lista de perfis. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        deleteProfile: 'Não foi possível excluir o perfil. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
      }
    },
    form: {
      editTitle: 'Editar perfil',
      addTitle: 'Adicionar perfil',
      descriptionLabel: 'Descrição',
      observationLabel: 'Observação',
      categoriesTitle: 'Categorias',
      accessCount: '{n} acesso | {n} acessos',
      actionEnable: 'Exibir',
      actionDisable: 'Desabilitar',
      actionHide: 'Ocultar',
      searchLabel: 'Pesquisar',
      accessHeader: 'Acesso',
      selectCategory: 'Selecione uma categoria',
      cancel: 'Cancelar',
      save: 'Salvar',
      validationError: 'Preencha os campos em destaque',
      duplicateError: 'Já existe um perfil cadastrado com essa descrição e observação.',
      createdSuccess: 'Perfil {id} criado com sucesso',
      updatedSuccess: 'Perfil {id} editado com sucesso',
      errors: {
        loadList: 'Não foi possível carregar a lista de acessos do perfil. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadProfile: 'Não foi possível carregar os dados do perfil. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        createProfile: 'Não foi possível cadastrar o perfil. Confira os dados e tente novamente; se continuar, fale com o suporte.',
        updateProfile: 'Não foi possível salvar as alterações do perfil. Confira os dados e tente novamente; se continuar, fale com o suporte.'
      }
    }
  },

  generic: {
    pageNotFound: {
      title: 'Página não encontrada',
      subtitle: 'A página que você procura não existe.',
      backHome: 'Voltar para o início',
      heading: 'A página que você está tentando acessar não existe ou não foi encontrada',
      hint: 'Verifique o endereço digitado ou tente novamente.',
      back: 'Voltar'
    },
    fileView: {
      notFoundTitle: 'Documento não encontrado',
      notFoundHint: 'O arquivo não está mais disponível. Atualize a página (F5) e tente de novo; se continuar, fale com o suporte.'
    },
    pageNotPermission: {
      title: 'Sem permissão',
      subtitle: 'Você não tem permissão para acessar esta página.',
      backHome: 'Voltar para o início',
      heading: 'Você não tem permissão para acessar essa página',
      hint: 'Entre em contato com o administrador do sistema',
      back: 'Voltar'
    }
  },

  home: {
    greeting: 'Olá, {name}',
    quotationTimer: 'Cotação atualiza em {countdown}',
    errors: {
      loadQuotations: 'Não foi possível obter cotações. Atualize a página (F5) e tente novamente.',
      loadCommercial: 'Não foi possível carregar a cotação comercial. Atualize a página (F5) e tente novamente.',
      loadPtax: 'Não foi possível carregar a cotação PTAX. Atualize a página (F5) e tente novamente.',
      loadCurrencies: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente.'
    }
  },

  comum: {
    moneyLoaderUi: {
      defaultMessage: 'Aguarde um momento...'
    },
    operationDocumentTypesUi: {
      didue: 'DUIMP/DU-E',
      swift: 'SWIFT',
      exchangeContract: 'Contrato de Câmbio',
      paymentReceipt: 'Comprovante de Pagamento',
      others: 'Outros',
      bankSlip: 'Boleto Bancário',
      deliveryAuthorization: 'Autorização de entrega',
      invoice: 'Invoice',
      blAwb: 'BL / AWB',
      miscContracts: 'Contratos diversos',
      hedgeContract: 'Contrato de Hedge',
      operationProposal: 'Proposta de Operação'
    },
    timelineSteps: {
      preSaleCreated: 'Pré-venda gerada',
      quoteLocked: 'Cotação fixada',
      pixCreated: 'PIX gerado',
      pixPaymentConfirmed: 'Pagamento PIX confirmado',
      paymentDataCreated: 'Dados para pagamento gerados',
      paymentConfirmed: 'Pagamento confirmado',
      paymentNotReceived: 'Pagamento não recebido',
      stablecoinConversion: 'Conversão para Stablecoin',
      stablecoinCredited: 'Crédito de {token} na Wallet',
      stablecoinDebited: 'Débito de {token} na Wallet',
      operationIdentified: 'Identificação da Operação',
      payoutOrderSent: 'Ordem de pagamento enviada',
      payoutRetrying: 'Envio em verificação ({retryCount} tentativas)',
      usdCreditConfirmed: 'Confirmação de crédito em USD',
      creditConfirmed: 'Confirmação de crédito em {currency}',
      creditConfirmedGeneric: 'Confirmação de crédito no destino',
      payoutNotCompleted: 'Envio ao beneficiário não concluído',
      exchangeContractSigned: 'Contrato de Câmbio formalizado',
      swiftReceiptAvailable: 'Comprovante SWIFT disponível',
      commissionGenerated: 'Geração da comissão do câmbio',
      operationFinished: 'Operação finalizada',
      statusUnderReview: 'Em análise',
      statusPending: 'Com pendências',
      statusPendingReview: 'Análise de pendências',
      statusSettling: 'Em Liquidação',
      statusSettled: 'Liquidada',
      statusCancelled: 'Cancelada',
      statusUnresolved: 'Sem Solução',
      statusReturned: 'Devolvida ao cliente'
    },
    timelineNotes: {
      quoteLockedExchange: 'Nova cotação estabelecida para a operação de câmbio. {rate}',
      quoteLockedPurchase: 'Nova cotação estabelecida para a operação de compra. {rate}',
      quoteSetOnOperation: 'Cotação definida diretamente na operação. {rate}',
      quoteSetByDesk: 'Operação criada sem pré-venda — cotação definida pela mesa.',
      registeredByDesk: 'Operação registrada diretamente pela mesa — sem pré-venda.',
      preSaleCreated: 'Nova pré-venda de compra no valor de {amount}',
      qrIssued: 'QR Code emitido. Aguardando pagamento.',
      qrIssuedWithAmount: 'QR Code emitido no valor de {amount}. Aguardando pagamento.',
      paymentDataIssuedWithAmount: 'Dados para pagamento emitidos no valor de {amount}. Aguardando pagamento.',
      paymentReceived: 'Recebemos o valor de {amount} via banco parceiro.',
      operationRegistered: 'Operação de câmbio nº {operationId} registrada.',
      stablecoinPurchased: 'Enviado ordem de compra de {amount} realizada com sucesso.',
      stablecoinCredited: 'Saldo de {amount} disponível na carteira do cliente.',
      stablecoinDebited: 'Realizado o débito de {amount} para liquidação internacional.',
      payoutRequested: 'Enviamos a solicitação ao banco parceiro para crédito em conta.',
      usdCredited: 'USD disponível na conta bancária de destino do cliente.',
      creditAvailable: '{currency} disponível na conta bancária de destino do cliente.',
      creditAvailableGeneric: 'Valor disponível na conta bancária de destino do cliente.',
      exchangeContractIssued: 'Contrato de Câmbio emitido e vinculado à operação.',
      swiftAttached: 'Documento SWIFT anexado. Já disponível para compartilhamento.',
      settlementDone: 'Liquidação concluída após confirmação do envio.',
      statusUnderReview: 'Operação nº {operationId} recebida e encaminhada para análise da mesa de câmbio.',
      statusPending: 'Foram identificadas pendências documentais. Aguardando regularização pelo cliente.',
      statusPendingReview: 'Documentação reenviada pelo cliente. Retornando para análise da mesa de câmbio.',
      statusSettling: 'Operação aprovada pela mesa de câmbio. Aguardando liquidação financeira.',
      statusSettled: 'Operação de câmbio liquidada com sucesso. Valores transferidos ao beneficiário.',
      statusCancelled: 'Operação cancelada. Nenhum valor foi transferido.',
      statusUnresolved: 'Operação encerrada sem solução. Pendências não foram resolvidas dentro do prazo.',
      statusReturned: 'Pagamento devolvido na conta do cliente. Nenhum envio ao exterior foi feito.',
      failure: '{context} — {reason}',
      failureContexts: {
        payoutGeneration: 'Envio em verificação',
        payinReceipt: 'Pagamento em verificação',
        providerProcessing: 'Processamento em verificação'
      },
      failureReasons: {
        bankRejected: 'banco rejeitou a transferência. Verifique os dados bancários do beneficiário.',
        accountNotFound: 'conta do beneficiário não encontrada. Verifique os dados bancários.',
        limitExceeded: 'limite de transferência excedido. Nossa equipe está verificando.',
        invalidBeneficiary: 'dados do beneficiário inválidos. Verifique nome e dados bancários.',
        complianceReview: 'transferência em análise de compliance. Nossa equipe está verificando.',
        pixExpired: 'o PIX expirou. Gere uma nova cobrança.',
        amountMismatch: 'valor do pagamento diverge do esperado.',
        paymentCancelled: 'pagamento foi cancelado ou estornado.',
        underReview: 'nossa equipe está verificando'
      }
    },
    timelineTradStepsUi: {
      quotationLocked: 'Cotação fixada',
      preSaleCreated: 'Pré-venda gerada',
      pixCreated: 'PIX gerado',
      operationIdentified: 'Identificação da Operação',
      exchangeContractSigned: 'Contrato de Câmbio formalizado',
      swiftReceiptAvailable: 'Comprovante SWIFT disponível',
      operationFinished: 'Operação finalizada'
    },
    generalConstantsUi: {
      registerType: {
        exchange: 'Pessoa física câmbio turismo',
        basicRemittance: 'Pessoa física básico',
        completeRemittance: 'Pessoa física completo',
        legalPerson: 'Pessoa jurídica'
      },
      personType: {
        legalPerson: 'Pessoa jurídica',
        naturalPerson: 'Pessoa física'
      },
      maritalStatus: {
        single: 'Solteiro(a)',
        married: 'Casado(a)',
        divorced: 'Divorciado(a)',
        stableUnion: 'União estável',
        widowed: 'Viúvo(a)'
      },
      marriageSystem: {
        partialCommunion: 'Comunhão parcial de bens',
        universalCommunion: 'Comunhão universão de bens',
        stableUnion: 'União estável',
        separation: 'Separação de Bens',
        separationFreedomOfChoice: 'Separação de Bens: Liberdade de escolha',
        partialCommunionJusticeAndUnion: 'Comunhão parcial de bens: Justiça e união'
      },
      identificationDocumentType: {
        rg: 'RG',
        cnh: 'CNH',
        functional: 'Funcional',
        rneRnm: 'RNE/RNM',
        passport: 'Passaporte',
        dniCedula: 'DNI ou cédula estrangeira'
      },
      operatingMode: {
        ownAccount: 'Por conta própria',
        onBehalfOfThirdParties: 'Por conta e ordem de terceiros. Neste caso, informe o nome e CNPJ do principal prestador de serviços. Utilize o campo "informações adicionais"'
      },
      habilitationMode: {
        limited: 'Limitado (antigo simplificado)',
        unlimited: 'Ilimitado (antigo ordinário)',
        express: 'Expressa'
      },
      paymentMode: {
        advance: 'Antecipado/A vista (Sem DI)',
        ready: 'Pronta (Com DI)',
        both: 'Ambos'
      },
      businessPurposeType: {
        commercial: 'Câmbio Comercial (Importação e Exportação)',
        unilateralTransfersAndTourism: 'Câmbio, Transferências Unilaterais e Turismo (Diponibilidade, Patrimônio, Manut. Res., etc',
        financial: 'Câmbio Financeiro (Investimento, Empréstimos, Juros, Serviços, etc',
        nonResidentAccount: 'Conta Corrente Não Residente (TIR)',
        hedgeAndDerivatives: 'Hedge e Derivativos no Exterior',
        foreignCurrencyAccount: 'Conta Corrente em Moeda Estrangeira',
        otherProducts: 'Outros Produtos e Serviços (Informar)'
      },
      assets: {
        upTo100Thousand: 'Até R$ 100 Mil Reais',
        upTo300Thousand: 'Até R$ 300 Mil Reais',
        upTo500Thousand: 'Até R$ 500 Mil Reais',
        upTo1Million: 'Até R$ 1 Milhão de Reais',
        over1Million: 'Acima de R$ 1 Milhão de Reais'
      },
      authorizationType: {
        perOperation: 'Por operação',
        sixMonths: 'Por 6 meses'
      },
      calculationType: {
        currencyAmount: 'Valor M.E.',
        brlAmount: 'Valor Real'
      },
      customerExchangeBanksColumns: {
        createdAt: 'Criado em',
        updatedAt: 'Última alteração',
        name: 'Nome / Razão social',
        registerProfile: 'Perfil do cadastro',
        corban: 'Corban',
        email: 'Email',
        flow: 'Fluxo',
        actions: 'Ações'
      }
    },
    appFooterUi: {
      environmentHomologation: 'Homologação',
      environmentProduction: 'Produção',
      environmentDevelopment: 'Desenvolvimento'
    },
    supportWidgetSessionUi: {
      replyAlert: 'Suporte: {author} respondeu. {preview}'
    },
    documentAnalysisUi: {
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      mediumHint: 'Documento pode precisar de ajustes',
      lowHint: 'Recomendamos trocar este documento'
    },
    timelineModalUtilsUi: {
      payin: 'Pagamento (BRL)',
      payout: 'Envio (ME)',
      commission: 'Comissão'
    },
    avatarUploadUi: {
      previewAlt: 'Avatar preview'
    },
    buttonUi: {
      processPayment: 'Processar Pagamento',
      processing: 'Processando...',
      paid: 'Pago!'
    },
    cameraModalUi: {
      capturedPhotoAlt: 'Foto capturada'
    },
    cpfOrCnpjFieldUi: {
      cnpjAriaLabel: 'CNPJ (letras e números)'
    },
    editorUnlayerUi: {
      loadError: 'Não foi possível carregar o editor. Verifique sua conexão e tente novamente.',
      scriptLoadError: 'Não foi possível carregar o script do editor. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadTimeout: 'Timeout ao carregar o editor (15s).',
      sdkUnavailable: 'SDK do Unlayer não disponível após carregamento.',
      configUnavailable: 'Configuração da aplicação não disponível.',
      imageUploadError: 'Não foi possível fazer upload da imagem. Confira se o arquivo é JPG, PNG ou PDF e tente novamente.',
      imageUploadConnectionError: 'Não foi possível fazer upload da imagem. Verifique sua conexão.'
    },
    internationalPaymentMethodChipUi: {
      comingSoon: 'Em breve'
    },
    timelineEventListUi: {
      empty: 'Nenhum evento nesta fase',
      observationLabel: 'Obs:'
    },
    timelinePhaseCardUi: {
      inProgress: 'Em andamento',
      completed: 'Concluída'
    },
    required: '*Obrigatório',
    address: {
      internationalCep: 'CEP internacional',
      zipCodeLabel: 'Cep',
      streetLabel: 'Endereço',
      numberLabel: 'Número',
      countryLabel: 'País',
      complementLabel: 'Complemento',
      complementTooltip: 'CASA, GALPAO, LOJA, SALA, ETC.',
      neighborhoodLabel: 'Bairro',
      stateLabel: 'Estado',
      stateHint: 'Use a sigla do estado com 2 caracteres (ex: FL, CA, NY)',
      stateMaxChars: 'Máximo 2 caracteres',
      stateMaxCharsOf: 'Máximo {max} caracteres',
      provinceHint: 'Província, estado ou região (ex.: Buenos Aires)',
      cityLabel: 'Cidade',
      cityNoDataText: 'Selecione uma UF para listar as cidades',
      cityTypeHint: 'Lista de cidades indisponível no momento. Digite o nome da cidade',
      invalidZipCode: 'Cep inválido'
    },
    bank: {
      bankLabel: 'Banco',
      agencyLabel: 'Agência',
      accountLabel: 'Conta',
      digitLabel: 'Dígito',
      pixKeyLabel: 'Chave pix'
    },
    internationalBank: {
      accountNameLabel: 'Apelido da conta',
      accountNameTooltip: 'Ex: Conta do banco XYZ',
      bankLabel: 'Banco',
      swiftBicLabel: 'Código SWIFT ou BIC',
      ibanLabel: 'Número da Conta ou IBAN',
      ownerNameLabel: 'Nome do titular',
      abaRoutingLabel: 'Número ABA/ROUTING',
      ffcLabel: 'FFC (For further credit)',
      addIntermediary: 'Deseja cadastrar um banco intermediário',
      countryLabel: 'País',
      intermediaryBankNameLabel: 'Nome banco intermediário',
      intermediarySwiftAbaLabel: 'Código SWIFT ou ABA banco intermediário'
    },
    cpfCnpjField: {
      duplicated: 'Já existe um cadastro com este {document}',
      available: '{document} válido e disponível',
      invalid: '{document} inválido. Confira o número digitado',
      incomplete: '{document} incompleto'
    },
    phoneField: {
      noCountryFound: 'Nenhum país encontrado',
      countryPlaceholder: 'Selecione um país',
      searchPlaceholder: 'Buscar país...'
    },
    documentInput: {
      deleteTitle: 'Excluir anexo?',
      descriptionLabel: 'Descrição',
      selectOrDragFile: 'Selecione ou arraste o arquivo',
      generateSelfieLink: 'Gerar link para selfie',
      options: 'Opções',
      download: 'Baixar',
      view: 'Visualizar',
      delete: 'Excluir',
      add: 'Adicionar',
      takePhoto: 'Tirar nova foto',
      fileLabel: 'Arquivo',
      sentAt: 'Enviado em {date}',
      defineCountry: 'Definir país',
      remove: 'Remover',
      downloadingAttachment: 'Baixando anexo',
      downloadError: 'Não foi possível baixar o anexo. Tente baixar novamente; se continuar, fale com o suporte.',
      attachmentDeleted: 'Anexo deletado com sucesso!',
      deleteError: 'Não foi possível excluir o anexo. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      fileSizeError: 'O arquivo não pode ter mais que 10MB!',
      uploadError: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.',
      descriptionError: 'Não foi possível atualizar a descrição do documento. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      onlyOneFile: 'É possível adicionar apenas um anexo por vez!',
      onlyImages: 'Apenas arquivos de imagem são aceitos!',
      noFileToView: 'Nenhum arquivo para visualizar.',
      viewError: 'Não foi possível abrir o arquivo para visualização. Tente baixar novamente; se continuar, fale com o suporte.',
      unsupportedFormat: 'Formato de arquivo não suportado para visualização.',
      allowPopups: 'Permita pop-ups para visualizar o arquivo ou use Baixar.',
      deleteMessage: 'Deseja realmente excluir este anexo? Esta ação não pode ser desfeita!'
    },
    documentUploadArea: {
      documentTypeLabel: 'Tipo de documento*',
      documentAlreadyRegistered: 'Documento já cadastrado',
      view: 'Visualizar',
      remove: 'Remover',
      uploading: 'Enviando documento...',
      browseFile: 'Procurar arquivo',
      fileSizeError: 'O arquivo não pode ter mais que {size}!',
      formatError: 'Formato de arquivo não permitido. Use JPEG, PNG, PDF ou MP4.',
      existingDocumentFallback: 'Documento anexado'
    },
    documentUploadWizard: {
      title: 'Adicionar documento',
      clickOrDrag: 'Clique ou arraste o arquivo aqui',
      maxSize: 'Tamanho máximo: 10MB',
      countryLabel: 'País de emissão *',
      cancel: 'Cancelar',
      add: 'Adicionar',
      countryRequired: 'Selecione um país para adicionar o documento.',
      onlyOneFile: 'É possível adicionar apenas um arquivo por vez!',
      fileTooLarge: 'O arquivo não pode ter mais que 10MB!',
      invalidFileType: 'Tipo de arquivo não permitido!',
      selectFileRequired: 'Selecione um arquivo para continuar.',
      descriptionCountryOnly: 'Selecione o país de emissão do documento.',
      descriptionFileOnly: 'Selecione o arquivo do documento.',
      descriptionBoth: 'Selecione o arquivo e o país de emissão do documento.'
    },
    documentUploadZone: {
      documentNamePlaceholder: 'Digite o nome do documento',
      instructionText: 'Escolha um arquivo ou arraste e solte aqui'
    },
    documentCountryModal: {
      title: 'País do documento',
      countryLabel: 'País',
      confirmButton: 'Confirmar',
      cancelButton: 'Cancelar',
      countryRequired: 'Selecione um país antes de confirmar.',
      updateError: 'Não foi possível atualizar o país do documento. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    pendencyModal: {
      title: 'Registrar pendência',
      alertText: 'Esta informação será enviada ao cliente no corpo do e-mail de pendência cadastral.',
      additionalInfo: 'Informações complementares',
      sendEmailLabel: 'Enviar e-mail de pendência para o cliente'
    },
    observationModal: {
      defaultTitle: 'Observação',
      additionalInfo: 'Informações complementares'
    },
    emptyTable: {
      defaultTitle: 'Não há registros emitidos'
    },
    selectCard: {
      chart: 'Gráfico',
      card: 'Cartão'
    },
    quotationCardGroup: {
      exchangeTourism: 'Câmbio turismo',
      commercialExchange: 'Câmbio comercial (Spot)',
      loading: 'Carregando cotações...'
    },
    activeStatus: {
      active: 'Ativo',
      inactive: 'Inativo'
    },
    releases: {
      title: 'Novidades do Tech Câmbio',
      subtitle: 'Acompanhe as últimas atualizações e melhorias',
      introTitle: 'Fique por dentro das novidades',
      introText: 'Descubra as novas funcionalidades, correções e melhorias que estamos entregando para tornar sua experiência ainda melhor.',
      noUpdates: 'Nenhuma atualização disponível no momento.',
      newVersion: 'Nova versão!',
      close: 'Fechar',
      loadError: 'Não foi possível carregar as atualizações. Por favor, tente novamente mais tarde.'
    },
    customerSearch: {
      defaultLabel: 'Cliente / CPF / CNPJ',
      loadError: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.'
    },
    operationSimulator: {
      moveRight: 'Mover simulador para a direita',
      moveLeft: 'Mover simulador para a esquerda',
      sellExit: 'Venda/Saída',
      buyEntry: 'Compra/Entrada',
      copyMessage: 'Copiar Mensagem do cliente',
      clear: 'Limpar',
      close: 'Fechar',
      validate: 'Validar',
      validateNewTab: 'Validar em Nova Aba',
      titleDefault: 'Simulador de Operação',
      titleWithCustomer: 'Simulando Operação | {type} - {name}',
      exchange: 'Câmbio',
      remittance: 'Remessa',
      messageSent: 'Mensagem enviada ao cliente por WhatsApp.',
      messageSentFallback: 'Não foi possível enviar por WhatsApp; mensagem copiada para a área de transferência.',
      messageCopied: 'Mensagem copiada para a área de transferência',
      messageCopyError: 'Não foi possível copiar ou enviar a mensagem. Selecione o texto e copie manualmente (Ctrl+C).',
      loadExchangeTypesError: 'Não foi possível carregar os tipos de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadRateError: 'Não foi possível carregar a cotação da moeda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadDollarError: 'Não foi possível carregar a cotação do dólar. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    avatarUpload: {
      changePhoto: 'Alterar foto',
      selectPhoto: 'Selecionar foto',
      formatError: 'Formato de arquivo não permitido. Use JPEG ou PNG.',
      sizeError: 'O arquivo não pode ter mais que 5MB.'
    },
    baseModal: {
      save: 'Salvar',
      cancel: 'Cancelar'
    },
    cameraModal: {
      title: 'Capturar Foto',
      positionFace: 'Posicione seu rosto aqui',
      loadingCamera: 'Carregando câmera...',
      cameraRequired: 'Acesso à câmera necessário',
      retry: 'Tentar novamente',
      faceDetectedMsg: 'Rosto detectado! Agora você pode capturar a foto',
      positionFaceMsg: 'Posicione seu rosto na área da câmera',
      capturedPreview: 'Prévia da foto capturada:',
      cancel: 'Cancelar',
      retake: 'Tirar novamente',
      capture: 'Capturar',
      confirm: 'Confirmar',
      errors: {
        notAllowed: 'Permissão para acessar a câmera foi negada. Clique em "Tentar novamente" e permita o acesso.',
        notFound: 'Nenhuma câmera foi encontrada no seu dispositivo.',
        notReadable: 'A câmera está sendo usada por outro aplicativo.',
        default: 'Não foi possível acessar a câmera. Verifique se seu navegador permite o acesso.'
      }
    },
    dataTableDocument: {
      addTooltip: 'Adicionar {name}',
      downloadTooltip: 'Baixar {name}',
      downloading: 'Baixando {name}',
      downloadError: 'Não foi possível baixar o anexo. Tente baixar novamente; se continuar, fale com o suporte.',
      onlyOneFile: 'É possível adicionar apenas um anexo por vez!',
      fileSizeError: 'O arquivo não pode ter mais que 10MB!',
      uploadSuccess: 'Documento adicionado com sucesso!',
      uploadError: 'O anexo não foi adicionado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente.'
    },
    federalRevenue: {
      importTooltip: 'Importar dados da Receita Federal',
      invalidCnpjWarning: 'Por favor, informe um CNPJ válido antes de importar os dados.',
      importedSuccess: 'Dados importados com sucesso',
      importError: 'Não foi possível importar dados do CNPJ. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    operationContextMenu: {
      viewOperation: 'Visualizar operação',
      cancelOperation: 'Cancelar Operação',
      relaunchOperation: 'Relançar operação',
      documents: 'Documentos'
    },
    documentInformedCard: {
      defaultFileName: 'Documento anexado',
      sentAt: 'Enviado em {date}'
    },
    tableCustomerCell: {
      externalIdTooltip: 'Cliente importado com ID externo {id}',
      viewCustomerTooltip: 'Visualizar cliente',
      fantasyName: 'Nome fantasia: {name}'
    },
    rssNews: {
      title: 'Notícias de câmbio',
      source: 'Fonte: Investing.com',
      updatedAt: 'Atualizado em {date}',
      loading: 'Carregando notícias...',
      empty: 'Nenhuma notícia disponível no momento',
      refreshTooltip: 'Atualizar notícias',
      publishedBy: 'Publicado por {author}',
      loadError: 'Não foi possível carregar as notícias. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    copyMessageButton: {
      defaultLabel: 'Copiar mensagem',
      notConfiguredError: 'Template não configurado. Acesse Configurações > Mensagem de Operação.',
      copyError: 'Não foi possível copiar a mensagem. Selecione o texto e copie manualmente (Ctrl+C).'
    },
    infoPopover: {
      title: 'Descrição da natureza'
    },
    actionsMenu: {
      ariaLabel: 'Opções'
    }
  },

  operationFilter: {
    title: 'Filtro',
    inactive: '(inativo)',
    duimpStatus: 'Status DUIMP',
    buy: 'Compra',
    sell: 'Venda',
    loadAgentsError: 'Não foi possível carregar a lista de correspondentes do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  confirmationWindow: {
    irreversibleDefault: 'Esta ação não poderá ser desfeita.',
    defaultMessage: 'Confirma a alteração?',
    defaultTitle: 'Confirmação',
    confirmPlaceholder: 'Digite "{word}" para continuar'
  },

  moneyField: {
    minError: 'O valor mínimo permitido é {value}',
    maxError: 'O valor máximo permitido é {value}',
    loadCurrenciesError: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  formCustomer: {
    sectionGuide: {
      ariaLabel: 'Partes do cadastro',
      personal: 'Seus dados',
      bank: 'Contas',
      declarations: 'Declarações',
      documents: 'Documentos',
      terms: 'Termos',
      position: '{current} de {total}'
    },
    customerDocumentDuplicateModalUi: {
      title: '{label} já cadastrado',
      fixButton: 'Corrigir {label}',
      openExistingMessage: 'Este {label} já pertence a um cadastro:',
      openExistingHint: 'Abra o cadastro existente para atualizar os dados, em vez de criar outro.',
      openExistingButton: 'Abrir cadastro existente',
      otherPartnerMessage: 'Este {label} já está cadastrado na plataforma, vinculado a outro parceiro.',
      otherPartnerHint: 'Para seguir com este cliente, fale com o atendimento.',
      contactSupportMessage: 'Já existe um cadastro com este {label}.',
      contactSupportHint: 'Para continuar, fale com o atendimento de quem enviou este link de cadastro.',
      understood: 'Entendi'
    },
    accountIntegrationStatusUi: {
      inAnalysis: 'Em Análise',
      approved: 'Aprovado',
      rejected: 'Rejeitado'
    },
    externalAccessUi: {
      sessionExpired: 'Sua sessão expirou. Para continuar o cadastro, abra de novo o link enviado ao seu e-mail. (Ref.: HTTP-401)',
      existingPartnerLinked: 'Este sócio já tem cadastro no sistema e será vinculado. Os dados dele não aparecem aqui por segurança.'
    },
    taxDomicileConstantsUi: {
      identificationDocument: 'Doc. de identificação',
      driverLicense: 'Carteira de motorista',
      taxDocument: 'Doc. Fiscal',
      identificationDocumentNumber: 'Nº do documento de identificação',
      driverLicenseNumber: 'Nº da carteira de motorista',
      defaultTaxIdLabel: 'Número de identificação fiscal (TIN)'
    },
    partnerLinkingUi: {
      confirmationTitle: 'Confirmação',
      linkPartnerTitle: 'Vincular sócio?',
      link: 'Vincular',
      divergentDateTitle: 'Data divergente',
      understood: 'Entendido',
      loadExistingCustomerError: 'Não foi possível carregar os dados do cliente existente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      checkDocumentDateError: 'Não foi possível conferir se o documento e a data informados já estão cadastrados. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    accountRefusalAlertUi: {
      title: 'Uma conta bancária foi recusada pelo provedor | {count} contas bancárias foram recusadas pelo provedor',
      text: 'Elas ainda não servem para operar. Veja o motivo em cada conta, corrija e envie de novo.',
      action: 'Ver contas'
    },
    bankAccountProvidersUi: {
      syncedIn: 'Conta sincronizada em {provider}.',
      notSyncedIn: 'A conta não foi sincronizada em {provider}. Confira os dados da conta e clique em Sincronizar novamente.',
      linkReactivatedIn: 'Vínculo reativado em {provider}.',
      accountRecreatedIn: 'Conta recriada e vinculada em {provider}.',
      notCheckedIn: 'A conta não foi conferida em {provider}. Clique em Sincronizar novamente; se continuar, fale com o suporte.',
      noPendingProvider: 'Nenhum provedor pendente para esta conta.',
      syncNotCompleted: 'sincronização não concluída',
      partiallySynced: 'Sincronizada em {synced} provedor(es). Não concluída em — {failures}',
      syncFailed: 'Não foi possível sincronizar. {failures}',
      syncedInCount: 'Conta sincronizada em {synced} provedor(es).',
      notSyncedWithProviders: 'A conta não foi sincronizada com os provedores. Confira os dados da conta e clique em Sincronizar novamente.'
    },
    bankLookupUi: {
      routingWithoutWire: 'Este routing number é só para ACH e não recebe Wire. Confirme com o banco o routing de Wire (costuma ser diferente).',
      routingWithoutAch: 'Este routing number não recebe ACH. Confirme com o banco o routing para ACH.',
      routingNotFound: 'Não encontramos este routing number. Confira os 9 dígitos.',
      swiftNotFound: 'Não encontramos este código SWIFT. Confira o código com o banco.',
      ibanNotFound: 'Não encontramos este IBAN. Confira o número.'
    },
    walletEmailLockUi: {
      emailLockedHint: 'E-mail ligado à carteira digital do cliente. Para trocar, fale com o suporte.'
    },
    bankAccountProviderConstantsUi: {
      syncedDescription: 'Sincronizado',
      syncedHint: 'Conta cadastrada neste provedor e disponível para operar',
      notSyncedDescription: 'Não sincronizado',
      pendingHint: 'Conta ainda não enviada a este provedor. Use o botão ao lado para enviar.',
      unsupportedDescription: 'Não disponível',
      unsupportedHint: 'Este provedor não opera este tipo de conta.',
      notEnabledDescription: 'Não habilitado',
      notEnabledHint: 'O cliente ainda não tem cadastro aprovado neste provedor. A conta pode ser enviada depois da aprovação.',
      unavailableDescription: 'Indisponível',
      unavailableHint: 'Este provedor ainda não recebe contas bancárias pelo sistema.',
      inconsistentDescription: 'Vínculo desativado',
      inconsistentHint: 'A conta já foi enviada a este provedor, mas o vínculo local foi desativado e ela não pode operar. Use o botão ao lado para reconciliar: ele consulta a conta no provedor e reativa o vínculo.',
      pendingFixDescription: 'Corrigir cadastro',
      pendingFixHint: 'O cadastro desta conta precisa de ajuste antes do envio a este provedor.',
      refusedDescription: 'Recusada',
      refusedHint: 'O provedor recusou esta conta na última tentativa. Corrija o que está indicado e envie de novo.',
      fallbackHint: 'Situação não informada pelo provedor',
      loadingDescription: 'Consultando',
      loadingHint: 'Buscando situação nos provedores',
      payoutBeta: 'Pagamentos em fase de testes neste provedor',
      payoutDisabled: 'Sem pagamentos por este provedor neste tipo de conta, no momento'
    },
    stablecoinProviderConstantsUi: {
      approvedDescription: 'Aprovado',
      approvedHint: 'Operações liberadas',
      viewLimitsTooltip: 'Ver limites do cliente',
      verifyingDescription: 'Em verificação',
      verifyingHint: 'Cadastro em análise na instituição',
      viewVerificationTooltip: 'Ver link de verificação',
      complianceRequestDescription: 'Pendência de compliance',
      complianceRequestHint: 'Documentos adicionais solicitados',
      partiallyRejectedDescription: 'Correção pedida',
      partiallyRejectedHint: 'Cliente precisa reenviar documentos pelo link',
      viewCorrectionTooltip: 'Ver o motivo e o link de correção',
      rejectedDescription: 'Cadastro recusado',
      rejectedHint: 'Cadastro não aprovado pelo provedor',
      deprecatedDescription: 'Encerrado',
      deprecatedHint: 'Cadastro substituído',
      loadingDescription: 'Consultando',
      loadingHint: 'Buscando situação no provedor',
      unlinkedDescription: 'Não vinculado',
      unlinkedHint: 'Cliente ainda não enviado ao provedor',
      linkProviderTooltip: 'Vincular provedor',
      notChosenDescription: 'Não escolhido',
      notChosenHint: 'Fora da escolha ao adicionar o banco',
      sendRegistrationTooltip: 'Enviar o cadastro para este provedor',
      notChosenPausedHint: 'Não está aceitando clientes novos no momento',
      rejectedReonboardHint: 'Recusado definitivamente — corrija a ficha e recadastre',
      reonboardTooltip: 'Ver o motivo e recadastrar',
      viewPendingTooltip: 'Ver pendências',
      onboardingTooltip: 'Acompanhar o envio do cadastro',
      sendingDescription: 'Enviando',
      sendingHint: 'Sistema enviando os documentos',
      apiVerifyingHint: 'Documentos enviados pelo sistema',
      awaitingCustomerDescription: 'Aguardando cliente',
      awaitingCustomerHint: 'Cliente completa o cadastro pelo link',
      apiCorrectionHint: 'Troque os documentos na ficha e reenvie',
      apiCorrectionTooltip: 'Ver o motivo e reenviar',
      documentsProgressHint: '{sent} de {total} documentos enviados',
      railsApprovedPendingHint: '{approved} liberado · {pending} em análise',
      railsPendingHint: '{pending} em análise'
    },
    unblockOnboardingUi: {
      title: 'Cadastro em {name}',
      defaultInstitution: 'a instituição',
      close: 'Fechar',
      rejectionsTitle: 'O que a instituição pediu para corrigir',
      fallbackTitle: 'Por que o cliente precisa completar pelo link',
      checklistEmpty: 'A instituição ainda não informou quais documentos precisa.',
      documentFallback: 'Documento',
      beneficiaryDocument: 'Sócio · {name}',
      summary: {
        approved: 'Cadastro aprovado. As operações estão liberadas.',
        correction: 'A instituição pediu correção. Troque os documentos na ficha do cliente e reenvie; não precisa de link.',
        rejected: 'Cadastro recusado pela instituição.',
        fallback: 'O sistema não conseguiu enviar tudo. Envie o link ao cliente para ele completar o que faltou.',
        checkRequested: 'Documentos enviados pelo sistema. A instituição está analisando o cadastro.',
        sending: 'O sistema está enviando os documentos do cliente. Esta tela atualiza sozinha.'
      },
      messages: {
        statusError: 'Não foi possível consultar o envio agora. Tente de novo em instantes.',
        linkCopied: 'Link copiado',
        linkCopyError: 'Não foi possível copiar o link. Selecione e copie manualmente.',
        resubmitSuccess: 'Documentos corrigidos reenviados',
        resubmitError: 'Os documentos não foram reenviados. Confira se foram trocados na ficha e tente de novo.',
        advanceSuccess: 'Envio retomado',
        advanceError: 'O envio não foi retomado agora. Tente de novo em instantes.'
      },
      documents: {
        NATIONAL_ID: 'RG / documento de identidade',
        DRIVER_LICENSE: 'CNH',
        PASSPORT: 'Passaporte',
        PROOF_OF_ADDRESS: 'Comprovante de endereço',
        SELFIE: 'Selfie',
        SOURCE_OF_FUNDS: 'Comprovante de renda (IR ou extrato)',
        INCORPORATION_ARTICLES: 'Contrato social',
        INCORPORATION_CERTIFICATE: 'Certidão da empresa',
        INCUMBENCY_CERTIFICATE: 'Certidão de administradores',
        SHAREHOLDER_REGISTRY: 'Quadro societário',
        STATE_COMPANY_REGISTRY: 'Cartão CNPJ / registro da empresa'
      },
      sides: {
        FRONT: 'frente',
        BACK: 'verso'
      },
      uploadStatus: {
        pending: 'aguardando envio',
        uploaded: 'enviado',
        failed: 'falhou ao enviar'
      },
      fallbackReasons: {
        missing_document: 'não está no cadastro',
        upload_failed: 'não foi aceito pelo envio do sistema',
        missing_beneficiary: 'sócio ainda sem identificação na instituição',
        check_refused: 'a instituição não aceitou pedir a análise',
        link_only_step: 'só pode ser respondido pelo cliente no link',
        missing_answers: 'falta resposta no perfil das operações da ficha',
        questionnaire_refused: 'o provedor não aceitou as respostas do perfil das operações'
      },
      subjects: {
        check: 'Pedido de análise',
        step: 'Etapa da instituição',
        beneficiary: 'Sócio'
      },
      steps: {
        QUESTIONNAIRE: 'Questionário',
        SOURCE_OF_FUNDS: 'Comprovante de origem dos recursos',
        DIAGRAM_FLOW: 'Fluxograma das operações'
      },
      progress: {
        created: 'Cadastro criado',
        documents: 'Documentos enviados',
        count: '{sent} de {total}',
        review: 'Em análise',
        afterCustomer: 'depois que o cliente concluir',
        result: 'Resultado'
      },
      actions: {
        resubmit: 'Reenviar documentos corrigidos',
        copyLink: 'Copiar link para o cliente',
        advance: 'Tentar de novo agora'
      }
    },
    internationalBankConstantsUi: {
      accountTypes: {
        checking: 'Conta corrente',
        savings: 'Poupança'
      },
      accountClasses: {
        individual: 'Individual',
        business: 'Empresarial'
      },
      recipientRelationships: {
        firstParty: 'Parte relacionada',
        employee: 'Funcionário',
        independentContractor: 'Prestador de serviço',
        vendorOrSupplier: 'Fornecedor',
        subsidiaryOrAffiliate: 'Subsidiária ou afiliada',
        merchantOrPartner: 'Parceiro comercial',
        customer: 'Cliente',
        landlord: 'Locador',
        family: 'Familiar',
        other: 'Outros'
      },
      speiProtocols: {
        debitCard: 'Cartão de débito',
        phoneNumber: 'Número de telefone'
      },
      usPostalCodeExample: '10115 ou 10115-1234'
    },
    swiftPaymentCodesUi: {
      ae_swift_str: 'Turismo e Viagens',
      ae_swift_tcs: 'Serviços de Telecomunicação',
      ae_swift_ipc: 'Royalties / Propriedade Intelectual',
      ae_swift_ifs: 'Serviços de Informação',
      ae_swift_sts: 'Transporte Marítimo',
      ae_swift_pms: 'Consultoria Profissional e de Gestão',
      ae_swift_its: 'Serviços de Tecnologia da Informação',
      ae_swift_gde: 'Exportação de Mercadorias (FOB)',
      ae_swift_ots: 'Outros Métodos de Transporte',
      ae_swift_tts: 'Serviços Técnicos, Comerciais e Outros',
      bh_swift_afa: 'Depósito / Conta Bancária no Exterior (Residentes)',
      bh_swift_afl: 'Depósito / Conta Bancária no Bahrein (Não Residentes)',
      bh_swift_ats: 'Transporte Aéreo',
      bh_swift_cea: 'Investimento Direto no Exterior (Participação Societária)',
      bh_swift_cel: 'Investimento Direto no Bahrein (Participação Societária)',
      bh_swift_chc: 'Doações e Contribuições Filantrópicas',
      bh_swift_dla: 'Títulos de Dívida no Exterior (Longo Prazo)',
      bh_swift_dlf: 'Empréstimos Intragrupo — Exterior',
      bh_swift_dll: 'Títulos de Residentes em Não Relacionadas (Longo Prazo)',
      bh_swift_doe: 'Dividendos Não Intragrupo',
      bh_swift_dsa: 'Títulos de Dívida no Exterior (Curto Prazo)',
      bh_swift_dsf: 'Títulos de Dívida Intragrupo Exterior',
      bh_swift_dsl: 'Títulos de Residentes em Não Relacionadas (Curto Prazo)',
      bh_swift_fam: 'Remessa para Família / Remessas de Trabalhadores',
      bh_swift_fda: 'Derivativos Financeiros — Exterior',
      bh_swift_fdl: 'Derivativos Financeiros — Bahrein',
      bh_swift_fia: 'Cotas de Fundos de Investimento — Exterior',
      bh_swift_fil: 'Cotas de Fundos de Investimento — Bahrein',
      bh_swift_fis: 'Serviços Financeiros',
      bh_swift_fsa: 'Participações Societárias no Exterior (Não Relacionadas)',
      bh_swift_fsl: 'Participações Societárias no Bahrein (Não Relacionadas)',
      bh_swift_gde: 'Exportação de Mercadorias (FOB)',
      bh_swift_gdi: 'Importação de Mercadorias (CIF)',
      bh_swift_gms: 'Processamento, Reparo e Manutenção de Mercadorias',
      bh_swift_gos: 'Bens e Serviços Governamentais',
      bh_swift_gri: 'Receitas Governamentais (Impostos, Tarifas, Transferências)',
      bh_swift_ifs: 'Serviços de Informação',
      bh_swift_igd: 'Dividendos Intragrupo',
      bh_swift_iid: 'Juros sobre Dívida Intragrupo',
      bh_swift_ins: 'Serviços de Seguros',
      bh_swift_iod: 'Rendimentos sobre Depósitos',
      bh_swift_iol: 'Rendimentos sobre Empréstimos',
      bh_swift_ipc: 'Royalties / Propriedade Intelectual',
      bh_swift_ish: 'Rendimentos de Cotas de Fundos',
      bh_swift_isl: 'Juros sobre Títulos (Longo Prazo)',
      bh_swift_iss: 'Juros sobre Títulos (Curto Prazo)',
      bh_swift_its: 'Serviços de Tecnologia da Informação',
      bh_swift_ldl: 'Empréstimos Intragrupo no Bahrein (Longo Prazo)',
      bh_swift_lds: 'Títulos de Dívida Intragrupo no Bahrein',
      bh_swift_lea: 'Arrendamento no Exterior',
      bh_swift_lel: 'Arrendamento no Bahrein',
      bh_swift_lla: 'Empréstimos a Não Residentes (Longo Prazo)',
      bh_swift_lll: 'Empréstimos de Não Residentes a Residentes (Longo Prazo)',
      bh_swift_ots: 'Outros Métodos de Transporte',
      bh_swift_pip: 'Lucros sobre Produtos Islâmicos',
      bh_swift_pms: 'Consultoria Profissional e de Gestão',
      bh_swift_ppa: 'Compra de Imóvel no Exterior',
      bh_swift_ppl: 'Compra de Imóvel no Bahrein',
      bh_swift_prr: 'Lucros ou Aluguéis de Imóveis',
      bh_swift_prs: 'Serviços Pessoais, Culturais, Audiovisuais e Recreativos',
      bh_swift_rda: 'Títulos de Dívida Reversa no Exterior',
      bh_swift_rdl: 'Títulos de Dívida Reversa no Bahrein',
      bh_swift_rds: 'Pesquisa e Desenvolvimento',
      bh_swift_rea: 'Participações Societárias Reversas no Exterior',
      bh_swift_rel: 'Participações Societárias Reversas no Bahrein',
      bh_swift_rfs: 'Repos sobre Títulos Estrangeiros',
      bh_swift_rls: 'Repos sobre Títulos de Residentes',
      bh_swift_sal: 'Salário / Remuneração de Empregados',
      bh_swift_sco: 'Construção Civil',
      bh_swift_sla: 'Empréstimos a Não Residentes (Curto Prazo)',
      bh_swift_sll: 'Empréstimos de Não Residentes a Residentes (Curto Prazo)',
      bh_swift_str: 'Turismo e Viagens',
      bh_swift_sts: 'Transporte Marítimo',
      bh_swift_tcp: 'Créditos Comerciais a Pagar',
      bh_swift_tcr: 'Créditos Comerciais a Receber',
      bh_swift_tcs: 'Serviços de Telecomunicação',
      bh_swift_tts: 'Serviços Técnicos, Comerciais e Outros',
      ch_swift_ccdndr: 'Doação Filantrópica',
      ch_swift_cctfdr: 'Transferência de Capital Transfronteiriça',
      ch_swift_cgoddr: 'Comércio de Mercadorias Transfronteiriço',
      ch_swift_cocadr: 'Outras Transações de Conta Corrente',
      ch_swift_cstrdr: 'Comércio de Serviços Transfronteiriço',
      ch_swift_remtdr: 'Pagamento Transfronteiriço (Individual)',
      cn_swift_ccdndr: 'Conta de Capital — Pagamento/Dívida/Empréstimo',
      cn_swift_cctfdr: 'Transferência de Capital Transfronteiriça',
      cn_swift_cgoddr: 'Comércio de Mercadorias Transfronteiriço',
      cn_swift_cocadr: 'Outras Transações de Conta Corrente',
      cn_swift_cstrdr: 'Comércio de Serviços Transfronteiriço',
      cn_swift_remtdr: 'Remessa — Pagamento Pessoal Não Comercial',
      hk_swift_charitabledonation: 'Doação Filantrópica',
      hk_swift_goods: 'Mercadorias',
      hk_swift_personal: 'Uso Pessoal',
      hk_swift_services: 'Serviços',
      jp_swift_101: 'Pagamento de Fatura / Compra',
      jp_swift_102: 'Pagamento de Conta de Utilidades',
      jp_swift_103: 'Recarga de Cartão Pré-pago',
      jp_swift_104: 'Ordens Permanentes',
      jp_swift_105: 'Doações Pessoais',
      jp_swift_106: 'Assistência e Despesas Familiares',
      jp_swift_107: 'Contribuição à Seguridade Social (Individual)',
      jp_swift_108: 'Mensalidades de Associações',
      jp_swift_109: 'Conta Poupança e Financiamento',
      jp_swift_110: 'Herança',
      jp_swift_111: 'Indenização de Rescisão',
      jp_swift_1111: 'Cartão de Crédito — Pagamento',
      jp_swift_1112: 'Empréstimo Pessoal — Pagamento',
      jp_swift_201: 'Salários — Setor Público',
      jp_swift_202: 'Salários — Trabalhadores',
      jp_swift_203: 'Salários — Setor Privado',
      jp_swift_301: 'Receitas de Investimento',
      jp_swift_302: 'Corretagem de Investimentos',
      jp_swift_303: 'Seguros',
      jp_swift_305: 'Investimento Local',
      jp_swift_306: 'Investimento Externo',
      jp_swift_401: 'Frete Aéreo',
      jp_swift_402: 'Frete Terrestre',
      jp_swift_403: 'Frete Marítimo',
      jp_swift_404: 'Turismo e Viagens',
      jp_swift_601: 'Exportação — Setor Público',
      jp_swift_602: 'Exportação — Setor Privado',
      jp_swift_603: 'Importação — Setor Público',
      jp_swift_604: 'Importação — Setor Privado',
      jp_swift_801: 'Serviços de Telecomunicação',
      jp_swift_802: 'Serviços Financeiros',
      jp_swift_803: 'Serviços de Tecnologia da Informação',
      jp_swift_804: 'Consultoria',
      jp_swift_805: 'Construção Civil',
      jp_swift_806: 'Manutenção e Montagem',
      jp_swift_807: 'Marketing e Mídia',
      jp_swift_809: 'Serviços Médicos e de Saúde',
      jp_swift_810: 'Serviços Culturais, Educacionais e de Entretenimento',
      jp_swift_811: 'Aluguel',
      jp_swift_812: 'Imóveis',
      jp_swift_813: 'Impostos e Taxas',
      jp_swift_815: 'Comissões',
      jp_swift_902: 'Fundos Governamentais',
      jp_swift_903: 'Fundos do Setor Privado',
      jp_swift_904: 'Fundos Recebidos do Exterior',
      jp_swift_1001: 'Remessas de Comunidades Internacionais e Embaixadas',
      jp_swift_1002: 'Missões Diplomáticas Permanentes',
      jp_swift_1003: 'Missões Diplomáticas Temporárias',
      jp_swift_1004: 'Receitas de Embaixadas Jordanianas',
      jp_swift_1101: 'Parcelas de Empréstimos de Longo Prazo — Setor Público',
      jp_swift_1102: 'Juros de Empréstimos de Longo Prazo — Setor Público',
      jp_swift_1103: 'Parcelas de Empréstimos de Curto Prazo — Setor Público',
      jp_swift_1104: 'Juros de Empréstimos de Curto Prazo — Setor Público',
      jp_swift_1105: 'Parcelas de Empréstimos de Longo Prazo — Setor Privado',
      jp_swift_1106: 'Juros de Empréstimos de Longo Prazo — Setor Público (Privado)',
      jp_swift_1107: 'Parcelas de Empréstimos de Curto Prazo — Setor Privado',
      jp_swift_1108: 'Juros de Empréstimos de Curto Prazo — Setor Privado',
      jp_swift_1109: 'Parcelas de Empréstimos com Garantia Governamental',
      jp_swift_1110: 'Juros de Empréstimos com Garantia Governamental',
      jp_swift_1201: 'Reencaminhamento / Rerouting',
      jp_swift_1202: 'Apoio à Pesquisa Científica',
      jp_swift_204: 'Salários do Corpo Diplomático Jordaniano',
      jp_swift_205: 'Salários do Corpo Diplomático Estrangeiro',
      jp_swift_206: 'Salários Recebidos do Exterior',
      jp_swift_207: 'Aposentadoria Civil / Militar',
      jp_swift_208: 'Aposentadoria pela Seguridade Social',
      jp_swift_209: 'Contribuição Previdenciária de Empresa',
      jp_swift_304: 'Assinaturas a Organizações Internacionais Não Monetárias',
      jp_swift_307: 'Garantia de Participação em Licitação (Tender Bond)',
      jp_swift_501: 'Transferências de Delegações Governamentais',
      jp_swift_502: 'Transferências de Delegações do Setor Privado',
      jp_swift_503: 'Educação Governamental',
      jp_swift_504: 'Educação — Setor Privado',
      jp_swift_701: 'Auxílio a Comunidades Religiosas',
      jp_swift_702: 'Auxílio a Comunidades Internacionais',
      jp_swift_703: 'Auxílio a Comunidades Árabes',
      jp_swift_704: 'Auxílio da ONU',
      jp_swift_705: 'Auxílio de Comunidades Beneficentes',
      jp_swift_808: 'Serviços de Mineração',
      jp_swift_814: 'Taxas e Tarifas',
      jp_swift_816: 'Taxas de Franquia e Licença',
      jp_swift_817: 'Cobrança de Cheques',
      jp_swift_818: 'Taxas de Associação / Anuidade',
      jp_swift_901: 'Fundos Municipais',
      ke_swift_airb: 'Transporte Aéreo',
      ke_swift_chc: 'Contribuições Filantrópicas / Caridade',
      ke_swift_comu: 'Desenvolvimento Comunitário',
      ke_swift_cons: 'Construção Civil',
      ke_swift_cort: 'Liquidação de Operação Comercial',
      ke_swift_divd: 'Pagamento de Dividendos',
      ke_swift_educ: 'Despesas com Educação',
      ke_swift_foex: 'Câmbio / Moeda Estrangeira',
      ke_swift_govt: 'Pagamentos Governamentais',
      ke_swift_hlfd: 'Alimentos e Bens de Consumo',
      ke_swift_hlti: 'Plano de Saúde',
      ke_swift_loan: 'Empréstimo',
      ke_swift_mdcs: 'Serviços Médicos',
      ke_swift_merc: 'Mercadorias e Produtos Manufaturados',
      ke_swift_paye: 'Pagamento de Salário (PAYE)',
      ke_swift_psco: 'Serviço Profissional / Comissão',
      ke_swift_refu: 'Reembolso',
      ke_swift_rent: 'Aluguel de Imóvel',
      ke_swift_sala: 'Pagamento de Salário',
      ke_swift_savg: 'Poupança',
      ke_swift_scho: 'Taxa Escolar',
      ke_swift_ship: 'Frete Marítimo',
      ke_swift_taxs: 'Pagamento de Imposto',
      ke_swift_ubil: 'Conta de Utilidades',
      ke_swift_vatx: 'Pagamento de IVA',
      ke_swift_whld: 'Retenção na Fonte',
      ke_swift_1001: 'Imposto de Importação — Petróleo',
      ke_swift_1002: 'Imposto de Importação',
      ke_swift_1101: 'Imposto de Consumo — Petróleo',
      ke_swift_1102: 'Imposto de Consumo (Excise Duty)',
      ke_swift_1201: 'IVA — Petróleo',
      ke_swift_1202: 'IVA — Importações',
      ke_swift_1206: 'IVA — Petróleo (8%)',
      ke_swift_1501: 'Taxa de Alteração',
      ke_swift_1518: 'Taxa de Concessão',
      ke_swift_1519: 'Taxas de Registro',
      ke_swift_1527: 'Taxa de Transbordo (Transshipment)',
      ke_swift_1801: 'Taxas IDF (2,0%)',
      ke_swift_1802: 'IDF / PIF — Petróleo',
      ke_swift_1908: 'Aluguel de Armazém Alfandegário',
      ke_swift_2101: 'Levy de Manutenção de Estradas (RML)',
      ke_swift_2301: 'Levy de Regulação do Setor de Petróleo (PRL)',
      ke_swift_2501: 'Pagamento Bruto — Fundo de Desenvolvimento do Petróleo (PDF)',
      ke_swift_2901: 'Imposto de Renda — PAYE',
      ke_swift_3001: 'Imposto de Renda — Empresas',
      ke_swift_3100: 'Imposto de Renda — Pessoa Física Residente',
      ke_swift_3101: 'Imposto Mensal sobre Receita de Aluguel',
      ke_swift_3103: 'Retenção na Fonte — Receita de Aluguel',
      ke_swift_3200: 'Imposto de Renda — Retenção na Fonte',
      ke_swift_3304: 'Imposto Antecipado sobre Veículos',
      ke_swift_3509: 'IVA — Retenção na Fonte',
      ke_swift_3514: 'IVA — Imposto sobre Valor Agregado',
      ke_swift_3801: 'Levy de Padrões (Standards Levy)',
      ke_swift_4103: 'Imposto de Selo (Stamp Duty)',
      ke_swift_4301: 'Secretaria de Pesca, Aquicultura e Economia Azul',
      ke_swift_4601: 'Certificado de Saúde de Importação',
      ke_swift_4702: 'Formulário de Declaração de Importação — Nozes e Óleos',
      ke_swift_512: 'Autoridade Nacional de Treinamento Industrial (NITA)',
      ke_swift_6001: 'Levy de Desenvolvimento Ferroviário do Quênia (RDL)',
      ke_swift_6002: 'Levy de Desenvolvimento Ferroviário do Quênia (RDL) — Petróleo',
      ke_swift_6101: 'Venda de Placa de Veículo (Unitária)',
      ke_swift_6102: 'Venda de Par de Placas de Veículo',
      ke_swift_6301: 'Taxa de Transferência de Registro de Veículo',
      ke_swift_6401: 'Levy do Superintendente de Navegação Mercante',
      ke_swift_6402: 'Levy do Superintendente de Navegação Mercante (MSS) — Petróleo',
      ke_swift_6501: 'Fundo de Segurança Rodoviária',
      ke_swift_6601: 'Imposto de Compra SHMV',
      ke_swift_adtx: 'Imposto Antecipado (Advance Tax)',
      ke_swift_artx: 'Receita de Agência (incl. Imposto de Selo, Apostas)',
      ke_swift_bech: 'Benefício por Filho (Child Benefit)',
      ke_swift_bsd: 'Departamento de Supervisão Bancária (BSD)',
      ke_swift_bttx: 'Imposto sobre Apostas (Betting Tax)',
      ke_swift_ccmc: 'Chamadas de Margem — Colateral em Dinheiro',
      ke_swift_cere: 'Cerimônias (Funeral, Formatura, Casamento)',
      ke_swift_cfr: 'CFR — Custo e Frete (Transporte Marítimo / Aquaviário) — Incoterms 2010',
      ke_swift_cgtx: 'Imposto sobre Ganho de Capital (CGT)',
      ke_swift_clot: 'Despesas com Vestuário',
      ke_swift_cotx: 'Identificação Fiscal de Empresa (Corporate Tax ID)',
      ke_swift_csdk: 'Pagamentos ao Depositário Central de Valores Mobiliários (CSD)',
      ke_swift_edtx: 'Imposto de Consumo (Excise Duty)',
      ke_swift_farm: 'Agropecuária',
      ke_swift_fuel: 'Despesas com Combustível',
      ke_swift_gokx: 'Pagamentos e Transferências Governamentais',
      ke_swift_holi: 'Férias / Turismo',
      ke_swift_ibld: 'Pagamento de Empréstimo / Depósito Interbancário',
      ke_swift_inpc: 'Prêmio de Seguro Automotivo',
      ke_swift_insu: 'Prêmio de Seguro',
      ke_swift_inte: 'Juros',
      ke_swift_intx: 'Imposto de Renda',
      ke_swift_invs: 'Investimentos e Títulos Financeiros',
      ke_swift_istx: 'Imposto Parcelado (Installment Tax)',
      ke_swift_licf: 'Taxa de Licença',
      ke_swift_lifi: 'Seguro de Vida',
      ke_swift_mach: 'Equipamentos e Maquinários',
      ke_swift_mafc: 'Contribuição ao Fundo de Auxílio Médico (MAFC)',
      ke_swift_pena: 'Multas e Penalidades',
      ke_swift_pl39: 'Taxa de Licença — Bancos Comerciais',
      ke_swift_pl40: 'Taxa de Licença — Instituições de Microcrédito com Depósito',
      ke_swift_pl41: 'Taxa de Licença — Casas de Câmbio (Forex Bureaus)',
      ke_swift_pl42: 'Taxa de Licença — Agências de Referência de Crédito',
      ke_swift_pl43: 'Taxa de Licença — Instituições Financeiras Hipotecárias',
      ke_swift_pl44: 'Taxa de Solicitação — Bancos Comerciais',
      ke_swift_pl45: 'Taxa de Solicitação — Instituições Financeiras Hipotecárias',
      ke_swift_pl46: 'Taxa de Solicitação — Instituições com Depósito',
      ke_swift_pl47: 'Taxa de Solicitação — Casas de Câmbio (Forex Bureaus)',
      ke_swift_pl48: 'Taxa de Solicitação — Agências de Referência de Crédito',
      ke_swift_pl49: 'Penalidade — Bancos Comerciais',
      ke_swift_pl50: 'Penalidade — Instituições Financeiras Hipotecárias',
      ke_swift_pl51: 'Penalidade — Instituições de Microcrédito com Depósito',
      ke_swift_pl52: 'Penalidade — Casas de Câmbio (Forex Bureaus)',
      ke_swift_pl53: 'Penalidade — Agências de Referência de Crédito',
      ke_swift_ppti: 'Seguro Patrimonial',
      ke_swift_prpy: 'Compra de Imóvel',
      ke_swift_relg: 'Atividades Religiosas',
      ke_swift_ritx: 'Imposto sobre Receita de Aluguel',
      ke_swift_rlwy: 'Ferrovia / Transporte Ferroviário',
      ke_swift_sdtx: 'Imposto de Selo',
      ke_swift_swlf: 'Sweeps / Financiamento de Liquidez',
      ke_swift_taxr: 'Reembolso de Imposto',
      ke_swift_tbil: 'Conta de Telecomunicações',
      ke_swift_tith: 'Dízimo e Ofertas',
      ke_swift_totx: 'Imposto sobre Faturamento (Turnover Tax)',
      ke_swift_trac: 'Removido do Rastreamento',
      ke_swift_vipn: 'Placa de Identificação de Veículo (VIPN)',
      za_swift_105: 'Mercadorias — Liquidações Comerciais',
      za_swift_220: 'Turismo e Viagens',
      za_swift_231: 'Seguros e Previdência',
      za_swift_242: 'Serviços de Construção',
      za_swift_250: 'Serviços de Telecomunicação',
      za_swift_251: 'Correio e Encomendas',
      za_swift_265: 'Serviços de Computação',
      za_swift_266: 'Serviços de Informação',
      za_swift_275: 'Royalties / Propriedade Intelectual',
      za_swift_276: 'Pesquisa e Desenvolvimento',
      za_swift_280: 'Serviços de Leasing Operacional',
      za_swift_285: 'Consultoria Jurídica, Contábil e de Gestão',
      za_swift_287: 'Outros Serviços Empresariais',
      za_swift_288: 'Manutenção e Reparos',
      za_swift_289: 'Arquitetura, Engenharia e Serviços Técnicos',
      za_swift_290: 'Serviços Pessoais, Culturais e Recreativos',
      za_swift_291: 'Serviços Audiovisuais',
      za_swift_296: 'Serviços de Intermediação Comercial',
      za_swift_297: 'Outros Serviços Empresariais Diversos',
      za_swift_308: 'Turismo Pessoal / Férias',
      za_swift_401: 'Remuneração de Empregados / Rendimentos de Investimentos',
      za_swift_10101: 'Transferências de Capital — Perdão de Dívida',
      za_swift_10301: 'Transferências de Capital — Imigrantes',
      za_swift_27201: 'Outras Transferências de Capital',
      in_swift_p0001: 'Repatriação — Portfólio Indiano no Exterior (Ações)',
      in_swift_p0002: 'Repatriação — Portfólio Indiano no Exterior (Títulos de Dívida)',
      in_swift_p0003: 'Repatriação — Investimento Direto Indiano no Exterior (Ações)',
      in_swift_p0004: 'Repatriação — Investimento Direto Indiano no Exterior (Títulos de Dívida)',
      in_swift_p0005: 'Repatriação — Investimento Indiano no Exterior (Imóveis)',
      in_swift_p0006: 'Investimento Direto Estrangeiro na Índia (Ações)',
      in_swift_p0007: 'Investimento Direto Estrangeiro na Índia (Títulos de Dívida)',
      in_swift_p0008: 'Investimento Direto Estrangeiro na Índia (Imóveis)',
      in_swift_p0009: 'Investimento de Portfólio Estrangeiro na Índia (Ações)',
      in_swift_p0010: 'Investimento de Portfólio Estrangeiro na Índia (Títulos de Dívida)',
      in_swift_p0011: 'Pagamento de Empréstimos a Não Residentes',
      in_swift_p0012: 'Empréstimos de Longo e Médio Prazo de Não Residentes para a Índia (ECB)',
      in_swift_p0013: 'Empréstimos de Curto Prazo de Não Residentes para a Índia (Crédito Comercial)',
      in_swift_p0014: 'Depósitos de Não Residentes — FCNR(B)/NR(E)RA',
      in_swift_p0015: 'Empréstimos e Descobertos Bancários — Conta Própria (ADs)',
      in_swift_p0016: 'Compra de Moeda Estrangeira contra Outra Moeda',
      in_swift_p0017: 'Venda de Ativos Não Produzidos Não Financeiros — Governo (Patentes, Imóveis, Recursos Naturais)',
      in_swift_p0019: 'Derivativos Financeiros — Margem, Prêmio e Liquidação',
      in_swift_p0020: 'Venda de Ações sob Plano de Opção de Empregado (ESOP)',
      in_swift_p0021: 'Outros Investimentos — ADRs/GDRs',
      in_swift_p0022: 'Assistência Externa Recebida pela Índia — Empréstimos Multilaterais e Bilaterais',
      in_swift_p0024: 'Transferências de Capital — Governo (Garantias, Grants de Investimento)',
      in_swift_p0025: 'Transferências de Capital — Não Governo (Garantias, Grants de Investimento)',
      in_swift_p0028: 'Realização de Cobranças de Exportação (Valor Integral da Fatura)',
      in_swift_p0029: 'Adiantamentos Recebidos contra Contratos de Exportação',
      in_swift_p0099: 'Pesquisa de Mercado e Pesquisa de Opinião Pública',
      in_swift_p0101: 'Serviços de Mineração e Processamento de Minérios',
      in_swift_p0102: 'Serviços de Agente Comissionado',
      in_swift_p0103: 'Comércio Atacadista e Varejista',
      in_swift_p0104: 'Leasing Operacional sem Tripulação — Fretamento',
      in_swift_p0105: 'Outros Serviços Técnicos — Científicos e Espaciais',
      in_swift_p0107: 'Serviços Audiovisuais — Produção, Distribuição e Exibição Cinematográfica',
      in_swift_p0108: 'Produção, Distribuição e Transmissão de Rádio e Televisão',
      in_swift_p0109: 'Serviços de Entretenimento',
      id_swift_2011: 'Exportação de Mercadorias',
      id_swift_2012: 'Importação de Mercadorias',
      id_swift_2015: 'Combustível e Mantimentos (Bunkers & Stores)',
      id_swift_2018: 'Pagamento Antecipado — Export/Import (Integral)',
      id_swift_2019: 'Pagamento Antecipado — Export/Import (Parcial)',
      id_swift_2097: 'Transação Comercial Não Export/Import — Indonésia',
      id_swift_2098: 'Transação Comercial Não Export/Import — Exterior',
      id_swift_2127: 'Liquidação de Saldos (Netting) — Relacionada a Exportação',
      id_swift_2129: 'Liquidação de Saldos (Netting) — Não Relacionada a Exportação',
      id_swift_2150: 'Remessa de Renda de Trabalhadores',
      id_swift_2163: 'Renda de Trabalhadores',
      id_swift_2193: 'Compra e Venda de Ativos de Marketing Não Financeiros',
      id_swift_2194: 'Compra e Venda de Contratos, Leasing e Licenças Não Financeiras',
      id_swift_2197: 'Compra e Venda de Terrenos',
      id_swift_2198: 'Compra e Venda de Imóveis / Edificações',
      id_swift_2203: 'Investimento de Capital na Indonésia',
      id_swift_2204: 'Investimento de Capital no Exterior',
      id_swift_2206: 'Desinvestimento de Capital na Indonésia',
      id_swift_2207: 'Desinvestimento de Capital no Exterior',
      id_swift_2221: 'Concessão/Saque de Empréstimo — Até 1 Ano',
      id_swift_2222: 'Concessão/Saque de Empréstimo — Acima de 1 Ano',
      id_swift_2231: 'Pagamento de Empréstimo — Até 1 Ano',
      id_swift_2232: 'Pagamento de Empréstimo — Acima de 1 Ano',
      id_swift_2233: 'Arrendamento Financeiro (Leasing)',
      id_swift_2240: 'Depósito a Prazo na Indonésia — Até 3 Meses',
      id_swift_2241: 'Outros Depósitos na Indonésia — Conta Corrente e Call Money até 3 Meses',
      id_swift_2242: 'Depósito na Indonésia — 3 a 6 Meses',
      id_swift_2243: 'Depósito na Indonésia — Acima de 6 Meses',
      id_swift_2244: 'Resgate de Depósito a Prazo na Indonésia — Até 3 Meses',
      id_swift_2245: 'Resgate de Outros Depósitos na Indonésia — Conta Corrente e Call Money até 3 Meses',
      id_swift_2246: 'Resgate de Depósito na Indonésia — 3 a 6 Meses',
      id_swift_2247: 'Resgate de Depósito na Indonésia — Acima de 6 Meses',
      id_swift_2251: 'Depósito Offshore — Conta Corrente e Call Money até 3 Meses',
      id_swift_2252: 'Depósito Offshore — Conta Corrente e Call Money acima de 3 Meses',
      id_swift_2255: 'Resgate de Depósito Offshore — Conta Corrente e Call Money até 3 Meses',
      id_swift_2256: 'Resgate de Depósito Offshore — Conta Corrente e Call Money acima de 3 Meses',
      id_swift_2257: 'Saque de Câmbio de Conta Offshore',
      id_swift_2261: 'Câmbio Spot — Moeda Estrangeira vs. Rupia',
      id_swift_2262: 'Câmbio Spot — Moeda Estrangeira vs. Outra Moeda',
      id_swift_2263: 'Câmbio Forward — Moeda Estrangeira vs. Rupia',
      id_swift_2264: 'Câmbio Forward — Moeda Estrangeira vs. Outra Moeda',
      id_swift_2271: 'Derivativo — Lucro em Forward ou Similar',
      id_swift_2272: 'Derivativo — Recebível em Acordo de Taxa Forward (FRA)',
      id_swift_2273: 'Derivativo — Recebível em Swap de Juros ou Swap de Moeda',
      id_swift_2274: 'Derivativo — Margem Inicial/Reembolsável',
      id_swift_2275: 'Derivativo — Margem de Variação/Não Reembolsável',
      id_swift_2276: 'Derivativo — Prêmio Recebível em Opções',
      id_swift_2277: 'Derivativo — Principal Recebível na 1ª Perna do Swap de Moeda',
      id_swift_2278: 'Derivativo — Principal Recebível na Última Perna do Swap de Moeda',
      id_swift_2279: 'Derivativo — Prêmio Recebível em Credit Default Swap (CDS)',
      id_swift_2280: 'Depósito/Devolução de Garantia (Collateral)',
      id_swift_2282: 'Reembolso — Transação Não Export/Import',
      id_swift_2299: 'Outras Transações de Capital/Financeiras',
      id_swift_2311: 'Ações — Emitidas por Não Residente',
      id_swift_2321: 'Títulos de Dívida (Bonds) — Não Residente, acima de 1 Ano',
      id_swift_2322: 'Medium Term Notes (MTNs) — Não Residente, acima de 1 Ano',
      id_swift_2323: 'Outros Títulos de Longo Prazo — Não Residente, acima de 1 Ano',
      id_swift_2331: 'Letras do Tesouro (Treasury Bills) — Não Residente, até 1 Ano',
      id_swift_2332: 'Notas Promissórias (PNs/Promes) — Não Residente, até 1 Ano',
      id_swift_2333: 'Outros Títulos de Curto Prazo — Não Residente, até 1 Ano',
      id_swift_2341: 'Ações — Emitidas por Residente',
      id_swift_2342: 'Outros Títulos de Patrimônio (Warrant, Right) — Residente',
      id_swift_2351: 'Títulos Públicos (Government Bonds) — Residente, acima de 1 Ano',
      id_swift_2352: 'Debêntures Corporativas — Residente, acima de 1 Ano',
      id_swift_2353: 'Medium Term Notes (MTNs) — Residente, acima de 1 Ano',
      id_swift_2354: 'Outros Títulos de Longo Prazo — Residente, acima de 1 Ano',
      id_swift_2361: 'SBI / SWBI (Certificados Banco da Indonésia) — até 1 Ano',
      id_swift_2362: 'SPN (Letras do Tesouro Nacional Indonésio) — até 1 Ano',
      id_swift_2363: 'Notas Promissórias (PNs/Promes) — Residente, até 1 Ano',
      id_swift_2364: 'Certificados de Depósito Negociáveis (NCD) — Residente, até 1 Ano',
      id_swift_2365: 'Outros Títulos de Curto Prazo — Residente, até 1 Ano',
      id_swift_2366: 'Certificado de Depósito do Banco da Indonésia — até 1 Ano',
      id_swift_2371: 'Fundos de Investimento (Reksadana)',
      id_swift_2372: 'Fundos de Investimento Negociados (Reksadana)',
      id_swift_2375: 'Venda de Títulos Residentes com Repo — Proprietário, até 1 Ano',
      id_swift_2376: 'Venda de Títulos Residentes com Repo — Proprietário, acima de 1 Ano',
      id_swift_2377: 'Revenda de Títulos Residentes com Repo — Comprador, até 1 Ano',
      id_swift_2378: 'Revenda de Títulos Residentes com Repo — Comprador, acima de 1 Ano',
      id_swift_2379: 'Recompra de Títulos Residentes com Repo — Proprietário, até 1 Ano',
      id_swift_2380: 'Recompra de Títulos Residentes com Repo — Proprietário, acima de 1 Ano',
      id_swift_2381: 'Compra de Títulos Residentes com Repo — até 1 Ano',
      id_swift_2382: 'Compra de Títulos Residentes com Repo — acima de 1 Ano',
      id_swift_2383: 'Factoring com Banco na Indonésia — até 1 Ano',
      id_swift_2384: 'Factoring com Banco na Indonésia — acima de 1 Ano',
      id_swift_2385: 'Factoring com Empresa na Indonésia — até 1 Ano',
      id_swift_2386: 'Factoring com Empresa na Indonésia — acima de 1 Ano',
      id_swift_2387: 'Factoring com Banco no Exterior — até 1 Ano',
      id_swift_2388: 'Factoring com Banco no Exterior — acima de 1 Ano',
      id_swift_2389: 'Factoring com Empresa no Exterior — até 1 Ano',
      id_swift_2390: 'Factoring com Empresa no Exterior — acima de 1 Ano',
      id_swift_2391: 'Gold Swap — Pagamento pelo Provedor de Caixa, até 1 Ano',
      id_swift_2392: 'Gold Swap — Pagamento pelo Provedor de Caixa, acima de 1 Ano',
      id_swift_2393: 'Gold Swap — Devolução pelo Proprietário do Ouro, até 1 Ano',
      id_swift_2394: 'Gold Swap — Devolução pelo Proprietário do Ouro, acima de 1 Ano',
      id_swift_2395: 'Gold Swap — Recebimento pelo Provedor de Caixa, até 1 Ano',
      id_swift_2396: 'Gold Swap — Recebimento pelo Provedor de Caixa, acima de 1 Ano',
      id_swift_2397: 'Gold Swap — Recebimento pelo Proprietário do Ouro, até 1 Ano',
      id_swift_2398: 'Gold Swap — Recebimento pelo Proprietário do Ouro, acima de 1 Ano',
      id_swift_2400: 'Processamento de Mercadorias',
      id_swift_2405: 'Manutenção e Reparo de Mercadorias',
      id_swift_2411: 'Transporte de Passageiros — Marítimo',
      id_swift_2412: 'Transporte de Passageiros — Aéreo',
      id_swift_2413: 'Transporte de Passageiros — Outros Modais',
      id_swift_2421: 'Frete Export/Import — Marítimo',
      id_swift_2422: 'Frete Export/Import — Aéreo',
      id_swift_2423: 'Frete Export/Import — Outros Modais',
      id_swift_2431: 'Frete Não Export/Import — Marítimo',
      id_swift_2432: 'Frete Não Export/Import — Aéreo',
      id_swift_2433: 'Frete Não Export/Import — Outros Modais',
      id_swift_2441: 'Serviços Auxiliares de Transporte — Marítimo',
      id_swift_2442: 'Serviços Auxiliares de Transporte — Aéreo',
      id_swift_2443: 'Serviços Auxiliares de Transporte — Outros Modais',
      id_swift_2450: 'Correios e Encomendas',
      id_swift_2461: 'Viagem Corporativa',
      id_swift_2462: 'Viagem Pessoal',
      id_swift_2466: 'Serviços de Saúde na Indonésia',
      id_swift_2467: 'Serviços de Saúde no Exterior',
      id_swift_2468: 'Educação / Treinamento na Indonésia',
      id_swift_2469: 'Educação / Treinamento no Exterior',
      id_swift_2480: 'Serviços de Telecomunicação',
      id_swift_2490: 'Serviços de Tecnologia da Informação',
      id_swift_2495: 'Serviços de Informação',
      id_swift_2501: 'Construção Civil na Indonésia — até 1 Ano',
      id_swift_2502: 'Construção Civil na Indonésia — acima de 1 Ano',
      id_swift_2511: 'Construção Civil no Exterior — até 1 Ano',
      id_swift_2512: 'Construção Civil no Exterior — acima de 1 Ano',
      id_swift_2521: 'Seguro de Vida Direto — Prêmio',
      id_swift_2522: 'Seguro de Vida Direto — Benefício',
      id_swift_2523: 'Seguro de Carga Direto — Prêmio',
      id_swift_2524: 'Seguro de Carga Direto — Sinistro',
      id_swift_2525: 'Outros Seguros Diretos — Prêmio',
      id_swift_2526: 'Outros Seguros Diretos — Sinistro',
      id_swift_2531: 'Resseguro — Prêmio',
      id_swift_2532: 'Resseguro — Sinistro',
      id_swift_2533: 'Resseguro — Comissão',
      id_swift_2541: 'Serviços Auxiliares de Seguros',
      id_swift_2546: 'Contribuição ao Fundo de Pensão',
      id_swift_2547: 'Benefício de Fundo de Pensão',
      id_swift_2550: 'Serviços Financeiros',
      id_swift_2560: 'Direitos Autorais / Propriedade Intelectual',
      id_swift_2570: 'Pesquisa e Desenvolvimento',
      id_swift_2580: 'Jurídico, Contabilidade, Consultoria de Gestão e Relações Públicas',
      id_swift_2590: 'Publicidade, Pesquisa de Mercado e Pesquisas',
      id_swift_2600: 'Arquitetura, Engenharia e Outros Serviços Técnicos',
      id_swift_2610: 'Mineração, Agricultura e Gestão de Resíduos / Poluição',
      id_swift_2615: 'Leasing Operacional — Aluguel de Bens',
      id_swift_2616: 'Leasing Operacional — Aluguel de Transporte sem Tripulação',
      id_swift_2630: 'Serviços Relacionados ao Comércio',
      id_swift_2640: 'Outros Serviços Empresariais',
      id_swift_2651: 'Arte, Cultura e Recreação na Indonésia',
      id_swift_2652: 'Arte, Cultura e Recreação no Exterior',
      id_swift_2660: 'Serviços Governamentais',
      id_swift_2670: 'Outros Serviços',
      id_swift_2701: 'Rendimentos de Títulos — Não Residente, até 1 Ano',
      id_swift_2702: 'Rendimentos de Títulos — Não Residente, acima de 1 Ano',
      id_swift_2705: 'Rendimentos de Conta Corrente, Poupança e Depósitos (incl. Mudharabah)',
      id_swift_2710: 'Rendimentos de Conta de Empréstimo (incl. Leasing, Murabahah, Musyarakah)',
      id_swift_2716: 'Rendimentos de Títulos — Residente, até 1 Ano',
      id_swift_2717: 'Rendimentos de Títulos — Residente, acima de 1 Ano',
      id_swift_2720: 'Rendimentos de Gold Swap',
      id_swift_2725: 'Dividendos e Lucros',
      id_swift_2730: 'Taxa Recebida pelo Proprietário de Títulos — Empréstimo de Títulos',
      id_swift_2731: 'Taxa Recebida pelo Proprietário de Títulos — Empréstimo de Ouro ou Gold Swap',
      id_swift_2741: 'Aluguel de Terreno',
      id_swift_2742: 'Aluguel de Escritório, Apartamento, Moradia e Similares',
      id_swift_2743: 'Aluguel de Terreno com Escritório/Apartamento/Moradia e Similares',
      id_swift_2751: 'Grant (Dinheiro) — Sem Obrigação de Comprar Ativo Fixo',
      id_swift_2752: 'Grant (Dinheiro) — Com Obrigação de Comprar Ativo Fixo',
      id_swift_2760: 'Sanção, Multa e Similares',
      id_swift_2765: 'Imposto, Contribuição, Restituição e Similares',
      id_swift_2766: 'Imposto de Renda e Previdência Social',
      id_swift_2767: 'Outros Impostos',
      id_swift_2770: 'Direito de Uso de Recursos Naturais',
      id_swift_2802: 'Reembolso de Exportação',
      id_swift_2803: 'Reembolso de Importação',
      id_swift_2804: 'Reembolso — Transação Não Export/Import',
      id_swift_2808: 'Capital de Giro / Cash Call — Petróleo e Gás',
      id_swift_2809: 'Capital de Giro / Cash Call — Não Petróleo e Gás',
      id_swift_2811: 'Pagamento Antecipado — Bens Não Export/Import',
      id_swift_2812: 'Pagamento Antecipado — Seguros',
      id_swift_2813: 'Outros Pagamentos Antecipados',
      id_swift_2814: 'Reembolso de Taxa de Pedido — IPO e Colocação Privada',
      id_swift_2815: 'Reembolso de Fundo de Emergência',
      id_swift_2821: 'Venda de Títulos Não Residentes com Repo — Proprietário, até 1 Ano',
      id_swift_2822: 'Venda de Títulos Não Residentes com Repo — Proprietário, acima de 1 Ano',
      id_swift_2823: 'Revenda de Títulos Não Residentes com Repo — Comprador, até 1 Ano',
      id_swift_2824: 'Revenda de Títulos Não Residentes com Repo — Comprador, acima de 1 Ano',
      id_swift_2825: 'Recompra de Títulos Não Residentes com Repo — Proprietário, até 1 Ano',
      id_swift_2826: 'Recompra de Títulos Não Residentes com Repo — Proprietário, acima de 1 Ano',
      id_swift_2827: 'Compra de Títulos Não Residentes com Repo — até 1 Ano',
      id_swift_2828: 'Compra de Títulos Não Residentes com Repo — acima de 1 Ano',
      ph_swift_1010101000: 'IED — Transferência de Capital (Ações)',
      ph_swift_1010102001: 'IED — Transferência de Capital (Lucros Reinvestidos)',
      ph_swift_1010102002: 'IED — Transferência de Capital (Lucros Reinvestidos — Outro Capital)',
      ph_swift_1010103001: 'IED — Transferência de Capital (Outro Capital — Empréstimos da Controladora)',
      ph_swift_1010103002: 'IED — Transferência de Capital (Outro Capital — Empréstimos de Afiliadas)',
      ph_swift_1010201000: 'IEP — Transferência de Capital (Ações)',
      ph_swift_1010202001: 'IEP — Transferência de Capital (Títulos de Dívida / Bonds)',
      ph_swift_1010202002: 'IEP — Transferência de Capital (Outros Títulos de Dívida)',
      ph_swift_1010203001: 'IEP — Transferência de Capital (Instrumentos de Mercado Monetário)',
      ph_swift_1010203002: 'IEP — Transferência de Capital (Derivativos Financeiros)',
      ph_swift_1010300000: 'Transferência de Capital — Outros Investimentos',
      ph_swift_1110100001: 'Transferências Correntes — Remessas de Trabalhadores (Bancos Locais)',
      ph_swift_1110200001: 'Transferências Correntes — Privadas (Remessas em Dinheiro — USD)',
      ph_swift_1110200002: 'Transferências Correntes — Privadas (Remessas em Dinheiro — EUR)',
      ph_swift_1110200003: 'Transferências Correntes — Privadas (Remessas em Dinheiro — JPY)',
      ph_swift_1110200004: 'Transferências Correntes — Privadas (Remessas em Dinheiro — Outra Moeda)',
      ph_swift_1110300001: 'Transferências Correntes — Privadas (Grants — Organizações Internacionais)',
      ph_swift_1110300002: 'Transferências Correntes — Privadas (Grants — Organizações Sem Fins Lucrativos)',
      ph_swift_1110300003: 'Transferências Correntes — Privadas (Grants — Pessoas Físicas)',
      ph_swift_1110300004: 'Transferências Correntes — Privadas (Grants — Outros Privados)',
      ph_swift_1110400001: 'Transferências Correntes — Privadas (Sinistros de Seguro — Vida)',
      ph_swift_1110400002: 'Transferências Correntes — Privadas (Sinistros de Seguro — Não Vida)',
      ph_swift_1110400003: 'Transferências Correntes — Privadas (Sinistros de Seguro — Resseguro)',
      ph_swift_1110400004: 'Transferências Correntes — Privadas (Sinistros de Seguro — Fundos de Pensão)',
      ph_swift_1110400005: 'Transferências Correntes — Privadas (Sinistros de Seguro — Garantias Padronizadas)',
      ph_swift_1110400006: 'Transferências Correntes — Privadas (Sinistros de Seguro — Outros)',
      ph_swift_1110500001: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Trabalhadores Locais)',
      ph_swift_1110500002: 'Transferências Correntes — Privadas (Benefícios Previdenciários — OFWs)',
      ph_swift_1110500003: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Pensão)',
      ph_swift_1110500004: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Anuidade)',
      ph_swift_1110500005: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Outros)',
      ph_swift_1110600001: 'Transferências Correntes — Privadas (Multas e Penalidades)',
      ph_swift_1110700001: 'Transferências Correntes — Privadas (Outras Transferências Correntes)',
      ph_swift_1310000001: 'Transferências Correntes — Governo (Grants)',
      ph_swift_1310000002: 'Transferências Correntes — Governo (Impostos Correntes sobre Renda e Patrimônio)',
      ph_swift_1310000003: 'Transferências Correntes — Governo (Outras Transferências Correntes)',
      ph_swift_1410100001: 'Receitas — Remuneração de Empregados (Salários e Ordenados)',
      ph_swift_1410100002: 'Receitas — Remuneração de Empregados (Outras Remunerações)',
      ph_swift_1410200001: 'Receitas — Renda de Investimento (IED — Dividendos)',
      ph_swift_1410200002: 'Receitas — Renda de Investimento (IED — Lucros Reinvestidos)',
      ph_swift_1410200003: 'Receitas — Renda de Investimento (IED — Juros Intercompany)',
      ph_swift_1410200004: 'Receitas — Renda de Investimento (IED — Lucros de Filial Não Distribuídos)',
      ph_swift_1410300000: 'Receitas — Renda de Investimento em Portfólio',
      ph_swift_1410400000: 'Receitas — Outras Rendas de Investimento',
      ph_swift_1410500000: 'Receitas — Renda de Reservas',
      ph_swift_1410600000: 'Receitas — Outras Rendas',
      ph_swift_1510000001: 'Exportação de Mercadorias — Mercadoria Geral',
      ph_swift_1510000002: 'Exportação de Mercadorias — Processamento',
      ph_swift_1510000003: 'Exportação de Mercadorias — Reparo de Bens',
      ph_swift_1510000004: 'Exportação de Mercadorias — Suprimentos em Portos',
      ph_swift_1510000005: 'Exportação de Mercadorias — Ouro Não Monetário',
      ph_swift_1510000006: 'Exportação de Mercadorias — Bens sob Leasing Financeiro (Líquido)',
      ph_swift_1510000007: 'Exportação de Mercadorias — Outros Bens',
      ph_swift_1510000008: 'Exportação Não Mercadoria — Militar',
      ph_swift_1510000009: 'Exportação Não Mercadoria — Embaixadas',
      ph_swift_1510000010: 'Exportação Não Mercadoria — Reparo de Bens',
      ph_swift_1510000011: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Marítimo)',
      ph_swift_1510000012: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Aéreo)',
      ph_swift_1510000013: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Terrestre)',
      ph_swift_1510000014: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Outros)',
      ph_swift_1510000015: 'Exportação Não Mercadoria — Outras Exportações Não Mercadoria',
      ph_swift_1510000016: 'Exportação Direta',
      ph_swift_1510000017: 'Exportação Indireta — Processamento',
      ph_swift_1510000018: 'Exportação Indireta — Compra e Venda',
      ph_swift_1510000019: 'Exportação Indireta — Consignação',
      ph_swift_1510000020: 'Exportação Indireta — Joint Venture',
      ph_swift_1510000021: 'Exportação Indireta — Outras',
      ph_swift_1510000023: 'Exportação — Pagamento Antecipado',
      ph_swift_1510000024: 'Exportação — Faturamento Progressivo',
      ph_swift_1510000025: 'Exportação — Pagamento Integral',
      ph_swift_210000001: 'Transporte — Frete Marítimo (Manifesto de Saída)',
      ph_swift_210000002: 'Transporte — Frete Aéreo (Manifesto de Saída)',
      ph_swift_210000003: 'Transporte — Frete Terrestre',
      ph_swift_210000004: 'Transporte — Passageiros (Marítimo)',
      ph_swift_210000005: 'Transporte — Passageiros (Aéreo)',
      ph_swift_210000006: 'Transporte — Passageiros (Terrestre)',
      ph_swift_210000007: 'Transporte — Serviços Portuários',
      ph_swift_210000008: 'Transporte — Serviços Aeroportuários',
      ph_swift_210000009: 'Transporte — Outros Serviços Auxiliares',
      ph_swift_210000010: 'Transporte — Outros Serviços de Transporte',
      ph_swift_510100001: 'Viagem Corporativa',
      ph_swift_510200001: 'Viagem Pessoal',
      ph_swift_510200002: 'Viagem Pessoal — Saúde',
      ph_swift_510301001: 'Comunicação — Correios / Encomendas',
      ph_swift_510301002: 'Comunicação — Telecomunicações',
      ph_swift_510301003: 'Comunicação — Internet',
      ph_swift_510302001: 'Comunicação — Radiodifusão',
      ph_swift_510302002: 'Comunicação — TV a Cabo',
      ph_swift_510302003: 'Comunicação — Satélite',
      ph_swift_510303000: 'Comunicação — Outras',
      ph_swift_510401000: 'Construção Civil no Exterior',
      ph_swift_510402001: 'Construção Civil nas Filipinas — Setor Privado',
      ph_swift_510402002: 'Construção Civil nas Filipinas — Governo',
      ph_swift_510402003: 'Construção Civil nas Filipinas — BOT',
      ph_swift_510402004: 'Construção Civil nas Filipinas — Joint Venture',
      ph_swift_510402005: 'Construção Civil nas Filipinas — EPIRA',
      ph_swift_510402006: 'Construção Civil nas Filipinas — Outras',
      ph_swift_510402007: 'Reparos e Manutenção',
      ph_swift_510500001: 'Seguros — Seguro de Vida',
      ph_swift_510500002: 'Seguros — Não Vida',
      ph_swift_510500003: 'Seguros — Resseguro',
      ph_swift_510500004: 'Seguros — Fundos de Pensão',
      ph_swift_510500005: 'Seguros — Garantias Padronizadas',
      ph_swift_510600001: 'Serviços Financeiros — Intermediação Financeira',
      ph_swift_510600002: 'Serviços Financeiros — Banco de Investimento',
      ph_swift_510600003: 'Serviços Financeiros — Relacionados a Seguros',
      ph_swift_510600004: 'Serviços Financeiros — Relacionados a Pensão',
      ph_swift_510600005: 'Serviços Financeiros — Outros',
      ph_swift_510700000: 'Computação e Informação — Software',
      ph_swift_510800001: 'Royalties — Franquias',
      ph_swift_510800002: 'Royalties — Outros',
      ph_swift_510900000: 'Outros Serviços Empresariais — Comercialização',
      ph_swift_511000001: 'Outros Serviços Empresariais — Leasing Operacional',
      ph_swift_511000002: 'Outros Serviços Empresariais — Leasing Financeiro',
      ph_swift_511100001: 'Outros Serviços Empresariais — Jurídico',
      ph_swift_511100002: 'Outros Serviços Empresariais — Contabilidade',
      ph_swift_511100003: 'Outros Serviços Empresariais — Consultoria de Gestão',
      ph_swift_511200000: 'Outros Serviços Empresariais — Publicidade',
      ph_swift_511300001: 'Outros Serviços Empresariais — Pesquisa e Desenvolvimento',
      ph_swift_511300002: 'Outros Serviços Empresariais — Arquitetura',
      ph_swift_511300003: 'Outros Serviços Empresariais — Engenharia',
      ph_swift_511300004: 'Outros Serviços Empresariais — Agropecuária',
      ph_swift_511300005: 'Outros Serviços Empresariais — Mineração',
      ph_swift_511300006: 'Outros Serviços Empresariais — Meio Ambiente',
      ph_swift_511300007: 'Outros Serviços Empresariais — Outros Serviços Técnicos',
      ph_swift_511300008: 'Outros Serviços Empresariais — Comércio',
      ph_swift_511400001: 'Serviços Governamentais — Embaixadas e Consulados',
      ph_swift_511400002: 'Serviços Governamentais — Organizações Internacionais',
      ph_swift_511400003: 'Serviços Governamentais — Operações Militares',
      ph_swift_511400004: 'Serviços Governamentais — Missões Diplomáticas',
      ph_swift_511400005: 'Serviços Governamentais — Outros',
      ph_swift_511500001: 'Serviços Pessoais — Educação',
      ph_swift_511500002: 'Serviços Pessoais — Saúde',
      ph_swift_511500003: 'Serviços Pessoais — Recreação / Cultura / Esportes',
      ph_swift_511500004: 'Serviços Pessoais — Outros',
      ph_swift_511600001: 'Outros Serviços — IT-BPO',
      ph_swift_511600002: 'Outros Serviços — Turismo',
      ph_swift_511600003: 'Outros Serviços — Não Classificados',
      ph_swift_511700001: 'Outros Serviços — Turismo Médico',
      ph_swift_511700002: 'Outros Serviços — Aposentadoria',
      ph_swift_511700003: 'Outros Serviços — Outros Tipos de Turismo',
      ph_swift_610000001: 'Empréstimos — Curto Prazo (Desembolso)',
      ph_swift_610000002: 'Empréstimos — Curto Prazo (Amortização)',
      ph_swift_610000003: 'Empréstimos — Longo Prazo (Desembolso)',
      ph_swift_610000004: 'Empréstimos — Longo Prazo (Amortização)',
      ph_swift_610000005: 'Empréstimos — Longo Prazo (Outros)',
      ph_swift_610000006: 'Crédito Comercial — Curto Prazo',
      ph_swift_610000007: 'Crédito Comercial — Longo Prazo',
      ph_swift_710100001: 'Depósitos em Moeda Estrangeira — Entrada (Novo Depósito)',
      ph_swift_710100002: 'Depósitos em Moeda Estrangeira — Entrada (Juros FCDU/EFCDU)',
      ph_swift_710100003: 'Depósitos em Moeda Estrangeira — Entrada (Outros)',
      ph_swift_710100004: 'Depósitos em Moeda Estrangeira — Saída (Saque)',
      ph_swift_710100006: 'Depósitos em Moeda Estrangeira — Saída (Transferência para Outros Bancos)',
      ph_swift_710100007: 'Depósitos em Moeda Estrangeira — Saída (Financiamento de Pagamentos no Exterior)',
      ph_swift_710100008: 'Depósitos em Moeda Estrangeira — Saída (Outros)',
      ph_swift_710100009: 'Depósitos em Moeda Estrangeira — Saída (Transferência ao BSP)',
      ph_swift_710200001: 'Depósitos Interbancários — Entrada (Aplicações de Bancos Estrangeiros)',
      ph_swift_710200002: 'Depósitos Interbancários — Entrada (Transferências de Bancos Estrangeiros)',
      ph_swift_710200003: 'Depósitos Interbancários — Entrada (Outros)',
      ph_swift_710200004: 'Depósitos Interbancários — Saída (Saques de Bancos Estrangeiros)',
      ph_swift_710200009: 'Depósitos Interbancários — Saída (Outros)',
      ph_swift_710300001: 'Contas Nostro — Entrada',
      ph_swift_710300002: 'Contas Nostro — Entrada (Juros)',
      ph_swift_710300003: 'Contas Nostro — Entrada (Outros)',
      ph_swift_710300004: 'Contas Nostro — Saída',
      ph_swift_710300009: 'Contas Nostro — Saída (Outros)',
      ph_swift_710400001: 'Outros Depósitos — Entrada',
      ph_swift_710400002: 'Outros Depósitos — Saída',
      ph_swift_810101001: 'Liquidação de Exportação — Carta de Crédito à Vista',
      ph_swift_810101002: 'Liquidação de Exportação — Carta de Crédito a Prazo (Usance)',
      ph_swift_810101003: 'Liquidação de Exportação — Carta de Crédito com Pagamento Diferido',
      ph_swift_810101004: 'Liquidação de Exportação — Carta de Crédito com Negociação com Recurso',
      ph_swift_810101007: 'Liquidação de Exportação — Outros Tipos de LC',
      ph_swift_810101008: 'Liquidação de Exportação — Carta de Crédito em Moeda Estrangeira',
      ph_swift_810101011: 'Liquidação de Exportação — Outras Liquidações de LC',
      ph_swift_810102001: 'Liquidação de Exportação — Cobrança Documentária (Documentos contra Pagamento)',
      ph_swift_810102002: 'Liquidação de Exportação — Cobrança Documentária (Documentos contra Aceite)',
      ph_swift_810102003: 'Liquidação de Exportação — Cobrança Simples (Clean Collection)',
      ph_swift_810102004: 'Liquidação de Exportação — Cobrança Documentária (Outros Tipos de Documentos)',
      ph_swift_810102005: 'Liquidação de Exportação — Pagamento Parcial Antecipado',
      ph_swift_810102006: 'Liquidação de Exportação — Pagamento Diferido',
      ph_swift_810102007: 'Liquidação de Exportação — Cobrança em Moeda Estrangeira',
      ph_swift_810102008: 'Liquidação de Exportação — Outros Tipos de Cobrança',
      ph_swift_810102009: 'Liquidação de Exportação — Conta Aberta (Open Account)',
      ph_swift_810201001: 'Liquidação de Importação — Carta de Crédito à Vista',
      ph_swift_810201002: 'Liquidação de Importação — Carta de Crédito a Prazo (Usance)',
      ph_swift_810201003: 'Liquidação de Importação — Carta de Crédito com Pagamento Diferido',
      ph_swift_810201004: 'Liquidação de Importação — Outros Tipos de LC',
      ph_swift_810202001: 'Liquidação de Importação — Cobrança Documentária (Documentos contra Pagamento)',
      ph_swift_810202002: 'Liquidação de Importação — Cobrança Documentária (Documentos contra Aceite)',
      ph_swift_810202003: 'Liquidação de Importação — Cobrança Simples (Clean Collection)',
      ph_swift_810202005: 'Liquidação de Importação — Cobrança Documentária (Outros Tipos de Documentos)',
      ph_swift_810202006: 'Liquidação de Importação — Outros Tipos de Cobrança',
      ph_swift_910100001: 'Operações Próprias do Banco — Entrada (Capital)',
      ph_swift_910100002: 'Operações Próprias do Banco — Entrada (Desembolso de Empréstimos)',
      ph_swift_910100003: 'Operações Próprias do Banco — Entrada (Pagamento de Empréstimos)',
      ph_swift_910100004: 'Operações Próprias do Banco — Entrada (Depósitos de Bancos Estrangeiros)',
      ph_swift_910100005: 'Operações Próprias do Banco — Entrada (Compras de Câmbio)',
      ph_swift_910100006: 'Operações Próprias do Banco — Entrada (Renda de Investimento)',
      ph_swift_910100007: 'Operações Próprias do Banco — Entrada (Outros)',
      ph_swift_910100009: 'Operações Próprias do Banco — Entrada (Transferências do BSP)',
      ph_swift_910100010: 'Operações Próprias do Banco — Entrada (Transferências de Bancos Estrangeiros)',
      ph_swift_910100011: 'Operações Próprias do Banco — Entrada (Outras Transferências)',
      ph_swift_910200001: 'Operações Próprias do Banco — Saída (Capital)',
      ph_swift_910200002: 'Operações Próprias do Banco — Saída (Desembolso de Empréstimos)',
      ph_swift_910200003: 'Operações Próprias do Banco — Saída (Pagamento de Empréstimos)',
      ph_swift_910200004: 'Operações Próprias do Banco — Saída (Depósitos em Bancos Estrangeiros)',
      ph_swift_910200005: 'Operações Próprias do Banco — Saída (Vendas de Câmbio)',
      ph_swift_910200006: 'Operações Próprias do Banco — Saída (Renda de Investimento)',
      ph_swift_910200007: 'Operações Próprias do Banco — Saída (Outros)',
      ph_swift_910200009: 'Operações Próprias do Banco — Saída (Transferências ao BSP)',
      ph_swift_910200010: 'Operações Próprias do Banco — Saída (Transferências a Bancos Estrangeiros)',
      ph_swift_910200011: 'Operações Próprias do Banco — Saída (Outras Transferências)',
      pk_swift_9009: 'Exportação de Mercadorias',
      pk_swift_9010: 'Comissão de Exportação',
      pk_swift_9011: 'Exportação em Consignação',
      pk_swift_9012: 'Exportação a Crédito / Pagamento Diferido',
      pk_swift_9013: 'Exportação com Seguro de Crédito Oficial',
      pk_swift_9014: 'Recebimento de Adiantamento Previamente Pago para Exportação',
      pk_swift_9015: 'Serviços de Subcontratado no Exterior',
      pk_swift_9016: 'Serviços de Construção no Exterior',
      pk_swift_9017: 'Manutenção e Reparo de Bens de Capital',
      pk_swift_9018: 'Operação de Equipamento de Transporte — Frete, Afretamento',
      pk_swift_9019: 'Salários de Trabalhadores Paquistaneses no Exterior',
      pk_swift_9020: 'Serviços de Imóveis — Locação',
      pk_swift_9021: 'Subcontratação de Serviços (Exceto Construção)',
      pk_swift_9022: 'Serviços Jurídicos, Contábeis, Publicidade e Outros Empresariais',
      pk_swift_9023: 'Outros Serviços Não Classificados',
      pk_swift_9024: 'Serviços de TI — Consultoria, Software, Dados',
      pk_swift_9025: 'Royalties / Propriedade Intelectual',
      pk_swift_9026: 'Dividendos / Lucros — Investimento Direto no Exterior',
      pk_swift_9027: 'Dividendos — Investimento em Portfólio no Exterior',
      pk_swift_9028: 'Juros sobre Empréstimos a Empresas Estrangeiras',
      pk_swift_9029: 'Juros sobre Títulos / Debêntures de Não Residentes',
      pk_swift_9030: 'Juros sobre Depósitos em Moeda Estrangeira',
      pk_swift_9031: 'Comissão de Agentes no Paquistão',
      pk_swift_9032: 'Serviços de Navegação Marítima — Frete e Sobrestadia',
      pk_swift_9033: 'Serviços Aéreos — Frete e Sobrestadia',
      pk_swift_9041: 'Rendimentos de Investimentos no Exterior (Fundos Mútuos, Unit Trusts)',
      pk_swift_9051: 'Passagem Marítima de Não Residentes',
      pk_swift_9052: 'Passagem Aérea de Não Residentes',
      pk_swift_9061: 'Tratamento Médico de Não Residentes no Paquistão',
      pk_swift_9071: 'Educação de Não Residentes no Paquistão',
      pk_swift_9072: 'Treinamento de Estrangeiros no Paquistão',
      pk_swift_9073: 'Educação / Treinamento Online por Instituições Paquistanesas',
      pk_swift_9081: 'Câmbio por Nacionais Paquistaneses de Visita ao País',
      pk_swift_9082: 'Câmbio por Turistas Estrangeiros no Paquistão',
      pk_swift_9083: 'Recebimentos de Visitantes Religiosos no Paquistão',
      pk_swift_9084: 'Devolução de Câmbio Não Utilizado — Viagem ao Exterior',
      pk_swift_9085: 'Devolução de Câmbio Não Utilizado — Hajjis',
      pk_swift_9086: 'Devolução de Câmbio Não Utilizado — Umrah / Ziarat',
      pk_swift_9091: 'Serviços Postais de Não Residentes',
      pk_swift_9092: 'Serviços de Courier de Não Residentes',
      pk_swift_9101: 'Serviços de Telecomunicação',
      pk_swift_9102: 'Call Centers — Serviços Prestados',
      pk_swift_9111: 'Remessa de Construção no Exterior',
      pk_swift_9121: 'Seguros de Vida e Fundos de Pensão — Prêmios',
      pk_swift_9122: 'Remessas de Seguradoras de Vida Paquistanesas no Exterior',
      pk_swift_9124: 'Reembolso de Seguros e Pensões',
      pk_swift_9141: 'Seguros Não Vida — Prêmios',
      pk_swift_9146: 'Reembolso de Outros Seguros Diretos',
      pk_swift_9151: 'Resseguro de Vida — Prêmios',
      pk_swift_9152: 'Resseguro Não Vida — Prêmios',
      pk_swift_9161: 'Serviços Auxiliares de Seguros — Corretagem e Agência',
      pk_swift_9171: 'Serviços Financeiros — Taxas de Intermediação Bancária',
      pk_swift_9172: 'Execução de Garantias Bancárias',
      pk_swift_9173: 'Outros Serviços Financeiros — Banco de Investimento, M&A, Corretagem',
      pk_swift_9174: 'Reembolso de Serviços Financeiros',
      pk_swift_9181: 'Consultoria de Hardware de TI para Não Residentes',
      pk_swift_9182: 'Serviços de Banco de Dados para Não Residentes',
      pk_swift_9183: 'Manutenção de Computadores no Exterior para Não Residentes',
      pk_swift_9184: 'Exportação de Software Personalizado',
      pk_swift_9185: 'Exportação de Software Empacotado',
      pk_swift_9186: 'Outros Serviços de TI para Não Residentes',
      pk_swift_9191: 'Serviços de Agência de Notícias para Não Residentes',
      pk_swift_9192: 'Serviços de Biblioteca e Arquivo para Não Residentes',
      pk_swift_9193: 'Outros Serviços de Informação para Não Residentes',
      pk_swift_9201: 'Royalties — Propriedade Intelectual (Patentes, Marcas, Franquias)',
      pk_swift_9202: 'Royalties — Direitos Autorais Audiovisuais',
      pk_swift_9211: 'Serviços de Facilitação Comercial (Finanças, Documentação, Alfândega)',
      pk_swift_9212: 'Leasing Operacional',
      pk_swift_9221: 'Serviços Jurídicos',
      pk_swift_9222: 'Serviços de Contabilidade e Auditoria',
      pk_swift_9230: 'Gestão Empresarial e Relações Públicas',
      pk_swift_9231: 'Serviços de Publicidade',
      pk_swift_9232: 'Pesquisa de Mercado e Pesquisa de Opinião',
      pk_swift_9233: 'Pesquisa e Desenvolvimento',
      pk_swift_9234: 'Serviços de Arquitetura',
      pk_swift_9235: 'Serviços de Engenharia',
      pk_swift_9236: 'Mineração e Prospecção',
      pk_swift_9237: 'Serviços Agropecuários',
      pk_swift_9238: 'Serviços Ambientais',
      pk_swift_9239: 'Outros Serviços Empresariais Diversos',
      pk_swift_9241: 'Serviços Audiovisuais — Filmes',
      pk_swift_9242: 'Serviços Audiovisuais — Rádio e TV',
      pk_swift_9243: 'Serviços Audiovisuais — VHS, CD, DVD',
      pk_swift_9244: 'Serviços Audiovisuais — Multimídia',
      pk_swift_9247: 'Outros Serviços Audiovisuais',
      pk_swift_9248: 'Serviços Pessoais',
      pk_swift_9249: 'Serviços Culturais',
      pk_swift_9250: 'Serviços Recreativos',
      pk_swift_9251: 'Serviços Educacionais',
      pk_swift_9261: 'Serviços a Governos Não Classificados',
      pk_swift_9262: 'Serviços de Saúde Não Classificados',
      pk_swift_9271: 'Serviços de Esportes e Recreação',
      pk_swift_9272: 'Serviços a Embaixadas e Consulados',
      pk_swift_9273: 'Serviços a Organizações Internacionais',
      pk_swift_9281: 'Serviços Diplomáticos, Consulares e Governamentais',
      pk_swift_9291: 'Outros Serviços Não Classificados',
      pk_swift_9301: 'Remessas de Trabalhadores Estrangeiros Residentes no Paquistão',
      pk_swift_9302: 'Transferências de Imigrantes para o Paquistão',
      pk_swift_9303: 'Outras Transferências Correntes',
      pk_swift_9311: 'Assistência Oficial ao Desenvolvimento (AOD) — Grants',
      pk_swift_9312: 'Assistência Oficial ao Desenvolvimento (AOD) — Empréstimos',
      pk_swift_9322: 'Investimento Direto Estrangeiro — Ações no Paquistão',
      pk_swift_9323: 'Empréstimos Intercompany da Controladora',
      pk_swift_9324: 'Lucros Reinvestidos',
      pk_swift_9331: 'Investimento em Portfólio — Títulos de Dívida do Paquistão',
      pk_swift_9332: 'Investimento em Portfólio — Ações do Paquistão',
      pk_swift_9333: 'Outros Investimentos em Portfólio',
      pk_swift_9341: 'Empréstimos de Instituições Financeiras Não Bancárias do Exterior',
      pk_swift_9351: 'Crédito Comercial — Importadores de Fornecedores Estrangeiros',
      pk_swift_9361: 'Adiantamentos de Compradores Estrangeiros para Exportações Futuras',
      pk_swift_9381: 'Aplicações de Curto Prazo do Exterior em Bancos no Paquistão',
      pk_swift_9391: 'Moeda Estrangeira em Circulação (Notas e Moedas)',
      pk_swift_9401: 'Saques do SBP de Contas no Exterior',
      pk_swift_9412: 'Compras e Empréstimos do FMI',
      pk_swift_9414: 'Alocação de Direitos Especiais de Saque (DES) pelo FMI',
      pk_swift_9421: 'Venda de Ouro Monetário pelo SBP',
      pk_swift_9422: 'Empréstimos de Curto Prazo Tomados por Bancos do Exterior',
      pk_swift_9423: 'Aplicações de Bancos no Exterior — até 3 Meses',
      pk_swift_9426: 'Aplicações de Bancos no Exterior — 3 Meses a 1 Ano',
      pk_swift_9431: 'Empréstimos de Curto Prazo entre Bancos no Paquistão',
      pk_swift_9432: 'Aplicações Interbancárias de Curto Prazo no Paquistão',
      pk_swift_9433: 'Aplicações Interbancárias de Curto Prazo do Exterior',
      pk_swift_9434: 'Aplicações Interbancárias de Curto Prazo no Paquistão — Bancos Islâmicos',
      pk_swift_9435: 'Aplicações Interbancárias de Curto Prazo do Exterior — Bancos Islâmicos',
      pk_swift_9441: 'Empréstimos Comerciais de Curto Prazo do Exterior por Bancos',
      pk_swift_9442: 'Empréstimos Comerciais de Curto Prazo no Paquistão por Bancos',
      pk_swift_9443: 'Empréstimos Comerciais de Curto Prazo do Exterior por Bancos Islâmicos',
      pk_swift_9444: 'Empréstimos Comerciais de Curto Prazo no Paquistão por Bancos Islâmicos',
      pk_swift_9445: 'Empréstimos Comerciais de Curto Prazo do Exterior por NBFI',
      pk_swift_9448: 'Outros Empréstimos de Curto Prazo do Exterior',
      pk_swift_9451: 'Depósitos em FCBU do SBP / Refinanciamento de Exportações',
      pk_swift_9452: 'Depósitos em PKR no SBP por Bancos',
      pk_swift_9453: 'Depósitos NIDA por Bancos',
      pk_swift_9454: 'Depósitos NIDA por Bancos Islâmicos',
      pk_swift_9455: 'Depósitos de Filiais de Bancos Estrangeiros no Paquistão',
      pk_swift_9456: 'Depósitos Recebidos de Pessoas Físicas Estrangeiras',
      pk_swift_9457: 'Depósitos NRE (Non-Resident External)',
      pk_swift_9458: 'Depósitos NRO (Non-Resident Ordinary)',
      pk_swift_9459: 'Depósitos NREA (Non-Resident External Account)',
      pk_swift_9461: 'Empréstimos de Longo Prazo Tomados por Bancos do Exterior',
      pk_swift_9462: 'Aplicações de Bancos no Exterior — 1 Ano ou Mais',
      pk_swift_9463: 'Empréstimos de Longo Prazo entre Bancos no Paquistão',
      pk_swift_9468: 'Empréstimos Comerciais de Longo Prazo do Exterior por Bancos',
      pk_swift_9469: 'Empréstimos Comerciais de Longo Prazo no Paquistão por Bancos',
      pk_swift_9470: 'Empréstimos Comerciais de Longo Prazo do Exterior por Bancos Islâmicos',
      pk_swift_9471: 'Empréstimos Comerciais de Longo Prazo no Paquistão por Bancos Islâmicos',
      pk_swift_9472: 'Empréstimos Comerciais de Longo Prazo do Exterior por NBFI',
      pk_swift_9473: 'Outros Empréstimos de Longo Prazo do Exterior',
      pk_swift_9474: 'Depósitos Interbancários em Moeda Estrangeira (IBFCD)',
      pk_swift_9475: 'Aplicações Interbancárias de Longo Prazo no Paquistão',
      pk_swift_9476: 'Aplicações Interbancárias de Longo Prazo do Exterior',
      pk_swift_9477: 'Aplicações Interbancárias de Longo Prazo no Paquistão — Bancos Islâmicos',
      pk_swift_9478: 'Aplicações Interbancárias de Longo Prazo do Exterior — Bancos Islâmicos',
      pk_swift_9479: 'Empréstimos Subordinados de Bancos no Exterior',
      pk_swift_9481: 'Transferências da Comissão Nacional de Finanças (NFC Award)',
      pk_swift_9482: 'Grants de Apoio Orçamentário',
      pk_swift_9483: 'Transferências Relacionadas a Impostos',
      pk_swift_9484: 'Grants Governamentais Não Classificados',
      pk_swift_9491: 'Pakistan Investment Bonds (PIBs)',
      pk_swift_9492: 'Letras do Tesouro (T-Bills)',
      pk_swift_9493: 'Market Treasury Bills (MTBs)',
      pk_swift_9494: 'Eurobonds Emitidos pelo Paquistão',
      pk_swift_9501: 'Investimento Direto Paquistanês no Exterior — Ações',
      pk_swift_9502: 'Empréstimos Intercompany para Afiliadas no Exterior',
      pk_swift_9503: 'Desinvestimento no Exterior',
      pk_swift_9521: 'NFCBA — Crédito Não Baseado em Fundos a Bancos no Exterior',
      pk_swift_9522: 'Compra de Ações / Títulos de Empresas Estrangeiras',
      pk_swift_9523: 'Compra de Letras do Tesouro de Governos Estrangeiros',
      pk_swift_9524: 'Compra de Títulos do Tesouro de Governos Estrangeiros',
      pk_swift_9525: 'Compra de Certificados de Depósito (CDs) de Bancos Estrangeiros',
      pk_swift_9526: 'Compra de Fundos Mútuos / Unit Trusts por Residentes',
      pk_swift_9527: 'Compra de Outros Instrumentos de Portfólio de Não Residentes',
      pk_swift_9528: 'Aplicações de Curto Prazo em Bancos Estrangeiros (até 1 Ano)',
      pk_swift_9529: 'Aplicações de Curto Prazo em Bancos Estrangeiros (1 a 3 Meses)',
      pk_swift_9530: 'Aplicações de Curto Prazo em Bancos Estrangeiros (3 Meses a 1 Ano)',
      pk_swift_9531: 'Aplicações de Longo Prazo em Bancos Estrangeiros (acima de 1 Ano)',
      pk_swift_9532: 'Aplicações em Bancos Estrangeiros sob Repo — Curto Prazo',
      pk_swift_9533: 'Aplicações em Bancos Estrangeiros sob Repo — Longo Prazo',
      pk_swift_9534: 'Recebimentos de Aplicações em Empresas de Câmbio no Exterior',
      pk_swift_9535: 'Entradas para Facilidade de Refinanciamento de Exportações (ERF) no SBP',
      pk_swift_9536: 'Bancos Islâmicos — Depósitos Murabaha do Exterior',
      pk_swift_9537: 'Bancos Islâmicos — Depósitos Musharaka do Exterior',
      pk_swift_9538: 'Bancos Islâmicos — Depósitos Ijarah do Exterior',
      pk_swift_9539: 'Bancos Islâmicos — Outros Depósitos Islâmicos do Exterior',
      pk_swift_9541: 'Venda de Ações em Empresas Listadas',
      pk_swift_9542: 'Venda de Cotas de Fundos Mútuos / Unit Trusts',
      pk_swift_9543: 'Venda de Instrumentos de Poupança Nacional',
      pk_swift_9544: 'Venda de Outros Títulos Domésticos a Não Residentes',
      pk_swift_9545: 'Venda de Instrumentos Islâmicos a Não Residentes — Sukuk',
      pk_swift_9546: 'Venda de Instrumentos Islâmicos a Não Residentes — Outros',
      pk_swift_9547: 'Venda de Ações em Empresas de Capital Estrangeiro',
      pk_swift_9548: 'Venda de Cotas de Fundos Estrangeiros',
      pk_swift_9549: 'Venda de Outros Títulos Estrangeiros',
      pk_swift_9551: 'Remessas de Trabalhadores — Canais Bancários Oficiais',
      pk_swift_9552: 'Remessas de Trabalhadores — Iniciativa HRI',
      pk_swift_9553: 'Remessas de Trabalhadores — Empresas de Câmbio',
      pk_swift_9554: 'Remessas de Trabalhadores — Agências Internacionais',
      pk_swift_9555: 'Manutenção Familiar do Exterior',
      pk_swift_9556: 'Presentes Pessoais ou Herança do Exterior',
      pk_swift_9561: 'Remessas de Doação de Pessoas Físicas no Exterior',
      pk_swift_9562: 'Dotações do Exterior',
      pk_swift_9563: 'Herança do Exterior',
      pk_swift_9564: 'Impostos e Taxas do Exterior',
      pk_swift_9565: 'Contribuições Previdenciárias do Exterior',
      pk_swift_9566: 'Multas e Penalidades do Exterior',
      pk_swift_9572: 'Doações Filantrópicas do Exterior',
      pk_swift_9573: 'Auxílio Humanitário do Exterior',
      pk_swift_9574: 'Outras Transferências Correntes do Exterior',
      pk_swift_9582: 'Transferências de Capital de Pessoas Físicas no Exterior',
      pk_swift_9583: 'Transferências de Capital de Empresas no Exterior',
      pk_swift_9584: 'Transferências de Capital de Governos no Exterior',
      pk_swift_9592: 'Cancelamento de Dívida',
      pk_swift_9593: 'Aquisição / Alienação de Ativos Não Produzidos Não Financeiros',
      pk_swift_9594: 'Grants de Investimento do Exterior',
      pk_swift_9595: 'Assunção de Dívida do Exterior',
      pk_swift_9596: 'Outras Transferências de Capital do Exterior',
      pk_swift_9597: 'Outros Recebimentos de Capital Não Classificados',
      pk_swift_9602: 'Reembolso de Empréstimos Comerciais de Curto Prazo a Não Residentes',
      pk_swift_9605: 'Reembolso de Principal de Leasing Financeiro de Curto Prazo a Não Residentes',
      pk_swift_9606: 'Reembolso de Empréstimos Sindicalizados de Curto Prazo a Não Residentes',
      pk_swift_9607: 'Reembolso de Outros Empréstimos de Curto Prazo a Não Residentes',
      pk_swift_9608: 'Reembolso de Empréstimos de Curto Prazo pelo SBP a Não Residentes',
      pk_swift_9609: 'Outras Transações Financeiras de Curto Prazo',
      pk_swift_9612: 'Reembolso de Empréstimos Comerciais de Longo Prazo a Não Residentes',
      pk_swift_9613: 'Reembolso de Principal de Leasing Financeiro de Longo Prazo a Não Residentes',
      pk_swift_9614: 'Reembolso de Empréstimos Sindicalizados de Longo Prazo a Não Residentes',
      pk_swift_9622: 'Reembolso de Outros Empréstimos de Longo Prazo a Não Residentes',
      pk_swift_9623: 'Reembolso de Empréstimos de Longo Prazo pelo SBP a Não Residentes',
      pk_swift_9624: 'Juros sobre Empréstimos de Longo Prazo a Não Residentes',
      pk_swift_9625: 'Outras Transações Financeiras de Longo Prazo',
      pk_swift_9637: 'Captações de Curto Prazo por Bancos de Outros Bancos no Paquistão',
      pk_swift_9638: 'Captações de Curto Prazo por Bancos do Exterior',
      pk_swift_9641: 'Captações de Longo Prazo por Bancos de Outros Bancos no Paquistão',
      pk_swift_9642: 'Captações por Bancos contra Saldos de Contas em Moeda Estrangeira',
      pk_swift_9643: 'Swap de Moeda Estrangeira por Bancos no Paquistão — 1 Ano ou Mais (Interbank)',
      pk_swift_9644: 'Swap de Moeda Estrangeira por Bancos no Paquistão — 1 Ano ou Mais (Exterior)',
      pk_swift_9645: 'Resgate de Aplicações no Paquistão ou SBP — 1 Ano ou Mais',
      pk_swift_9646: 'Resgate de Aplicações em Bancos no Exterior — 1 Ano ou Mais',
      pk_swift_9647: 'Captações de Longo Prazo por Não Bancos do Exterior',
      pk_swift_9648: 'Remessas de Participação Acionária até 10% — Contas Especiais em Moeda Estrangeira',
      pk_swift_9649: 'Remessas de Participação Acionária acima de 10% — Contas Especiais em Moeda Estrangeira',
      pk_swift_9650: 'Empréstimos Intercompany de Curto Prazo (Participação >= 10%) — Contas FCA Especiais',
      pk_swift_9651: 'Empréstimos do Exterior — Contas FCA Especiais de Empresas',
      pk_swift_9652: 'Qarz-e-Hasna (Empréstimo Islâmico sem Juros)',
      pk_swift_9653: 'Remessas para Compra de Imóveis e Negócios por Imigrantes',
      pk_swift_9654: 'Empréstimos Intercompany de Longo Prazo (Participação >= 10%) — Contas FCA Especiais',
      pk_swift_9668: 'Seguro de Vida — Prêmios e Suplementos de Renda de Investimento',
      pk_swift_9669: 'Seguro de Vida — Sinistros',
      pk_swift_9673: 'Reembolso de Missões Diplomáticas Paquistanesas no Exterior',
      pk_swift_9674: 'Empréstimos Externos de Curto Prazo do Governo — Serviço da Dívida',
      pk_swift_9675: 'Reembolsos de Empréstimos de Longo Prazo com Recursos Próprios',
      pk_swift_9676: 'Estorno — Reembolso de Principal de Empréstimos Externos de Longo Prazo',
      pk_swift_9677: 'Empréstimos Externos em Dinheiro — 1 Ano ou Mais — Serviço da Dívida',
      pk_swift_9678: 'Estorno de Remessas para Fins Especiais',
      pk_swift_9681: 'Exportação de Notas e Moedas em Moeda Estrangeira',
      pk_swift_9682: 'Cheques e Ordens Bancárias em Moeda Estrangeira — Venda de Notas',
      pk_swift_9693: 'Superávit de Agentes de Frete e Despachantes',
      pk_swift_9694: 'Devolução de Saldo por Empresas de Navegação Estrangeiras no Paquistão',
      pk_swift_9695: 'Devolução de Saldo por Companhias Aéreas Estrangeiras no Paquistão',
      pk_swift_9697: 'Reembolso de Créditos de Fornecedores Não Sujeitos a Serviço da Dívida',
      pk_swift_9698: 'Fundos Recebidos no Paquistão de FCA Offshore Própria (Form R)',
      pk_swift_9699: 'Fundos Recebidos em FCA Onshore de FCA Offshore Permissível',
      pk_swift_9703: 'Custo de Amostras de Exportação',
      pk_swift_9707: 'E-commerce — Produtos Digitais',
      pk_swift_9708: 'E-commerce — Serviços Digitais'
    },
    bankAccountCardUi: {
      accountLine: 'Agência: {agency} Conta: {account}{digit}',
      editNotAllowed: 'Conta vinculada a banco com integração. Edição não permitida.',
      deleteNotAllowed: 'Conta vinculada a banco com integração. Exclusão não permitida.',
      copyAccountData: 'Copiar dados da conta',
      syncAccountData: 'Sincronizar dados da conta',
      deactivateAccount: 'Inativar conta',
      reactivateAccount: 'Reativar conta',
      copyTitle: '🏦 Dados da conta',
      copyBank: 'Banco: {value}',
      copyAgency: 'Agência: {value}',
      copyAccount: 'Conta: {value}',
      copyDigit: 'Dígito: {value}'
    },
    bankAccountProvidersPanelUi: {
      reasons: {
        providerWithoutAccountSync: 'Este provedor ainda não recebe contas bancárias pelo sistema.',
        accountInactive: 'Conta inativa',
        missingPixKey: 'Conta sem chave PIX. Cadastre a chave PIX para enviar a conta a este provedor.',
        accountTypeNotSupported: 'Este provedor não opera este tipo de conta.',
        receiverNotApproved: 'O cliente ainda não tem cadastro aprovado neste provedor. A conta pode ser enviada depois da aprovação.',
        deactivatedLink: 'A conta já foi enviada a este provedor, mas o vínculo local foi desativado e ela não pode operar. Reconciliar consulta a conta no provedor e reativa o vínculo.',
        maskedAccountNumber: 'O número da conta está incompleto (só os últimos dígitos). Edite a conta e informe o número completo.',
        missingAccountNumber: 'Falta o número da conta. Edite a conta e informe o número completo.',
        invalidRoutingNumber: 'O routing number precisa ter 9 dígitos (número ABA do banco nos EUA). Para banco fora dos EUA, cadastre a conta como SWIFT internacional.',
        missingBankName: 'Falta o nome do banco. Edite a conta e informe o banco (ao digitar o routing number ele é preenchido automaticamente).',
        missingBeneficiaryName: 'Falta o nome do beneficiário. Edite a conta e informe quem recebe.',
        incompleteWireAddress: 'Endereço incompleto para envio por Wire: falta {fields}. Complete o endereço do banco na conta.',
        foreignWireBankAddress: 'O endereço do banco precisa ser nos Estados Unidos para envio por Wire. Em "Endereço do banco", informe o endereço da agência nos EUA (endereço, cidade, estado, CEP e país). Se o banco fica fora dos EUA, cadastre a conta como SWIFT internacional.',
        foreignWireBeneficiaryAddress: 'Para envio por Wire, o endereço precisa ser nos Estados Unidos. Em "Endereço do banco", informe o endereço da agência nos EUA (endereço, cidade, estado, CEP e país).',
        refused: {
          beneficiaryNameMismatch: 'O provedor recusou a conta: conta própria precisa estar no nome do cliente. Se a conta é de outra pessoa ou empresa, edite a conta, ajuste a relação com o titular e envie de novo.',
          pixKeyInvalid: 'O provedor recusou a conta: a chave PIX não é válida. Confira se a chave está ativa e foi digitada sem espaços, e envie de novo.',
          routingNotWire: 'O provedor recusou a conta: este routing number (ABA) não aceita wire. Confirme com o banco o ABA para wire e envie de novo.',
          dataIncomplete: 'O provedor recusou a conta: falta um dado obrigatório. Edite a conta, complete os campos e envie de novo.',
          customerNotFound: 'O provedor não encontrou o cadastro do cliente. Reenvie o cadastro em Bancos e Limites e depois envie a conta.',
          generic: 'O provedor recusou esta conta na última tentativa. Revise os dados da conta e envie de novo.'
        },
        addressFields: {
          street_line_1: 'endereço',
          city: 'cidade',
          state: 'estado',
          postal_code: 'CEP',
          country: 'país'
        }
      },
      providers: 'PROVEDORES',
      syncAll: 'Sincronizar em todos',
      syncAllTooltip: 'Sincronizar esta conta em todos os provedores disponíveis',
      noProviders: 'Nenhum provedor ativo no sistema.',
      reconcileTooltip: 'Reconciliar com o provedor: consulta a conta lá antes de alterar qualquer coisa',
      syncAfterFix: 'Sincronizar depois de corrigir o cadastro',
      syncThisProvider: 'Sincronizar esta conta neste provedor'
    },
    bankTypeInfoCardUi: {
      title: 'Tipos de Cadastro Bancário',
      onlineTitle: 'Banco Online',
      onlineText: 'Banco com processo de forma online, possibilitando cadastro e operação de forma automática.',
      offlineTitle: 'Banco Offline',
      offlineText: 'Processo tradicional de cadastro e operação com documentação manual via e-mail.',
      signatureTitle: 'Banco via Assinatura',
      signatureText: 'Banco requer assinatura digital do cliente em formulário específico, com cadastro e operações offline.'
    },
    customerBankUi: {
      notSent: 'Não enviado'
    },
    customerBankSelectUi: {
      inactive: '(Inativo)',
      online: 'Online',
      digitalSignature: 'Assinatura Digital',
      offline: 'Offline'
    },
    customerContactFormDialogUi: {
      editTitle: 'Editar contato',
      addTitle: 'Adicionar contato',
      fullName: 'Nome completo *',
      role: 'Função / Cargo',
      department: 'Departamento *',
      customDepartment: 'Nome do departamento *',
      email: 'E-mail *',
      duimpEmailPrimary: 'E-mail primário DUIMP/DU-E',
      duimpEmailSecondary: 'E-mail secundário DUIMP/DU-E',
      cellphone: 'Celular',
      landline: 'Telefone fixo',
      notes: 'Observações',
      isPrimary: 'Contato principal do departamento',
      nameMaxLength: 'Nome deve ter no máximo 255 caracteres',
      roleMaxLength: 'Função deve ter no máximo 100 caracteres',
      customDepartmentMaxLength: 'Departamento customizado deve ter no máximo 100 caracteres',
      notesMaxLength: 'Observações devem ter no máximo 500 caracteres'
    },
    customerContactListUi: {
      noDepartment: 'Sem departamento'
    },
    customerDirectorsProxiesUi: {
      title: 'Diretores e procuradores',
      hasDirectorsQuestion: 'A empresa possui diretores ou procuradores?'
    },
    customerDuimpDueEmailsNotificationsUi: {
      title: 'Notificações de DUIMP/DU-E',
      primaryEmail: 'E-mail principal',
      secondaryEmail: 'E-mail secundário'
    },
    customerExchangeBankModalUi: {
      editTitle: 'Editar banco',
      addTitle: 'Adicionar banco',
      bankTypesInfo: 'Informações sobre tipos de banco',
      remittanceDescription: 'Operações de remessa para o exterior',
      tourismDescription: 'Operações de turismo e viagens',
      defaultDescription: 'Operação de câmbio',
      bankInactive: 'Este banco está inativo e não pode ser utilizado'
    },
    customerProviderSendingProgressUi: {
      analyzingTitle: 'Analisando os dados do cliente',
      analyzingSubtitle: 'Conferindo o cadastro salvo',
      documentsTitle: 'Verificando os documentos',
      documentsSubtitle: 'Conferindo a autenticidade dos arquivos',
      sendingTitle: 'Enviando para os bancos parceiros',
      sendingSubtitle: 'Aguardando a resposta de cada um',
      extendedTitle: 'Os bancos parceiros ainda estão respondendo',
      extendedSubtitle: 'Isso pode levar alguns segundos a mais'
    },
    customerExchangeBanksUi: {
      sendLimitApprovalTitle: 'Enviar aprovação de limite?',
      sendLimitApprovalMessage: 'Deseja enviar a aprovação de limite ao cliente?',
      bankFallback: 'Banco',
      bankFallbackLower: 'banco',
      thisCustomer: 'este cliente',
      resyncMessage: '<p>Vamos consultar o <b>{bankName}</b> com os dados de <b>{customerName}</b>:</p><ul><li>Verificamos se este cadastro já existe dentro do banco;</li><li>Sincronizamos as informações de limites operacionais para este cliente.</li></ul>',
      noExpiration: 'SEM EXPIRAÇÃO DEFINIDA',
      naturesCount: '{count} natureza | {count} naturezas',
      inactiveBankSuffix: '{status} (banco inativo)',
      unknownStatus: 'Status desconhecido',
      dolspayUpdated: 'Cadastro DolsPay atualizado',
      dolspayPending: 'Pendências detectadas no cadastro DolsPay',
      dolspayFailed: 'Cadastro DolsPay não concluído'
    },
    customerInternationalBankModalUi: {
      editTitle: 'Editar conta bancária',
      addTitle: 'Adicionar conta bancária',
      paymentMethod: 'Método de pagamento',
      otherMethodsHint: 'Outros métodos ficam disponíveis quando o cliente possui banco digital na aba Bancos e limites.',
      continue: 'Continuar',
      rtpRoutingHint: 'Este número de roteamento permite salvar como RTP.'
    },
    customerOperationNatureSelectUi: {
      label: 'Natureza da Operação',
      noResults: 'Nenhuma natureza encontrada para a busca',
      selectBankFirst: 'Selecione um banco para ver as naturezas disponíveis',
      selectedCount: '{count} naturezas selecionadas'
    },
    customerPartnersUi: {
      nestedTitle: 'Cadastro do sócio - {name}',
      viewFallback: 'Visualização',
      link: 'Vincular'
    },
    customerPartnersShareholdersUi: {
      title: 'Sócios e Acionistas'
    },
    customerPaymentAccountModalUi: {
      editTitle: 'Editar conta de pagamento',
      addTitle: 'Adicionar conta de pagamento'
    },
    customerPaymentAccountsUi: {
      sectionTitle: 'Contas para pagamento',
      sameOwnership: 'Mesma titularidade',
      emptyTitle: 'Nenhuma conta para pagamento',
      emptySubtitle: 'Clique em Adicionar para cadastrar uma conta com mesma titularidade.',
      deleteMessage: 'Deseja realmente excluir esta conta para pagamento?',
      deleteTitle: 'Excluir conta de pagamento?',
      deactivateTitle: 'Inativar conta para pagamento',
      deactivateMessage: 'Ao inativar esta conta, ela não aparecerá mais como opção ao criar novas operações. Os registros históricos são mantidos.'
    },
    customerPoliticallyExposedPersonUi: {
      subtitle: 'Pessoa politicamente exposta'
    },
    customerPreRegistrationModalUi: {
      title: 'Envie um pré-cadastro por email',
      registerType: 'Tipo de cadastro',
      fullName: 'Nome completo',
      phone: 'Telefone',
      sendByEmail: 'Enviar por email',
      exchangeDescription: 'Operações de turismo e viagens',
      basicRemittanceDescription: 'Remessas básicas para o exterior',
      completeRemittanceDescription: 'Remessas completas para o exterior',
      legalPersonDescription: 'Pessoa jurídica e empresas',
      defaultDescription: 'Cadastro de cliente'
    },
    customerRegistrationResponsibleUi: {
      title: 'Responsável pelo cadastro'
    },
    customerSendDocumentsModalUi: {
      title: 'Enviar documentos',
      stepCustomerDocs: 'Documentos do Cliente',
      stepOperationalDocs: 'Documentos Complementares',
      stepPartnersDocs: 'Documentos dos Sócios',
      stepSummary: 'Resumo',
      cancelConfirmMessage: 'Tem certeza que deseja cancelar o envio dos documentos? Todas as seleções serão perdidas.',
      partnerFallback: 'Sócio',
      loadCustomerDocsError: 'Não foi possível carregar documentos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadOperationalDocsError: 'Não foi possível carregar documentos complementares. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      complementNumber: '{type} - Compl. {number}',
      downloadCustomerDocError: 'Não foi possível baixar documento do cliente. Tente baixar novamente; se continuar, fale com o suporte.',
      downloadOperationalDocError: 'Não foi possível baixar documento complementar. Tente baixar novamente; se continuar, fale com o suporte.',
      downloadPartnerDocError: 'Não foi possível baixar documento do sócio. Tente baixar novamente; se continuar, fale com o suporte.'
    },
    customerSpreadsUi: {
      partnerFeeTitle: 'Spread padrão para stablecoin',
      partnerFeeLabel: 'Spread',
      partnerFeeHint: 'Vale para as operações com stablecoin deste cliente: vem preenchido na operação e dá para trocar lá, se precisar. Os spreads de bancos tradicionais ficam abaixo.',
      sectionTitle: 'Spread de remessa',
      notFoundTitle: 'Nenhum spread encontrado',
      emptyTitle: 'Nenhum spread cadastrado',
      notFoundSubtitle: 'Nenhum spread encontrado para a pesquisa.',
      emptySubtitle: 'Clique em Adicionar para começar.',
      sell: 'Venda',
      buy: 'Compra',
      min: 'Min',
      rec: 'Rec',
      max: 'Max',
      minSell: 'Spread Mínimo Venda(%)',
      recSell: 'Spread Recomendado Venda(%)',
      maxSell: 'Spread Máximo Venda(%)',
      minBuy: 'Spread Mínimo Compra(%)',
      recBuy: 'Spread Recomendado Compra(%)',
      maxBuy: 'Spread Máximo Compra(%)'
    },
    customerStablecoinReceiverUi: {
      title: 'Receiver (KYC/AML)',
      receiverId: 'Receiver ID',
      kycLevel: 'KYC Level',
      createdAt: 'Data de Criação',
      updatedAt: 'Última Atualização',
      sync: 'Sincronizar',
      notFound: 'Receiver não encontrado para este cliente.',
      statusRejected: 'Rejeitado',
      statusUnderReview: 'Em Análise'
    },
    customerSummaryHeaderUi: {
      customerPhoto: 'Foto do cliente',
      importedExternalId: 'Cliente importado com ID externo {externalId}',
      copyDocument: 'Copiar {document}',
      cellphone: 'Celular:',
      copyCellphone: 'Copiar celular',
      reactivate: 'Reativar cadastro',
      operateTourism: 'Operar Turismo',
      operateRemittance: 'Operar Remessa',
      upgradeRegistration: 'Progredir cadastro',
      statusOnDate: '{description} em {date}',
      updatedAt: 'Atualizado em {date}'
    },
    customerTypeSelectorUi: {
      question: 'Qual tipo de cadastro deseja realizar?'
    },
    customerUpgradeExchangeToBasicModalUi: {
      birthplace: 'Local de nascimento',
      sendReason: 'Motivo do envio'
    },
    customerUpgradeRegistrationModalUi: {
      invalidValue: 'Informe um valor válido'
    },
    customerUserAgreementUi: {
      title: 'Acordo de Usuário',
      attention: 'ATENÇÃO, AO PROSSEGUIR COM O CADASTRO VOCÊ ESTÁ CONCORDANDO COM OS SEGUINTES TERMOS:',
      agree: 'Concordo com os termos',
      termsNotConfigured: 'Termos não configurados.',
      termsNotFound: 'Termos não encontrados.',
      termsLoadError: 'Não foi possível carregar os termos.'
    },
    customerWorkUi: {
      title: 'Trabalho'
    },
    documentGenerationStepperUi: {
      title: 'Gerar Documento',
      loadTemplatesError: 'Não foi possível carregar os templates disponíveis.',
      noTemplates: 'Nenhum template disponível para geração de documentos.',
      incomeTaxTemplateName: 'Extrato para IR',
      incomeTaxTemplateDescription: 'Operações liquidadas no ano, agrupadas por banco',
      stepSelectDocument: 'Selecionar documento',
      stepFillData: 'Preencher dados',
      stepPreview: 'Preview e Confirmar',
      generateAndSave: 'Gerar e Salvar',
      next: 'Próximo',
      previewError: 'Não foi possível gerar o preview do documento. Tente novamente.'
    },
    documentsSelectionTableUi: {
      uploadDate: 'Data do Upload',
      selectAll: 'Selecionar todos ({count}/{total})',
      noDocuments: 'Nenhum documento',
      complementNumber: '{type} - Compl. {number}'
    },
    exchangeTypeSelectorUi: {
      operationType: 'Tipo de operação'
    },
    incomeTaxStatementFieldsUi: {
      year: 'Ano',
      layout: 'Modelo'
    },
    internationalBankAccountCardUi: {
      resyncStatus: 'Resincronizar status',
      sendToIntegrator: 'Enviar ao integrador bancário',
      beneficiary: 'Beneficiário',
      copyAccountData: 'Copiar dados da conta',
      deactivateAccount: 'Inativar conta',
      reactivateAccount: 'Reativar conta',
      copyTitle: '🏦 Dados da conta no exterior',
      copyBank: 'Banco: {value}',
      copyName: 'Nome: {value}',
      copyOwner: 'Titular: {value}',
      copyType: 'Tipo: {value}',
      copySwift: 'Código Swift/BIC: {value}',
      copyRouting: 'Número ABA/Routing: {value}',
      copyFfc: 'FFC (For Further Credit): {value}'
    },
    pdfPreviewUi: {
      generating: 'Gerando preview do documento...'
    },
    resyncResultModalUi: {
      title: 'Resultado da Resincronização',
      subEntities: 'Sub-entidades',
      documents: 'Documentos',
      statusSuccess: 'Sucesso',
      statusSkipped: 'Ignorado',
      statusFailed: 'Não concluído'
    },
    sepaFormUi: {
      examplePlaceholder: 'Ex: {example}'
    },
    thirdPartyFormUi: {
      fullName: 'Nome completo',
      nationality: 'Nacionalidade',
      maritalStatus: 'Estado civil',
      street: 'Logradouro'
    },
    unblockProfileForm: {
      title: 'Perfil das operações para {provider}',
      intro: 'Estas respostas só a {provider} pede. Elas não ficam na ficha do cliente: responda aqui para enviar o cadastro.',
      saveAndContinue: 'Salvar e conferir de novo',
      saveError: 'Não foi possível gravar as respostas do perfil. Confira os campos e tente de novo.'
    },
    unblockOnboardingModalUi: {
      title: 'Cadastro em {provider}',
      resendTitle: 'O que o cliente precisa reenviar:',
      shareLinkText: 'Compartilhe este link com o cliente para que ele conclua a verificação de identidade (KYC) via Sumsub:',
      verificationLinkLabel: 'Link de verificação KYC',
      copyLink: 'Copiar link',
      openInNewTab: 'Abrir em nova aba',
      linkPending: 'O link de verificação será gerado pelo {provider} em breve. Verifique novamente mais tarde.',
      checkError: 'Não foi possível verificar os requisitos agora. Você pode tentar iniciar o onboarding mesmo assim, mas o provedor pode pedir ajustes no cadastro durante o processo.',
      pendingIntro: 'Para iniciar o onboarding {provider}, corrija os itens abaixo:',
      goToPartners: '→ Ir para a aba Sócios',
      rejectedBanner: '{provider} recusou o cadastro deste cliente definitivamente.',
      reasonTitle: 'Motivo informado:',
      reonboardText: 'Corrija a ficha do cliente e confirme: um cadastro novo é criado no {provider} com os dados atuais e um novo link de verificação é gerado.',
      notLinkedBanner: 'Este cliente ainda não está vinculado ao {provider}.',
      confirmText: 'Ao confirmar, o cliente será cadastrado no {provider} e um link de verificação de identidade (KYC) será gerado.',
      reonboard: 'Recadastrar',
      confirmAnyway: 'Confirmar assim mesmo',
      correctionRequested: '{provider} pediu correção. Envie o link abaixo ao cliente para ele reenviar os documentos.',
      alreadyLinked: 'Este cliente já está vinculado ao {provider}, mas ainda não foi aprovado.',
      registeredSuccess: 'Cadastro realizado com sucesso no {provider}.',
      onboardError: 'O cadastro não foi vinculado a {provider}. Confira os dados do cliente e tente novamente; se continuar, fale com o suporte.',
      linkExpiresAt: 'Este link vale até {date}.',
      linkExpired: 'Este link venceu em {date}. Gere um novo e envie ao cliente.',
      renewLink: 'Gerar novo link',
      renewAvailableAfter: 'Disponível quando este link vencer (3 dias depois de gerado).',
      renewSuccess: 'Novo link gerado. Envie ao cliente.',
      renewError: 'Não foi possível gerar um novo link agora. Tente de novo em instantes.'
    },
    formCustomerUi: {
      externalSubtitle: 'Suas informações serão salvas temporariamente neste dispositivo até que você termine seu cadastro.',
      bankPendingTitle: 'Pendências com o banco',
      divergentDateTitle: 'Sócio com data divergente:',
      divergentDateInformedBy: 'a data informada por',
      divergentDateDetail: 'foi {informed}, mas a data cadastrada no sistema é {system}. Verifique qual dado está correto e atualize manualmente.',
      missingRegisterType: 'Este cliente está sem tipo de cadastro, por isso o formulário não pode ser exibido. Acione o suporte técnico informando o ID do cliente.',
      saveAndExit: 'Salvar e sair',
      requestRegistrationUpdate: 'Solicitar atualização cadastral',
      requestForeignAccount: 'Solicitar cadastro de conta no exterior',
      fieldRequired: '{label}: campo obrigatório',
      reviewHighlightedFields: 'Revise os campos em destaque antes de enviar ao banco.',
      dateNotInformed: 'não informada'
    },
    partnersShareholdersUi: {
      colActions: 'Ações',
      partnerNameSuffix: '{name} (sócio)',
      defaultPartnerName: 'sócio',
      partnerDocumentsTitle: 'Documentos de {name}'
    },
    partnerDialogUi: {
      titleLabel: 'Cargo/Função',
      nestedPartnersTitle: 'Sócios deste sócio (PJ)',
      incompleteDate: 'Data incompleta',
      invalidDate: 'Data inválida',
      dataMismatch: 'Os dados informados não conferem ou não são válidos.'
    },
    partnerWizardUi: {
      docIdentification: 'Documento de identificação',
      docAddressProof: 'Comprovante de endereço'
    },
    cover: {
      sectionTitle: 'Informações iniciais'
    },
    contact: {
      sectionTitle: 'Informações de contato'
    },
    address: {
      sectionTitle: 'Endereço'
    },
    compliance: {
      sectionTitle: 'Compliance'
    },
    financial: {
      sectionTitle: 'Dados bancários no Brasil',
      requiredAccount: 'Necessário cadastrar pelo menos 1 conta'
    },
    documents: {
      title: 'Documentos',
      titleLegalPerson: 'Documentos da Empresa',
      searchPlaceholder: 'Buscar por tipo de documento'
    },
    brazilianBank: {
      sectionTitle: 'Contas Brasil',
      requiredAccount: 'Necessário cadastrar pelo menos 1 conta',
      add: 'Adicionar',
      emptyTitle: 'Nenhuma conta bancária no Brasil',
      emptySubtitle: 'Clique em Adicionar para cadastrar uma conta (PIX, agência e conta).',
      deleteConfirmMessage: 'Deseja realmente excluir esta conta bancária?',
      deleteConfirmTitle: 'Excluir conta bancária?',
      deleteButton: 'Excluir',
      deactivateTitle: 'Inativar conta bancária',
      deactivateMessage: 'Ao inativar esta conta, ela não aparecerá mais como opção ao criar novas operações. Os registros históricos são mantidos.',
      deactivateButton: 'Inativar',
      cancelButton: 'Cancelar',
      syncTempError: 'Não foi possível sincronizar com a DolsPay no momento. Tente novamente em alguns instantes.',
      syncInvalidCharsError: 'Apenas letras, números, espaços e hífens são permitidos. Revise o nome do beneficiário e remova caracteres especiais (acentos, pontos, barras, etc).',
      syncSaveError: 'A conta foi salva, mas a DolsPay não aceitou a sincronização: {message}. Corrija o dado indicado e clique em Sincronizar.',
      syncFailed: 'Não foi possível sincronizar esta conta com a DolsPay. Revise os dados bancários e tente novamente.',
      syncNotSynced: 'A conta foi salva, mas não foi sincronizada com a DolsPay. Clique em Sincronizar na conta; se continuar, fale com o suporte.',
      saveBeforeSync: 'Salve o cliente antes de sincronizar contas com o DolsPay.',
      alreadyIntegrated: 'Esta conta já está integrada com a DolsPay.',
      syncGenericError: 'Não foi possível sincronizar contas com o DolsPay. Tente novamente.',
      reactivateSuccess: 'Conta reativada com sucesso.',
      deactivateSuccess: 'Conta inativada com sucesso.',
      toggleStatusError: 'O status da conta não foi alterado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      deleteWithDolspayError: 'Conta excluída, mas a DolsPay não confirmou: {message}',
      deleteSuccess: 'Conta excluída com sucesso.',
      deleteError: 'A conta não foi excluída. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    internationalBank: {
      sectionTitle: 'Contas no exterior',
      add: 'Adicionar',
      emptyTitle: 'Nenhuma conta no exterior',
      emptySubtitle: 'Clique em Adicionar para cadastrar uma conta internacional.',
      deleteConfirmTitle: 'Excluir conta?',
      deleteConfirmYes: 'Sim',
      deleteConfirmMessageDolspay: 'Esta conta também será excluída na DolsPay. Deseja continuar?',
      deleteConfirmMessage: 'Deseja realmente excluir esta conta no exterior?',
      deactivateTitle: 'Inativar conta bancária',
      deactivateMessage: 'Ao inativar esta conta, ela não aparecerá mais como opção ao criar novas operações. Os registros históricos são mantidos.',
      deactivateButton: 'Inativar',
      cancelButton: 'Cancelar',
      bankTypeWire: 'Wire doméstico',
      bankTypeSwift: 'SWIFT internacional',
      bankTypeAch: 'ACH',
      bankTypeRtp: 'RTP Instantâneo',
      bankTypeTransfers3: 'Transfers 3.0',
      bankTypeAchColombia: 'ACH Colômbia',
      bankTypeSpei: 'SPEI',
      bankTypeSepa: 'SEPA EUR',
      bankTypeFasterPayments: 'Faster Payments GBP',
      saveBeforeSync: 'Salve o cliente antes de enviar ao integrador bancário.',
      documentRequired: 'O número do documento deve ser preenchido antes do envio ao integrador.',
      noIntegrationBank: 'Nenhum banco de integração elegível encontrado para este cliente.',
      syncBankingSuccess: 'Conta internacional enviada ao integrador com sucesso',
      syncStatusSuccess: 'Status de integração atualizado com sucesso',
      saveBeforeSyncDolspay: 'Salve o cliente antes de sincronizar contas com o DolsPay.',
      syncTempError: 'Não foi possível sincronizar com a DolsPay no momento. Tente novamente em alguns instantes.',
      syncAccessDeniedError: 'Sincronização de conta no exterior não disponível para seu perfil. Entre em contato com o suporte se precisar deste recurso.',
      syncInvalidCharsError: 'Apenas letras, números, espaços e hífens são permitidos. Revise o nome do beneficiário e remova caracteres especiais (acentos, pontos, barras, etc).',
      syncInvalidSwiftCode: 'O cadastro do banco não pôde ser integrado com a DolsPay porque o "Código de pagamento SWIFT" está preenchido com um valor inválido. Clique no ícone de editar do banco, localize o campo "Código de pagamento SWIFT", selecione uma das opções da lista (ex: Comércio de mercadorias, Serviços, Remessa pessoal) e salve novamente.',
      syncSaveError: 'A conta foi salva, mas a DolsPay não aceitou a sincronização: {message}. Corrija o dado indicado e clique em Sincronizar.',
      syncFailed: 'Não foi possível sincronizar esta conta com a DolsPay. Revise os dados bancários e tente novamente.',
      syncGenericError: 'Não foi possível sincronizar contas com o DolsPay. Tente novamente.',
      syncSuccess: 'Sincronização com DolsPay realizada com sucesso.',
      alreadyIntegrated: 'Esta conta já está integrada com a DolsPay.',
      reactivateSuccess: 'Conta reativada com sucesso.',
      deactivateSuccess: 'Conta inativada com sucesso.',
      toggleStatusError: 'O status da conta não foi alterado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      deleteWithDolspayError: 'Conta excluída, mas a DolsPay não confirmou: {message}',
      deleteSuccess: 'Conta excluída com sucesso.',
      deleteError: 'A conta não foi excluída. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    exchangeBanks: {
      sectionTitle: 'Bancos/Naturezas e Limites',
      searchLabel: 'Pesquisar',
      addBank: 'Adicionar Banco',
      limitAvailable: 'Limite disponível',
      percentUsed: '% utilizado',
      available: 'Disponível',
      labelIn: 'ENTRADA',
      labelOut: 'SAÍDA',
      notConfigured: 'Não configurado',
      validity: 'VALIDADE: {date}',
      editTooltip: 'Editar',
      viewPendings: 'Ver Pendências',
      emptyTitleNoSearch: 'Nenhum banco vinculado',
      emptyTitleSearch: 'Nenhum banco encontrado',
      emptySubtitleNoSearch: 'Clique em Adicionar Banco para começar.',
      emptySubtitleSearch: 'Nenhum banco encontrado para a pesquisa.',
      addBankButton: 'Adicionar banco',
      limitApprovedTitle: 'Limite aprovado',
      inputValueIn: 'Valor Entrada',
      inputValueOut: 'Valor Saída',
      inputValue: 'Valor',
      inputExpireAt: 'Data de Validade',
      saveButton: 'Salvar',
      cancelButton: 'Cancelar',
      pendingReqTitle: 'Pré-requisitos pendentes',
      closeButton: 'Fechar',
      signatureTitle: 'Assinatura digital',
      signatureMessage: 'Deseja enviar a ficha cadastral para assinatura digital do cliente?',
      signatureYes: 'Sim',
      signatureNo: 'Não',
      blockBankTitle: 'Bloquear banco',
      blockBankMessage: 'O banco será bloqueado e não poderá ser utilizado em novas operações.',
      blockReasonLabel: 'Motivo (opcional)',
      blockReasonPlaceholder: 'Descreva o motivo do bloqueio, se necessário',
      blockButton: 'Bloquear',
      resyncTitle: 'Sincronizar dados com {bankName}?',
      resyncButton: 'Sincronizar',
      integrationFallbackTitle: 'Integração bancária não concluída',
      integrationFallbackMessage: 'A integração bancária não foi concluída. Deseja manter o banco cadastrado pelo fluxo manual?',
      foreignIntegrationTitle: 'Integração online indisponível',
      foreignIntegrationMessage: 'O processo de integração online não está disponível para clientes estrangeiros. O cadastro será realizado pelo fluxo offline.',
      foreignIntegrationButton: 'Entendi',
      actions: {
        changeLimit: 'Alterar Limite',
        customerLimits: 'Limites do cliente',
        requestIncrease: 'Solicitar aumento',
        sendBankUpdate: 'Enviar Atualização ao Banco',
        generateRegisterForm: 'Gerar Ficha Cadastral',
        resendRegisterForm: 'Reenviar Ficha Cadastral',
        statement: 'Extrato de movimentação',
        integrate: 'Integrar',
        resync: 'Resincronizar dados com o banco',
        inactiveBank: 'Banco inativo na lista de bancos: bloqueado para todos os clientes',
        unblockBank: 'Desbloquear banco',
        blockBank: 'Bloquear banco'
      },
      messages: {
        missingCompanyName: 'Razão social não preenchida',
        missingCnpj: 'CPF/CNPJ não preenchido',
        docsWithoutCountry: 'Existem documentos sem país definido',
        missingSelfie: 'Selfie do cliente não enviada. Gere o link da selfie na aba Documentos e envie ao cliente.',
        bankBlockedSuccess: '{bankName} bloqueado com sucesso.',
        bankBlockError: 'Não foi possível bloquear o banco. Tente novamente.',
        bankUnblockError: 'Não foi possível desbloquear o banco. Tente novamente.',
        preRegInProgress: 'Já existe um pré-cadastro em andamento. Aguarde um instante.',
        checkReadinessError: 'Não conseguimos conferir se o cliente pode ser enviado a este banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        sendToBankDigitalError: 'Não foi possível enviar o cadastro do cliente ao banco digital. Confira os documentos do cliente e tente novamente; se continuar, fale com o suporte.',
        bankRemovedError: 'Não foi possível remover o banco. Recarregue a página.',
        integratedSuccess: 'Cliente integrado com sucesso!',
        notSentToBank: 'O cadastro não foi enviado ao banco. Confira se os dados obrigatórios estão preenchidos e tente novamente.',
        resyncSuccess: 'Dados do cliente resincronizados com sucesso',
        resyncError: 'Os dados do cliente não foram atualizados no banco. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        bankUpdateError: 'O banco do cliente não foi atualizado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadBanksError: 'Não foi possível carregar a lista de bancos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadNaturesError: 'Não foi possível carregar as naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadExchangeTypesError: 'Não foi possível carregar os tipos de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        limitBankNotFound: 'Dados do banco não encontrados. Não foi possível adicionar o limite.',
        limitAddedSuccess: 'Limite adicionado com sucesso!',
        limitSaveError: 'Não foi possível salvar o limite do cliente. Confira os valores e tente novamente; se continuar, fale com o suporte.',
        limitApprovalSentSuccess: 'Aprovação de limite enviada com sucesso!',
        limitApprovalSentError: 'Não foi possível enviar a aprovação de limite ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        emailUpdateSuccess: 'Email de atualização cadastral enviado ao banco com sucesso!',
        bankRegisterUpdateError: 'Não foi possível enviar a atualização cadastral ao banco. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        processingInProgress: 'Processamento em andamento. Atualize a página em instantes.',
        tosAcceptedMessage: 'Termo aceito. O cadastro vai ser enviado para {providerName} em instantes.',
        dolsPayBankNotFound: 'Banco DolsPay não encontrado na lista de bancos disponíveis.',
        digitalNatureNotFound: 'Natureza de operação digital não encontrada. Tente novamente.',
        registerResendSuccess: 'Cadastro reenviado ao banco com sucesso',
        registerResendFailure: 'Reenvio não concluído. Tente novamente.',
        registerResendInitiated: 'Reenvio iniciado. Aguarde a confirmação.',
        resendNotIdentified: 'Não foi possível identificar o cliente. Tente pela tela de edição do cadastro.',
        resendError: 'O cadastro não foi reenviado ao banco. Confira as pendências do cliente e tente novamente.',
        checkCustomerDataError: 'Não conseguimos conferir os dados do cliente. Revise o cadastro e tente novamente.',
        integrationCompleteReloadError: 'Integração concluída, mas não foi possível atualizar os dados na tela. Recarregue a página.',
        downloadingAttachment: 'Baixando anexo',
        downloadAttachmentError: 'Não foi possível baixar o anexo. Verifique se há um template vinculado a esse banco.',
        limitsLoadError: 'Os limites do cliente não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      }
    },
    contactList: {
      saveBefore: 'Salve o cadastro do cliente antes de adicionar contatos.',
      addContact: 'Adicionar contato',
      filterByDepartment: 'Filtrar por departamento',
      searchLabel: 'Pesquisar',
      emptyTitle: 'Nenhum contato cadastrado',
      emptySubtitle: 'Adicione contatos para registrar as pessoas de cada departamento do cliente.',
      emptySearchTitle: 'Nenhum contato encontrado',
      emptySearchSubtitle: 'Nenhum contato corresponde aos filtros aplicados.',
      deleteTitle: 'Excluir contato?',
      messages: {
        loadError: 'Não foi possível carregar contatos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        deleteSuccess: 'Contato excluído com sucesso.',
        deleteError: 'Não foi possível excluir contato. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        deleteMessage: 'Deseja excluir o contato {name} do departamento {dept}?'
      }
    },
    partners: {
      sectionTitle: 'Sócios',
      addButton: 'Adicionar',
      linkButton: 'Vincular cliente cadastrado',
      searchLabel: 'Pesquisar',
      emptyTitleNoSearch: 'Nenhum sócio cadastrado',
      emptyTitleSearch: 'Nenhum sócio encontrado',
      emptySubtitleNoSearch: 'Clique em Adicionar para começar.',
      emptySubtitleSearch: 'Nenhum sócio encontrado para a pesquisa.',
      personTypeLegal: 'Pessoa Jurídica',
      personTypePhysical: 'Pessoa Física',
      fieldCpfCnpj: 'CPF/CNPJ',
      fieldCellphone: 'Celular',
      fieldEmail: 'E-mail',
      fieldShare: 'Participação',
      tooltipDocuments: 'Ir para documentos',
      tooltipEdit: 'Editar',
      tooltipDelete: 'Excluir',
      linkModalTitle: 'Vincular sócio',
      sharePercent: '% de participação',
      messages: {
        loadPartnerError: 'O cadastro do sócio (cliente {id}) não carregou. Atualize a página e tente novamente.',
        requiredFields: 'Por favor, preencha todos os campos obrigatórios.',
        saveError: 'O sócio não foi salvo. Confira nome, documento e participação e tente novamente; se continuar, fale com o suporte.',
        saveSuccess: 'Sócio salvo com sucesso',
        nestedSaveError: 'Não foi possível salvar o sócio. Tente novamente.',
        partnerAdded: 'Sócio do sócio vinculado adicionado!',
        nestedPartnerAdded: 'Sócio do sócio adicionado!',
        nestedPartnerUpdated: 'Sócio do sócio atualizado com sucesso!',
        partnerShareSum: 'A soma das participações dos sócios deste sócio deve ser 100%. Atual: {value}%',
        partnerShareOverflow: 'A soma das participações não pode ultrapassar 100%. Atual: {value}%.',
        deleteNestedTitle: 'Excluir sócio?',
        deleteNestedMessage: 'Deseja realmente excluir este sócio do sócio?',
        removeLinkedTitle: 'Remover sócio da empresa?',
        removeLinkedMessage: 'Deseja remover este sócio da empresa selecionada? Ao confirmar, o sócio será desvinculado da empresa selecionada mas o cadastro como cliente continuará ativo no sistema.',
        removeMessage: 'Deseja remover este sócio?',
        cancelTitle: 'Cancelar?',
        cancelEditMessage: 'Há dados preenchidos, deseja realmente cancelar a edição?',
        cancelNewMessage: 'Há dados preenchidos, deseja realmente cancelar o cadastro?',
        nestedDocumentsSaveError: 'Alguns documentos não foram salvos. Acesse a ficha do sócio e reenvie os documentos pendentes.',
        nestedUpdatedWarning: 'Os dados atualizados do sócio não carregaram; mostrando os dados desta tela. Atualize a página para ver a versão mais recente.',
        customerNotFound: 'Cliente não encontrado por documento, criando novo registro',
        nestedDataIncomplete: 'Dados aninhados podem não estar completos',
        linkedExists: 'Sócio vinculado com sucesso (já existente)',
        linkedExistsAlready: 'Sócio vinculado com sucesso (registro já existia).',
        notLinkedCreatingNew: 'O sócio já cadastrado não foi vinculado; um novo cadastro será criado para ele.',
        partnerCreated: 'Sócio cadastrado com sucesso',
        partnerCreatedError: 'O sócio não foi criado. Confira os dados e tente novamente.',
        fieldRequired: 'Este campo é obrigatório',
        nestedFindInfo: 'Sócio aninhado {name} será criado como novo registro'
      }
    },
    operationalDocuments: {
      sectionTitle: 'Documentos complementares',
      typePlaceholder: 'Tipo',
      defaultDescription: 'Compl. {num}'
    },
    issuedDocuments: {
      sectionTitle: 'Documentos Emitidos',
      generateButton: 'Gerar Documento',
      emptyMessage: 'Nenhum documento emitido para este cliente.',
      defaultDescription: 'Autorização'
    },
    kyc: {
      sectionTitle: 'KYC',
      estimatedVolume: 'Volume anual estimado',
      currency: 'Moeda pretendida',
      destinationCountry: 'País de destino dos fundos'
    },
    formTab: {
      bankChannelsSearch: 'Buscar em contas internacionais, Brasil e pagamento',
      tabs: {
        registrationData: 'Dados cadastrais',
        contacts: 'Contatos',
        partners: 'Sócios',
        bankChannels: 'Canais bancários',
        documents: 'Documentos',
        limits: 'Bancos/Naturezas e Limites',
        spreads: 'Spreads',
        kyc: 'KYC',
        history: 'Histórico'
      }
    },
    complementaryInfo: {
      sectionTitle: 'Informações Complementares',
      accountPurpose: 'Propósito da conta',
      accountPurposeOther: 'Descreva o propósito da conta',
      businessType: 'Tipo de negócio',
      businessIndustry: 'Código da indústria (NAICS)',
      estimatedAnnualRevenue: 'Receita anual estimada',
      sourceOfWealth: 'Fonte de riqueza',
      publiclyTraded: 'Empresa de capital aberto',
      businessDescription: 'Descrição do negócio',
      businessDescriptionHint: 'Descreva as atividades do negócio (máximo {max} caracteres)',
      purposeDescriptionRequired: 'Descrição do propósito é obrigatória quando selecionado "Outro"',
      minChars: 'Mínimo 3 caracteres',
      maxChars: 'Máximo 512 caracteres'
    },
    operationProfile: {
      businessTitle: 'Perfil da empresa e das operações',
      individualTitle: 'Perfil das operações',
      groups: {
        company: 'Sobre a empresa',
        operations: 'Operações',
        funds: 'Origem dos recursos'
      },
      businessDescriptionHint: 'Conte o que a empresa faz, para quem e como (de {min} a {max} caracteres)',
      businessDescriptionShort: 'Faltam {missing} caracteres: o provedor pede pelo menos {min}',
      sourceOfWealthHint: 'Esta origem não tem equivalente no banco parceiro: escolha a fonte de riqueza mais próxima',
      fundsHandlingHint: 'Ex.: recebe dos clientes numa conta separada e paga os fornecedores deles; ou não recebe dinheiro de clientes',
      fields: {
        mainCountries: 'Outros países onde a empresa opera',
        hasLicenses: 'Tem licença ou registro regulatório?',
        licenseDetails: 'Qual licença ou registro e de qual órgão',
        requiresAmlProgram: 'Precisa de programa de prevenção à lavagem de dinheiro?',
        monthlyVolume: 'Volume mensal',
        monthlyTransactions: 'Operações por mês',
        sendsFundsOnBehalf: 'Envia dinheiro em nome de clientes?',
        sendsFundsOnBehalfDescription: 'Como envia dinheiro em nome de clientes',
        fundsSource: 'Origem dos recursos',
        fundsSourceDescription: 'De onde vem o dinheiro das operações',
        fundsHandlingDetails: 'Como o dinheiro de clientes passa pela empresa',
        useFor: 'Para que vai usar a conta',
        employmentStatus: 'Situação profissional',
        occupationIndustry: 'Ramo de atuação',
        netWorth: 'Faixa de patrimônio',
        wealthSource: 'Origem do patrimônio',
        txPerMonth: 'Operações por mês',
        txVolumePerMonth: 'Volume por mês'
      },
      options: {
        useFor: {
          Investing: 'Investimentos',
          PaymentToFriendsFamilyorOthers: 'Pagamentos a família, amigos ou terceiros',
          PurchaseDigitalAssets: 'Compra de ativos digitais',
          OnlinePurchasesOfGoodsOrServices: 'Compras online de produtos ou serviços',
          Trading: 'Compra e venda de ativos (trading)'
        },
        employmentStatus: {
          Employed: 'Empregado',
          SelfEmployed: 'Autônomo',
          Retired: 'Aposentado',
          Student: 'Estudante',
          Unemployed: 'Sem ocupação'
        },
        occupationIndustry: {
          Agriculture: 'Agronegócio',
          ArtsAndEntertainment: 'Artes e entretenimento',
          Construction: 'Construção',
          Education: 'Educação',
          FinancialServices: 'Serviços financeiros',
          InformationAndTechnology: 'Tecnologia da informação',
          Retail: 'Comércio',
          RealEstate: 'Imóveis',
          BusinessOwner: 'Empresário',
          Healthcare: 'Saúde',
          Industrial: 'Indústria',
          LegalServices: 'Serviços jurídicos',
          PublicSector: 'Setor público',
          SeniorManagement: 'Alta gestão',
          Other: 'Outro'
        },
        netWorth: {
          UpTo25000: 'Até US$ 25 mil',
          Between25001And50000: 'US$ 25 mil a 50 mil',
          Between50001And100000: 'US$ 50 mil a 100 mil',
          Between100001And300000: 'US$ 100 mil a 300 mil',
          Between300001And500000: 'US$ 300 mil a 500 mil',
          Between500001And1000000: 'US$ 500 mil a 1 milhão',
          Over1000001: 'Acima de US$ 1 milhão'
        },
        wealthSource: {
          Salary: 'Salário',
          Savings: 'Poupança',
          Investments: 'Investimentos',
          CryptoTrading: 'Operações com cripto',
          Other: 'Outra'
        },
        txPerMonth: {
          LessThan5: 'Menos de 5',
          Between5And10: 'De 5 a 10',
          MoreThan10: 'Mais de 10'
        },
        txVolumePerMonth: {
          LessThan500: 'Até US$ 500',
          MoreThan500LessThan2000: 'US$ 500 a 2 mil',
          MoreThan2000: 'Acima de US$ 2 mil'
        },
        monthlyVolume: {
          TenToTwentyFiveThousand: 'US$ 10 mil a 25 mil',
          TwentyFiveToFiftyThousand: 'US$ 25 mil a 50 mil',
          FiftyToOneHundredThousand: 'US$ 50 mil a 100 mil',
          OneHundredToTwoHundredFiftyThousand: 'US$ 100 mil a 250 mil',
          TwoHundredFiftyToFiveHundredThousand: 'US$ 250 mil a 500 mil',
          MoreThanFiveHundredThousand: 'Acima de US$ 500 mil'
        },
        monthlyTransactions: {
          LessThanTen: 'Menos de 10',
          TenToTwentyFive: 'De 10 a 25',
          TwentyFiveToFifty: 'De 25 a 50',
          FiftyToOneHundred: 'De 50 a 100',
          MoreThanOneHundred: 'Mais de 100'
        },
        fundsSource: {
          BusinessRevenue: 'Receita do negócio',
          ShareholderFunds: 'Aporte dos sócios',
          VcPrivateEquity: 'Fundo de investimento (venture capital ou private equity)',
          AssetSale: 'Venda de bens ou participações',
          IcoProceeds: 'Oferta de tokens (ICO)',
          CryptoActivityProceeds: 'Atividade com criptoativos',
          LoanProceeds: 'Empréstimo',
          Other: 'Outra'
        }
      }
    },
    pf: {
      coverFields: {
        birthCountry: 'País de nascimento',
        fullName: 'Nome completo',
        birthDate: 'Data de nascimento',
        birthplace: 'Local de nascimento',
        sexMale: 'Masculino',
        sexFemale: 'Feminino',
        documentType: 'Tipo de documento',
        documentNumber: 'Nº do documento',
        documentIssueDate: 'Data de emissão',
        documentDueDate: 'Data de validade',
        uf: 'UF',
        issuingAgency: 'Órgão expedidor',
        issuingAgencyOther: 'Órgão expedidor (Outros)',
        issuingAgencyOtherPlaceholder: 'Especifique',
        maritalStatus: 'Estado civil',
        marriageSystem: 'Regime de Casamento',
        spouseName: 'Nome completo do Cônjuge',
        monthlyIncome: 'Renda média mensal',
        profession: 'Profissão',
        professionOther: 'Profissão (Outros)',
        professionOtherPlaceholder: 'Especifique',
        operationNature: 'Motivo do envio',
        dependentName: 'Nome Completo do Dependente',
        dependentKinship: 'Grau de Parentesco do Dependente',
        assetLabel: 'Patrimônio',
        fatherName: 'Nome do pai',
        motherName: 'Nome da mãe',
        documentExpiredHint: 'Este documento está vencido.',
        loadNaturesError: 'Não foi possível carregar as naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadProfessionsError: 'Não foi possível carregar a lista de profissões. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
        loadIssuingAgenciesError: 'Não foi possível carregar a lista de órgãos emissores. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      },
      contactFields: {
        cellphone: 'Celular',
        email: 'E-mail',
        secondEmail: 'E-mail secundário',
        landline: 'Telefone Fixo'
      },
      work: {
        profession: 'Profissão',
        professionOther: 'Profissão (Outros)',
        professionOtherPlaceholder: 'Especifique',
        company: 'Empresa atual',
        companySector: 'Setor da empresa',
        position: 'Nome do cargo',
        loadProfessionsError: 'Não foi possível carregar a lista de profissões. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      },
      address: {
        residential: 'Endereço residencial',
        addDelivery: 'Deseja cadastrar outro endereço para entrega',
        delivery: 'Endereço entrega'
      },
      documents: {
        noCountryWarning: 'Este cliente possui documentos sem país definido. Clique em "Definir país" nos documentos sinalizados para corrigir.',
        sixtyKQuestion: 'Pretende operar valores superiores a 60 mil reais por ano? Favor adicionar seu Imposto de Renda e Recibo.',
        otherDocuments: 'Outros documentos',
        selfieLinkCopied: 'Link de selfie copiado para a área de transferência!',
        selfieLinkCopyError: 'Não foi possível copiar link. Copie manualmente: ',
        selfieLinkGenerateError: 'O link da selfie não foi gerado. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        selfieNeedSave: 'Cliente deve estar criado para gerar link de selfie.'
      },
      politicallyExposed: {
        question: 'Exerce ou exerceu cargo ou função relevante?',
        position: 'Cargo',
        positionCode: 'Código do cargo',
        practiceStart: 'Inicio do exercicio',
        practiceEnd: 'Fim do exercicio',
        publicAgency: 'Empresa ou orgão público',
        relationshipQuestion: 'Possui relacionamento com agente público?',
        relatedName: 'Nome completo do relacionado',
        relatedPosition: 'Cargo ou função',
        relationshipType: 'Tipo de relacionamento / Relação'
      },
      taxDomicile: {
        sectionTitle: 'Domicílio fiscal',
        introExternal: 'Informe todos os países onde você é residente fiscal. É o domicílio fiscal — não a nacionalidade — que define qual documento cada país exige.',
        introAdmin: 'Informe todos os países onde o cliente é residente fiscal. É o domicílio fiscal, não a nacionalidade que define qual documento cada país exige.',
        primaryLabel: 'Domicílio fiscal principal',
        additionalLabel: 'Domicílio fiscal adicional {index}',
        removeAriaLabel: 'Remover {label}',
        countryLabel: 'País',
        documentTypeLabel: 'Tipo de documento',
        addDomicile: 'Adicionar domicílio fiscal',
        addAnotherDomicile: 'Adicionar outro domicílio fiscal',
        fatcaAlertBefore: 'Domicílio fiscal nos Estados Unidos: o cadastro será reportado sob',
        fatcaAlertAfter: '(Foreign Account Tax Compliance Act).',
        crsAlertBefore: 'Domicílio fiscal fora do Brasil: o cadastro será reportado sob',
        crsAlertAfter: '(Common Reporting Standard).'
      },
      taxDomicileAbroad: {
        question: 'O cliente possui domicílio fiscal no exterior - FATCA ou CRS?',
        hint: 'FATCA: Foreign Account Tax Compliance Act. CRS: Common Reporting Standard.',
        countryLabel: 'País',
        identificationLabel: 'Número de identificação'
      },
      usPerson: {
        question: 'O cliente é cidadão americano?',
        itinLabel: 'Número ITIN'
      }
    },
    pj: {
      cover: {
        operationNature: 'Natureza da Operação',
        legalName: 'Razão Social',
        fantasyName: 'Nome Fantasia',
        formOfIncorporation: 'Forma de constituição',
        activitySector: 'Setor de atividade',
        mainActivity: 'Atividade principal',
        cnae: 'CNAE',
        numberOfEmployees: 'Qnt. de funcionários',
        annualGrossRevenue: 'Faturamento bruto anual',
        integratedSocialCapital: 'Capital social integralizado',
        assets: 'Patrimônio',
        foundingDate: 'Data da fundação',
        lastChangeDate: 'Data da última alteração',
        boardElectionDate: 'Data da eleição da diretoria',
        importTitle: 'Importar dados da Receita Federal?',
        importQuestion: 'Deseja importar os dados da Receita Federal para este CNPJ?',
        importSuccess: 'Dados importados com sucesso',
        importError: 'Não foi possível importar dados do CNPJ. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
        loadNaturesError: 'Não foi possível carregar as naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
      },
      contact: {
        landline: 'Telefone Fixo',
        website: 'Website',
        cellphone: 'Celular',
        email: 'E-mail',
        secondEmail: 'E-mail secundário'
      },
      address: {
        commercial: 'Endereço comercial',
        sameForDelivery: 'Usar o mesmo endereço para correspondência',
        delivery: 'Endereço de correspondência'
      },
      compliance: {
        importExportQuestion: 'Já realizou importação ou exportação anteriormente?',
        businessPurpose: 'Propósito da relação de negócios',
        radarModal: 'Modalidade do Radar:',
        paymentMode: 'Modalidade de Pagamento:',
        operatingMode: 'Informe o Modo Operante:',
        supplierLabel: 'Fornecedor {n}',
        productLabel: 'Produto {n}',
        productTypeLabel: 'Tipo de produto {n}',
        diLabel: 'DI {n}',
        diQuestion: 'Possui alguma DI registrada nos últimos 6 meses?',
        crimeQuestion: 'A empresa e/ou seus sócios respondem (ou responderam) por processo crime, inquérito policial e outras ocorrências ou circunstâncias análogas? Caso afirmativo, explique nas informações adicionais.',
        estimatedAmount: 'Montante Estimado Anual (US$)',
        additionalInfo: 'Informações adicionais'
      },
      documents: {
        noCountryWarning: 'Este cliente possui documentos sem país definido. Clique em "Definir país" nos documentos sinalizados para corrigir.',
        socialContractLabel: 'Contrato social / Estatuto social {n}',
        balancePgdasLabel: 'Balanço ou PGDAS (Declaração) {n}',
        signedNoticeHint: 'Obrigatório estar assinado pelo sócio e contador.',
        othersSection: 'Outros documentos',
        otherDescription: 'Outros'
      },
      directors: {
        fullName: 'Nome Completo',
        position: 'Cargo',
        termStartDate: 'Dt. inicial do mandato',
        termEndDate: 'Data final do mandato',
        addAnother: 'Adicionar outro'
      },
      responsible: {
        name: 'Nome',
        position: 'Cargo',
        email: 'Email',
        phone: 'Telefone'
      },
      wizardStep1: {
        initialInfoTitle: 'Informações iniciais',
        contactInfoTitle: 'Informações de Contato',
        addressTitle: 'Endereços'
      },
      partnerWizard: {
        titlePersonTypePJ: 'Pessoa Jurídica',
        titlePersonTypePF: 'Pessoa Física',
        titleAdd: 'Adicionar sócio',
        titleEdit: 'Editar sócio',
        titleFor: 'para {name}',
        loadingDefault: 'Carregando...',
        loadingSaving: 'Salvando dados do sócio...',
        stepBasicData: 'Dados básicos',
        stepAddress: 'Endereço',
        stepDocuments: 'Documentos',
        stepNestedPartners: 'Sócios do sócio',
        stepSummary: 'Resumo',
        btnBack: 'Voltar',
        btnCancel: 'Cancelar',
        btnSave: 'Salvar',
        btnNext: 'Próximo',
        personTypePF: 'Pessoa Física',
        personTypePJ: 'Pessoa Jurídica',
        foreignerLabel: 'Estrangeiro',
        linkedWarning: 'Cliente vinculado: só participação editável.',
        unlinkButton: 'Desvincular',
        nameLabel: 'Nome',
        passportLabel: 'Passaporte',
        birthDateLabel: 'Data de Nascimento',
        legalNameLabel: 'Razão Social',
        foundingDateLabel: 'Data de Fundação',
        cellphoneLabel: 'Celular',
        emailLabel: 'E-mail pessoal',
        shareLabel: '% de participação',
        taxTypeLabel: 'Tax Type',
        foreignTaxIdLabel: 'Tax ID Estrangeiro',
        validationShareNumber: 'Porcentagem deve ser um número válido',
        validationShareNegative: 'Porcentagem não pode ser negativa',
        validationShareMax: 'Porcentagem não pode ser maior que 100%',
        validationShareTotal: 'A soma total não pode ultrapassar 100%. Máximo permitido: {remaining}%',
        validationCpfCnpjDuplicate: 'Este CPF/CNPJ já está sendo usado por outro sócio',
        validationEmailDuplicate: 'Este e-mail já está sendo usado por outro sócio',
        missingDocsBefore: 'Preencha todos os documentos obrigatórios do sócio antes de continuar.',
        missingDocsList: 'Preencha todos os documentos obrigatórios do sócio: {list}.',
        foundByCpfBirthDate: 'Encontramos um cliente com este CPF e data de nascimento. Deseja vincular e preencher os dados automaticamente?',
        birthDateMismatch: 'A data de nascimento informada não corresponde à cadastrada para este CPF. Para corrigir, acesse a ficha do cliente vinculado e atualize a data de nascimento.',
        foundByCnpjFoundingDate: 'Encontramos um cliente com este CNPJ e data de fundação. Deseja vincular e preencher os dados automaticamente?',
        foundingDateMismatch: 'A data de fundação informada não corresponde à cadastrada para este CNPJ. Para corrigir, acesse a ficha do cliente vinculado e atualize a data de fundação.',
        linkedSuccess: 'Sócio vinculado a cliente existente',
        unlinkedSuccess: 'Vínculo removido e dados limpos.',
        summaryBasicData: 'Dados básicos',
        summaryAddress: 'Endereço',
        summaryNestedPartners: 'Sócios do sócio',
        summaryDocuments: 'Documentos',
        summaryNameLabel: 'Nome/Razão Social:',
        summaryCpfCnpjLabel: 'CPF/CNPJ:',
        summaryBirthDateLabel: 'Data de Nascimento:',
        summaryFoundingDateLabel: 'Data de Fundação:',
        summaryEmailLabel: 'E-mail:',
        summaryCellphoneLabel: 'Celular:',
        summaryShareLabel: 'Participação:',
        summaryNestedShare: 'Participação: {share}%',
        summaryDefaultPartnerName: 'Sócio',
        summaryDefaultDocName: 'Documento'
      },
      partnersShareholders: {
        colType: 'Tipo',
        colName: 'Nome/Razão Social',
        colCpfCnpj: 'CPF/CNPJ',
        colCellphone: 'Celular',
        colEmail: 'E-mail',
        colAddress: 'Endereço',
        colShare: '% Participação',
        nestedTitle: 'Sócios deste sócio',
        nestedAddPartner: 'Adicionar sócio',
        loading: 'Carregando...',
        noNestedPartners: 'Nenhum sócio cadastrado.',
        mobileNameLabel: 'Nome:',
        mobileCpfLabel: 'CPF:',
        mobileCnpjLabel: 'CNPJ:',
        mobileCellphone: 'Celular:',
        mobileEmail: 'E-mail:',
        mobileAddress: 'Endereço:',
        mobileShare: 'Participação:',
        addPartner: 'Adicionar sócio',
        linkPartner: 'Vincular sócio',
        linkModalTitle: 'Vincular sócio',
        linkShareLabel: '% de participação',
        messages: {
          deleteConfirm: 'Deseja realmente excluir este sócio?',
          createCustomerError: 'Não foi possível criar o cliente principal. Tente novamente.',
          partnerCreateError: 'O cadastro do sócio não foi criado. Confira os dados e tente novamente.',
          nestedPartnersSaveError: 'Os sócios desta empresa sócia não foram salvos. Confira os dados e tente novamente.',
          prepareError: 'Não foi possível preparar o cadastro do sócio. Confira os dados e tente novamente; se continuar, fale com o suporte.',
          shareSum: 'A soma das participações dos sócios deste sócio deve ser 100%. Atual: {value}%',
          partnerAdded: 'Sócio adicionado!',
          partnerUpdated: 'Sócio atualizado com sucesso!',
          nestedPartnerAdded: 'Sócio do sócio adicionado!',
          nestedPartnerUpdated: 'Sócio do sócio atualizado com sucesso!',
          nestedCreateError: 'Não foi possível criar o cadastro do sócio. Confira os dados e tente novamente; se continuar, fale com o suporte.',
          requiredFields: 'Por favor, preencha todos os campos obrigatórios.',
          alreadyLinked: 'Este cliente já está vinculado como sócio.',
          linkedSuccess: 'Sócio vinculado com sucesso!'
        }
      }
    }
  },
  paymentMethods: {
    common: {
      routingNumber: 'Número de roteamento',
      routingNumberAba: 'Número de roteamento (ABA)',
      accountType: 'Tipo de conta',
      accountNumber: 'Número da conta',
      beneficiaryName: 'Nome do beneficiário',
      beneficiaryRelationship: 'Relacionamento com o beneficiário',
      relationship: 'Relacionamento',
      beneficiaryAddressTitle: 'Endereço do beneficiário',
      postalCode: 'CEP/Código postal',
      country: 'País',
      stateProvinceRegion: 'Estado/Província/Região',
      city: 'Cidade',
      addressLine1: 'Endereço linha 1',
      addressLine2: 'Endereço linha 2',
      ffc: 'FFC',
      swiftBic: 'Código Swift / BIC',
      swiftBicPlaceholder: 'Digite o código Swift/BIC (ex: CHASUS33XXX)',
      maxTwoChars: 'Máximo de 2 caracteres',
      invalidUsState: 'Use a sigla do estado nos EUA (ex.: FL, NY, CA)'
    },
    achColombia: {
      accountTypeRequired: 'Tipo de conta *',
      accountNumberRequired: 'Número da conta *',
      bankCode: 'Código do banco *',
      beneficiaryFirstName: 'Primeiro nome do beneficiário *',
      beneficiaryLastName: 'Sobrenome do beneficiário *',
      documentId: 'ID do documento *',
      documentType: 'Tipo de documento *',
      email: 'Email *'
    },
    wire: {
      routingNumberRequired: 'Número de roteamento é obrigatório',
      routingNumberNineDigits: 'Número de roteamento deve ter exatamente 9 dígitos',
      documentId: 'Número do documento',
      documentIdRequired: 'Número do documento *'
    },
    sepa: {
      ibanLabel: 'IBAN *',
      bicSwift: 'BIC / SWIFT *',
      beneficiaryCountry: 'País do beneficiário *',
      postalCode: 'Código postal *',
      businessBlockedWarning: 'Este país não aceita pagamentos SEPA para contas empresariais. Altere o tipo de conta para "Individual" ou utilize SWIFT Internacional.',
      ibanMinMaxChars: 'IBAN deve ter entre 15 e 34 caracteres',
      ibanInvalidFormat: 'Formato de IBAN inválido',
      ibanCountryMismatch: 'Este IBAN é de outro país ({ibanCountry}). Para uma conta em {countryName}, o IBAN precisa começar com "{beneficiaryCountry}".'
    },
    fasterPayments: {
      sortCode: 'Sort code *',
      sortCodeHint: 'Código de 6 números da agência no Reino Unido',
      sortCodeInvalid: 'O sort code tem {digits} números (ex.: 20-00-00)',
      accountNumber: 'Número da conta *',
      accountNumberHint: 'Número da conta no Reino Unido, com 8 números',
      accountNumberInvalid: 'O número da conta tem {digits} números',
      beneficiaryCountry: 'País do beneficiário *',
      postalCode: 'Código postal'
    },
    spei: {
      protocol: 'Protocolo *',
      clabeLabel: 'Número da conta / CLABE *',
      clabePlaceholder: '18 dígitos (ex: 014027000005555558)',
      debitCardLabel: 'Número do cartão de débito *',
      debitCardPlaceholder: '16 dígitos (ex: 4152314189639159)',
      phoneNumLabel: 'Número de telefone *',
      phoneNumPlaceholder: 'Ex: 5512345678',
      institutionCodeRequired: 'Código da instituição *',
      institutionCode: 'Código da instituição',
      beneficiaryName: 'Nome do beneficiário *'
    },
    swift: {
      accountIban: 'Número da conta / IBAN',
      confirmAccountIban: 'Confirmar número da conta / IBAN',
      accountsMustMatch: 'Os números da conta devem ser iguais',
      beneficiaryNameTitle: 'Nome do beneficiário / Titular da conta',
      swiftPaymentCode: 'Código de pagamento SWIFT',
      ifscBranch: 'IFSC da agência',
      ifscHint: '11 caracteres, como ICIC0005023',
      beneficiaryAddressTitle: 'Endereço do beneficiário',
      bankAddressTitle: 'Endereço do banco',
      addressLinesHint: 'Linhas 1 e 2 juntas: {current} de {limit} caracteres',
      cityMaxLength: 'A cidade pode ter no máximo {limit} caracteres',
      addressLinesMaxLength: 'As linhas 1 e 2 do endereço juntas podem ter no máximo {limit} caracteres',
      ifscRequired: 'Informe o IFSC da agência do banco na Índia',
      ifscFormat: 'O IFSC tem 11 caracteres: 4 letras do banco, um zero e 6 da agência (ex.: ICIC0005023)',
      maxTwoChars: 'Máximo de 2 caracteres'
    },
    bankAddress: {
      title: 'Endereço do banco (opcional)',
      hint: 'Endereço do banco que recebe (ex.: a agência nos EUA). Com ele preenchido, a conta passa a ter mais opções de envio; sem ele, continua funcionando normalmente.'
    },
    bankAccountHeader: {
      displayName: 'Nome de exibição',
      displayNameHint: 'Ex: Conta principal pessoal',
      bankName: 'Nome do banco',
      beneficiaryName: 'Nome do beneficiário *',
      accountClass: 'Classe da conta'
    },
    intermediary: {
      checkboxLabel: 'Cadastrar banco intermediário',
      bankName: 'Nome do banco intermediário',
      swiftAba: 'Código SWIFT/ABA'
    },
    business: {
      sectionTitle: 'Dados empresariais (obrigatórios para conta empresarial)',
      industry: 'Setor de atuação (NAICS) *',
      taxId: 'Identificação fiscal (Tax ID)',
      taxIdHint: 'Formato SSN/ITIN: XXX-XX-XXXX',
      phone: 'Telefone *',
      taxIdInvalid: 'Tax ID deve ter 9 dígitos (formato SSN/ITIN: XXX-XX-XXXX)'
    },
    transfers3: {
      accountTypeCvuCbu: 'Tipo de conta (CVU/CBU) *',
      accountNumberPlaceholder: '22 dígitos',
      accountNumber: 'Número da conta *',
      beneficiaryName: 'Nome do beneficiário *'
    }
  },
  sendDocuments: {
    stepFooter: {
      advance: 'Avançar',
      back: 'Voltar',
      cancel: 'Cancelar',
      sendToBank: 'Enviar ao Banco',
      cancelSend: 'Cancelar envio'
    },
    stepCustomerDocs: {
      noDocuments: 'Não há documentos'
    },
    stepPartnersDocs: {
      share: 'Participação: {share}%',
      nestedPartnerNoProfile: 'Sócio aninhado sem cadastro completo',
      noDocumentsForPartner: 'Nenhum documento encontrado para este sócio',
      partnerNoProfile: 'Sócio não possui cadastro completo',
      partnerNoProfileDesc: 'Para enviar documentos deste sócio, é necessário completar seu cadastro como cliente no sistema.',
      noPartners: 'Nenhum sócio cadastrado',
      noPartnersDesc: 'Este cliente não possui sócios ou acionistas cadastrados.',
      nestedPartnersTitle: 'Sócios deste sócio'
    },
    stepOperationalDocs: {
      noDocuments: 'Não há documentos complementares'
    },
    stepSummary: {
      complementaryInfo: 'Informações complementares',
      customerDocs: 'Documentos do cliente',
      noneSelected: 'Nenhum selecionado',
      operationalDocs: 'Documentos complementares',
      partnersDocs: 'Documentos dos sócios',
      nestedPartnersTitle: 'Sócios deste sócio'
    },
    resetTosTitle: 'Reiniciar cadastro no banco?',
    resetTosMessage: 'O cadastro deste cliente foi recusado pelo banco. Deseja reiniciar o processo de aceite dos termos de serviço?',
    resetTosPrimary: 'Sim, reiniciar',
    resetTosSecondary: 'Não, apenas salvar',
    pendingLimitTitle: 'Progressão de limite em andamento',
    pendingLimitSubtitle: 'É necessário realizar contato com o banco para prosseguir com a progressão de cadastro.'
  },
  formOperation: {
    bankFlowTableUi: {
      brlSettlement: 'Reais'
    },
    digitalRemittanceQuotationProgressUi: {
      analyzingTitle: 'Analisando os dados da sua operação',
      analyzingSubtitle: 'Isso leva só alguns segundos',
      comparingTitle: 'Comparando os caminhos disponíveis',
      comparingSubtitle: 'Consultando nossos parceiros de pagamento',
      choosingTitle: 'Escolhendo o melhor caminho para você',
      choosingSubtitle: 'Considerando moeda, forma de pagamento e valor',
      calculatingTitle: 'Calculando a sua cotação',
      calculatingSubtitle: 'Conferindo taxas e valores',
      extendedTitle: 'Estamos analisando as melhores opções para a sua operação',
      extendedSubtitle: 'Escolhendo o melhor parceiro de pagamento para você'
    },
    shipmentPostponeValidationUi: {
      required: 'Campo obrigatório.',
      maxLength: 'Máximo de 200 caracteres.',
      invalidFormat: 'Formato não permitido. Aceitos: PDF, JPG, PNG.',
      fileTooLarge: 'Arquivo excede o tamanho máximo de 10 MB.',
      selectStage: 'Selecione o estágio da mercadoria.',
      expectedDateRequired: 'Data prevista é obrigatória.',
      expectedDateFuture: 'Data prevista deve ser posterior ao dia atual.',
      observationMaxLength: 'Observação deve ter no máximo 200 caracteres.',
      attachmentRequired: 'Anexo obrigatório.'
    },
    importDocumentsUi: {
      duimpSaveError: 'Não foi possível salvar documento DUIMP/DU-E. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      invoiceSaveError: 'Não foi possível salvar documento de Invoice. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      bankingProductSaveError: 'Não foi possível salvar documento de produto bancário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      savedRowNotFound: '{message} Linha salva não encontrada.'
    },
    authorizationDocumentModalUi: {
      documentTypeLabel: 'Tipo de Documento *'
    },
    customerOperationalDocumentsUi: {
      documentsLabel: 'Documentos'
    },
    digitalRemittanceProfitCardUi: {
      approximateProfit: 'Lucro aproximado',
      fillHintStart: 'Preencha os dados à esquerda e clique em',
      fillHintEnd: 'para ver o resultado aqui.',
      contractor: 'Contratante',
      contractorProfit: 'Lucro {name}'
    },
    digitalRemittanceQuotationResultUi: {
      renewing: 'Renovando cotação',
      expired: 'Cotação expirada',
      expiresIn: 'Expira em {time}',
      balanceUnavailable: 'Não foi possível consultar o saldo da carteira agora. O pagamento só é enviado se o saldo cobrir o valor.',
      walletBalance: 'Saldo na carteira:',
      afterPayment: 'Depois deste pagamento:',
      insufficientBalance: 'O saldo da carteira não cobre este pagamento. Reduza o valor ou faça antes uma entrada na aba Pay-in.',
      transferFee: 'Taxa de transferência:',
      commercialRate: 'Câmbio comercial',
      providerRate: 'Câmbio {bank}',
      linkSentEmail: 'Valores enviados ao cliente às {time}. O valor final é o que o cliente confirmar no link.',
      linkSentNoEmail: 'Link gerado às {time}, mas o e-mail não foi enviado. Envie o link ao cliente pelo WhatsApp.',
      walletOut: 'Sai da carteira do cliente',
      clientPays: 'Cliente paga'
    },
    operationRemittanceUi: {
      nationalAccountItem: 'Banco: {bank} - Agência: {agency} - Conta: {account} - Dígito: {digit}',
      foreignAccountItem: '{name} - Banco: {bank} - IBAN: {iban} - Código Swift/BIC: {swift} - Número ABA/Routing: {routing}',
      brazilAccount: 'Conta Brasil',
      foreignAccount: 'Conta exterior',
      noPaymentAccount: 'Este cliente não possui conta de pagamento cadastrada para este banco',
      noIntegratedAccount: 'Este cliente não tem conta no exterior aprovada neste banco. Integre uma conta no cadastro do cliente para operar.',
      noWireAccount: 'Você não possui contas no exterior do tipo WIRE'
    },
    duimpExternalAccessUi: {
      backToSelection: 'Voltar à seleção',
      operationNotFound: 'Operação não encontrada.'
    },
    formOperationUi: {
      outOfHoursDescription: 'O horário para realizar operações online é de segunda a sexta, das {min}h às {max}h',
      editCustomer: 'Editar cliente',
      selectOtherBank: 'Selecione outro banco ou tente novamente mais tarde.',
      manualQuotationNotice: 'Cotação manual: o negócio não será fechado no {bankName} pelo sistema. Feche a ordem diretamente com o {bankName}.',
      lockFailed: 'Não foi possível bloquear esta pré-venda. Tente novamente ou aguarde alguns instantes.',
      lockExpired: 'O bloqueio desta pré-venda expirou. A página será recarregada.'
    },
    digitalRemittance: {
      quotationError: 'Não foi possível gerar a cotação',
      paymentError: 'Não foi possível gerar o pagamento',
      comingSoon: 'Em breve',
      amountClearedForCurrency: 'O valor foi apagado porque aqui ele é em {currency}. Digite de novo.',
      operationDataTitle: 'Dados da operação',
      walletOriginLabel: 'Sai de',
      walletStablecoinValue: 'Stablecoin na carteira do cliente',
      useFullBalance: 'Usar saldo total',
      senderCurrencyLabel: 'Moeda origem',
      destinationCurrencyLabel: 'Moeda destino *',
      destinationCurrencyHint: 'Em que moeda a conta recebe',
      noCurrencyAvailable: 'Nenhuma moeda disponível para este cliente',
      paymentMethodLabel: 'Forma de pagamento',
      paymentMethodHint: 'Como o cliente envia o dinheiro',
      spreadLabel: 'Spread *',
      corbanLabel: 'Corban',
      bankAccountLabel: 'Conta bancária *',
      noBankAccountForCurrency: 'Nenhuma conta deste cliente recebe nesta moeda',
      addInternationalAccount: 'Adicionar conta no exterior',
      pendingAccountsTitle: 'Contas ainda não ativas para stablecoin',
      pendingAccountsText: 'Sincronize em Canais bancários, no cadastro do cliente, para usar estas contas.',
      openBankChannels: 'Abrir Canais bancários',
      accountHolder: 'Titular',
      copyAccountData: 'Copiar dados da conta',
      routingOptionsFailed: 'Não foi possível consultar as moedas e contas disponíveis para este cliente.',
      retryButton: 'Tentar de novo',
      noPayoutOption: 'Este cliente ainda não pode receber pagamentos. Conclua o cadastro DolsPay dele em Bancos e Limites, no cadastro do cliente.',
      transactionDocumentType: 'Tipo de documento *',
      transactionDocumentId: 'Número do documento *',
      transactionDocumentFile: 'Arquivo do documento *',
      fileUploaded: 'Arquivo enviado',
      flowSoonTitle: '{label} em breve',
      flowSoonText: 'Este fluxo ainda não está disponível nesta tela. Para operar agora, use a aba Fiat to Fiat.',
      approvalLinkLabel: 'Link para o cliente',
      payOutSentTitle: 'Pagamento enviado',
      payOutSentText: 'O valor saiu da carteira do cliente para a conta {account}. A operação aparece como Liquidada, com o comprovante, assim que o pagamento for confirmado.',
      newPayment: 'Novo pagamento',
      generateQuotation: 'Gerar cotação',
      newQuotation: 'Nova cotação',
      newOperation: 'Nova operação',
      goToPresale: 'Ir para pré-venda',
      payinOnlyReceives: 'Recebe',
      partnerFeeNoDataEntry: 'Nenhum spread com percentual de entrada',
      partnerFeeNoDataExit: 'Nenhum spread com percentual de saída',
      partnerFeeNoDataCorbanRange: 'Nenhum spread disponível para corban. Fale com o administrador.',
      partnerFeeNoData: 'Nenhum spread cadastrado',
      amountHintWalletOut: 'O valor é o que sai da carteira do cliente; as taxas saem dele',
      amountHintDestination: 'O valor é o que chega na conta',
      amountHintWalletIn: 'O valor é o que entra na carteira do cliente',
      walletStablecoinName: 'USDC na carteira',
      walletStablecoinShort: 'na carteira',
      amountHintCustomerPays: 'O valor é o que o cliente paga',
      senderCurrencyHintSingle: 'Única opção para este cliente',
      senderCurrencyHintDefault: 'Em que moeda o cliente paga',
      fieldRequired: 'Campo obrigatório',
      descriptionRequiredForWire: 'Descrição é obrigatória para contas Wire',
      documentFileRequired: 'Arquivo do documento é obrigatório',
      descriptionRequired: 'Descrição *',
      descriptionOptional: 'Descrição (opcional)',
      descriptionHintPayoutDestination: 'Vai junto com o pagamento para o banco do beneficiário',
      descriptionHintFiatDestination: 'Aparece no contrato de câmbio e na transferência ao banco do beneficiário',
      descriptionHintWire: '{base} (obrigatória para contas Wire)',
      activeForStablecoin: 'Ativas para stablecoin',
      accountDetail_tipo: 'Tipo',
      accountDetail_banco: 'Banco',
      accountDetail_swiftBic: 'Swift/BIC',
      accountDetail_abaRouting: 'ABA/Routing',
      accountDetail_iban: 'IBAN',
      accountDetail_conta: 'Conta',
      accountDetail_tipoConta: 'Tipo de conta',
      accountDetail_titular: 'Titular',
      modalInitError: 'A tela de operação não abriu. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      accountDataCopied: 'Dados da conta copiados.',
      saveInternationalBankError: 'A conta no exterior não foi salva. Confira os dados bancários do beneficiário e tente novamente.',
      quotationRenewedWarning: 'A cotação tinha vencido e foi renovada. Confira os valores e gere o pagamento.',
      quotationNotRenewed: 'A cotação não foi renovada: {errorMessage}. Clique em Nova cotação para gerar outra.',
      documentUploadSuccess: 'Documento enviado com sucesso!',
      documentUploadError: 'O documento não foi enviado. Confira se o arquivo é PDF, JPG ou PNG e tente novamente; se continuar, fale com o suporte.',
      quotationDataCopied: 'Dados da cotação copiados!',
      quotationCopyError: 'Os dados não foram copiados. Selecione o texto e copie manualmente (Ctrl+C).',
      generateQuotationFirst: 'Gere uma cotação primeiro',
      quotationNotGenerated: 'Cotação não gerada. Gere uma cotação primeiro.',
      noNatureFound: 'Natureza da operação não encontrada para este banco',
      quotationUnavailable: 'A cotação não está mais disponível. Gere uma nova cotação para continuar.',
      preSaleNotSaved: 'A pré-venda não foi salva. Clique em Nova cotação e tente de novo.',
      payInDataForPayment: 'os dados para pagamento',
      payInPix: 'o PIX',
      generateDataError: 'Não foi possível gerar {what}: {errorMessage}',
      preSaleNotSavedRetry: 'A pré-venda não foi salva. Confira os dados da operação e tente novamente.',
      paymentSentSuccess: 'Pagamento enviado. A operação aparece como Liquidada assim que o pagamento for confirmado.',
      paymentSendError: 'Não foi possível enviar o pagamento: {payInError}',
      paymentConfirmedSuccess: 'Pagamento confirmado com sucesso!',
      paymentNotConfirmedForeign: 'O pagamento não foi confirmado. Crie uma nova operação para gerar novos dados de pagamento.',
      pixExpiredNotConfirmed: 'O PIX expirou e o pagamento não foi confirmado. Crie uma nova operação para gerar outro QR Code.',
      loadOperationDataError: 'Os dados da operação não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      setCorbanAutoError: 'O corban do cliente não foi preenchido automaticamente. Escolha um manualmente.',
      loadNatureWarning: 'Não foi possível carregar a natureza da operação. A natureza padrão de remessa digital foi aplicada.',
      bankSavedReady: 'Conta no exterior cadastrada e pronta para operar!',
      bankSavedProcessing: 'Conta cadastrada. Ela está sendo registrada para operar e fica disponível em instantes; se não ficar, recarregue a página.',
      loadSpreadsError: 'Não foi possível carregar os spreads. Recarregue a página e tente de novo.',
      loadBankAccountsError: 'Não foi possível carregar as contas bancárias do cliente. Recarregue a página e tente de novo.',
      loadCorbansError: 'A lista de corbans não carregou. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      fillRequiredFields: 'Preencha todos os campos obrigatórios corretamente',
      chooseBankAccountForCurrency: 'Escolha uma conta bancária que receba nesta moeda.',
      quotationRenewFailed: 'Não foi possível renovar a cotação. Gere uma nova manualmente.'
    },
    duimpItemCard: {
      accessKey: 'Chave de acesso',
      value: 'Valor',
      uploadInstruction: 'Escolha um arquivo ou arraste e solte aqui',
      downloadDocument: 'Baixar documento',
      removeFile: 'Remover arquivo',
      removeDuimp: 'Remover DUIMP/DU-E',
      addDuimp: 'Adicionar DUIMP/DU-E'
    },
    duimpExternal: {
      successTitle: 'Enviado com sucesso',
      successMessage: 'Sua informação foi registrada. Obrigado por manter sua operação em dia.',
      operationTitle: 'Operação #{id}',
      nature: 'Natureza',
      currency: 'Moeda',
      value: 'Valor',
      supplier: 'Fornecedor',
      duimpStatus: 'Status DUIMP',
      operationDate: 'Data da operação',
      originDestination: 'Origem / Destino',
      lastDuimpInserted: 'Última inserção DUIMP',
      existingDuimps: 'DUIMP/DU-E já enviados',
      shipmentHistory: 'Histórico de embarque',
      accessKey: 'Chave de acesso',
      insertedAt: 'Inserido em',
      noDoc: 'Sem doc.',
      shipmentStageTitle: 'Estágio da mercadoria',
      estimatedShippingDate: 'Data prevista de embarque:',
      shipmentStageLabel: 'Estágio da mercadoria',
      estimatedDate: 'Data prevista',
      blAwbUpload: 'BL/AWB — Escolha um arquivo ou arraste e solte aqui',
      observation: 'Observação',
      submitShipment: 'Informar estágio',
      limitAlert: 'Limite máximo de {max} protocolos atingido para esta operação.',
      addDuimpTitle: 'Adicionar DUIMP/DU-E',
      submitDuimp: 'Enviar DUIMP/DU-E',
      removeFile: 'Remover arquivo',
      downloadDocument: 'Baixar documento',
      accessKeyRequired: 'Chave de acesso obrigatória.',
      accessKeyMaxLength: 'Máximo de 40 caracteres.',
      valueRequired: 'Valor obrigatório',
      valueExceeds: 'Valor ultrapassa o pendente de {prefix}{value}',
      fileRequired: 'Anexo obrigatório.',
      exceedsMessage: 'O valor informado ultrapassa o pendente de {prefix}{value}',
      shipmentSuccess: 'Estágio da mercadoria registrado com sucesso.',
      shipmentError: 'Não foi possível registrar estágio. Tente novamente.',
      duimpSuccess: 'DUIMP/DU-E enviado com sucesso!',
      duimpError: 'Não foi possível enviar DUIMP/DU-E. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      downloadError: 'Não foi possível baixar o documento. Tente baixar novamente; se continuar, fale com o suporte.',
      operationObservationLabel: 'Observação da operação'
    },
    invoiceManager: {
      title: 'Gerenciar Invoices',
      invoiceNumber: 'Nº da Invoice',
      invoiceDate: 'Data da Invoice',
      shippingForecast: 'Previsão de embarque',
      uploadInstruction: 'Escolha um arquivo ou arraste e solte aqui',
      downloadDocument: 'Baixar documento',
      removeFile: 'Remover arquivo',
      removeInvoice: 'Remover invoice',
      addInvoice: 'Adicionar invoice',
      saveError: 'Não foi possível salvar invoices. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      saveDocError: 'Não foi possível salvar documento de Invoice. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      downloadError: 'Não foi possível baixar o documento. Tente baixar novamente; se continuar, fale com o suporte.'
    },
    liquidationSelect: {
      receivingFlow: 'Fluxo de recebimento',
      paymentFlow: 'Fluxo de pagamento',
      liquidationME: 'Liquidação ME',
      liquidationBRL: 'Liquidação BRL',
      holiday: 'Feriado',
      cutoffHint: '⏱ {countdown} para encerrar D+0',
      holidayHint: 'Feriado: {name}',
      required: 'Este campo é obrigatório'
    },
    operationDocumentCard: {
      descriptionPlaceholder: 'Digite o nome do documento',
      typePlaceholder: 'Tipo',
      selectTypeError: 'Selecione o tipo do documento',
      addDocument: 'Adicionar documento',
      removeDocument: 'Remover documento'
    },
    operationBasicInfo: {
      customerLabel: 'Cliente / CPF / CNPJ',
      cityLabel: 'Cidade',
      natureLabel: 'Natureza',
      bankLabel: 'Banco',
      stablecoinSubtitle: 'Operações em stablecoins',
      limitPrefix: 'Limite',
      expiresPrefix: 'Expira em',
      sellOperation: 'Venda/Saída',
      buyOperation: 'Compra/Entrada',
      alertExchangeBuy: 'Seu cliente está vendendo moeda estrangeira',
      alertExchangeSell: 'Seu cliente está comprando moeda estrangeira',
      alertPayIn: 'Seu cliente está comprando stablecoin, que fica na carteira dele',
      alertPayout: 'Seu cliente está enviando stablecoin da carteira dele para a conta de destino',
      duimpPendingTitle: 'Pendências de DUIMP/DU-E',
      duimpPendingText: 'O cliente possui DUIMP/DU-E com mais de 60 dias sem atualização.',
      duimpPendingLink: 'Acesse a Gestão de DUIMP/DU-E',
      noPaymentAccount: 'Este cliente não possui conta de pagamento cadastrada para este banco',
      noCorban: 'Esse cliente não possui um corban!',
      errorLoadCustomers: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.',
      errorLoadBanks: 'Não foi possível carregar os bancos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadTurismoBanks: 'Não foi possível carregar os bancos de câmbio turismo do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      natureLabelReadonly: 'Natureza'
    },
    operationBankAccount: {
      titleInternational: 'Conta Bancária Internacional',
      titleBrazil: 'Conta Bancária do Brasil',
      bank: 'Banco',
      iban: 'IBAN',
      swiftBic: 'Código Swift/BIC',
      abaRouting: 'Número ABA/Routing',
      ownerName: 'Nome do titular',
      ffc: 'FFC',
      intermediaryCountry: 'País Intermediário',
      intermediaryBank: 'Banco Intermediário',
      intermediaryAbaRouting: 'ABA/Routing Intermediário',
      agency: 'Agência',
      account: 'Conta',
      digit: 'Dígito',
      pix: 'PIX'
    },
    operationExchange: {
      bankLabel: 'Banco',
      storeLabel: 'Loja',
      natureLabel: 'Natureza',
      deliveryTypeLabel: 'Forma de entrega',
      amountLabel: 'Quantidade ME',
      customerRateLabel: 'Taxa do cliente',
      spreadLabel: 'Spread',
      profitLabel: 'Lucro',
      deliveryCostLabel: 'Custo de Entrega',
      deliveryDatePickupLabel: 'Data de retirada',
      deliveryDateDeliveryLabel: 'Data de entrega',
      deliveryTimeLabel: 'Período',
      travelDateLabel: 'Data de Viagem',
      destinationCountryLabel: 'País de Destino',
      customerAccountLabel: 'Conta cliente',
      bankAccountLabel: 'Conta banco',
      observationLabel: 'Observações',
      corbanLabel: 'Corban',
      noCorban: 'Esse cliente não possui um corban!',
      paymentMethodLabel: 'Forma de pagamento',
      itemTextAccount: 'Banco: {bank} - Agência: {agency} - Conta: {account}',
      errorLoadDeliveryTypes: 'Não foi possível carregar os tipos de entrega. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadDeliveryTimes: 'Não foi possível carregar os horários de entrega. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorbans: 'Não foi possível carregar a lista de correspondentes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadPaymentMethods: 'Não foi possível carregar as formas de pagamento. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCustomer: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadExchangeBanks: 'Não foi possível carregar os bancos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSearchCustomers: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.',
      cashPaymentWarning: 'Pagamento em dinheiro precisa ser retirado em loja'
    },
    operationMessages: {
      loadConfigError: 'Não foi possível carregar configurações. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      userNotConfigured: 'O seu usuário não está configurado para operar, por favor, entre em contato com o responsável pelo sistema.',
      loadOperationTypesError: 'Não foi possível carregar os tipos de operação liberados para o seu usuário. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadPreSaleError: 'Não foi possível carregar os dados da pré-venda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      operationHourError: 'Não foi possível {action}. Por favor, tente novamente dentro do horário de funcionamento ({start}h às {end}h)',
      createOperationHourError: 'Não foi possível criar a operação. Por favor, tente novamente dentro do horário de funcionamento ({start}h às {end}h)',
      createPreSaleHourError: 'Não foi possível criar a pré-venda. Por favor, tente novamente dentro do horário de funcionamento ({start}h às {end}h)',
      natureRequired: 'Informe a natureza da operação.',
      duimpOverflow: 'A soma dos valores DUIMP/DU-E não pode ser maior que a quantidade em M.E. da operação.',
      copyMessageError: 'Não foi possível copiar a mensagem. Verifique as permissões do navegador.',
      bankDisabledWithDesc: 'Este banco não está habilitado para operações: {description}',
      bankDisabledDefault: 'Este banco não está habilitado para operações no momento.',
      operationSaved: 'Operação salva com sucesso!',
      operationSavedWithWarning: 'Operação salva. {warning}',
      bankQuotationError: 'Não foi possível cotar no {bankName}. Tente atualizar a cotação.',
      bankNoFlows: 'O {bankName} não cotou nenhum fluxo de liquidação agora. Atualize a cotação ou tente mais tarde.',
      loadCustomerError: 'Não foi possível carregar os dados do cliente da operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadBanksError: 'A lista de bancos não carregou. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadNaturesError: 'Não foi possível carregar a natureza da operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCurrenciesError: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      emailClosingError: 'Não foi possível enviar o e-mail de fechamento da operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailIndicationError: 'Não foi possível enviar o e-mail de ciência da indicação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailIndicationExchangeError: 'Não foi possível enviar o e-mail de ciência da indicação da operação de câmbio. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailPixError: 'Não foi possível enviar o e-mail de retirada por PIX da compra de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailCashError: 'Não foi possível enviar o e-mail de retirada em espécie da compra de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      preSaleSaved: 'Pré-venda salva com sucesso!',
      preSaveSaveError: 'Não foi possível salvar a pré-venda. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      preSaleUpdateSaved: 'Pré-venda salva com sucesso!',
      preSaleUpdateError: 'Não foi possível salvar as alterações da pré-venda. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      documentsError: 'A operação foi salva, mas não foi possível anexar os documentos. Abra a operação, confira os documentos e anexe de novo o que faltar; se continuar, fale com o suporte.',
      saveOperationError: 'Não foi possível salvar a operação. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      generateWithdrawalError: 'Não foi possível gerar autorização de retirada. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      generateWithdrawalMissingData: 'A autorização de retirada não foi gerada: faltam dados de quem vai receber a moeda. Complete na operação e gere pela aba de documentos.',
      generateWithdrawalSuccess: 'Autorização de retirada gerada automaticamente!',
      emailSellPix: 'Não foi possível enviar o e-mail de retirada por PIX da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailSellCash: 'Não foi possível enviar o e-mail de retirada em espécie da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailSellCard: 'Não foi possível enviar o e-mail de retirada no cartão da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailSellDeliveryPix: 'Não foi possível enviar o e-mail de entrega por PIX da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankBuyPix: 'Não foi possível enviar o e-mail ao banco de retirada por PIX da compra de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankBuyCash: 'Não foi possível enviar o e-mail ao banco de retirada em espécie da compra de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankSellPix: 'Não foi possível enviar o e-mail ao banco de retirada por PIX da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankSellCash: 'Não foi possível enviar o e-mail ao banco de retirada em espécie da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankSellCard: 'Não foi possível enviar o e-mail ao banco de retirada no cartão da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      emailBankSellDeliveryPix: 'Não foi possível enviar o e-mail ao banco de entrega por PIX da venda de moeda. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    operationRemittance: {
      stablecoinHint: 'Operações em stablecoins',
      corbanLabel: 'Corban',
      observationLabel: 'Observações',
      countryLabel: 'País',
      addForeignAccountTooltip: 'Adicionar conta no exterior',
      addNationalAccountTooltip: 'Adicionar conta no Brasil',
      copyForeignAccountTooltip: 'Copiar informações da conta no exterior',
      copyNationalAccountTooltip: 'Copiar informações da conta no Brasil',
      foreignAccountLabel: 'Conta no exterior',
      nationalAccountLabel: 'Conta no Brasil',
      foreignAccountSectionTitle: 'Conta bancária no exterior - {name}',
      brazilAccountSectionTitle: 'Conta bancária do Brasil',
      fieldBank: 'Banco',
      fieldIban: 'IBAN',
      fieldSwift: 'Código Swift/BIC',
      fieldRouting: 'Número ABA/Routing',
      fieldFfc: 'FFC',
      fieldHolder: 'Nome do titular',
      fieldAgency: 'Agência',
      fieldAccount: 'Conta',
      fieldDigit: 'Digito',
      fieldIntermediaryTitle: 'Banco intermediário',
      fieldIntermediaryCountry: 'País',
      fieldIntermediaryBank: 'Banco',
      fieldIntermediaryRouting: 'ABA/Routing',
      amountHintBrl: 'Total da operação em reais (BRL).',
      amountHintForeign: 'Quantidade em moeda estrangeira ({code}).',
      amountHintForeignNoCode: 'Quantidade em moeda estrangeira.',
      errorLoadCustomer: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadExchangeBanks: 'Não foi possível carregar os bancos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorSearchCustomers: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.',
      errorLoadCurrencies: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorbans: 'Não foi possível carregar a lista de correspondentes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadCorrespondente: 'Não foi possível carregar o correspondente do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      copyInfoError: 'Não foi possível copiar informações. Tente novamente.'
    },
    digitalRemittanceBankSelect: {
      hint: 'Apenas bancos digitais (stablecoins)',
      label: 'Banco',
      requiredValidation: 'Campo obrigatório',
      loadBanksError: 'Não foi possível carregar os bancos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    digitalRemittanceClienteSelect: {
      loadClientsError: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.'
    },
    digitalRemittanceClienteBanco: {
      loadClientError: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    finishOperationModal: {
      title: 'Fechamento de operação',
      cardOperationTitle: 'Operação',
      cardTaxesTitle: 'Tributos e custos',
      labelTotal: 'TOTAL',
      labelBankRate: 'Taxa do banco',
      labelQuotation: 'COTAÇÃO',
      labelCurrency: 'M.E.',
      labelAmountCurrency: 'VALOR M.E.',
      labelCustomerRate: 'TAXA DO CLIENTE',
      labelIof: 'IOF',
      labelTariff: 'TARIFA',
      labelVet: 'VET',
      btnCopyBank: 'Copiar simulação do banco',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      copiedSuccess: 'Simulação do banco copiada.',
      templateNotConfigured: 'Template não configurado. Acesse Configurações > Mensagem de Operação.',
      copyError: 'Não foi possível copiar a mensagem. Selecione o texto e copie manualmente (Ctrl+C).'
    },
    bankRateModal: {
      title: 'Fechar negócio',
      bankRateLabel: 'Taxa do banco',
      btnCopy: 'Copiar simulação',
      btnConfirm: 'Fechar negócio'
    },
    returnToCustomerModal: {
      title: 'Devolvida ao cliente',
      alertText: 'Use quando o pagamento do cliente foi devolvido na conta dele e a saída não vai acontecer. A operação fica encerrada, o sistema para de tentar a saída e a comissão não é paga. Essa ação não pode ser desfeita.',
      amountLabel: 'Valor devolvido ao cliente',
      reasonLabel: 'Motivo',
      btnConfirm: 'Confirmar devolução',
      btnCancel: 'Voltar',
      validationAmount: 'Informe o valor devolvido.',
      validationReasonMin: 'Informe o motivo da devolução.',
      validationReasonMax: 'Máximo de {max} caracteres.'
    },
    operationPreview: {
      summaryTitle: 'Resumo',
      manualRateLabel: 'Inserir cotação manualmente',
      timerNeedsData: 'Informe valor e fluxo de liquidação para cotar no {bankName}',
      timerFrozen: 'Operação congelada',
      timerUpdating: 'Atualizando...',
      timerCountdown: 'Atualizando em {seconds}s',
      errorLoadQuotation: 'Não foi possível carregar a cotação da moeda. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorLoadDollar: 'Não foi possível carregar a cotação do dólar. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      errorBankQuotation: 'Não foi possível cotar no {bankName}. Tente novamente.'
    },
    operationPreviewShared: {
      spotLabel: 'Câmbio comercial (SPOT)',
      spotLabelBank: 'Cotação {bankName}',
      manualSpotLabel: 'Câmbio comercial (SPOT)',
      manualDollarLabel: 'Dólar comercial (para paridade)',
      ptaxAlert: 'Não é possível obter cotação comercial para esta moeda. Será utilizada a cotação de fechamento do dia anterior.',
      labelIofPct: 'IOF(%)',
      labelIofValue: 'Valor do IOF',
      labelIrPct: 'IR(%)',
      labelIrValue: 'Valor do IR',
      labelCidePct: 'CIDE(%)',
      labelCideValue: 'Valor do CIDE',
      labelTariff: 'Tarifa',
      labelCustomerRate: 'Taxa do cliente',
      labelVet: 'VET (Valor efetivo total)',
      labelTotal: 'Total da operação',
      labelCustomerPays: 'Cliente paga',
      labelCustomerReceives: 'Cliente recebe',
      btnCopyOperation: 'Copiar dados da operação',
      templateNotConfigured: 'Template não configurado. Acesse Configurações > Mensagem de Operação.',
      copyError: 'Não foi possível copiar a mensagem. Selecione o texto e copie manualmente (Ctrl+C).'
    },
    operationExchangeDeliveryAddress: {
      deliverySectionTitle: 'Dados de Entrega',
      receiverQuestion: 'Quem irá receber a Moeda estrangeira?',
      radioCustomer: 'O próprio cliente',
      radioThirdParty: 'Outra pessoa indicada',
      thirdPartySectionTitle: 'Dados do terceiro designado',
      fieldFullName: 'Nome completo',
      fieldNationality: 'Nacionalidade',
      fieldMaritalStatus: 'Estado civil',
      fieldCep: 'CEP',
      fieldStreet: 'Logradouro',
      fieldNumber: 'Número',
      fieldComplement: 'Complemento',
      fieldNeighborhood: 'Bairro',
      fieldState: 'UF',
      fieldCity: 'Cidade',
      fieldDocumentType: 'Tipo de documento',
      fieldCpf: 'CPF',
      fieldRg: 'RG',
      fieldCellphone: 'Celular',
      invalidCep: 'Cep inválido',
      errorSearchCep: 'Não foi possível buscar o CEP. Preencha o endereço manualmente.',
      successGenerateDoc: 'Autorização de retirada gerada com sucesso!',
      errorGenerateDoc: 'Não foi possível gerar documento de autorização. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorLoadCustomer: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    operationalDocumentsShared: {
      title: 'Documentos da operação',
      typeLabel: 'Tipo',
      addDocumentLabel: 'Adicionar documento',
      contractDoc: 'Contrato de Câmbio',
      swiftDoc: 'SWIFT',
      bankSlipDoc: 'Boleto',
      paySlipDoc: 'Comp. pagamento',
      titleComex: 'Documentos de Comex',
      btnSendToBank: 'Enviar ao banco e fechar',
      noDataAllAdded: 'Todos os documentos do cliente já estão na operação',
      successDocumentUpdated: 'A lista de documentos foi atualizada! Uma notificação foi enviada ao banco!',
      errorNotifyBank: 'Não foi possível avisar o banco sobre o novo documento da operação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorNotifyBankOnSend: 'Não foi possível enviar notificação ao banco. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
      errorDownload: 'Não foi possível baixar documento. Tente baixar novamente; se continuar, fale com o suporte.'
    },
    bankFlowTable: {
      bestRate: 'Melhor taxa'
    },
    bankQuotationCard: {
      bankRateTitle: 'Taxa do {bankName}',
      lockedLabel: 'Travada às {time}',
      customerRateLabel: 'Taxa do cliente',
      totalLabel: 'Total da operação',
      refreshButton: 'Atualizar cotação',
      refreshCountdown: 'Atualizando em {seconds}s'
    },
    integratedAccountSelect: {
      internationalPayer: {
        label: 'Conta no exterior de quem paga',
        required: 'Escolha a conta no exterior de quem vai pagar esta operação.',
        empty: 'Este cliente não tem conta no exterior aprovada neste banco. Integre uma conta no cadastro do cliente para operar.'
      },
      internationalReceiver: {
        label: 'Conta no exterior que recebe',
        required: 'Escolha a conta no exterior que vai receber esta operação.',
        empty: 'Este cliente não tem conta no exterior aprovada neste banco. Integre uma conta no cadastro do cliente para operar.'
      },
      national: {
        label: 'Conta do cliente no Brasil',
        required: 'Escolha a conta do cliente no Brasil para esta operação.',
        empty: 'Este cliente não tem conta ativa no Brasil. Cadastre uma conta no cadastro do cliente para operar.'
      },
      nationalItem: 'Banco {bank} - Ag. {agency} - Conta {account}'
    },
    integratedBankQuotation: {
      expired: 'A cotação do {bankName} venceu e foi atualizada para {rate}. Confira a taxa e feche o negócio de novo.'
    },
    integratedNatures: {
      loadError: 'Não foi possível carregar as naturezas integradas com o banco. Tentando de novo.'
    },
    chargeEmailHistoryModal: {
      title: 'Histórico de solicitação de DUIMPs/DUEs',
      headerDate: 'Data/Hora',
      headerAttempt: 'Tentativa',
      headerStatus: 'Status',
      headerRecipient: 'Destinatário',
      headerType: 'Tipo',
      headerReason: 'Motivo',
      btnResend: 'Reenviar agora',
      btnClose: 'Fechar',
      confirmTitle: 'Confirmar reenvio',
      confirmMessage: 'Deseja reenviar o email de cobrança para esta Invoice?',
      statusSuccess: 'Sucesso',
      statusFailed: 'Não enviado',
      statusPaused: 'Pausada',
      pausedAlert: 'A cobrança automática desta invoice está pausada depois de várias tentativas sem envio. Corrija o motivo mostrado no histórico e use Reenviar agora para retomar.',
      isManualLabel: 'Manual',
      isAutoLabel: 'Automático',
      emptyMessage: 'Nenhum email de cobrança enviado para esta Invoice.',
      loadError: 'Não foi possível carregar o histórico.',
      btnRetry: 'Tentar novamente',
      resendSuccess: 'Email reenviado com sucesso.',
      resendError: 'Não foi possível reenviar email. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    duimpDueManagerModal: {
      title: 'Gerenciar DUIMP/DU-E',
      errorDownload: 'Não foi possível baixar o documento. Tente baixar novamente; se continuar, fale com o suporte.',
      errorSave: 'Não foi possível salvar DUIMP/DU-E. Confira os dados e tente novamente; se continuar, fale com o suporte.',
      errorUpload: 'Não foi possível salvar documento DUIMP/DU-E. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    duimpTimelineModal: {
      titlePrefix: 'Linha do Tempo — Operação #{id}',
      loadError: 'A linha do tempo não carregou. Tente de novo.',
      btnRetry: 'Tentar novamente',
      emptyMessage: 'Nenhum evento registrado para esta operação.'
    },
    editShippingDateModal: {
      title: 'Editar Data de Embarque',
      btnSave: 'Salvar',
      btnCancel: 'Cancelar',
      currentDateLabel: 'Data de embarque atual',
      newDateLabel: 'Nova data de embarque',
      noDateLabel: 'Não informada',
      nextChargeLabel: 'Próxima cobrança prevista:',
      validationRequired: 'Informe a nova data de embarque.',
      successUpdate: 'Data de embarque atualizada com sucesso.',
      errorUpdate: 'Não foi possível atualizar data de embarque. Confira os dados e tente novamente; se continuar, fale com o suporte.'
    },
    shipmentUpdateHistoryModal: {
      title: 'Histórico de atualizações de embarque',
      labelDate: 'Data',
      labelNewForecast: 'Nova Previsão',
      labelReason: 'Motivo',
      labelObservation: 'Observação',
      labelDocument: 'Documento',
      tooltipDownload: 'Baixar documento',
      emptyMessage: 'Nenhuma atualização de embarque registrada.',
      loadError: 'Não foi possível carregar o histórico.',
      btnRetry: 'Tentar novamente'
    },
    authorizationDocumentModal: {
      title: 'Gerar Autorização de Retirada',
      btnGenerate: 'Gerar e Salvar',
      btnCancel: 'Cancelar',
      customerLabel: 'Cliente (Autorizador)',
      operationLabel: 'Operação',
      authorizationTypeLabel: 'Tipo de Autorização *',
      withdrawerDataTitle: 'Dados do Retirante',
      fullNameLabel: 'Nome completo *',
      nationalityLabel: 'Nacionalidade *',
      maritalStatusLabel: 'Estado civil *',
      addressLabel: 'Endereço completo *',
      cpfLabel: 'CPF *',
      rgLabel: 'RG',
      validationAuthorizationType: 'Selecione o tipo de autorização.',
      validationName: 'Informe o nome do terceiro.',
      validationNationality: 'Informe a nacionalidade do terceiro.',
      validationMaritalStatus: 'Informe o estado civil do terceiro.',
      validationAddress: 'Informe o endereço do terceiro.',
      validationDocument: 'Informe o CPF do terceiro.',
      successGenerate: 'Autorização gerada com sucesso.',
      errorGenerate: 'Não foi possível gerar autorização. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
    },
    operationImportData: {
      sectionTitle: 'Dados de Importação / Exportação',
      originCountryLabel: 'País de Origem',
      destinationCountryLabel: 'País de Destino',
      bankingProductQuestion: 'Essa operação está vinculada a algum produto bancário?',
      bankingProductHint: '(Ex.: Pronamp, Finimp, Capital de Giro, etc.)',
      bankingProductYes: 'Sim',
      bankingProductNo: 'Não',
      bankingProductDocumentsTitle: 'Documentos do produto bancário',
      invoicesTitle: 'Invoices da operação',
      invoiceNumberLabel: 'Nº da Invoice',
      invoiceDateLabel: 'Data da Invoice',
      shippingForecastLabel: 'Previsão de embarque',
      tooltipRemoveFile: 'Remover arquivo',
      tooltipRemoveDoc: 'Remover documento',
      tooltipAddDoc: 'Adicionar documento',
      tooltipRemoveInvoice: 'Remover invoice',
      tooltipAddInvoice: 'Adicionar invoice',
      duimpTitle: 'DUIMP/DU-E',
      validationBankingProduct: 'Informe se a operação está vinculada a um produto bancário'
    },
    duimpCoverageProgress: {
      finished: 'Finalizado',
      pending: 'Pendente: {code} {value}',
      pendingNoCode: 'Pendente: {value}'
    },
    customerOperationalDocuments: {
      sectionTitle: 'Documentos complementares',
      btnSearch: 'Buscar no cliente',
      modalTitle: 'Documentos complementares',
      btnAdd: 'Adicionar',
      btnClose: 'Fechar',
      noDataText: 'Todos os documentos do cliente já estão na operação',
      errorLoadCustomer: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    },
    currencySelect: {
      validationRequired: 'Moeda obrigatória',
      noDataText: 'Nenhuma moeda disponível'
    },
    cancelConfirmTitle: 'Cancelar?',
    cancelConfirmPrimary: 'Sim, cancelar',
    cancelConfirmMsgEdit: 'Há dados preenchidos, deseja realmente cancelar a edição?',
    cancelConfirmMsgNew: 'Há dados preenchidos, deseja realmente cancelar o cadastro?',
    bankNotEnabledTitle: 'Este banco não está habilitado para operações no momento',
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    viewBankSimulation: 'Visualizar simulação do Banco',
    closeBusinessButton: 'Fechar negócio',
    savePreSaleButton: 'Salvar pré-venda',
    updatePreSaleButton: 'Atualizar pré-venda'
  },
  onboarding: {
    checklist: {
      title: 'Primeiros Passos',
      progress: '{completed}/{total} concluídos',
      markComplete: 'Marcar como concluído',
      next: 'Próximo',
      stepCompleted: 'Passo concluído com sucesso!',
      loadError: 'Não foi possível carregar primeiros passos. Atualize a página (F5) e tente novamente.',
      completeError: 'Não foi possível marcar passo como concluído. Confira os dados e tente novamente.'
    },
    steps: {
      welcome: 'Bem-vindo',
      users: 'Equipe',
      corban: 'Correspondente',
      banks: 'Bancos',
      spreads: 'Spreads',
      client: 'Primeiro cliente',
      templates: 'Templates',
      triggers: 'Gatilhos'
    },
    setupWizard: {
      goToSystem: 'Ir para o sistema',
      markComplete: 'Marcar como concluído',
      next: 'Próximo',
      finishSetup: 'Concluir configuração',
      confirmTitle: 'Confirmar conclusão',
      confirmYes: 'Sim, concluir',
      confirmPendingBody: 'Existem passos obrigatórios que ainda não foram concluídos. Sem finalizá-los, não será possível iniciar a operação (comprar ou vender moeda estrangeira).',
      confirmContinueBody: 'Deseja concluir mesmo assim? Você poderá retomar a configuração pelo menu de Configurações.',
      setupCompleted: 'Configuração concluída! Você pode acessar o setup novamente em Configurações.'
    },
    sidebar: {
      title: 'PRIMEIROS PASSOS',
      stagesCompleted: '{completed}/{total} etapas concluídas',
      mandatory: 'obrigatório',
      helpTitle: 'Precisa de ajuda?',
      helpLink: 'Fale com o suporte'
    },
    welcome: {
      features: {
        internationalRemittances: {
          title: 'Remessas Internacionais',
          description: 'Envie e receba valores do exterior com cotações em tempo real e rastreamento completo.'
        },
        dashboard: {
          title: 'Dashboard Operacional',
          description: 'Acompanhe métricas de operações, lucro e volume em um painel gerencial completo.'
        },
        customerManagement: {
          title: 'Gestão de Clientes',
          description: 'Cadastro completo com compliance, fluxo cadastral e aprovação integrada ao banco.'
        },
        spreads: {
          title: 'Spreads e Comissões',
          description: 'Configure margens por moeda e automatize o cálculo de comissões para correspondentes.'
        },
        duimp: {
          title: 'Gestão DUIMP/DU-E',
          description: 'Controle de importações e exportações com acompanhamento de embarques e cobranças automáticas.'
        },
        whatsapp: {
          title: 'WhatsApp Integrado',
          description: 'Comunicação direta com clientes via WhatsApp com histórico centralizado no sistema.'
        },
        reports: {
          title: 'Relatórios Gerenciais',
          description: 'Relatórios operacionais, de lucro e de gestão exportáveis para tomada de decisão.'
        },
        audit: {
          title: 'Auditoria e Compliance',
          description: 'Registro completo de ações no sistema com rastreabilidade e conformidade regulatória.'
        },
        automations: {
          title: 'Automações',
          description: 'E-mails automáticos, gatilhos por evento e notificações configuráveis.'
        },
        whitelabel: {
          title: 'Whitelabel',
          description: 'Personalize cores, logo e templates com a identidade visual da sua empresa.'
        }
      },
      setupGreeting: 'Que bom ter você aqui!',
      setupSubtitle: 'Estamos felizes em te receber no Tech Câmbio. Preparamos um guia rápido para te ajudar a deixar tudo no jeito — no seu ritmo, sem pressa.',
      tipTitle: 'Fique tranquilo',
      tipText: 'Esse setup dura poucos minutos e você pode voltar quando quiser. Etapas opcionais podem ser configuradas depois.',
      whatAwaitsTitle: 'O QUE TE ESPERA',
      setupFeatures: {
        internationalRemittances: {
          title: 'Remessas Internacionais',
          description: 'Envie e receba valores do exterior com cotações em tempo real.'
        },
        dashboard: {
          title: 'Dashboard Operacional',
          description: 'Métricas de operações, lucro e volume em um painel completo.'
        },
        customerManagement: {
          title: 'Gestão de Clientes',
          description: 'Cadastro com compliance, fluxo cadastral e aprovação integrada.'
        },
        spreads: {
          title: 'Spreads e Comissões',
          description: 'Margens por moeda e cálculo automático de comissões.'
        },
        automations: {
          title: 'Automações',
          description: 'E-mails automáticos, gatilhos por evento e notificações.'
        },
        whitelabel: {
          title: 'Whitelabel',
          description: 'Cores, logo e templates com a identidade da sua empresa.'
        }
      }
    },
    users: {
      profileHeader: 'Perfil',
      loadError: 'Não foi possível carregar usuários. Atualize a página (F5) e tente novamente.',
      setupTitle: 'Monte sua equipe',
      setupSubtitle: 'Cada pessoa que opera o sistema precisa de um usuário próprio. Assim você tem controle de quem fez o quê, com permissões adequadas para cada função.',
      infoCards: {
        security: {
          title: 'Segurança',
          description: 'Cada ação fica registrada com o nome de quem fez.'
        },
        profiles: {
          title: 'Perfis de acesso',
          description: 'Controle o que cada pessoa pode ver e fazer no sistema.'
        }
      },
      inviteTitle: 'Convidar colaborador',
      inviteEmailLabel: 'E-mail do colaborador',
      inviteButton: 'Convidar',
      inviteHint: 'O colaborador receberá um e-mail para criar senha e acessar o sistema com o perfil selecionado.',
      noInvitesSent: 'Nenhum convite enviado ainda',
      inviteStatusPending: 'Aguardando primeiro acesso',
      inviteStatusAccepted: 'Acesso realizado',
      inviteSentSuccess: 'Convite enviado com sucesso!',
      inviteSendError: 'Não foi possível enviar convite. Tente novamente em alguns instantes.',
      addManually: 'Cadastrar manualmente',
      manageProfiles: 'Gerenciar perfis'
    },
    corban: {
      registrationDate: 'Data de cadastro',
      loadError: 'Não foi possível carregar correspondentes. Atualize a página (F5) e tente novamente.',
      setupTitle: 'Seu correspondente bancário',
      setupSubtitle: 'O correspondente (Corban) é quem intermedia as operações de câmbio entre seus clientes e os bancos. Sem ele cadastrado, o sistema não consegue processar operações.',
      infoCards: {
        mediation: {
          title: 'Intermediação',
          description: 'O Corban conecta seus clientes aos bancos de câmbio.'
        },
        commissions: {
          title: 'Comissões',
          description: 'Receba comissões automaticamente a cada operação fechada.'
        },
        compliance: {
          title: 'Compliance',
          description: 'Dados cadastrais e regulatórios em um só lugar.'
        }
      },
      registeredChip: 'Cadastrado',
      emailLabel: 'E-mail',
      phoneLabel: 'Telefone',
      noCorbanText: 'Nenhum correspondente cadastrado ainda',
      addCorbanButton: 'Cadastrar correspondente',
      editCorbanButton: 'Editar'
    },
    bank: {
      companyName: 'Razão social',
      loadError: 'A lista de bancos não carregou. Atualize a página (F5) e tente novamente.',
      setupTitle: 'Bancos de câmbio parceiros',
      setupSubtitle: 'Os bancos são os parceiros que liquidam as operações de câmbio. O sistema já vem com os principais bancos pré-cadastrados — basta ativar os que você vai operar.',
      infoCards: {
        preCadastred: {
          title: 'Pré-cadastrados',
          description: 'Os principais bancos já estão no sistema, prontos para ativar.'
        },
        toggleActive: {
          title: 'Ativar e desativar',
          description: 'Ligue ou desligue um banco a qualquer momento com um clique.'
        },
        newBanks: {
          title: 'Novos bancos',
          description: 'Se precisar de um banco que não está aqui, cadastre manualmente.'
        }
      },
      availableBanksTitle: 'Bancos disponíveis',
      addBankButton: 'Cadastrar novo banco',
      viewBanksButton: 'Ver todos os bancos'
    },
    spread: {
      reviewButton: 'Revisar spreads',
      currencyHeader: 'Moeda',
      spreadSell: 'Spread venda (%)',
      spreadBuy: 'Spread compra (%)',
      loadError: 'Não foi possível carregar moedas. Atualize a página (F5) e tente novamente.',
      setupTitle: 'Suas margens de lucro',
      setupSubtitle: 'O spread é a diferença entre o câmbio comercial e o preço que seu cliente paga. É assim que você gera receita em cada operação. O sistema já vem com valores recomendados — ajuste conforme sua estratégia.',
      infoCards: {
        perCurrency: {
          title: 'Margem por moeda',
          description: 'Defina spreads diferentes para cada moeda conforme sua estratégia.'
        },
        directImpact: {
          title: 'Impacto direto',
          description: 'O spread define o preço que seus clientes verão nas cotações.'
        },
        adjustAnytime: {
          title: 'Ajuste a qualquer momento',
          description: 'Altere os valores sempre que precisar, sem impactar operações fechadas.'
        }
      },
      spreadsByCurrencyTitle: 'Spreads por moeda',
      buyCurrencyLabel: 'Compra',
      sellCurrencyLabel: 'Venda',
      editSpreadsButton: 'Editar spreads',
      viewCurrenciesButton: 'Ver todas as moedas'
    },
    client: {
      createButton: 'Cadastrar cliente',
      workflowButton: 'Fluxo cadastral',
      setupTitle: 'Cadastre seu primeiro cliente',
      setupSubtitle: 'Com o cliente cadastrado, você já consegue criar sua primeira operação de câmbio. O formulário é simples e pode ser completado depois.',
      infoCards: {
        quickRegistration: {
          title: 'Cadastro rápido',
          description: 'Preencha apenas os dados essenciais agora e complete o resto depois.'
        },
        organizedDocs: {
          title: 'Documentação organizada',
          description: 'Anexe documentos e mantenha tudo centralizado no cadastro.'
        },
        alwaysEditable: {
          title: 'Sempre editável',
          description: 'Volte ao cadastro a qualquer momento para atualizar informações.'
        }
      },
      customersRegistered: '{count} cliente(s) cadastrado(s)',
      canCreateOperations: 'Você já pode criar operações de câmbio',
      noCustomersText: 'Nenhum cliente cadastrado ainda',
      addClientButton: 'Cadastrar cliente',
      sendRegistrationButton: 'Enviar cadastro',
      viewClientsButton: 'Ver clientes cadastrados',
      onboardingFlowTitle: 'Como funciona o fluxo cadastral',
      onboardingFlowDesc: 'O cadastro do cliente passa por etapas até estar pronto para operar. Você controla o andamento pelo board de Fluxo Cadastral, movendo os cards conforme analisa e aprova cada etapa.',
      stages: {
        registration: {
          title: '1. Cadastro',
          description: 'Crie o cliente (PF ou PJ) com dados pessoais, endereço, documentos e contas bancárias.'
        },
        submission: {
          title: '2. Envio para análise',
          description: 'Após preencher o cadastro, envie para análise. O card aparece no board de Fluxo Cadastral.'
        },
        analysis: {
          title: '3. Análise e aprovação',
          description: 'Analise os dados e documentos. Mova o card para Aprovado, Pendência ou Recusado conforme necessário.'
        },
        bankEnable: {
          title: '4. Habilitação no banco',
          description: 'Adicione o banco de câmbio ao cliente e acompanhe a aprovação. Cada banco tem seu próprio status.'
        },
        readyToOperate: {
          title: '5. Pronto para operar',
          description: 'Com cadastro finalizado + banco aprovado + limites definidos, o cliente pode realizar operações.'
        }
      }
    },
    templates: {
      emailTemplatesTitle: 'Templates de e-mail',
      emailTemplatesDesc: 'Toda vez que o sistema envia um e-mail para seus clientes, correspondentes ou bancos, ele usa um template como base. O template define o visual (logo, cores, layout) e o texto da mensagem. Você pode personalizar todos os templates para que seus e-mails tenham a identidade da sua empresa.',
      features: {
        visualEditor: {
          title: 'Editor visual',
          description: 'Edite o conteúdo dos e-mails usando um editor de texto rico — sem precisar saber HTML.'
        },
        autoData: {
          title: 'Dados automáticos',
          description: 'Insira campos como nome do cliente ou valor da operação. O sistema preenche sozinho na hora do envio.'
        },
        onePerSituation: {
          title: 'Um template por situação',
          description: 'Cada tipo de e-mail (ficha cadastral, confirmação, pendência) tem seu próprio template independente.'
        }
      },
      tip: 'Dica: personalize os templates antes de configurar os gatilhos. Assim, quando ativar o envio automático, os e-mails já sairão com a cara da sua empresa.',
      viewTemplatesButton: 'Ver templates',
      createTemplateButton: 'Criar template',
      setupTitle: 'Personalize suas comunicações',
      setupSubtitle: 'Os templates definem a aparência dos e-mails, mensagens e documentos que seus clientes recebem. O sistema já vem com modelos prontos — personalize com sua marca quando quiser.',
      infoCards: {
        brandIdentity: {
          title: 'Sua identidade visual',
          description: 'Logomarca, cores e informações da sua empresa nos documentos.'
        },
        readyModels: {
          title: 'Modelos prontos',
          description: 'Comece com os templates padrão e ajuste conforme a necessidade.'
        },
        preview: {
          title: 'Pré-visualização',
          description: 'Veja como seus clientes vão receber antes de ativar.'
        }
      },
      availableTemplatesTitle: 'Templates disponíveis',
      types: {
        email: {
          title: 'E-mails',
          description: 'Notificações de cadastro, operações, pendências e alertas.'
        },
        operationMessage: {
          title: 'Mensagens de operação',
          description: 'Textos prontos para enviar ao cliente via WhatsApp ou copiar.'
        },
        documents: {
          title: 'Documentos emitidos',
          description: 'Contratos de câmbio, comprovantes e fichas de cliente.'
        }
      },
      editTemplatesButton: 'Editar templates',
      emailLayoutButton: 'Layout de e-mail'
    },
    triggers: {
      emailTriggersTitle: 'Gatilhos de e-mail',
      emailTriggersDesc: 'O sistema pode enviar e-mails automaticamente em situações importantes — como quando um cliente preenche a ficha cadastral, quando uma operação muda de status, ou quando há alguma pendência. Cada e-mail automático é chamado de "gatilho" e você decide quais quer manter ativos.',
      categoriesTitle: 'Categorias de gatilhos',
      categories: {
        customer: {
          title: 'E-mails para o cliente',
          description: 'Envio da ficha cadastral, aviso de pendência, confirmação de conta no exterior e câmbio turismo.'
        },
        corban: {
          title: 'E-mails para o correspondente',
          description: 'Notificações de atualização cadastral, aprovação de clientes, relatórios e criação de usuário.'
        },
        bank: {
          title: 'E-mails para o banco',
          description: 'Envio de cadastro do cliente ao banco, atualização de dados e comprovantes de operação.'
        },
        system: {
          title: 'E-mails do sistema',
          description: 'Recuperação de senha e notificações de segurança para os usuários do sistema.'
        }
      },
      categoriesFooter: 'Cada gatilho utiliza um dos templates que você configurou no passo anterior. Para ativar ou desativar um gatilho, acesse a tela de configurações e altere o campo "Habilitado" do e-mail desejado.',
      viewSettingsButton: 'Ver configurações',
      setupTitle: 'Automações de e-mail',
      setupSubtitle: 'Os gatilhos disparam e-mails automaticamente quando algo acontece no sistema — um cliente se cadastra, uma operação é fechada, um documento fica pendente. Ative apenas os que fazem sentido para o seu fluxo.',
      infoCards: {
        automatic: {
          title: 'Automático',
          description: 'E-mails são disparados sem ação manual do operador.'
        },
        manageable: {
          title: 'Gerenciável',
          description: 'Ative, desative e customize cada gatilho nas configurações.'
        },
        customizable: {
          title: 'Personalizável',
          description: 'Cada gatilho usa um template que você pode editar.'
        }
      },
      mainTriggersTitle: 'Principais gatilhos',
      triggerItems: {
        sendRegistration: {
          title: 'Envio de ficha cadastral',
          description: 'Quando o operador envia o cadastro ao cliente.'
        },
        registrationComplete: {
          title: 'Cadastro finalizado',
          description: 'Quando o cliente completa o preenchimento.'
        },
        pendingDocs: {
          title: 'Pendências documentais',
          description: 'Quando há documentos faltando no cadastro.'
        },
        operationClosed: {
          title: 'Fechamento de operação',
          description: 'Quando uma operação de câmbio é concluída.'
        },
        operationCancelled: {
          title: 'Cancelamento de operação',
          description: 'Quando uma operação é cancelada.'
        },
        swiftSent: {
          title: 'Comprovante SWIFT',
          description: 'Quando o comprovante de pagamento é enviado.'
        }
      },
      manageTriggersButton: 'Gerenciar todos os gatilhos'
    }
  },

  simulator: {
    slider: {
      send: 'Enviar',
      pay: 'O cliente paga'
    },
    optionalCustomer: '(Opcional) Cliente / CPF / CNPJ',
    cityLabel: 'Cidade',
    bankLabel: 'Banco',
    storeLabel: 'Loja',
    natureLabel: 'Natureza',
    currencyAmountLabel: 'Quantidade ME',
    brlAmountLabel: 'Quantidade Reais',
    deliveryTypeLabel: 'Forma de Entrega',
    deliveryCostLabel: 'Custo de Entrega',
    spreadLabel: 'Spread',
    customerRateLabel: 'Taxa do Cliente',
    tariffLabel: 'Tarifa',
    spotRateLabel: 'Câmbio comercial (SPOT)',
    iofLabel: 'IOF({pct}%)',
    irLabel: 'IR({pct}%)',
    cideLabel: 'CIDE({pct}%)',
    totalLabel: 'Total',
    limitLabel: 'Limite:',
    expiresLabel: 'Expira em:',
    errors: {
      loadCities: 'Não foi possível carregar a lista de cidades. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadBanks: 'Não foi possível carregar os bancos que atendem a cidade escolhida. Escolha a cidade de novo; se continuar, fale com o suporte.',
      loadStores: 'Não foi possível carregar as lojas do banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadNatures: 'Não foi possível carregar as naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadDeliveryTypes: 'Não foi possível carregar os tipos de entrega. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCurrencies: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadBankList: 'Não foi possível carregar a lista de bancos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCustomers: 'Não foi possível buscar os clientes. Confira o texto da busca e tente novamente; se continuar, fale com o suporte.',
      loadCustomerBanks: 'Não foi possível carregar os bancos do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
      loadCustomerData: 'Não foi possível carregar os dados do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
    }
  },

  usersControl: {
    tabSystemic: 'Usuários sistêmicos',
    tabCorban: 'Usuários corbans',
    tabCustomer: 'Usuários clientes',
    addUserButton: 'Adicionar',
    optionsTooltip: 'Opções',
    editMenuItem: 'Editar',
    inactivateMenuItem: 'Inativar',
    resendAccessMenuItem: 'Reenviar acesso',
    modalTitleAdd: 'Adicionar usuário',
    modalTitleEdit: 'Editar usuário',
    nameLabel: 'Nome',
    profileLabel: 'Perfil',
    canOperateLabel: 'Pode operar?',
    passwordLabel: 'Senha',
    colCode: 'Código',
    colProfile: 'Perfil',
    colCreatedAt: 'Data de cadastro',
    colStatus: 'Status',
    colFirstAccess: 'Já realizou primeiro acesso',
    colCanOperate: 'Pode operar',
    colActions: 'Ações',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    addSuccess: 'Usuário cadastrado com sucesso!',
    updateSuccess: '{email} foi atualizado com sucesso!',
    inactiveSuccess: 'O {email} foi inativado com sucesso!',
    accessResentSuccess: 'Acesso reenviado com sucesso!',
    inactivateTitle: 'Inativar usuário?',
    inactivateMessage: 'Deseja realmente inativar o usuário {email}?',
    resendEmailTitle: 'Reenviar e-mail de acesso?',
    resendEmailMessage: 'Ao reenviar o e-mail de primeiro acesso, o usuário receberá um e-mail com uma senha provisória e precisará obrigatoriamente redefinir a senha no primeiro acesso.',
    loadProfilesError: 'Não foi possível carregar a lista de perfis de acesso. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadUsersError: 'Não foi possível carregar a lista de usuários. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',    addError: 'Não foi possível cadastrar o usuário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    updateError: 'Não foi possível salvar as alterações do usuário. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    inactivateError: 'Não foi possível inativar o usuário. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    accessResentError: 'Não foi possível enviar o e-mail de acesso ao usuário. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    avatarError: 'Os dados do usuário foram salvos, mas não foi possível enviar a foto. Edite o usuário e envie a foto de novo; se continuar, fale com o suporte.',
    avatarRemoveError: 'Não foi possível remover a foto do usuário. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
  },

  supportRedirect: {
    loading: 'Abrindo o suporte...',
    back: 'Voltar',
    errorForbidden: 'Seu perfil não tem acesso ao suporte. Fale com o administrador da sua empresa.',
    errorUnavailable: 'Suporte não disponível nesta instância.',
    errorDefault: 'Não foi possível abrir o suporte. Tente novamente em instantes.'
  },

  customersControl: {
    columns: {
      code: 'Código',
      customer: 'Cliente',
      email: 'E-mail',
      phone: 'Telefone',
      status: 'Status',
      registrationDate: 'Data de cadastro',
      actions: 'Ações',
      expandedStatus: 'Status',
      type: 'Tipo',
      linkedBank: 'Banco vinculado',
      approvedNatures: 'Naturezas aprovadas',
      entry: 'Entrada',
      exit: 'Saída',
      validity: 'Validade'
    },
    loadCustomerDetailsError: 'Não foi possível carregar os detalhes do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCorbansFilterError: 'Não foi possível carregar a lista de corbans do filtro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadListError: 'Não foi possível carregar a lista de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCountError: 'Não foi possível carregar a quantidade de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    preSaveSavedSuccess: 'Cliente salvo com sucesso!',
    preSaveSaveError: 'Não foi possível salvar o pré-cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    resendSuccess: 'Cadastro reenviado ao banco com sucesso.',
    resendError: 'Não foi possível reenviar. Verifique os dados e tente novamente.',
    updateRequestSent: 'Solicitação de atualização cadastral enviada com sucesso!',
    updateRequestError: 'Não foi possível enviar o pedido de atualização do cadastro ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    firstAccessEmailResent: 'E-mail de primeiro acesso reenviado',
    firstAccessEmailResentError: 'Não foi possível reenviar o e-mail de primeiro acesso ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
  },

  customersAuthorizationControl: {
    loadListError: 'Não foi possível carregar a lista de clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCountError: 'Não foi possível carregar a quantidade de clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    limitMissingData: 'Dados do banco ou cliente não encontrados.',
    limitAdded: 'Limite adicionado com sucesso!',
    limitAddError: 'Não foi possível adicionar o limite do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    refreshError: 'Os dados não foram atualizados. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  formAuthorizationCustomer: {
    statusUpdated: 'Status atualizado com sucesso!',
    statusUpdateError: 'Não foi possível alterar a situação do cadastro do cliente. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    statusUpdateBankError: 'Não foi possível alterar a situação do cadastro do cliente no banco. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    pendingEmailSent: 'Email de pendência cadastral enviado com sucesso!',
    pendingEmailError: 'Não foi possível enviar o e-mail de pendência do cadastro ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
  },

  externalShortLink: {
    opening: 'Abrindo o link',
    unavailable: 'Link indisponível'
  },

  customerSelfie: {
    customerSelfieUi: {
      sentSelfieAlt: 'Selfie enviada',
      verificationDoneTitle: 'Verificação concluída',
      verificationDoneText: 'Seus documentos e informações estão sendo analisados para a conclusão do cadastro. Em breve, um de nossos especialistas entrará em contato',
      goToWebsite: 'Ir para o site',
      processingPhoto: 'Processando a foto',
      qrCodeTitle: 'Acesse pelo celular',
      qrCodeText: 'Escaneie o QR Code para continuar o processo de verificação de identidade',
      orCopyLink: 'Ou copie o link:'
    },
    customerNotFound: 'Cliente não encontrado. Redirecionando...',
    selfieNotSent: 'A selfie não foi enviada: a foto não foi reconhecida. Tire uma nova foto com o rosto bem iluminado.',
    selfieUploadError: 'A selfie não foi enviada. Confira sua internet e tente novamente.',
    qrCodeError: 'O QR Code não foi gerado. Atualize a página e tente novamente.',
    linkCopied: 'Link copiado para a área de transferência!',
    linkCopyError: 'Não foi possível copiar link. Tente copiar manualmente.'
  },

  operationDocumentsExternalAccess: {
    pageTitle: 'Documentos da operação',
    documentsSection: 'Documentos',
    complementarySection: 'Documentos Complementares',
    comexSection: 'Documentos de Comex',
    downloadError: 'Não foi possível baixar documento. Tente baixar novamente; se continuar, fale com o suporte.',
    loadDocumentsError: 'Não foi possível carregar os documentos da operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  correspondentSpreads: {
    sectionTitle: 'Spread de remessa',
    columns: {
      code: 'Código',
      name: 'Nome',
      minSpreadSell: 'Spread Mínimo Venda(%)',
      recSpreadSell: 'Spread Recomendado Venda(%)',
      maxSpreadSell: 'Spread Máximo Venda(%)',
      minSpreadBuy: 'Spread Mínimo Compra(%)',
      recSpreadBuy: 'Spread Recomendado Compra(%)',
      maxSpreadBuy: 'Spread Máximo Compra(%)',
      deliveryExemption: 'Valor Para Isenção de Delivery($)',
      actions: 'Ações'
    },
    fields: {
      search: 'Pesquisar',
      minSpreadSell: 'Spread Mínimo Venda(%)',
      recSpreadSell: 'Spread Recomendado Venda(%)',
      maxSpreadSell: 'Spread Máximo Venda(%)',
      minSpreadBuy: 'Spread Mínimo Compra(%)',
      recSpreadBuy: 'Spread Recomendado Compra(%)',
      maxSpreadBuy: 'Spread Máximo Compra(%)'
    },
    loadCurrenciesError: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    addSpreadError: 'Não foi possível adicionar o spread. Confira os valores e tente novamente; se continuar, fale com o suporte.',
    saveSpreadError: 'Não foi possível salvar as alterações do spread. Confira os valores e tente novamente; se continuar, fale com o suporte.'
  },

  bankCover: {
    loadBankTypesError: 'Não foi possível carregar os tipos de banco. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadDocumentModelsError: 'Não foi possível carregar a lista de modelos de documento. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadIntegrationsError: 'Não foi possível carregar a lista de integrações bancárias. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    noIntegrationHint: 'Sem integração: cadastro segue por ficha e e-mail',
    choosePlayerHint: 'Escolha o player para definir o tipo da integração',
    signaturePlayerLabel: 'Player de assinatura',
    integrationPlayerLabel: 'Player de integração',
    signaturePlayerNotConfigured: 'O player {player} ainda não tem credenciais configuradas. O envio de fichas para assinatura não vai funcionar até que sejam configuradas em Configurações → Assinaturas.',
    signaturePlayerDefaultNotConfigured: 'Sem um player próprio, este banco usa o player padrão ({player}), que ainda não tem credenciais configuradas em Configurações → Assinaturas.',
    signaturePlayerNotDefined: 'Nenhum player de assinatura definido para este banco nem como padrão em Configurações → Assinaturas. O envio de fichas para assinatura não vai funcionar.'
  },

  exchangeStores: {
    loadDeliveryTypesError: 'Não foi possível carregar os tipos de entrega. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadDeliveryTimesError: 'Não foi possível carregar os horários de entrega. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadWithdrawalDatesError: 'Não foi possível carregar as datas de retirada. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    addStoreError: 'Não foi possível adicionar a loja. Confira os dados e tente novamente; se continuar, fale com o suporte.',
    saveStoreError: 'Não foi possível salvar as alterações da loja. Confira os dados e tente novamente; se continuar, fale com o suporte.'
  },

  formCustomerMessages: {
    savedWithPending: 'Dados salvos. O cadastro será enviado ao banco automaticamente.',
    pendingNotResolved: 'Pendências não resolvidas. Revise os dados.',
    resubmittedSuccess: 'Cadastro reenviado ao banco com sucesso!',
    resubmitError: 'Não foi possível reenviar cadastro ao banco. Revise os dados e tente novamente.',
    externalTitlePJ: 'Cadastro de Pessoa Jurídica',
    externalTitleCustomer: 'Cadastro de Cliente',
    validationRequired: 'Existem campos obrigatórios não preenchidos',
    validationPartnersCpf: 'Todos os sócios precisam ter CPF/CNPJ informado',
    validationNationalBank: 'É necessário cadastrar pelo menos uma conta bancária no Brasil',
    docProofOfAddress: 'Comprovante de endereço da empresa',
    docRevenue12Months: 'Faturamento dos últimos 12 meses',
    docDreOrPgdas: 'DRE ou Recibo PGDAS',
    docTypeChangedWarning: 'Você alterou o tipo de documento. Verifique se os documentos anexados correspondem ao novo tipo selecionado.',
    partnerLinkedUpdated: 'Cliente do sócio atualizado!',
    partnerLinkedUpdateError: 'Não foi possível atualizar o cliente vinculado ao sócio. Confira os dados do sócio e tente de novo; se continuar, fale com o suporte.',
    loadCustomerError: 'Não foi possível carregar o cadastro do cliente. Atualize a página (F5) e tente de novo; se continuar, fale com o suporte.',
    emailAlreadyRegistered: 'Este email já está cadastrado para outro cliente',
    requiredDocsMissing: 'Preencha todos os documentos obrigatórios da empresa antes de salvar.',
    requiredDocsNamed: 'Documentos obrigatórios da empresa não preenchidos: {docs}.',
    prepareError: 'Os dados do cliente não foram preparados para envio. Revise o cadastro e tente novamente.',
    preSaveError: 'Não foi possível salvar o pré-cadastro do cliente. Confira os dados e tente de novo; se continuar, fale com o suporte.',
    createSuccess: 'Cliente salvo com sucesso!',
    finalizeError: 'O cadastro não foi finalizado. Confira os campos obrigatórios destacados e tente novamente.',
    saveError: 'Não foi possível salvar o cliente. Confira os campos do cadastro e tente de novo; se continuar, fale com o suporte.',
    emailTriggerError: 'O cliente foi salvo, mas não foi possível enviar o e-mail de acesso. Reenvie o acesso na lista de clientes; se continuar, fale com o suporte.',
    updateSuccess: 'Cliente atualizado com sucesso!',
    updateError: 'Não foi possível atualizar o cliente. Confira os campos do cadastro e tente de novo; se continuar, fale com o suporte.',
    updateRequestSent: 'Solicitação de atualização cadastral enviada com sucesso!',
    updateRequestError: 'Não foi possível enviar ao cliente o pedido de atualização cadastral. Confira o e-mail no cadastro e tente de novo.',
    bankAccountEmailSent: 'Email de solicitação de cadastro de conta enviado com sucesso!',
    bankAccountEmailError: 'Não foi possível enviar ao cliente o pedido de cadastro de conta no exterior. Confira o e-mail no cadastro e tente de novo.',
    progressPFComplete: 'Cadastro progredido para Pessoa Física Completo e salvo. Agora você pode preencher os campos adicionais.',
    progressPFBasic: 'Cadastro progredido para Pessoa Física Básico e salvo. Agora você pode preencher os campos adicionais.',
    progressError: 'Não foi possível progredir cadastro. Tente novamente.',
    mainCustomerCreating: 'Criando cliente principal...',
    mainCustomerCreated: 'Cliente principal criado com sucesso!',
    mainCustomerError: 'O cliente principal não foi criado. Confira os dados e tente novamente.',
    confirmationEmailError: 'O cadastro foi concluído, mas não foi possível enviar o e-mail de confirmação ao cliente. Confira o e-mail no cadastro; se continuar, fale com o suporte.',
    partnersShareError: 'A soma das participações dos sócios deve ser igual a 100%.',
    generateSelfieNeedCustomer: 'Cliente deve estar criado para gerar link de selfie.',
    generateSelfieAdminNotReady: 'Funcionalidade de envio por email será implementada. Por enquanto, acesse o cliente via acesso externo para gerar o link.',
    generateSelfieExternalOnly: 'O link de selfie só pode ser gerado pelo link de cadastro enviado ao cliente. Abra o cadastro por esse link e tente de novo.',
    selfieLinkCopied: 'Link de selfie copiado para a área de transferência!',
    selfieLinkGenerated: 'Link gerado: {link}',
    bankPendingLoadError: 'As pendências do banco não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  customersAuthorizationBoard: {
    customersAuthorizationControlBoardUi: {
      reactivate: 'Reativar cadastro',
      sendToBank: 'Enviar ao banco'
    },
    updateBoardError: 'Não foi possível atualizar o quadro de clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCustomersError: 'Não foi possível carregar os clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    changeStatusError: 'Não foi possível mudar o status do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    changeStatusAndRevertError: 'Não foi possível mudar o status do cliente e o card voltou para a coluna anterior. Tente novamente; se continuar, fale com o suporte.',
    pendingEmailSent: 'Email de pendência cadastral enviado com sucesso!',
    pendingRegistered: 'Pendência registrada com sucesso!',
    pendingRegisterError: 'Não foi possível registrar a pendência do cliente. Confira o texto da pendência e tente novamente; se continuar, fale com o suporte.',
    observationSaved: 'Observação salva com sucesso!',
    observationSaveError: 'Não foi possível salvar a observação. Tente novamente; se continuar, fale com o suporte.',
    loadBanksError: 'Não foi possível carregar a lista de bancos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadNaturesError: 'Não foi possível carregar as naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadExchangeTypesError: 'Não foi possível carregar os tipos de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCustomerDataError: 'Não foi possível carregar o cadastro completo do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    bankAdded: 'Banco adicionado com sucesso!',
    bankRemoveError: 'Não foi possível remover o banco. Recarregue a página.',
    emailResentSuccess: 'E-mail de ficha cadastral reenviado',
    emailResentError: 'Não foi possível reenviar o e-mail de acesso ao cliente. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    cannotMoveStatus: 'Não é possível mover para este status',
    editObservation: 'Editar observação',
    addObservation: 'Adicionar observação',
    observation: 'Observação',
    integrationFallbackTitle: 'Integração bancária não concluída',
    integrationFallbackMsg: 'A integração bancária não foi concluída. Deseja manter o banco cadastrado pelo fluxo manual?',
    editPendency: 'Editar pendência',
    finalizedApproved: 'Finalizado e Aprovado',
    rejectedRegistration: 'Cadastro Recusado',
    inactiveRegistration: 'Cadastro Inativado',
    validationCheckError: 'Não conseguimos conferir os dados do cliente. Revise o cadastro e tente novamente.',
    autoSaveError: 'As alterações não foram salvas. Confira os campos e tente novamente.',
    saveBankError: 'O banco não foi salvo no cadastro. Confira os campos e tente novamente.',
    selectStatusLabel: 'Selecione o status desejado',
    selectStatusNoData: 'Selecione um status',
    additionalInfo: 'Informações adicionais'
  },

  customersAuthorizationBankBoard: {
    customersAuthorizationControlBankBoardUi: {
      resendToBank: 'Reenviar ao banco'
    },
    integratedLabel: 'Integrado',
    customerIntegratedSuccess: 'Cliente integrado com sucesso!',
    updateBoardError: 'Não foi possível atualizar o quadro de bancos dos clientes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadError: 'Não foi possível carregar os bancos dos clientes em análise. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    changeStatusError: 'Não foi possível mudar o status do banco do cliente. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    changeStatusAndRevertError: 'Não foi possível mudar o status do banco do cliente e o card voltou para a coluna anterior. Tente novamente; se continuar, fale com o suporte.',
    saveLimitError: 'Não foi possível salvar o limite do cliente. Confira os valores e tente novamente; se continuar, fale com o suporte.',
    limitAddedInOut: 'Limite adicionado de {valueIn} (In) / {valueOut} (Out)',
    limitAdded: 'Limite adicionado de {value}',
    observationSaved: 'Observação salva com sucesso!',
    observationSaveError: 'Não foi possível salvar a observação. Tente novamente; se continuar, fale com o suporte.',
    pendingEmailSent: 'Email de pendência cadastral enviado com sucesso!',
    pendingRegistered: 'Pendência registrada com sucesso!',
    pendingRegisterError: 'Não foi possível registrar a pendência do banco. Confira o texto da pendência e tente novamente; se continuar, fale com o suporte.',
    emailResentError: 'Não foi possível reenviar o e-mail de primeiro acesso. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    resubmittedSuccess: 'Cadastro reenviado ao banco com sucesso',
    cannotMoveStatus: 'Não é possível mover para este status',
    observation: 'Observação',
    customerDataLoadError: 'Os dados do cliente não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    emailResentSuccess: 'E-mail de primeiro acesso reenviado',
    retryTosStartError: 'O reenvio ao banco não começou. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    retryTosSubmitError: 'O cadastro não foi reenviado ao banco. Confira as pendências do cliente e tente novamente.',
    editObservation: 'Editar observação',
    addObservation: 'Adicionar observação',
    sendToIntegrationTitle: 'Enviar para integração bancária?',
    sendToIntegrationMsg: 'Deseja enviar o cliente para integração com {bankName}?',
    foreignCustomerTitle: 'Integração online indisponível',
    foreignCustomerMsg: 'O processo de integração online não está disponível para clientes estrangeiros. O cadastro será realizado pelo fluxo offline.',
    foreignCustomerOk: 'Entendi',
    integrationFallbackTitle: 'Integração bancária não concluída',
    integrationFallbackMsg: 'A integração bancária não foi concluída. Deseja manter o banco cadastrado pelo fluxo manual?',
    editPendency: 'Editar pendência',
    rfiPendingFallback: 'Pendência de compliance (RFI) aguardando resolução.',
    bankRejectedFallback: 'O banco não aceitou o cadastro. Revise os dados e documentos do cliente.'
  },

  notificationHistory: {
    notificationBadgesUi: {
      externalOperation: 'Operação externa',
      customerOperation: 'Operação de cliente',
      signedForm: 'Ficha assinada',
      preSale: 'Pré-venda',
      signedRegistrationForm: 'Ficha cadastral assinada',
      notification: 'Notificação',
      registrationSent: 'Cadastro enviado',
      registrationApproved: 'Cadastro aprovado',
      registrationPending: 'Cadastro pendente',
      registrationFailed: 'Cadastro não concluído',
      duimpUpdated: 'DUIMP atualizado',
      bankStatus: 'Status bancário',
      limitIncrease: 'Aumento de limite',
      urgentCommission: 'Comissão urgente',
      duimpChargePending: 'Cobrança de DUIMP parada'
    },
    notificationHistoryUi: {
      searchLabel: 'Pesquisar na mensagem',
      selectedCount: '{count} selecionada | {count} selecionadas',
      open: 'Abrir',
      noLinkedScreen: 'Sem tela vinculada'
    },
    loadError: 'Não foi possível carregar o histórico de notificações. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    deleteError: 'Não foi possível excluir a notificação. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    emptyTitle: 'Nenhuma notificação encontrada',
    emptyFilterSubtitle: 'Nenhum registro corresponde aos filtros aplicados.',
    emptyDefaultSubtitle: 'As notificações ficam disponíveis por 30 dias.',
    deleteMultipleError: 'Não foi possível excluir as notificações. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    markAsRead: 'Marcar como lida',
    markAsUnread: 'Marcar como não lida',
    statusRead: 'Lida',
    statusUnread: 'Não lida',
    statusAll: 'Todas',
    statusUnreadPlural: 'Não lidas',
    statusReadPlural: 'Lidas',
    summaryLoading: 'Carregando…',
    summaryNotification: 'notificação',
    summaryNotifications: 'notificações',
    summaryNoPending: 'nenhuma pendente',
    summaryUnread: 'não lida',
    summaryUnreadPlural: 'não lidas',
    markReadSingleError: 'Não foi possível marcar a notificação como lida.',
    markUnreadSingleError: 'Não foi possível marcar a notificação como não lida.',
    markReadMultipleError: 'Não foi possível marcar as notificações como lidas.',
    markUnreadMultipleError: 'Não foi possível marcar as notificações como não lidas.',
    period24h: 'Últimas 24h',
    period7days: 'Últimos 7 dias',
    period30days: 'Últimos 30 dias',
    colType: 'Tipo',
    colNotification: 'Notificação',
    colReceivedAt: 'Recebida em',
    colStatus: 'Status'
  },

  customerDocumentsExternalAccess: {
    invalidToken: 'Token de acesso inválido ou ausente.',
    loadError: 'Não foi possível carregar os documentos do cadastro. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  interbanksControl: {
    title: 'Interbancário',
    boughtToday: 'Comprado no dia',
    soldToday: 'Vendido no dia',
    balance: 'Saldo',
    operationsTab: 'Operações realizadas',
    movementsTab: 'Movimentações',
    totalSelected: 'Total selecionado',
    registerPurchase: 'Registrar compra',
    loadError: 'Não foi possível carregar a lista de operações interbancárias. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    columns: {
      operationCode: 'Código da operação',
      meAmount: 'Quantidade ME',
      currency: 'Moeda',
      spot: 'Spot',
      actions: 'Ações'
    },
    registerPurchaseModal: {
      title: 'Registrar compra',
      purchasedValue: 'Valor comprado',
      spot: 'SPOT',
      bank: 'Banco',
      save: 'Salvar',
      cancel: 'Cancelar'
    }
  },

  correspondentPreFormModal: {
    title: 'Novo corban',
    pfDescription: 'Pessoa natural, titular da conta',
    pjDescription: 'Empresas e CNPJ',
    internationalDescription: 'Agentes no exterior',
    sendByEmail: 'Enviar por email',
    submitSuccess: 'Pré-cadastro enviado por email com sucesso!',
    submitError: 'Não foi possível enviar o pré-cadastro do correspondente por e-mail. Confira os dados e tente novamente; se continuar, fale com o suporte.'
  },

  correspondentIndicated: {
    title: 'Agente Indicador',
    modalTitle: 'Indicado',
    externalIdTooltip: 'Indicador importado com ID externo {id}',
    colName: 'Nome',
    colFantasyName: 'Nome Fantasia',
    colEmail: 'Email',
    colState: 'Estado',
    colCity: 'Cidade',
    colCreatedAt: 'Criado Em',
    colActions: 'Ações',
    loadError: 'Não foi possível carregar os correspondentes indicados. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  correspondentCover: {
    sectionTitle: 'Dados cadastrais',
    internationalId: 'Documento de Identificação Internacional',
    legalName: 'Razão Social',
    name: 'Nome',
    fantasyName: 'Nome fantasia',
    accessEmail: 'Email de acesso',
    landline: 'Telefone fixo',
    cellphone: 'Celular'
  },

  correspondentContactEmail: {
    sectionTitle: 'Emails operacionais',
    sectionRegister: 'Cadastro',
    sectionOperation: 'Operação',
    sectionDocumentation: 'Documentação',
    sectionFinancial: 'Financeiro',
    firstEmail: 'Primeiro email',
    secondEmail: 'Segundo email',
    thirdEmail: 'Terceiro email'
  },

  correspondentPartnersShareholders: {
    sectionTitle: 'Sócios e Acionistas',
    isLegalPerson: 'Pessoa Jurídica?',
    legalName: 'Razão Social',
    name: 'Nome',
    share: '% de participação'
  },

  correspondentAdministrative: {
    sectionTitle: 'Dados administrativos',
    operationTypes: 'Tipos de operação',
    tourismCommission: 'Comissão turismo(%)',
    remittanceCommission: 'Comissão remessa(%)',
    stablecoinMinimumSpread: 'Spread mínimo DolsPay (%)',
    stablecoinMaximumSpread: 'Spread máximo DolsPay (%)',
    stablecoinSpreadHint: 'Faixa de spread só deste corban. Vazia, vale a faixa geral de Configurações > DolsPay. O spread do cliente vale sempre.',
    stablecoinSpreadInverted: 'O spread mínimo não pode ser maior que o máximo.',
    tourismBanks: 'Bancos câmbio turismo',
    remittanceBanks: 'Bancos remessa internacional',
    loadExchangeTypesError: 'Não foi possível carregar os tipos de câmbio. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadBanksError: 'Não foi possível carregar a lista de bancos. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  correspondentInternationalBank: {
    sectionTitle: 'Dados bancários no exterior',
    accountQuestion: 'Deseja cadastrar uma conta no exterior?',
    description: 'Contas usadas para receber comissão no exterior. Os dados seguem o mesmo padrão das contas do cliente.',
    addAccount: 'Adicionar conta',
    emptyTitle: 'Nenhuma conta no exterior',
    emptySubtitle: 'Cadastre a conta do corban para recebimento no exterior.',
    confirmRemoveTitle: 'Remover conta?',
    confirmRemoveText: 'A conta {name} será removida do cadastro ao salvar.',
    removeAction: 'Remover',
    copySuffix: ' (cópia)'
  },

  correspondentFinancial: {
    sectionTitle: 'Dados bancários no Brasil',
    accountQuestion: 'Deseja cadastrar uma conta no Brasil?'
  },

  notices: {
    audience: {
      ALL: 'Todos os usuários',
      ADMIN: 'Administrativo',
      CORBAN: 'Corbans',
      CUSTOMER: 'Clientes'
    },
    status: {
      active: 'Ativo',
      expired: 'Encerrado',
      cancelled: 'Cancelado'
    },
    control: {
      new: 'Novo informativo',
      search: 'Pesquisar',
      empty: 'Nenhum informativo cadastrado.',
      corbanCount: '{count} corban | {count} corbans',
      requiresAck: 'Leitura obrigatória',
      cancel: 'Cancelar informativo',
      cancelTitle: 'Cancelar informativo?',
      cancelText: 'O informativo "{title}" deixa de aparecer para todos. Quem já leu continua registrado.',
      published: 'Informativo publicado.',
      updated: 'Informativo atualizado.',
      cancelled: 'Informativo cancelado.',
      loadError: 'Não foi possível carregar os informativos. Atualize a página e tente de novo.',
      saveError: 'Não foi possível salvar o informativo. Tente novamente; se continuar, fale com o suporte.',
      columns: {
        title: 'Título',
        audience: 'Público',
        period: 'Período',
        requiresAck: 'Confirmação',
        status: 'Status',
        reads: 'Leituras',
        createdBy: 'Criado por',
        actions: 'Ações'
      }
    },
    form: {
      newTitle: 'Novo informativo',
      editTitle: 'Editar informativo',
      publish: 'Publicar',
      title: 'Título',
      content: 'Conteúdo',
      contentRequired: 'Escreva o conteúdo do informativo.',
      audience: 'Exibir para',
      corbans: 'Corbans específicos',
      corbansHint: 'Deixe vazio para alcançar todos os corbans.',
      startsAt: 'Exibir a partir de',
      endsAt: 'Exibir até',
      requiresAck: 'Exigir confirmação de leitura',
      requiresAckHint: 'A tela fica travada até o usuário marcar "Li e estou ciente".',
      resetReads: 'Exigir nova confirmação de quem já leu',
      required: 'Campo obrigatório',
      endsBeforeStart: 'A data final não pode ser anterior à inicial.'
    },
    center: {
      acknowledge: 'Li e estou ciente',
      markRead: 'Marcar como lido',
      remaining: 'Mais {count} informativo aguarda sua confirmação. | Mais {count} informativos aguardam sua confirmação.',
      ackError: 'Não foi possível registrar a leitura. Tente novamente.'
    }
  },

  correspondentDocuments: {
    sectionTitle: 'Documentos',
    saveFirst: 'Salve o cadastro do corban para anexar documentos.',
    uploadLabel: 'Enviar um novo documento',
    uploadDefault: 'Escolha um arquivo ou arraste e solte aqui',
    uploadSpecs: 'Formatos JPEG, PNG e PDF, até 10MB',
    descriptionLabel: 'Descrição (opcional)',
    send: 'Enviar',
    empty: 'Nenhum documento anexado a este corban.',
    columns: {
      name: 'Arquivo',
      description: 'Descrição',
      size: 'Tamanho',
      sentAt: 'Enviado em',
      sentBy: 'Enviado por',
      actions: 'Ações'
    },
    download: 'Baixar',
    remove: 'Excluir',
    confirmRemoveTitle: 'Excluir documento?',
    confirmRemoveText: 'O arquivo {name} será removido do cadastro do corban. Esta ação não pode ser desfeita.',
    uploadSuccess: 'Documento enviado com sucesso.',
    uploadError: 'Não foi possível enviar o documento. Tente novamente; se continuar, fale com o suporte.',
    loadError: 'Não foi possível carregar os documentos do corban. Atualize a página e tente de novo.',
    downloadError: 'Não foi possível baixar o documento. Tente novamente; se continuar, fale com o suporte.',
    removeSuccess: 'Documento excluído.',
    removeError: 'Não foi possível excluir o documento. Tente novamente; se continuar, fale com o suporte.'
  },

  customerPaymentAccounts: {
    loadBanksError: 'A lista de bancos não carregou. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    bankNotFound: 'Banco de integração não encontrado para esta conta.',
    syncSuccess: 'Conta de pagamento sincronizada com sucesso',
    accountReactivated: 'Conta reativada com sucesso.',
    accountDeactivated: 'Conta inativada com sucesso.',
    toggleStatusError: 'O status da conta não foi alterado. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    syncError: 'A conta de pagamento não foi sincronizada com o banco. Confira os dados da conta e tente novamente.',
    deactivateButtonLabel: 'Inativar'
  },

  bankContactEmail: {
    nothingToCopy: 'Nada para copiar: os campos de Pessoa Jurídica já estão preenchidos.',
    emailsCopied: '{count} e-mail copiado de Pessoa Física. | {count} e-mails copiados de Pessoa Física.'
  },

  bankBrandAssets: {
    brandAssetValidationUi: {
      embeddedPage: 'conteúdo de página embutido',
      eventHandler: 'ação ao clicar ou ao abrir',
      scriptLink: 'link que executa código',
      tooLarge: 'é grande demais: o limite é de {limit} caracteres. Use uma versão otimizada do SVG',
      notSvg: 'precisa ser um arquivo SVG. Exporte a imagem no formato SVG e envie de novo',
      forbiddenContent: 'tem conteúdo que não é permitido em imagem ({content}). Exporte o SVG de novo, sem scripts nem interações'
    },
    fileReadError: 'Não foi possível ler o arquivo selecionado para {fieldLabel}.',
    validationError: '{fieldLabel} {error}.'
  },

  customerBankStatement: {
    noLimits: 'Não há limites cadastrados para este banco',
    noOperations: 'Não há operações realizadas para este banco',
    statementMenuLabel: 'Extrato de movimentação',
    statementTitle: 'Extrato de movimentações - {name} - {bank}',
    startDate: 'Data Inicial',
    endDate: 'Data Final',
    applyFilter: 'Aplicar filtro',
    limitAvailableIn: 'Limite Disponível Entrada',
    limitAvailableOut: 'Limite Disponível Saída',
    limitAvailable: 'Limite Disponível',
    noData: 'Não há informações',
    movementIn: 'Movimentação Entrada',
    movementOut: 'Movimentação Saída',
    colDate: 'Data',
    colLimitIn: 'Limite Entrada',
    colLimitOut: 'Limite Saída',
    colOperationAmount: 'Valor da Operação ME',
    colMoveIn: 'Movimentação Entrada',
    colMoveOut: 'Movimentação Saída',
    colOperationCode: 'Código da Operação',
    colActions: 'Ações'
  },

  customerSummaryHeader: {
    copiedToClipboard: 'Copiado para a área de transferência!',
    copyError: 'Não foi possível copiar. Selecione o texto e copie manualmente (Ctrl+C).'
  },

  customerNationalBankModal: {
    editBankTitle: 'Editar conta bancária no Brasil',
    addBankTitle: 'Adicionar conta bancária no Brasil',
    integratedAccountUpdates: 'Esta conta já foi enviada aos provedores. Se você trocar a chave PIX, ao salvar ela é atualizada neles também.',
    accountAddedPendingSave: 'Conta adicionada. Salve o cliente para confirmar.',
    accountSaveErrorFallback: 'A conta não foi salva. Confira os dados bancários e tente novamente.'
  },

  bankAccountProviderSync: {
    savingWithProviders: 'Salvando a conta e enviando aos provedores…',
    saved: 'Conta salva.',
    savedSuccess: 'Conta salva com sucesso.',
    sentTo: 'Enviada a {providers}.',
    and: 'e',
    providerIssue: '{provider}: {message}',
    sendFailed: 'não foi possível enviar agora.',
    inUseNow: 'Esta conta entrou numa operação agora e continua como estava neste provedor. Depois que a operação terminar, salve a conta de novo para atualizar o provedor.',
    replaceFailed: 'Não foi possível trocar a conta neste provedor agora, e ela continua como estava lá. Salve a conta de novo para tentar outra vez.',
    notice: {
      in_progress: 'Conta salva. O envio aos provedores ainda está em andamento; a situação aparece no card em instantes.',
      unreachable: 'Conta salva, mas não foi possível falar com os provedores agora. Use "Sincronizar" no card da conta.'
    }
  },

  customerInternationalBankModal: {
    integratedAccountUpdates: 'Esta conta já foi enviada aos provedores. Se você alterar os dados, ao salvar ela é atualizada neles também.',
    requiredFieldsError: 'Existem campos obrigatórios não preenchidos. Revise os campos em vermelho.',
    accountSaveError: 'A conta não foi salva. Confira os dados bancários e tente novamente.'
  },

  customerUpgradeRegistrationModal: {
    assetsRequired: 'O campo Patrimônio é obrigatório.',
    attachIrDocs: 'Anexe o Recibo e a Declaração de IR para progredir o cadastro.',
    confirmTitle: 'Progredir cadastro?',
    confirmMessage: 'Deseja progredir o cadastro deste cliente para Pessoa Física Completo?',
    confirmButtonLabel: 'Progredir cadastro',
    infoText: 'Para progredir a ficha para Pessoa Física Completo, informe os dados abaixo.',
    patrimonyLabel: 'Patrimônio',
    motherNameLabel: 'Nome da mãe',
    irReceiptDescription: 'Recibo de imposto de renda',
    progressionTitle: 'Progressão de cadastro',
    cancelLabel: 'Cancelar',
    documentsLabel: 'Documentos (obrigatório)',
    declarationIrLabel: 'Declaração de imposto de renda',
    loadingDocType: 'Carregando tipo do documento…'
  },

  customerUpgradeExchangeToBasicModal: {
    loadNaturesError: 'Não foi possível carregar naturezas de operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    attachAddressProof: 'Anexe o Comprovante de endereço para progredir o cadastro.',
    confirmTitle: 'Progredir cadastro?',
    confirmMessage: 'Deseja progredir o cadastro deste cliente para Pessoa Física Básico?',
    confirmButtonLabel: 'Progredir cadastro',
    infoText: 'Para progredir a ficha para Pessoa Física Básico, informe os dados abaixo.',
    documentsLabel: 'Documentos (obrigatório)',
    addressProofDescription: 'Comprovante de endereço',
    progressionTitle: 'Progressão de cadastro',
    cancelLabel: 'Cancelar',
    loadingDocType: 'Carregando tipo do documento…'
  },

  correspondentSelect: {
    loadError: 'Não foi possível carregar a lista de correspondentes. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  customerSpreads: {
    loadPartnerFeesError: 'Não foi possível carregar a lista de spreads. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    loadCurrenciesError: 'Não foi possível carregar a lista de moedas. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  incomeTaxStatement: {
    generateError: 'Não foi possível gerar o extrato. Confira o ano e o modelo escolhidos e tente de novo; se continuar, fale com o suporte.',
    loadLayoutsError: 'Não foi possível carregar os modelos de extrato. Atualize a página e tente de novo; se continuar, fale com o suporte.',
    title: 'Extrato para Imposto de Renda',
    generateButton: 'Gerar extrato',
    generateSuccess: 'Extrato gerado e salvo em Documentos emitidos.',
    infoText: 'O extrato considera somente as operações liquidadas no ano escolhido, agrupadas por banco.'
  },

  approvalTermsDialog: {
    versionMeta: 'Versão {version} · atualizado em {updatedAt}'
  },

  stablecoinLimitsDialog: {
    operation: 'Operação: #{operationId}'
  },

  partnerDialog: {
    partnerLinked: 'Sócio vinculado a cliente existente',
    linkRemoved: 'Vínculo removido e dados limpos.'
  },

  signatureCredentialsConfiguration: {
    defaultPlayerWarning: 'O player padrão ({defaultPlayer}) ainda não tem credenciais configuradas. Envios de fichas para assinatura não vão funcionar até que ele seja configurado.'
  },

  documentGenerationStepper: {
    generateSuccess: 'Documento gerado com sucesso!',
    generateError: 'Não foi possível salvar o documento. Tente novamente.'
  },

  customerContactFormDialog: {
    contactUpdated: 'Contato atualizado com sucesso.',
    contactCreated: 'Contato criado com sucesso.',
    contactSaveError: 'Não foi possível salvar o contato. Confira nome, e-mail e telefone e tente novamente; se continuar, fale com o suporte.'
  },

  unblockOnboardingModal: {
    linkCopied: 'Link copiado'
  },

  customerStablecoinReceiver: {
    receiverSynced: 'Receiver sincronizado com sucesso',
    loadReceiverError: 'O cadastro DolsPay do cliente não carregou. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    syncError: 'O cadastro DolsPay não foi atualizado. Tente novamente em alguns instantes; se continuar, fale com o suporte.'
  },

  bankDocumentsExternalAccess: {
    pageTitle: 'Documentos da Operação',
    pageSubtitle: 'Acompanhamento de documentos pelo banco',
    downloadDuimpTooltip: 'Baixar documento DUIMP',
    rejectDuimpTitle: 'Recusar DUIMP',
    pendingValidationTitle: 'Validação pendente',
    loadError: 'Não foi possível carregar operação. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    downloadError: 'Não foi possível baixar documento. Tente baixar novamente; se continuar, fale com o suporte.',
    duimpApproved: 'DUIMP {protocol} aprovada com sucesso.',
    duimpApproveError: 'Não foi possível aprovar DUIMP. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    duimpRejected: 'DUIMP {protocol} recusada.',
    duimpRejectError: 'Não foi possível recusar DUIMP. Tente novamente em alguns instantes; se continuar, fale com o suporte.',
    confirmRejectButton: 'Confirmar recusa',
    invalidLink: 'Link inválido ou expirado',
    invalidLinkDesc: 'Este link não é mais válido. Solicite um novo link de acesso à equipe responsável.',
    operationTitle: 'Operação #{id}',
    creationDate: 'Data de criação',
    analyzeDuimpsHint: 'Analise as DUIMPs abaixo e registre seu parecer',
    operationObservation: 'Observação da operação',
    nature: 'Natureza',
    currency: 'Moeda',
    value: 'Valor',
    supplier: 'Fornecedor',
    duimpStatus: 'Status DUIMP',
    originDestination: 'Origem / Destino',
    latestClientUpdate: 'Última atualização do cliente',
    duimpAttached: 'DUIMP/DU-E anexada',
    observation: 'Observação',
    duimpsSent: 'DUIMP/DU-E enviados',
    duimpsPendingValidation: 'Existem DUIMPs pendentes de validação',
    merchandiseStage: 'Estágio da mercadoria',
    newExpectedDate: 'Nova data prevista',
    accessKey: 'Chave de acesso',
    sentAt: 'Enviado em',
    approveButton: 'Aprovar',
    rejectButton: 'Recusar',
    historyButton: 'Histórico',
    noDuimpsInformed: 'Nenhuma DUIMP foi informada.',
    documentApproved: 'Documento aprovado',
    documentRejected: 'Documento reprovado',
    noDocument: 'Sem doc.',
    invoicesTitle: 'Invoices',
    noInvoicesInformed: 'Nenhum invoice foi informado.',
    invoiceNumberLabel: 'Número',
    shippingForecastLabel: 'Previsão embarque',
    noOperationDocuments: 'Nenhum documento da operação foi informado.',
    complementaryDocumentsTitle: 'Documentos complementares',
    rejectReasonPrompt: 'Informe o motivo da recusa para a DUIMP {protocol}:',
    rejectReasonLabel: 'Motivo da recusa',
    rejectReasonMinChars: 'Mínimo 20 caracteres',
    exitWithoutValidationPrompt: 'Você ainda não aprovou ou recusou todas as DUIMPs desta operação. Deseja realmente sair sem concluir a validação?'
  },

  remittanceOperationReport: {
    sendToClientConfirmMsg: 'Deseja enviar ao cliente?',
    sendToClientConfirmTitle: 'Enviar ao cliente?',
    whatsappConfirmMsg: 'Deseja enviar notificação por WhatsApp ao cliente sobre a liquidação (SWIFT)?',
    whatsappConfirmTitle: 'Notificar por WhatsApp?',
    cancelConfirmMsg: 'Deseja cancelar essa operação?',
    cancelConfirmTitle: 'Cancelar operação?'
  },

  stablecoinRemittanceOperationReport: {
    sendToClientConfirmMsg: 'Deseja enviar ao cliente?',
    sendToClientConfirmTitle: 'Enviar ao cliente?',
    whatsappConfirmMsg: 'Deseja enviar notificação por WhatsApp ao cliente sobre a liquidação (SWIFT)?',
    whatsappConfirmTitle: 'Notificar por WhatsApp?',
    emptyByClient: 'fechadas pelo cliente',
    emptyByDesk: 'fechadas pela mesa',
    emptyMessage: 'Não há operações de Câmbio Remessa {origin} para o período selecionado.',
    noPayInFound: 'Nenhum pagamento encontrado para esta operação.',
    loadPayInData: 'Os dados do pagamento não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  exchangeOperationReport: {
    cancelConfirmMsg: 'Deseja cancelar essa operação?',
    cancelModalTitle: 'Cancelar operação?',
    complementaryInfoTitle: 'Informação complementar',
    saveObservationError: 'Não foi possível salvar observação. Confira os dados e tente novamente; se continuar, fale com o suporte.'
  },

  customerSendDocumentsModal: {
    cancelSendTitle: 'Cancelar envio?'
  },

  duimpDueOperationReport: {
    sendToClientConfirmMsg: 'Deseja enviar ao cliente?',
    sendToClientConfirmTitle: 'Enviar ao cliente?',
    cancelConfirmMsg: 'Deseja cancelar essa operação?',
    cancelConfirmTitle: 'Cancelar operação?',
    noSolutionConfirmMsg: 'Deseja marcar essa operação como Sem Solução?',
    noSolutionConfirmTitle: 'Sem Solução?',
    resendDocsConfirmMsg: 'Deseja reenviar os documentos da operação para o banco?',
    resendDocsConfirmTitle: 'Reenviar documentos para o banco?'
  },

  customerExchangeBanks: {
    sendToIntegrationMsg: 'Deseja enviar o cliente para integração com {bankName}?',
    sendToIntegrationTitle: 'Enviar para integração bancária?'
  },

  digitalRemittanceProfitCard: {
    grossProfit: 'Lucro bruto',
    totalSpreadTooltip: 'Total do spread cobrado na operação, antes da divisão com o banco.',
    bankProfit: 'Lucro bancário:',
    operationalCost: 'Custo operacional',
    netProfit: 'Lucro líquido',
    commissions: 'Comissões',
    corbanLabel: 'Corban – {percentage}',
    corbanMasterLabel: 'Corban master – {percentage}'
  },

  digitalRemittanceQuotationResult: {
    clientReceivesOnAccount: 'Chega na conta',
    clientReceivesInWallet: 'Cliente recebe na carteira',
    clientReceives: 'Cliente recebe',
    viewProgress: 'Ver andamento',
    viewSentLink: 'Ver link enviado',
    sendLinkToClient: 'Enviar link ao cliente',
    sendPayment: 'Enviar pagamento',
    generatePixCode: 'Gerar código PIX',
    generatePaymentData: 'Gerar dados para pagamento'
  },

  duimpExternalAccess: {
    pageSubtitle: 'Envio de documentos de Comex',
    allPendingTab: 'Todas as Pendências',
    emptyPending: 'Nenhuma pendência de DUIMP/DU-E encontrada.',
    welcomeModalTitle: 'Pendência de DUIMP/DU-E',
    welcomeModalAlertTitle: 'Documentos de Comex pendentes',
    welcomeModalBody: 'Você recebeu este link porque há documentos de Comex pendentes para regularização do seu contrato de câmbio. Para evitar novas cobranças e manter sua operação em dia, selecione uma das opções abaixo.',
    sendNowSubtitle: 'Enviar a DUIMP/DU-E agora',
    loadError: 'Não foi possível carregar pendências. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.',
    invalidLink: 'Link inválido ou expirado',
    invalidLinkDesc: 'Este link não é mais válido. Solicite um novo link de acesso à equipe responsável.',
    currentOperationTab: 'Operação Atual',
    currentOperationDocsTab: 'Documentos da operação atual',
    natureza: 'Natureza',
    currency: 'Moeda',
    supplier: 'Fornecedor',
    duimpStatus: 'Status DUIMP',
    createdAt: 'Criação',
    delay: 'Atraso',
    haveAccessKey: 'Tenho a chave de acesso',
    dontHaveKey: 'Ainda não tenho',
    informMerchandiseStage: 'Informar o estágio da mercadoria',
    downloadError: 'Não foi possível baixar documento. Tente baixar novamente; se continuar, fale com o suporte.',
    noDocuments: 'Nenhum documento encontrado para esta operação.'
  },

  openOperationsReport: {
    chipBuy: 'Compra',
    chipSell: 'Venda',
    typeRemittanceBuy: 'Remessa de Compra',
    typeRemittanceSell: 'Remessa de Venda',
    typeBuyME: 'Compra de M.E.',
    typeSellME: 'Venda de M.E.',
    statusWaiting: 'Aguardando',
    statusSendingFromWallet: 'Enviando da carteira',
    statusWaitingPayment: 'Aguardando Pagamento',
    statusBrlReceived: 'Reais Recebido',
    statusNotCompleted: 'Não concluído',
    noPayInFound: 'Nenhum Pay In encontrado para esta pré-venda.',
    payinStatusPending: 'Pendente',
    payinStatusProcessing: 'Aguardando Pagamento',
    payinStatusReceived: 'Reais Recebido',
    payinStatusNotCompleted: 'Não concluído',
    payinStatusExpired: 'Expirado',
    payinStatusCancelled: 'Cancelado',
    payinStatusIgnored: 'Ignorado',
    payinStatusRefunded: 'Reembolsado',
    payinStatusOnHold: 'Em Espera',
    payoutStatusPending: 'Pendente',
    payoutStatusApprovalRequired: 'Aprovação Necessária',
    payoutStatusApproved: 'Aprovado',
    payoutStatusProcessing: 'Processando',
    payoutStatusCompleted: 'Liquidado',
    payoutStatusNotCompleted: 'Não concluído',
    payoutStatusCancelled: 'Cancelado',
    payoutStatusIgnored: 'Ignorado',
    payoutStatusRefunded: 'Reembolsado',
    payoutStatusOnHold: 'Em Espera',
    pixExpired: 'Expirado',
    loadPayInData: 'Os dados do pagamento não carregaram. Atualize a página (F5) e tente novamente; se continuar, fale com o suporte.'
  },

  operationDocuments: {
    sectionTitle: 'Documentos da operação'
  },

  stablecoinRemittanceOperationManagementReport: {
    profitColumnLabel: 'Lucro {name}'
  },

  digitalRemittancePixScreen: {
    canCloseNowHint: 'Você já pode fechar esta tela usando os botões abaixo.',
    valuePaid: 'Valor pago',
    valueToPay: 'Valor a pagar',
    paymentConfirmed: 'Pagamento confirmado com sucesso!',
    pixExpiredFailed: 'PIX expirado — pagamento não confirmado.',
    paymentNotConfirmed: 'Pagamento não confirmado.',
    requoteHintPix: 'Clique em "Cotar novamente" para gerar um novo código PIX com a taxa atual.',
    requoteHintOther: 'Clique em "Cotar novamente" para gerar novos dados de pagamento com a taxa atual.',
    openBankAndPayPix: 'Abra seu banco e pague pelo código PIX abaixo.',
    copyPixCodeHint: 'Ou copie o código PIX:',
    copyButton: 'Copiar',
    copyPixTooltip: 'Copiar código PIX',
    pixCodeUnavailable: 'Código PIX não disponível',
    expirationNotAvailable: 'Não disponível',
    expired: 'Expirado',
    paymentConfirmedTimer: 'Pagamento confirmado',
    pixExpiredTimer: 'PIX expirado',
    paymentNotConfirmedTimer: 'Pagamento não confirmado',
    waitingPaymentTimer: 'Aguardando o pagamento',
    expiresIn: 'Expira em {time}',
    qrCodeGenerationError: 'O QR Code do PIX não foi gerado. Copie o código PIX abaixo e envie ao cliente.',
    pixCopied: 'Código PIX copiado para a área de transferência!',
    pixCopyError: 'Não foi possível copiar código PIX. Tente copiar manualmente.'
  },

  digitalRemittancePixModal: {
    requoteButton: 'Cotar novamente',
    sendPixWhatsAppTooltip: 'Enviar chave PIX para o WhatsApp do cliente',
    pixWhatsAppSendSuccess: 'PIX enviado para o WhatsApp do cliente!',
    pixWhatsAppSendError: 'O PIX não foi enviado pelo WhatsApp. Copie o código PIX e envie ao cliente por outro canal.',
    newOperationButton: 'Nova operação',
    sendPixButton: 'Enviar PIX',
    goToOpenOperationsButton: 'Ir para pré-venda',
    paymentViaMethod: 'Pagamento via {method}',
    paymentCompleted: '{title} — Concluído'
  },

  digitalRemittanceSidebar: {
    summaryTitle: 'Resumo'
  },

  digitalRemittancePaymentInstruction: {
    dataGeneratingHint: 'Os dados para pagamento estão sendo gerados e aparecem aqui em instantes.',
    accountTypeChecking: 'Corrente',
    accountTypeSavings: 'Poupança',
    leadClabe: 'Transfira pelo SPEI para a CLABE abaixo, da conta do próprio cliente.',
    leadBankTransfer: 'Transfira pelo Transfers 3.0 para a conta abaixo, a partir do CUIT/CUIL do próprio cliente.',
    leadCheckoutLink: 'Conclua o pagamento pelo link abaixo.',
    leadBankDetails: 'Faça um {method} para a conta abaixo e informe o código de referência na descrição da transferência.',
    leadDefault: 'Use os dados abaixo para pagar.',
    methodFallback: 'transferência',
    customer: {
      leadClabe: 'Transfira pelo SPEI para a CLABE abaixo, de uma conta em seu nome.',
      leadBankTransfer: 'Faça uma transferência bancária para a conta abaixo, de uma conta em seu nome (no seu CUIT/CUIL).',
      leadDebit: 'Débito automático: o valor sai da conta nos EUA que você conectou e autorizou.'
    },
    leadDebit: 'Débito automático: o valor é debitado da conta nos EUA que o cliente conectou e autorizou no link.',
    fieldClabe: 'CLABE',
    fieldCbuCvu: 'CBU/CVU',
    fieldAccountType: 'Tipo de conta',
    fieldTaxId: 'CUIT do destinatário',
    fieldMemoCode: 'Código de referência',
    memoRequiredLabel: 'Código de referência (obrigatório)',
    memoWarning: 'Informe este código na descrição da transferência. Sem ele, o pagamento não é identificado e o valor é devolvido para a conta de origem.',
    fieldBankName: 'Banco',
    fieldRoutingNumber: 'Routing number',
    fieldAccountNumber: 'Número da conta',
    fieldBeneficiaryName: 'Beneficiário',
    fieldBeneficiaryAddress: 'Endereço do beneficiário',
    fieldBankAddress: 'Endereço do banco',
    fieldPaymentLink: 'Link de pagamento',
    copyTooltip: 'Copiar {label}',
    copiedSuccess: '{label} copiado.',
    copyError: 'Não foi possível copiar. Selecione o texto e copie manualmente.'
  },

  bankAccountCard: {
    accountDataCopied: 'Dados da conta copiados.'
  },

  internationalBankAccountCard: {
    accountDataCopied: 'Dados da conta copiados.'
  },

  wizardPjCustomer: {
    actionsUi: {
      next: 'Próximo',
      finishRegistration: 'Finalizar Cadastro'
    },
    steps: {
      registrationData: 'Dados Cadastrais',
      compliance: 'Compliance',
      bankingData: 'Dados Bancários',
      documents: 'Documentos',
      partners: 'Sócios',
      userAgreement: 'Acordo de Usuário'
    },
    missingDocsGeneric: 'Preencha todos os documentos obrigatórios da empresa antes de prosseguir.',
    docAddressProof: 'Comprovante de endereço da empresa',
    docRevenue12m: 'Faturamento dos últimos 12 meses',
    docDreOrPgdas: 'DRE ou Recibo PGDAS',
    docCnpjCard: 'Cartão CNPJ',
    docSocialContract: 'Contrato social / Estatuto social',
    docBalanceOrPgdas: 'Balanço ou PGDAS (Declaração)',
    missingDocsList: 'Preencha todos os documentos obrigatórios da empresa: {docs}.',
    fillRequiredBeforeContinue: 'Por favor, preencha todos os campos obrigatórios antes de continuar.',
    fillAddressBeforeContinue: 'Preencha o endereço da empresa antes de continuar.',
    requireBrazilBankAccount: 'É necessário cadastrar pelo menos uma conta bancária no Brasil.',
    partnerShareRequired: 'A participação total dos sócios deve somar 100% para prosseguir.',
    addOnePartnerWithData: 'Adicione pelo menos um sócio e preencha todos os dados obrigatórios (nome, documento, e-mail, celular, endereço e, para pessoa física, data de nascimento).',
    addOnePartner: 'Adicione pelo menos um sócio com todos os dados obrigatórios preenchidos.',
    partnerShareRequiredFinish: 'A participação total dos sócios deve somar 100% para finalizar o cadastro.',
    fillPartnerDataRequired: 'Preencha todos os dados obrigatórios de cada sócio (nome, documento, e-mail, celular, endereço e, para pessoa física, data de nascimento).',
    fillRequiredBeforeFinish: 'Por favor, preencha todos os campos obrigatórios antes de finalizar.'
  },

  formCurrency: {
    currencyLiquidationConfigUi: {
      title: 'Horários de Liquidação por Banco',
      subtitle: 'Defina o horário limite de liquidação para cada banco ativo. Todos os bancos devem ser configurados antes de salvar.',
      bulkFillTitle: 'Preencher todos os bancos',
      sell: 'Venda',
      buy: 'Compra',
      applyToAll: 'Aplicar a todos',
      bulkFillHint: 'Os horários informados irão sobrescrever os valores já preenchidos em todos os bancos.',
      emptyState: 'Nenhum banco ativo encontrado. A moeda será criada sem configuração de horários.'
    }
  },

  supportWidget: {
    supportWidgetHostUi: {
      panelLabel: 'Suporte',
      frameTitle: 'Suporte'
    },
    supportWidgetLauncherUi: {
      open: 'Abrir o suporte',
      dismiss: 'Esconder o suporte'
    }
  },

  backendErrors: {
    ERR_AUTH_001: 'Usuário ou senha inválidos',
    ERR_AUTH_002: 'Sessão encerrada. Faça login novamente para continuar',
    ERR_AUTH_003: 'Muitas tentativas de acesso. Aguarde alguns minutos antes de tentar novamente',
    ERR_AUTH_004: 'Você não tem permissão para realizar esta ação',
    ERR_AUTH_005: 'Autenticação necessária. Faça login para continuar',
    ERR_AUTH_006: 'Não foi possível entrar com o {provedor}. Tente de novo',
    ERR_AUTH_007: 'O tempo para vincular acabou. Clique em Fazer login com o {provedor} de novo',
    ERR_AUTH_008: 'Esta conta {provedor} já está vinculada a outro acesso. Entre com seu e-mail e senha ou use outra conta {provedor}',
    ERR_AUTH_009: 'Entrar com {provedor} não está disponível no momento. Use seu e-mail e senha',
    ERR_AUTH_010: 'Não encontramos essa conta vinculada. Atualize a página e tente de novo',
    ERR_AUTH_011: 'Este acesso abre só a ficha de cadastro. Para continuar, use o link enviado ao seu e-mail',
    ERR_AUTH_012: 'Este link não vale mais ou está incompleto. Peça um novo link a quem enviou',
    ERR_AUTH_013: 'Senha atual incorreta',
    ERR_FX_001: 'Operação não localizada. Verifique o número da operação',
    ERR_FX_002: 'Valor fora dos limites permitidos para sua conta. Verifique os limites mínimo e máximo disponíveis',
    ERR_FX_003: 'Cotação expirada. Solicite uma nova cotação para continuar',
    ERR_FX_004: 'Valor inválido. Verifique o valor informado e tente novamente',
    ERR_FX_005: 'Documento obrigatório não encontrado. Verifique os anexos da operação',
    ERR_FX_006: 'Esta forma de pagamento não está disponível para esta operação no momento. Tente outra opção',
    ERR_FX_007: 'Modelo de documento não disponível para esta operação. Acione o suporte técnico',
    ERR_FX_008: 'Feriado não encontrado. Ele pode ter sido excluído; atualize a página e tente de novo.',
    ERR_FX_009: 'Moeda não encontrada. Atualize a página e tente de novo.',
    ERR_FX_010: 'O status desta operação vem do banco integrado. Use Resincronizar status para atualizar.',
    ERR_FX_011: 'Esta operação está no banco integrado e não pode ser cancelada por aqui. Use Resincronizar status para ver o status no banco.',
    ERR_FX_012: 'Esta operação já foi enviada ao banco integrado e não pode ser editada. Use Resincronizar status para ver o status no banco.',
    ERR_FX_013: 'A conta no exterior escolhida não está aprovada neste banco. Escolha uma conta aprovada.',
    ERR_FX_014: 'A natureza escolhida ainda não é integrada com este banco. Escolha uma natureza integrada.',
    ERR_FX_015: 'Este banco não está com operação integrada. Escolha um banco integrado para enviar a operação.',
    ERR_FX_016: 'Escolha uma cotação do banco antes de gravar a operação.',
    ERR_FX_017: 'A cotação do banco venceu. Atualize a cotação e grave de novo.',
    ERR_FX_018: 'Escolha a conta no exterior de quem vai pagar esta operação.',
    ERR_FX_019: 'Escolha a conta no exterior que vai receber esta operação.',
    ERR_FX_020: 'Escolha a conta do cliente no Brasil para esta operação.',
    ERR_FX_021: 'Esta operação não foi enviada a um banco integrado.',
    ERR_FX_022: 'Só operações com envio ao banco não concluído podem ser reenviadas ao banco.',
    ERR_FX_023: 'Esta operação só podia ser reenviada ao banco no dia em que foi criada. Cancele a operação e crie outra.',
    ERR_FX_024: 'O banco ainda não tem registro desta operação. Reenvie ao banco.',
    ERR_FX_025: 'O documento do banco ainda não foi baixado. Tente de novo em alguns minutos.',
    ERR_FX_026: 'Este prazo de liquidação não está disponível no banco agora. Escolha outro prazo.',
    ERR_SC_001: 'Cadastro DolsPay não localizado. Verifique seu cadastro ou inicie uma nova ativação',
    ERR_SC_002: 'Seu cadastro DolsPay ainda está em análise. Acompanhe o status na tela de cadastro',
    ERR_SC_003: 'Carteira digital não localizada. Verifique seu cadastro ou entre na tela de ativação',
    ERR_SC_004: 'Carteira digital inativa. Acesse a tela de cadastro para verificar o status',
    ERR_SC_005: 'A conta bancária escolhida não foi encontrada no cadastro do cliente. Recarregue a página e selecione a conta de novo',
    ERR_SC_006: 'Pagamento não localizado. Verifique o histórico de pagamentos',
    ERR_SC_007: 'Transferência não localizada. Verifique o histórico de transferências',
    ERR_SC_008: 'Cotação expirada. Solicite uma nova cotação para continuar',
    ERR_SC_009: 'Valor fora dos limites permitidos para esta operação. Verifique os limites disponíveis',
    ERR_SC_010: 'O serviço de pagamento está indisponível agora. Aguarde alguns minutos e tente de novo. Se continuar, fale com o suporte informando a referência',
    ERR_SC_011: 'No momento, não há provedor disponível para esta operação. Tente novamente mais tarde ou fale com o suporte',
    ERR_SC_012: 'O DolsPay ainda não está ativo para sua conta. Complete o cadastro para habilitar esta função',
    ERR_SC_013: 'Cotação não localizada. Gere uma nova cotação para continuar',
    ERR_SC_014: 'Esta cotação não é compatível com a operação solicitada. Gere uma nova cotação',
    ERR_SC_015: 'Esta cotação não está mais disponível. Gere uma nova cotação para continuar',
    ERR_SC_016: 'Valor abaixo do mínimo permitido para transferências em EUR. Aumente o valor e tente novamente',
    ERR_SC_017: 'Conta EUR não aprovada. Cadastre e aguarde a aprovação de uma conta SEPA para operar em EUR',
    ERR_SC_018: 'Descrição obrigatória para transferências wire. Preencha o campo de descrição e tente novamente',
    ERR_SC_019: 'Documento de transação obrigatório não informado. Preencha todos os campos e tente novamente',
    ERR_SC_020: 'Cadastro já aprovado e ativo. Nenhuma ação necessária',
    ERR_SC_021: 'Já existe uma solicitação de aumento de limite em análise. Aguarde a conclusão antes de enviar uma nova',
    ERR_SC_022: 'Nenhuma documentação pendente encontrada. Seu cadastro está em dia',
    ERR_SC_023: 'Spread não encontrado. Atualize a página e escolha outro',
    ERR_SC_024: 'Serviço temporariamente indisponível. Tente novamente em instantes',
    ERR_SC_025: 'Requisição rejeitada por motivo de segurança. Tente novamente ou gere uma nova solicitação',
    ERR_SC_026: 'Dados do sócio incompletos. Verifique o nome e o percentual de participação',
    ERR_SC_027: 'Não foi possível enviar o arquivo. Verifique sua conexão e tente novamente',
    ERR_SC_028: 'Transação na rede não foi concluída. Verifique o status da operação e tente novamente',
    ERR_SC_029: 'Sócio não vinculado a um cadastro. Vincule o sócio ao cadastro antes de prosseguir',
    ERR_SC_030: 'Data de nascimento do sócio não cadastrada. Preencha a data de nascimento antes de continuar',
    ERR_SC_031: 'CPF do sócio não cadastrado. Preencha o CPF antes de continuar',
    ERR_SC_032: 'Endereço do sócio não cadastrado. Preencha o endereço antes de continuar',
    ERR_SC_033: 'Documentação adicional solicitada. Acesse a tela de cadastro para enviar os documentos pendentes',
    ERR_SC_034: 'A foto do documento está com qualidade insuficiente. Tire uma nova foto com boa iluminação, sem reflexos e com o documento inteiro visível',
    ERR_SC_035: 'O documento enviado não está legível. Tire uma nova foto em alta resolução, sem sombras e com todos os dados visíveis',
    ERR_SC_036: 'A selfie não corresponde ao documento enviado. Tire uma nova selfie em ambiente iluminado, sem óculos escuros, com o rosto centralizado',
    ERR_SC_037: 'O documento enviado não pôde ser verificado. Certifique-se de enviar o documento original, sem edições ou cópias de imagens',
    ERR_SC_038: 'O arquivo não foi recebido pelo banco digital. Envie novamente em formato JPG, PNG ou PDF (até 3MB)',
    ERR_SC_039: 'Formato de arquivo não aceito pelo banco digital. Envie em JPG, PNG ou PDF',
    ERR_SC_040: 'Arquivo acima do tamanho aceito. Envie o documento em JPG, PNG ou PDF com até 3MB',
    ERR_SC_041: 'O link do arquivo está inválido. Faça o upload do documento novamente e tente outra vez',
    ERR_SC_042: 'O banco digital não conseguiu acessar os arquivos. Envie os documentos novamente em JPG, PNG ou PDF',
    ERR_SC_043: 'O comprovante de endereço foi recusado. Envie um documento recente (últimos 3 meses), legível e com o endereço igual ao cadastrado',
    ERR_SC_044: 'O documento de identidade enviado está vencido. Envie um documento dentro do prazo de validade (RG, CNH ou Passaporte)',
    ERR_SC_045: 'O e-mail informado não é válido ou não pode receber mensagens. Atualize o e-mail no cadastro e tente novamente',
    ERR_SC_046: 'Os documentos enviados não passaram na verificação automática. Revise identidade, comprovante de endereço e selfie — todos devem estar legíveis e atualizados',
    ERR_SC_047: 'CPF ou CNPJ inválido para o banco digital. Verifique se o número está correto no cadastro',
    ERR_SC_048: 'Os termos de uso precisam ser aceitos antes de continuar. Acesse a tela de cadastro para aceitar os termos',
    ERR_SC_049: 'Os dados da conta bancária não foram aceitos pelo banco digital. Verifique os dados informados e tente novamente',
    ERR_SC_050: 'Foi detectada uma foto de tela em vez do documento original. Fotografe o documento diretamente, sem tirar foto do monitor ou imagem',
    ERR_SC_051: 'Foi detectada uma cópia de foto do documento. Envie uma foto original e direta do documento, sem fotografar outra foto ou impressão',
    ERR_SC_052: 'O verso do documento não foi enviado. Envie frente e verso do documento de identidade',
    ERR_SC_053: 'O tipo de documento selecionado não corresponde ao documento enviado. Verifique se selecionou o tipo correto (RG, CNH ou Passaporte)',
    ERR_SC_054: 'A selfie não foi aprovada. Tire uma nova selfie em ambiente bem iluminado, sem óculos escuros, com o rosto centralizado e próximo à câmera',
    ERR_SC_055: 'O nome no documento não confere com o nome cadastrado. Verifique se o nome está exatamente igual ao que aparece no documento',
    ERR_SC_056: 'A data de nascimento no documento não confere com a cadastrada. Corrija a data de nascimento no cadastro',
    ERR_SC_057: 'A data de emissão do documento não foi identificada. Envie um documento com a data de emissão visível',
    ERR_SC_058: 'O telefone informado está inválido. Informe o número completo com DDI e DDD (exemplo: +55 11 99999-9999)',
    ERR_SC_059: 'Os dados da operação foram recusados pelo provedor de pagamento. Revise os campos e tente novamente. Se persistir, acione o suporte com o código da referência',
    ERR_SC_060: 'A conta bancária está sem dados obrigatórios. Abra o cadastro da conta, complete os campos indicados e sincronize novamente',
    ERR_SC_061: 'Este método de pagamento não está disponível neste provedor. Abra o cadastro da conta e escolha outro método',
    ERR_SC_062: 'Para selfie e documento de identidade, envie uma foto em JPG ou PNG. PDF não é aceito para esse tipo de documento',
    ERR_SC_063: 'A chave PIX informada não é válida. Confira se ela está ativa no banco e foi digitada sem espaços',
    ERR_SC_064: 'Este número de roteamento (ABA) não aceita transferência wire. Confirme com o banco o ABA para wire, que costuma ser diferente do usado em ACH',
    ERR_SC_065: 'Para conta do próprio titular, o nome do beneficiário precisa ser igual ao nome do cliente. Corrija o nome no cadastro da conta',
    ERR_SC_066: 'O valor desta operação está acima do limite permitido por operação. Reduza o valor ou divida em mais de uma operação',
    ERR_SC_067: 'O valor mínimo por operação é de US$ 20,00, ou o equivalente na moeda de envio. Aumente o valor e tente novamente',
    ERR_SC_068: 'Este provedor está indisponível no momento. Use outro corredor ou acione o suporte',
    ERR_SC_069: 'Este provedor não está aceitando operações novas no momento',
    ERR_SC_070: 'Este provedor não opera este corredor no momento',
    ERR_SC_072: 'Este provedor cota pelo valor enviado. Informe o valor em reais para usar este corredor',
    ERR_SC_073: 'O cliente ainda não tem cadastro aprovado neste provedor',
    ERR_SC_074: 'O cadastro do cliente está bloqueado por compliance neste provedor',
    ERR_SC_075: 'O cliente não tem carteira ativa neste provedor',
    ERR_SC_101: 'Para operar só entrada ou só saída, o cliente precisa da carteira digital própria, e ele ainda não tem. Acione o suporte para criá-la',
    ERR_SC_076: 'Esta conta ainda não está liberada para receber pagamentos. Sincronize a conta em Canais bancários, no cadastro do cliente',
    ERR_SC_077: 'O spread selecionado não está registrado neste provedor. Sincronize os spreads ou escolha outro',
    ERR_SC_078: 'O provedor indicado para este valor não pode atender este cliente. Ajuste o cadastro ou acione o suporte antes de continuar',
    ERR_SC_079: 'Esta forma de pagamento está em fase de testes. Confira os dados da operação antes de confirmar',
    ERR_SC_080: 'O provedor preferido deste corredor não pôde atender, e a operação segue pelo alternativo. Confira o provedor antes de confirmar',
    ERR_SC_081: 'Não foi possível estimar o valor em dólar. Os limites do corredor serão conferidos na cotação',
    ERR_SC_082: 'O provedor fixo deste cliente não pôde atender esta operação, que segue pela regra do corredor. Confira o cadastro do cliente nesse provedor',
    ERR_SC_083: 'Desligar a integração do provedor para também os jobs e os webhooks das operações em andamento. Confirme a ação para continuar',
    ERR_SC_084: 'O sistema ainda não sabe executar este corredor neste provedor. Ele precisa ser implementado antes de ser liberado',
    ERR_SC_085: 'Descreva por que esta regra existe. É essa descrição que explica a escolha do provedor depois',
    ERR_SC_086: 'Informe os provedores da regra em ordem, cada um uma vez. Uma regra com um provedor só precisa estar sem alternativa',
    ERR_SC_087: 'A faixa de valor se sobrepõe a outra regra da mesma rota. Ajuste os limites antes de salvar',
    ERR_SC_088: 'Informe o motivo do provedor fixo para este cliente',
    ERR_SC_089: 'Escolha um provedor integrado ao sistema para ser o provedor fixo deste cliente',
    ERR_SC_090: 'Novos cadastros estão pausados neste provedor no momento. Tente novamente mais tarde ou fale com o suporte',
    ERR_SC_091: 'Um provedor desta regra ainda não tem esta forma de pagamento ligada. A regra passa a valer para ele quando o pagamento for ligado',
    ERR_SC_092: 'Este provedor atende esta forma de pagamento só para outro tipo de cliente (pessoa física ou jurídica)',
    ERR_SC_093: 'Informe o tipo de cliente como individual (pessoa física) ou business (pessoa jurídica), ou deixe vazio para valer para todos',
    ERR_SC_094: 'Este provedor não conseguiu cotar esta operação, e ela seguiu pelo próximo, quando havia',
    ERR_SC_133: 'O provedor de pagamento não aceitou esta operação agora. Faça a cotação de novo: ela segue por outro provedor, quando houver',
    ERR_SC_134: 'Este provedor não aceitou uma operação nesta forma de pagamento há pouco e fica de fora por alguns minutos. A operação segue pelo próximo, quando houver',
    ERR_SC_135: 'O cadastro do cliente foi aprovado neste provedor, mas esta forma de pagamento ainda não foi liberada para ele',
    ERR_SC_136: 'Esta conta está numa operação em andamento. Altere os dados dela depois que a operação terminar',
    ERR_SC_137: 'Esta conta veio do provedor com o número mascarado. Para alterar os dados, digite o número completo da conta',
    ERR_SC_138: 'PDF protegido em: {documents}. O banco parceiro não aceita PDF com senha ou trancado. Abra o arquivo, use Imprimir > Salvar como PDF e anexe a cópia nova',
    ERR_SC_139: 'O banco parceiro não aceitou o arquivo de: {documents}. Gere o arquivo de novo (Imprimir > Salvar como PDF) ou envie em JPG ou PNG',
    ERR_SC_140: 'O débito automático não está disponível para este cadastro. Pague por transferência',
    ERR_SC_141: 'Escolha a conta que vai pagar ou conecte uma conta nos EUA em seu nome',
    ERR_SC_142: 'Marque a autorização do débito para continuar',
    ERR_SC_143: 'Seu banco não autorizou o débito e nenhum valor saiu da sua conta. Tente com outra conta ou pague por transferência',
    ERR_SC_144: 'Para depositar nesta moeda, cadastre antes uma conta sua no país dela. O depósito precisa sair de uma conta no seu nome',
    ERR_SC_145: 'A conta escolhida não é sua ou não é desta moeda. Escolha outra conta para depositar',
    ERR_SC_146: 'Conta em libra não aprovada. Cadastre e aguarde a aprovação de uma conta Faster Payments para enviar libra',
    ERR_SC_147: 'Pagar nesta moeda não está disponível no momento. Por enquanto, ela só pode ser enviada ao destinatário',
    ERR_SC_148: 'Esta ação não está disponível para esta instituição. Atualize a tela e tente de novo',
    ERR_SC_149: 'Este campo é corrigido na ficha do cliente. Use o botão Preencher na ficha',
    ERR_SC_150: 'Confirme com o código que enviamos para o seu e-mail',
    ERR_SC_151: 'Não conseguimos ler este código de pagamento. Confira o código e tente de novo',
    ERR_SC_152: 'Este código já foi pago ou venceu e não pode mais ser pago. Peça ao emissor um código atualizado',
    ERR_SC_153: 'Este boleto vence antes do próximo dia útil e não dá mais para pagá-lo no prazo. Peça ao emissor um boleto atualizado',
    ERR_SC_154: 'Este código Pix não tem valor definido. Peça ao recebedor um código Pix com o valor',
    ERR_SC_155: 'Este tipo de conta ainda não pode ser paga pelo app. Você pode pagar boleto, conta de consumo, tributo e Pix copia e cola',
    ERR_SC_156: 'Este spread está fora da faixa permitida para corban. Escolha outro spread e tente de novo.',
    ERR_SC_157: 'Este código venceu. Clique em Reenviar código para receber um novo',
    ERR_SC_158: 'Código incorreto. Confira os 6 dígitos que enviamos para o seu e-mail',
    ERR_SC_159: 'Muitas tentativas com este código. Clique em Reenviar código para receber um novo',
    ERR_SC_160: 'Digite o código que enviamos para o seu e-mail antes de aprovar',
    ERR_SC_161: 'Não conseguimos enviar o código para o seu e-mail agora. Tente de novo em alguns minutos ou fale com quem enviou o link',
    ERR_SC_162: 'Confira os valores da operação antes de pedir o código',
    ERR_SC_163: 'A aprovação na sua carteira não foi concluída. Aprove de novo pela carteira e tente outra vez',
    ERR_SC_164: 'Para continuar, leia e aceite os termos de uso',
    ERR_SC_165: 'Nesta moeda o pagamento é em valor inteiro, sem centavos. Ajuste o valor e tente de novo',
    ERR_SC_095: 'O serviço de pagamento não aceitou os dados desta operação e não informou o motivo. Confira valor, moeda e conta escolhida. Se estiverem certos, fale com o suporte informando a referência; repetir sem mudar nada não resolve',
    ERR_SC_096: 'Para pagar nesta moeda, o cadastro do cliente precisa do documento fiscal do país do pagamento (na Argentina, o CUIT/CUIL). Inclua em Domicílio fiscal, no cadastro do cliente',
    ERR_SC_097: 'Com o pagamento em outra moeda, informe o valor na moeda do pagamento',
    ERR_SC_106: 'Para banco na Índia, informe o código IFSC da agência: 11 caracteres, como ICIC0005023 (4 letras do banco, um zero e 6 da agência)',
    ERR_SC_102: 'No pagamento só de saída, informe o valor em dólar ou na moeda de destino',
    ERR_SC_103: 'O saldo da carteira do cliente não cobre este pagamento. Reduza o valor ou faça antes uma entrada na aba Pay-in',
    ERR_SC_098: 'O valor mínimo para operações em euro é R$ 120,00',
    ERR_SC_099: 'Para pagar em peso colombiano, cadastre a conta bancária do cliente na Colômbia, com cédula (CC) ou NIT, e um celular colombiano (+57) no cadastro do cliente',
    ERR_SC_100: 'A conta bancária escolhida não está liberada para operações em stablecoin. Recarregue a página e selecione a conta de novo; se continuar, sincronize a conta na aba Canais bancários do cliente',
    ERR_SC_104: 'A carteira digital deste cadastro ainda não está pronta para esta operação. Fale com o atendimento',
    ERR_SC_130: 'Estamos preparando a carteira digital do cliente. Isso pode levar alguns segundos. Tente de novo em instantes',
    ERR_SC_107: 'Informe um e-mail válido no cadastro do cliente para criarmos a carteira digital dele',
    ERR_SC_108: 'Este link não vale mais. Se ainda precisar fazer esta operação, fale com quem enviou o link',
    ERR_SC_128: 'Este cliente já gerou o pagamento de outra operação nas últimas 24 horas. Confira antes de enviar outro link',
    ERR_SC_129: 'O cliente já gerou o pagamento deste link. Aguarde o pagamento ou o prazo para pagar vencer antes de reenviar o link',
    ERR_SC_132: 'Já mandamos um link a este cliente. Enviar outro cancela o anterior',
    ERR_SC_109: 'Aprove a operação antes de gerar o PIX',
    ERR_SC_110: 'Não conseguimos confirmar a sua aprovação. Clique em Aprovar para tentar de novo',
    ERR_SC_111: 'O saldo da carteira está menor que o valor desta operação. Fale com o atendimento',
    ERR_SC_112: 'Muitas tentativas seguidas. Aguarde alguns minutos e tente de novo',
    ERR_SC_113: 'Esta operação já foi aprovada. Agora é só pagar o PIX',
    ERR_SC_114: 'Este cliente aprova as operações pela própria carteira. Envie o link da operação para ele',
    ERR_SC_115: 'Não conseguimos consultar a rede agora. Tente de novo em alguns minutos',
    ERR_SC_116: 'A cotação foi atualizada. Confira os novos valores antes de aprovar',
    ERR_SC_117: 'Esta operação não pode ser aprovada pelo link no momento. Fale com o atendimento',
    ERR_SC_118: 'Confira o e-mail: ele precisa ser o mesmo do cadastro',
    ERR_SC_119: 'Este cliente aprova as operações pela própria carteira digital, que está ligada ao e-mail atual. Para trocar o e-mail, fale com o suporte',
    ERR_SC_120: 'Toda operação é aprovada pelo cliente no link da operação. Envie o link para ele',
    ERR_SC_121: 'Valor abaixo do mínimo para esta forma de recebimento. Aumente o valor e tente novamente',
    ERR_SC_122: 'Autorize o pagamento na sua carteira com o código enviado ao seu e-mail para continuar',
    ERR_SC_123: 'A autorização da sua carteira não confere com este pagamento. Faça uma nova cotação e autorize de novo',
    ERR_SC_124: 'A autorização da sua carteira ainda está sendo confirmada. Aguarde alguns segundos e tente de novo',
    ERR_SC_125: 'Este pagamento já foi enviado ou está sendo processado. Acompanhe o andamento antes de tentar de novo',
    ERR_SC_126: 'Estamos preparando a sua carteira para o envio. Aguarde alguns segundos e tente de novo',
    ERR_SC_127: 'Não foi possível preparar a sua carteira agora. Tente de novo em alguns minutos',
    ERR_SC_105: 'A pré-venda desta operação não está mais disponível. Gere uma nova cotação para continuar',
    ERR_VAL_001: 'Campos obrigatórios não preenchidos. Verifique e complete todas as informações solicitadas',
    ERR_VAL_002: 'Dados no formato incorreto. Verifique as informações e corrija antes de continuar',
    ERR_VAL_003: 'Não foi possível completar o cadastro com os dados informados. Verifique as informações e tente novamente',
    ERR_VAL_004: 'CPF inválido. Verifique os dígitos e tente novamente',
    ERR_VAL_005: 'CNPJ inválido. Verifique os dígitos e tente novamente',
    ERR_VAL_006: 'Formato de arquivo não aceito. Envie um arquivo JPG, PNG ou PDF',
    ERR_VAL_007: 'Arquivo muito grande. O tamanho máximo permitido é 5MB',
    ERR_VAL_008: 'Item não localizado. Verifique os dados informados e tente novamente',
    ERR_VAL_009: 'Este item já está cadastrado. Verifique se já existe um cadastro com esses dados',
    ERR_VAL_010: 'Tipo de documento não reconhecido. Envie documento de identidade (frente ou verso), selfie, comprovante de endereço ou contrato social',
    ERR_VAL_011: 'Nenhum arquivo foi enviado. Anexe o documento e tente novamente',
    ERR_VAL_012: 'Para clientes do Brasil, informe um CPF (11 dígitos) ou um CNPJ (14 dígitos)',
    ERR_VAL_013: 'Esta chave PIX já está cadastrada para este cliente. Remova a conta existente ou utilize outra chave PIX',
    ERR_VAL_014: 'Só é possível reativar cadastros inativados ou recusados. Atualize a página para ver o status atual do cliente',
    ERR_VAL_015: 'Escolha para qual status o cadastro volta: Finalizado ou Cadastro em análise',
    ERR_VAL_016: 'Informe o motivo da reativação. Ele fica registrado no histórico do cliente',
    ERR_VAL_017: 'Muitas buscas seguidas. Aguarde alguns segundos e tente de novo',
    ERR_VAL_018: 'O CUIT/CUIL informado em Domicílio fiscal (Argentina) não confere. Revise os 11 dígitos no documento do cliente',
    ERR_VAL_019: 'A cobrança desta invoice já foi enviada hoje. Você pode reenviar a partir de amanhã',
    ERR_VAL_020: 'O modelo do e-mail de cobrança de DUIMP está desligado em Configurações. Ligue o modelo e tente de novo',
    ERR_EXT_001: 'Serviço temporariamente indisponível. Aguarde alguns instantes e tente novamente',
    ERR_EXT_002: 'A operação demorou mais que o esperado. Verifique sua conexão e tente novamente',
    ERR_EXT_003: 'Não foi possível concluir o cadastro no momento. Aguarde alguns minutos e tente novamente',
    ERR_EXT_004: 'Não foi possível processar o pagamento no momento. Verifique seu histórico antes de tentar novamente',
    ERR_EXT_005: 'Serviço indisponível por problema de configuração. Acione o suporte técnico',
    ERR_EXT_006: 'A instituição não aceitou a resposta. Confira os campos indicados e envie de novo',
    ERR_INT_001: 'Não foi possível processar a solicitação no momento. Tente novamente e, se persistir, acione o suporte',
    ERR_INT_002: 'Não foi possível concluir porque este item está ligado a outros registros (por exemplo, operações ou contas). Ajuste ou remova esses vínculos antes',
    ERR_INT_003: 'O sistema está com instabilidade para acessar os dados. Aguarde alguns instantes e tente novamente',
    ERR_INT_004: 'A busca demorou demais para responder. Tente um período ou filtro menor, ou aguarde alguns instantes e tente novamente'
  }
};
